// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23323a49%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27rgba%28255, 255, 255, 0.87%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27rgba%28255, 255, 255, 0.87%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27rgba%28255, 255, 255, 0.87%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27rgba%28255, 255, 255, 0.87%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%288, 10, 12, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgb%28171.5, 170.5, 234.5%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.87%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%231b9e3e%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23e55353%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23e55353%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2837, 42.92, 54.02, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27rgba%2837, 42.92, 54.02, 0.95%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%233634a3%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.87%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%2859.35, 57.55, 157.45%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23080a0c%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%28var%28--cui-emphasis-color-rgb%29, 0.65%29%27 stroke-width=%272.25%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%28var%28--cui-emphasis-color-rgb%29, 0.8%29%27 stroke-width=%272.25%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%0A%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27%3E%3Cg xmlns=%27http://www.w3.org/2000/svg%27 transform=%27matrix%28-1 0 0 -1 512 512%29%27%3E%3Cpath fill=%27%23000%27 d=%27M472,16H40A24.028,24.028,0,0,0,16,40V200H48V48H464V464H48V304H16V472a24.028,24.028,0,0,0,24,24H472a24.028,24.028,0,0,0,24-24V40A24.028,24.028,0,0,0,472,16Z%27/%3E%3Cpolygon fill=%27%23000%27 points=%27209.377 363.306 232.004 385.933 366.627 251.31 232.004 116.687 209.377 139.313 305.374 235.311 16 235.311 16 267.311 305.372 267.311 209.377 363.306%27/%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * CoreUI  v5.4.0 (https://coreui.io)
 * Copyright (c) 2025 creativeLabs Łukasz Holeczek
 * Licensed under MIT (https://github.com/coreui/coreui/blob/main/LICENSE)
 */
:root,
[data-coreui-theme=light] {
  --cui-blue: #0d6efd;
  --cui-indigo: #6610f2;
  --cui-purple: #6f42c1;
  --cui-pink: #d63384;
  --cui-red: #dc3545;
  --cui-orange: #fd7e14;
  --cui-yellow: #ffc107;
  --cui-green: #198754;
  --cui-teal: #20c997;
  --cui-cyan: #0dcaf0;
  --cui-black: #080a0c;
  --cui-white: #fff;
  --cui-gray: #6d7d9c;
  --cui-gray-dark: #323a49;
  --cui-gray-100: #f3f4f7;
  --cui-gray-200: #e7eaee;
  --cui-gray-300: #dbdfe6;
  --cui-gray-400: #cfd4de;
  --cui-gray-500: #aab3c5;
  --cui-gray-600: #6d7d9c;
  --cui-gray-700: #4a566d;
  --cui-gray-800: #323a49;
  --cui-gray-900: #212631;
  --cui-primary: #5856d6;
  --cui-secondary: #6b7785;
  --cui-success: #1b9e3e;
  --cui-info: #39f;
  --cui-warning: #f9b115;
  --cui-danger: #e55353;
  --cui-light: #f3f4f7;
  --cui-dark: #212631;
  --cui-primary-rgb: 88, 86, 214;
  --cui-secondary-rgb: 107, 119, 133;
  --cui-success-rgb: 27, 158, 62;
  --cui-info-rgb: 51, 153, 255;
  --cui-warning-rgb: 249, 177, 21;
  --cui-danger-rgb: 229, 83, 83;
  --cui-light-rgb: 243, 244, 247;
  --cui-dark-rgb: 33, 38, 49;
  --cui-primary-text-emphasis: #3634a3;
  --cui-secondary-text-emphasis: #212233;
  --cui-success-text-emphasis: #0f5722;
  --cui-info-text-emphasis: #184c77;
  --cui-warning-text-emphasis: #764705;
  --cui-danger-text-emphasis: #671414;
  --cui-light-text-emphasis: #4a566d;
  --cui-dark-text-emphasis: #323a49;
  --cui-primary-bg-subtle: #cfc7f3;
  --cui-secondary-bg-subtle: #ced2d8;
  --cui-success-bg-subtle: #cbedd6;
  --cui-info-bg-subtle: #c0e6ff;
  --cui-warning-bg-subtle: #feecc5;
  --cui-danger-bg-subtle: #f9d4d4;
  --cui-light-bg-subtle: rgb(249, 249.5, 251);
  --cui-dark-bg-subtle: #cfd4de;
  --cui-primary-border-subtle: #9d92e6;
  --cui-secondary-border-subtle: #9da5b1;
  --cui-success-border-subtle: #96dbad;
  --cui-info-border-subtle: #80c6ff;
  --cui-warning-border-subtle: #fcd88a;
  --cui-danger-border-subtle: #f2a9a9;
  --cui-light-border-subtle: #e7eaee;
  --cui-dark-border-subtle: #aab3c5;
  --cui-white-rgb: 255, 255, 255;
  --cui-black-rgb: 8, 10, 12;
  --cui-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --cui-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --cui-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --cui-body-font-family: var(--cui-font-sans-serif);
  --cui-body-font-size: 1rem;
  --cui-body-font-weight: 400;
  --cui-body-line-height: 1.5;
  --cui-body-color: rgba(37, 42.92, 54.02, 0.95);
  --cui-body-color-rgb: 37, 42.92, 54.02;
  --cui-body-bg: #fff;
  --cui-body-bg-rgb: 255, 255, 255;
  --cui-emphasis-color: #080a0c;
  --cui-emphasis-color-rgb: 8, 10, 12;
  --cui-secondary-color: rgba(37, 42.92, 54.02, 0.681);
  --cui-secondary-color-rgb: 37, 42.92, 54.02;
  --cui-secondary-bg: #e7eaee;
  --cui-secondary-bg-rgb: 231, 234, 238;
  --cui-tertiary-color: rgba(37, 42.92, 54.02, 0.38);
  --cui-tertiary-color-rgb: 37, 42.92, 54.02;
  --cui-tertiary-bg: #f3f4f7;
  --cui-tertiary-bg-rgb: 243, 244, 247;
  --cui-body-color-dark: rgba(255, 255, 255, 0.87);
  --cui-body-color-rgb-dark: 255, 255, 255;
  --cui-body-bg-dark: #212631;
  --cui-body-bg-rgb-dark: 33, 38, 49;
  --cui-emphasis-color-dark: #fff;
  --cui-emphasis-color-rgb-dark: 255, 255, 255;
  --cui-secondary-color-dark: rgba(255, 255, 255, 0.6);
  --cui-secondary-color-rgb-dark: 255, 255, 255;
  --cui-secondary-bg-dark: #323a49;
  --cui-secondary-bg-rgb-dark: 50, 58, 73;
  --cui-tertiary-color-dark: rgba(255, 255, 255, 0.38);
  --cui-tertiary-color-rgb-dark: 255, 255, 255;
  --cui-tertiary-bg-dark: rgb(41.5, 48, 61);
  --cui-tertiary-bg-rgb-dark: 41.5, 48, 61;
  --cui-high-emphasis: rgba(37, 42.92, 54.02, 0.95);
  --cui-medium-emphasis: rgba(37, 42.92, 54.02, 0.681);
  --cui-disabled: rgba(37, 42.92, 54.02, 0.38);
  --cui-high-emphasis-inverse: rgba(255, 255, 255, 0.87);
  --cui-medium-emphasis-inverse: rgba(255, 255, 255, 0.6);
  --cui-disabled-inverse: rgba(255, 255, 255, 0.38);
  --cui-heading-color: inherit;
  --cui-link-color: #5856d6;
  --cui-link-color-rgb: 88, 86, 214;
  --cui-link-decoration: underline;
  --cui-link-hover-color: rgb(70.4, 68.8, 171.2);
  --cui-link-hover-color-rgb: 70.4, 68.8, 171.2;
  --cui-code-color: #d63384;
  --cui-highlight-color: rgba(37, 42.92, 54.02, 0.95);
  --cui-highlight-bg: rgb(255, 242.6, 205.4);
  --cui-border-width: 1px;
  --cui-border-style: solid;
  --cui-border-color: #dbdfe6;
  --cui-border-color-translucent: rgba(8, 10, 12, 0.175);
  --cui-border-radius: 0.375rem;
  --cui-border-radius-sm: 0.25rem;
  --cui-border-radius-lg: 0.5rem;
  --cui-border-radius-xl: 1rem;
  --cui-border-radius-xxl: 2rem;
  --cui-border-radius-2xl: var(--cui-border-radius-xxl);
  --cui-border-radius-pill: 50rem;
  --cui-box-shadow: 0 0.5rem 1rem rgba(8, 10, 12, 0.15);
  --cui-box-shadow-sm: 0 0.125rem 0.25rem rgba(8, 10, 12, 0.075);
  --cui-box-shadow-lg: 0 1rem 3rem rgba(8, 10, 12, 0.175);
  --cui-box-shadow-inset: inset 0 1px 2px rgba(8, 10, 12, 0.075);
  --cui-focus-ring-width: 0.25rem;
  --cui-focus-ring-opacity: 0.25;
  --cui-focus-ring-color: rgba(88, 86, 214, 0.25);
  --cui-form-valid-color: #1b9e3e;
  --cui-form-valid-border-color: #1b9e3e;
  --cui-form-invalid-color: #e55353;
  --cui-form-invalid-border-color: #e55353;
}

[data-coreui-theme=dark] {
  color-scheme: dark;
  --cui-body-color: rgba(255, 255, 255, 0.87);
  --cui-body-color-rgb: 255, 255, 255;
  --cui-body-bg: #212631;
  --cui-body-bg-rgb: 33, 38, 49;
  --cui-emphasis-color: #fff;
  --cui-emphasis-color-rgb: 255, 255, 255;
  --cui-secondary-color: rgba(255, 255, 255, 0.6);
  --cui-secondary-color-rgb: 255, 255, 255;
  --cui-secondary-bg: #323a49;
  --cui-secondary-bg-rgb: 50, 58, 73;
  --cui-tertiary-color: rgba(255, 255, 255, 0.38);
  --cui-tertiary-color-rgb: 255, 255, 255;
  --cui-tertiary-bg: rgb(41.5, 48, 61);
  --cui-tertiary-bg-rgb: 41.5, 48, 61;
  --cui-high-emphasis: rgba(255, 255, 255, 0.87);
  --cui-medium-emphasis: rgba(255, 255, 255, 0.6);
  --cui-disabled: rgba(255, 255, 255, 0.38);
  --cui-primary: rgb(94.2, 92.4, 207.6);
  --cui-secondary: #6b7785;
  --cui-success: rgb(33.55, 151.45, 65.05);
  --cui-info: rgb(61.2, 153, 244.8);
  --cui-warning: rgb(237.6, 172.8, 32.4);
  --cui-danger: rgb(221.7, 90.3, 90.3);
  --cui-light: #f3f4f7;
  --cui-dark: #212631;
  --cui-gray-100: #f3f4f7;
  --cui-gray-200: #e7eaee;
  --cui-gray-300: #dbdfe6;
  --cui-gray-400: #cfd4de;
  --cui-gray-500: #aab3c5;
  --cui-gray-600: #6d7d9c;
  --cui-gray-700: #4a566d;
  --cui-gray-800: #323a49;
  --cui-gray-900: #212631;
  --cui-primary-rgb: 94.2, 92.4, 207.6;
  --cui-secondary-rgb: 107, 119, 133;
  --cui-success-rgb: 33.55, 151.45, 65.05;
  --cui-info-rgb: 61.2, 153, 244.8;
  --cui-warning-rgb: 237.6, 172.8, 32.4;
  --cui-danger-rgb: 221.7, 90.3, 90.3;
  --cui-light-rgb: 243, 244, 247;
  --cui-dark-rgb: 33, 38, 49;
  --cui-primary-text-emphasis: rgb(59.35, 57.55, 157.45);
  --cui-secondary-text-emphasis: #212233;
  --cui-success-text-emphasis: rgb(18.6, 83.4, 35.7);
  --cui-info-text-emphasis: rgb(28.75, 75.55, 114.25);
  --cui-warning-text-emphasis: rgb(112.35, 70.05, 10.65);
  --cui-danger-text-emphasis: rgb(98.85, 24.15, 24.15);
  --cui-light-text-emphasis: #f3f4f7;
  --cui-dark-text-emphasis: #dbdfe6;
  --cui-primary-bg-subtle: #cfc7f3;
  --cui-secondary-bg-subtle: #ced2d8;
  --cui-success-bg-subtle: #cbedd6;
  --cui-info-bg-subtle: #c0e6ff;
  --cui-warning-bg-subtle: #feecc5;
  --cui-danger-bg-subtle: #f9d4d4;
  --cui-light-bg-subtle: #323a49;
  --cui-dark-bg-subtle: rgb(29, 34, 42.5);
  --cui-primary-border-subtle: #9d92e6;
  --cui-secondary-border-subtle: #9da5b1;
  --cui-success-border-subtle: #96dbad;
  --cui-info-border-subtle: #80c6ff;
  --cui-warning-border-subtle: #fcd88a;
  --cui-danger-border-subtle: #f2a9a9;
  --cui-light-border-subtle: #4a566d;
  --cui-dark-border-subtle: #323a49;
  --cui-heading-color: inherit;
  --cui-link-color: rgb(94.2, 92.4, 207.6);
  --cui-link-hover-color: rgb(126.36, 124.92, 217.08);
  --cui-link-color-rgb: 94.2, 92.4, 207.6;
  --cui-link-hover-color-rgb: 126.36, 124.92, 217.08;
  --cui-code-color: rgb(230.4, 132.6, 181.2);
  --cui-highlight-color: rgba(255, 255, 255, 0.87);
  --cui-highlight-bg: rgb(102, 77.2, 2.8);
  --cui-border-color: #323a49;
  --cui-border-color-translucent: rgba(255, 255, 255, 0.1);
  --cui-form-valid-color: rgb(117, 183, 152.4);
  --cui-form-valid-border-color: rgb(117, 183, 152.4);
  --cui-form-invalid-color: rgb(234, 133.8, 143.4);
  --cui-form-invalid-border-color: rgb(234, 133.8, 143.4);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--cui-body-font-family);
  font-size: var(--cui-body-font-size);
  font-weight: var(--cui-body-font-weight);
  line-height: var(--cui-body-line-height);
  color: var(--cui-body-color);
  text-align: var(--cui-body-text-align);
  background-color: var(--cui-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(8, 10, 12, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--cui-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--cui-heading-color);
}

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.5rem;
  }
}

h2, .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2rem;
  }
}

h3, .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.75rem;
  }
}

h4, .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.5rem;
  }
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-inline-start: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-inline-start: 0;
  margin-bottom: 0.5rem;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--cui-highlight-color);
  background-color: var(--cui-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--cui-link-color-rgb), var(--cui-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --cui-link-color-rgb: var(--cui-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--cui-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
  color: var(--cui-pre-color, );
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--cui-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--cui-kbd-color, var(--cui-body-bg));
  background-color: var(--cui-kbd-bg, var(--cui-body-color));
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--cui-table-caption-color, var(--cui-secondary-color));
  text-align: start;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: inline-start;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  line-height: inherit;
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

*[dir=rtl] [type=tel],
*[dir=rtl] [type=url],
*[dir=rtl] [type=email],
*[dir=rtl] [type=number] {
  direction: ltr;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.625rem + 4.5vw);
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.575rem + 3.9vw);
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.525rem + 3.3vw);
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.475rem + 2.7vw);
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.425rem + 2.1vw);
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-inline-start: 0;
  list-style: none;
}

.list-inline {
  padding-inline-start: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-inline-end: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6d7d9c;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--cui-thumbnail-bg, var(--cui-body-bg));
  border: var(--cui-border-width) solid var(--cui-thumbnail-border-color, var(--cui-border-color));
  border-radius: var(--cui-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--cui-figure-caption-color, var(--cui-secondary-color));
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --cui-gutter-x: 1.5rem;
  --cui-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--cui-gutter-x) * 0.5);
  padding-left: calc(var(--cui-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --cui-breakpoint-xs: 0;
  --cui-breakpoint-sm: 576px;
  --cui-breakpoint-md: 768px;
  --cui-breakpoint-lg: 992px;
  --cui-breakpoint-xl: 1200px;
  --cui-breakpoint-xxl: 1400px;
  --cui-mobile-breakpoint: lg;
}

.row {
  --cui-gutter-x: 1.5rem;
  --cui-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--cui-gutter-y));
  margin-right: calc(-0.5 * var(--cui-gutter-x));
  margin-left: calc(-0.5 * var(--cui-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--cui-gutter-x) * 0.5);
  padding-left: calc(var(--cui-gutter-x) * 0.5);
  margin-top: var(--cui-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-inline-start: 8.33333333%;
}

.offset-2 {
  margin-inline-start: 16.66666667%;
}

.offset-3 {
  margin-inline-start: 25%;
}

.offset-4 {
  margin-inline-start: 33.33333333%;
}

.offset-5 {
  margin-inline-start: 41.66666667%;
}

.offset-6 {
  margin-inline-start: 50%;
}

.offset-7 {
  margin-inline-start: 58.33333333%;
}

.offset-8 {
  margin-inline-start: 66.66666667%;
}

.offset-9 {
  margin-inline-start: 75%;
}

.offset-10 {
  margin-inline-start: 83.33333333%;
}

.offset-11 {
  margin-inline-start: 91.66666667%;
}

.g-0,
.gx-0 {
  --cui-gutter-x: 0;
}

.g-0,
.gy-0 {
  --cui-gutter-y: 0;
}

.g-1,
.gx-1 {
  --cui-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --cui-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --cui-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --cui-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --cui-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --cui-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --cui-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --cui-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --cui-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --cui-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-inline-start: 0;
  }
  .offset-sm-1 {
    margin-inline-start: 8.33333333%;
  }
  .offset-sm-2 {
    margin-inline-start: 16.66666667%;
  }
  .offset-sm-3 {
    margin-inline-start: 25%;
  }
  .offset-sm-4 {
    margin-inline-start: 33.33333333%;
  }
  .offset-sm-5 {
    margin-inline-start: 41.66666667%;
  }
  .offset-sm-6 {
    margin-inline-start: 50%;
  }
  .offset-sm-7 {
    margin-inline-start: 58.33333333%;
  }
  .offset-sm-8 {
    margin-inline-start: 66.66666667%;
  }
  .offset-sm-9 {
    margin-inline-start: 75%;
  }
  .offset-sm-10 {
    margin-inline-start: 83.33333333%;
  }
  .offset-sm-11 {
    margin-inline-start: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --cui-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --cui-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --cui-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --cui-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --cui-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-inline-start: 0;
  }
  .offset-md-1 {
    margin-inline-start: 8.33333333%;
  }
  .offset-md-2 {
    margin-inline-start: 16.66666667%;
  }
  .offset-md-3 {
    margin-inline-start: 25%;
  }
  .offset-md-4 {
    margin-inline-start: 33.33333333%;
  }
  .offset-md-5 {
    margin-inline-start: 41.66666667%;
  }
  .offset-md-6 {
    margin-inline-start: 50%;
  }
  .offset-md-7 {
    margin-inline-start: 58.33333333%;
  }
  .offset-md-8 {
    margin-inline-start: 66.66666667%;
  }
  .offset-md-9 {
    margin-inline-start: 75%;
  }
  .offset-md-10 {
    margin-inline-start: 83.33333333%;
  }
  .offset-md-11 {
    margin-inline-start: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --cui-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --cui-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --cui-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --cui-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --cui-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-inline-start: 0;
  }
  .offset-lg-1 {
    margin-inline-start: 8.33333333%;
  }
  .offset-lg-2 {
    margin-inline-start: 16.66666667%;
  }
  .offset-lg-3 {
    margin-inline-start: 25%;
  }
  .offset-lg-4 {
    margin-inline-start: 33.33333333%;
  }
  .offset-lg-5 {
    margin-inline-start: 41.66666667%;
  }
  .offset-lg-6 {
    margin-inline-start: 50%;
  }
  .offset-lg-7 {
    margin-inline-start: 58.33333333%;
  }
  .offset-lg-8 {
    margin-inline-start: 66.66666667%;
  }
  .offset-lg-9 {
    margin-inline-start: 75%;
  }
  .offset-lg-10 {
    margin-inline-start: 83.33333333%;
  }
  .offset-lg-11 {
    margin-inline-start: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --cui-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --cui-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --cui-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --cui-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --cui-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-inline-start: 0;
  }
  .offset-xl-1 {
    margin-inline-start: 8.33333333%;
  }
  .offset-xl-2 {
    margin-inline-start: 16.66666667%;
  }
  .offset-xl-3 {
    margin-inline-start: 25%;
  }
  .offset-xl-4 {
    margin-inline-start: 33.33333333%;
  }
  .offset-xl-5 {
    margin-inline-start: 41.66666667%;
  }
  .offset-xl-6 {
    margin-inline-start: 50%;
  }
  .offset-xl-7 {
    margin-inline-start: 58.33333333%;
  }
  .offset-xl-8 {
    margin-inline-start: 66.66666667%;
  }
  .offset-xl-9 {
    margin-inline-start: 75%;
  }
  .offset-xl-10 {
    margin-inline-start: 83.33333333%;
  }
  .offset-xl-11 {
    margin-inline-start: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --cui-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --cui-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --cui-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --cui-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --cui-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-inline-start: 0;
  }
  .offset-xxl-1 {
    margin-inline-start: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-inline-start: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-inline-start: 25%;
  }
  .offset-xxl-4 {
    margin-inline-start: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-inline-start: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-inline-start: 50%;
  }
  .offset-xxl-7 {
    margin-inline-start: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-inline-start: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-inline-start: 75%;
  }
  .offset-xxl-10 {
    margin-inline-start: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-inline-start: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --cui-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --cui-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --cui-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --cui-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --cui-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --cui-gutter-y: 3rem;
  }
}
.table {
  --cui-table-color-type: initial;
  --cui-table-bg-type: initial;
  --cui-table-color-state: initial;
  --cui-table-bg-state: initial;
  --cui-table-color: var(--cui-emphasis-color);
  --cui-table-bg: var(--cui-body-bg);
  --cui-table-border-color: var(--cui-border-color);
  --cui-table-accent-bg: transparent;
  --cui-table-striped-color: var(--cui-emphasis-color);
  --cui-table-striped-bg: rgba(var(--cui-emphasis-color-rgb), 0.05);
  --cui-table-active-color: var(--cui-emphasis-color);
  --cui-table-active-bg: rgba(var(--cui-emphasis-color-rgb), 0.1);
  --cui-table-hover-color: var(--cui-emphasis-color);
  --cui-table-hover-bg: rgba(var(--cui-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--cui-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--cui-table-color-state, var(--cui-table-color-type, var(--cui-table-color)));
  background-color: var(--cui-table-bg);
  border-bottom-width: var(--cui-border-width);
  box-shadow: inset 0 0 0 9999px var(--cui-table-bg-state, var(--cui-table-bg-type, var(--cui-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--cui-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--cui-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--cui-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --cui-table-color-type: var(--cui-table-striped-color);
  --cui-table-bg-type: var(--cui-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --cui-table-color-type: var(--cui-table-striped-color);
  --cui-table-bg-type: var(--cui-table-striped-bg);
}

.table-active {
  --cui-table-color-state: var(--cui-table-active-color);
  --cui-table-bg-state: var(--cui-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --cui-table-color-state: var(--cui-table-hover-color);
  --cui-table-bg-state: var(--cui-table-hover-bg);
}

.table-primary {
  --cui-table-color: #080a0c;
  --cui-table-bg: rgb(221.6, 221.2, 246.8);
  --cui-table-border-color: rgb(178.88, 178.96, 199.84);
  --cui-table-striped-bg: rgb(210.92, 210.64, 235.06);
  --cui-table-striped-color: #080a0c;
  --cui-table-active-bg: rgb(200.24, 200.08, 223.32);
  --cui-table-active-color: #080a0c;
  --cui-table-hover-bg: rgb(205.58, 205.36, 229.19);
  --cui-table-hover-color: #080a0c;
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-secondary {
  --cui-table-color: #080a0c;
  --cui-table-bg: rgb(225.4, 227.8, 230.6);
  --cui-table-border-color: rgb(181.92, 184.24, 186.88);
  --cui-table-striped-bg: rgb(214.53, 216.91, 219.67);
  --cui-table-striped-color: #080a0c;
  --cui-table-active-bg: rgb(203.66, 206.02, 208.74);
  --cui-table-active-color: #080a0c;
  --cui-table-hover-bg: rgb(209.095, 211.465, 214.205);
  --cui-table-hover-color: #080a0c;
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-success {
  --cui-table-color: #080a0c;
  --cui-table-bg: rgb(209.4, 235.6, 216.4);
  --cui-table-border-color: rgb(169.12, 190.48, 175.52);
  --cui-table-striped-bg: rgb(199.33, 224.32, 206.18);
  --cui-table-striped-color: #080a0c;
  --cui-table-active-bg: rgb(189.26, 213.04, 195.96);
  --cui-table-active-color: #080a0c;
  --cui-table-hover-bg: rgb(194.295, 218.68, 201.07);
  --cui-table-hover-color: #080a0c;
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-info {
  --cui-table-color: #080a0c;
  --cui-table-bg: rgb(214.2, 234.6, 255);
  --cui-table-border-color: rgb(172.96, 189.68, 206.4);
  --cui-table-striped-bg: rgb(203.89, 223.37, 242.85);
  --cui-table-striped-color: #080a0c;
  --cui-table-active-bg: rgb(193.58, 212.14, 230.7);
  --cui-table-active-color: #080a0c;
  --cui-table-hover-bg: rgb(198.735, 217.755, 236.775);
  --cui-table-hover-color: #080a0c;
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-warning {
  --cui-table-color: #080a0c;
  --cui-table-bg: rgb(253.8, 239.4, 208.2);
  --cui-table-border-color: rgb(204.64, 193.52, 168.96);
  --cui-table-striped-bg: rgb(241.51, 227.93, 198.39);
  --cui-table-striped-color: #080a0c;
  --cui-table-active-bg: rgb(229.22, 216.46, 188.58);
  --cui-table-active-color: #080a0c;
  --cui-table-hover-bg: rgb(235.365, 222.195, 193.485);
  --cui-table-hover-color: #080a0c;
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-danger {
  --cui-table-color: #080a0c;
  --cui-table-bg: rgb(249.8, 220.6, 220.6);
  --cui-table-border-color: rgb(201.44, 178.48, 178.88);
  --cui-table-striped-bg: rgb(237.71, 210.07, 210.17);
  --cui-table-striped-color: #080a0c;
  --cui-table-active-bg: rgb(225.62, 199.54, 199.74);
  --cui-table-active-color: #080a0c;
  --cui-table-hover-bg: rgb(231.665, 204.805, 204.955);
  --cui-table-hover-color: #080a0c;
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-light {
  --cui-table-color: #080a0c;
  --cui-table-bg: #f3f4f7;
  --cui-table-border-color: rgb(196, 197.2, 200);
  --cui-table-striped-bg: rgb(231.25, 232.3, 235.25);
  --cui-table-striped-color: #080a0c;
  --cui-table-active-bg: rgb(219.5, 220.6, 223.5);
  --cui-table-active-color: #080a0c;
  --cui-table-hover-bg: rgb(225.375, 226.45, 229.375);
  --cui-table-hover-color: #080a0c;
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-dark {
  --cui-table-color: #fff;
  --cui-table-bg: #212631;
  --cui-table-border-color: rgb(77.4, 81.4, 90.2);
  --cui-table-striped-bg: rgb(44.1, 48.85, 59.3);
  --cui-table-striped-color: #fff;
  --cui-table-active-bg: rgb(55.2, 59.7, 69.6);
  --cui-table-active-color: #fff;
  --cui-table-hover-bg: rgb(49.65, 54.275, 64.45);
  --cui-table-hover-color: #fff;
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + var(--cui-border-width));
  padding-bottom: calc(0.375rem + var(--cui-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--cui-border-width));
  padding-bottom: calc(0.5rem + var(--cui-border-width));
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--cui-border-width));
  padding-bottom: calc(0.25rem + var(--cui-border-width));
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--cui-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--cui-body-color);
  appearance: none;
  background-color: var(--cui-body-bg);
  background-clip: padding-box;
  border: var(--cui-border-width) solid var(--cui-border-color);
  border-radius: var(--cui-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--cui-body-color);
  background-color: var(--cui-body-bg);
  border-color: rgb(171.5, 170.5, 234.5);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(88, 86, 214, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--cui-input-placeholder-color, var(--cui-secondary-color));
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--cui-secondary-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--cui-body-color);
  background-color: var(--cui-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--cui-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--cui-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--cui-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--cui-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--cui-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--cui-border-radius-sm);
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--cui-border-radius-lg);
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--cui-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--cui-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--cui-border-width) * 2));
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--cui-border-radius);
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--cui-border-radius);
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--cui-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2));
}

.form-select {
  --cui-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding-inline-start: 0.75rem;
  padding-inline-end: 2.25rem;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--cui-body-color);
  appearance: none;
  background-color: var(--cui-body-bg);
  background-image: var(--cui-form-select-bg-img), var(--cui-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--cui-border-width) solid var(--cui-border-color);
  border-radius: var(--cui-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgb(171.5, 170.5, 234.5);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(88, 86, 214, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-inline-end: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  background-color: var(--cui-secondary-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--cui-body-color);
}

.form-select-sm {
  padding-inline-start: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
  border-radius: var(--cui-border-radius-sm);
}

.form-select-lg {
  padding-inline-start: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 1.25rem;
  border-radius: var(--cui-border-radius-lg);
}

[data-coreui-theme=dark] .form-select {
  --cui-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-inline-start: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: inline-start;
  margin-inline-start: -1.5em;
}

.form-check-reverse {
  padding-inline: 0 1.5em;
  text-align: end;
}
.form-check-reverse .form-check-input {
  float: inline-end;
  margin-inline: 0 -1.5em;
}

.form-check-input {
  --cui-form-check-bg: var(--cui-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--cui-form-check-bg);
  background-image: var(--cui-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--cui-border-width) solid var(--cui-border-color);
  print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgb(171.5, 170.5, 234.5);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(88, 86, 214, 0.25);
}
.form-check-input:checked {
  background-color: var(--cui-form-check-input-checked-bg-color, var(--cui-primary));
  border-color: var(--cui-form-check-input-checked-border-color, var(--cui-primary));
}
.form-check-input:checked[type=checkbox] {
  --cui-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input:checked[type=radio] {
  --cui-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: var(--cui-primary);
  border-color: var(--cui-primary);
  --cui-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-check-label {
  color: var(--cui-form-check-label-color, );
}

.form-switch {
  padding-inline-start: 2.5em;
}
.form-switch .form-check-input {
  --cui-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2em;
  margin-inline-start: -2.5em;
  background-image: var(--cui-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --cui-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --cui-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.form-switch.form-check-reverse {
  padding-inline: 0 2.5em;
}
.form-switch.form-check-reverse .form-check-input {
  margin-inline: 0 -2.5em;
}

.form-switch-lg {
  min-height: 1.25em;
  padding-inline-start: 3em;
}
.form-switch-lg .form-check-input {
  width: 2.5em;
  height: 1.25em;
  margin-inline-start: -3em;
}
.form-switch-lg .form-check-label {
  padding-top: calc((1.25em - 1rem) / 2);
}

.form-switch-xl {
  min-height: 1.5em;
  padding-inline-start: 3.5em;
}
.form-switch-xl .form-check-input {
  width: 3em;
  height: 1.5em;
  margin-inline-start: -3.5em;
}
.form-switch-xl .form-check-label {
  padding-top: calc((1.5em - 1rem) / 2);
}

.form-check-inline {
  display: inline-block;
  margin-inline-end: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-coreui-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --cui-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(88, 86, 214, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(88, 86, 214, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: var(--cui-primary);
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(204.9, 204.3, 242.7);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--cui-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: var(--cui-primary);
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(204.9, 204.3, 242.7);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--cui-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--cui-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--cui-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--cui-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--cui-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  z-index: 2;
  max-width: 100%;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  color: rgba(var(--cui-body-color-rgb), 0.65);
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--cui-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-inline-start: 0.75rem;
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > textarea:focus ~ label::after,
.form-floating > textarea:not(:placeholder-shown) ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--cui-body-bg);
  border-radius: var(--cui-border-radius);
}
.form-floating > textarea:disabled ~ label::after {
  background-color: var(--cui-secondary-bg);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--cui-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6d7d9c;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--cui-input-group-addon-color, var(--cui-body-color));
  text-align: center;
  white-space: nowrap;
  background-color: var(--cui-input-group-addon-bg, var(--cui-tertiary-bg));
  border: var(--cui-border-width) solid var(--cui-input-group-addon-border-color, var(--cui-border-color));
  border-radius: var(--cui-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--cui-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--cui-border-radius-sm);
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-inline-end: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-start-end-radius: 0;
  border-end-end-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-start-end-radius: 0;
  border-end-end-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-inline-start: calc(-1 * var(--cui-border-width));
  border-start-start-radius: 0;
  border-end-start-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-start-start-radius: 0;
  border-end-start-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--cui-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--cui-success);
  border-radius: var(--cui-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--cui-form-valid-border-color);
  padding-inline-end: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--cui-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-inline-end: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--cui-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --cui-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-inline-end: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--cui-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--cui-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--cui-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--cui-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-inline-start: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--cui-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--cui-danger);
  border-radius: var(--cui-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--cui-form-invalid-border-color);
  padding-inline-end: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--cui-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-inline-end: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--cui-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --cui-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  padding-inline-end: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--cui-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--cui-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--cui-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--cui-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-inline-start: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --cui-btn-padding-x: 0.75rem;
  --cui-btn-padding-y: 0.375rem;
  --cui-btn-font-family: ;
  --cui-btn-font-size: 1rem;
  --cui-btn-font-weight: 400;
  --cui-btn-line-height: 1.5;
  --cui-btn-color: var(--cui-body-color);
  --cui-btn-bg: transparent;
  --cui-btn-border-width: var(--cui-border-width);
  --cui-btn-border-color: transparent;
  --cui-btn-border-radius: var(--cui-border-radius);
  --cui-btn-hover-border-color: transparent;
  --cui-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(8, 10, 12, 0.075);
  --cui-btn-disabled-opacity: 0.65;
  --cui-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--cui-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--cui-btn-padding-y) var(--cui-btn-padding-x);
  font-family: var(--cui-btn-font-family);
  font-size: var(--cui-btn-font-size);
  font-weight: var(--cui-btn-font-weight);
  line-height: var(--cui-btn-line-height);
  color: var(--cui-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--cui-btn-border-width) solid var(--cui-btn-border-color);
  border-radius: var(--cui-btn-border-radius);
  background-color: var(--cui-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--cui-btn-hover-color);
  background-color: var(--cui-btn-hover-bg);
  border-color: var(--cui-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--cui-btn-color);
  background-color: var(--cui-btn-bg);
  border-color: var(--cui-btn-border-color);
}
.btn:focus-visible {
  color: var(--cui-btn-hover-color);
  background-color: var(--cui-btn-hover-bg);
  border-color: var(--cui-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--cui-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--cui-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--cui-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--cui-btn-active-color);
  background-color: var(--cui-btn-active-bg);
  border-color: var(--cui-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--cui-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--cui-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--cui-btn-disabled-color);
  pointer-events: none;
  background-color: var(--cui-btn-disabled-bg);
  border-color: var(--cui-btn-disabled-border-color);
  opacity: var(--cui-btn-disabled-opacity);
}

.btn-ghost {
  --cui-btn-color: var(--cui-secondary-color);
  --cui-btn-border-color: transparent;
  --cui-btn-active-color: var(--cui-body-color);
  --cui-btn-active-bg: var(--cui-tertiary-bg);
  --cui-btn-active-border-color: var(--cui-tertiary-bg);
  --cui-btn-disabled-color: var(--cui-secondary-color);
  --cui-btn-disabled-border-color: transparent;
  --cui-btn-hover-color: var(--cui-body-color);
  --cui-btn-hover-bg: var(--cui-tertiary-bg);
  --cui-btn-hover-border-color: var(--cui-tertiary-bg);
  --cui-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--cui-tertiary-bg-rgb), .5);
}

.btn-outline {
  --cui-btn-color: var(--cui-secondary-color);
  --cui-btn-border-color: var(--cui-border-color);
  --cui-btn-active-color: var(--cui-body-color);
  --cui-btn-active-bg: var(--cui-tertiary-bg);
  --cui-btn-active-border-color: var(--cui-border-color);
  --cui-btn-disabled-color: var(--cui-secondary-color);
  --cui-btn-disabled-border-color: var(--cui-border-color);
  --cui-btn-hover-color: var(--cui-body-color);
  --cui-btn-hover-bg: var(--cui-tertiary-bg);
  --cui-btn-hover-border-color: var(--cui-border-color);
  --cui-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--cui-tertiary-bg-rgb), .5);
}

.btn-transparent {
  --cui-btn-active-border-color: transparent;
  --cui-btn-disabled-border-color: transparent;
  --cui-btn-hover-border-color: transparent;
}

.btn-primary {
  --cui-btn-color: #fff;
  --cui-btn-bg: #5856d6;
  --cui-btn-border-color: #5856d6;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: rgb(74.8, 73.1, 181.9);
  --cui-btn-hover-border-color: rgb(70.4, 68.8, 171.2);
  --cui-btn-focus-shadow-rgb: 113.05, 111.35, 220.15;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: rgb(70.4, 68.8, 171.2);
  --cui-btn-active-border-color: rgb(66, 64.5, 160.5);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #fff;
  --cui-btn-disabled-bg: #5856d6;
  --cui-btn-disabled-border-color: #5856d6;
}

.btn-secondary {
  --cui-btn-color: #fff;
  --cui-btn-bg: #6b7785;
  --cui-btn-border-color: #6b7785;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: rgb(90.95, 101.15, 113.05);
  --cui-btn-hover-border-color: rgb(85.6, 95.2, 106.4);
  --cui-btn-focus-shadow-rgb: 129.2, 139.4, 151.3;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: rgb(85.6, 95.2, 106.4);
  --cui-btn-active-border-color: rgb(80.25, 89.25, 99.75);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #fff;
  --cui-btn-disabled-bg: #6b7785;
  --cui-btn-disabled-border-color: #6b7785;
}

.btn-success {
  --cui-btn-color: #080a0c;
  --cui-btn-bg: #1b9e3e;
  --cui-btn-border-color: #1b9e3e;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(61.2, 172.55, 90.95);
  --cui-btn-hover-border-color: rgb(49.8, 167.7, 81.3);
  --cui-btn-focus-shadow-rgb: 24.15, 135.8, 54.5;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(72.6, 177.4, 100.6);
  --cui-btn-active-border-color: rgb(49.8, 167.7, 81.3);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #080a0c;
  --cui-btn-disabled-bg: #1b9e3e;
  --cui-btn-disabled-border-color: #1b9e3e;
}

.btn-info {
  --cui-btn-color: #080a0c;
  --cui-btn-bg: #39f;
  --cui-btn-border-color: #39f;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(81.6, 168.3, 255);
  --cui-btn-hover-border-color: rgb(71.4, 163.2, 255);
  --cui-btn-focus-shadow-rgb: 44.55, 131.55, 218.55;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(91.8, 173.4, 255);
  --cui-btn-active-border-color: rgb(71.4, 163.2, 255);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #080a0c;
  --cui-btn-disabled-bg: #39f;
  --cui-btn-disabled-border-color: #39f;
}

.btn-warning {
  --cui-btn-color: #080a0c;
  --cui-btn-bg: #f9b115;
  --cui-btn-border-color: #f9b115;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(249.9, 188.7, 56.1);
  --cui-btn-hover-border-color: rgb(249.6, 184.8, 44.4);
  --cui-btn-focus-shadow-rgb: 212.85, 151.95, 19.65;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(250.2, 192.6, 67.8);
  --cui-btn-active-border-color: rgb(249.6, 184.8, 44.4);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #080a0c;
  --cui-btn-disabled-bg: #f9b115;
  --cui-btn-disabled-border-color: #f9b115;
}

.btn-danger {
  --cui-btn-color: #080a0c;
  --cui-btn-bg: #e55353;
  --cui-btn-border-color: #e55353;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(232.9, 108.8, 108.8);
  --cui-btn-hover-border-color: rgb(231.6, 100.2, 100.2);
  --cui-btn-focus-shadow-rgb: 195.85, 72.05, 72.35;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(234.2, 117.4, 117.4);
  --cui-btn-active-border-color: rgb(231.6, 100.2, 100.2);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #080a0c;
  --cui-btn-disabled-bg: #e55353;
  --cui-btn-disabled-border-color: #e55353;
}

.btn-light {
  --cui-btn-color: #080a0c;
  --cui-btn-bg: #f3f4f7;
  --cui-btn-border-color: #f3f4f7;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(206.55, 207.4, 209.95);
  --cui-btn-hover-border-color: rgb(194.4, 195.2, 197.6);
  --cui-btn-focus-shadow-rgb: 207.75, 208.9, 211.75;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(194.4, 195.2, 197.6);
  --cui-btn-active-border-color: rgb(182.25, 183, 185.25);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #080a0c;
  --cui-btn-disabled-bg: #f3f4f7;
  --cui-btn-disabled-border-color: #f3f4f7;
}

.btn-dark {
  --cui-btn-color: #fff;
  --cui-btn-bg: #212631;
  --cui-btn-border-color: #212631;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: rgb(66.3, 70.55, 79.9);
  --cui-btn-hover-border-color: rgb(55.2, 59.7, 69.6);
  --cui-btn-focus-shadow-rgb: 66.3, 70.55, 79.9;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: rgb(77.4, 81.4, 90.2);
  --cui-btn-active-border-color: rgb(55.2, 59.7, 69.6);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #fff;
  --cui-btn-disabled-bg: #212631;
  --cui-btn-disabled-border-color: #212631;
}

.btn-outline-primary {
  --cui-btn-color: #5856d6;
  --cui-btn-border-color: #5856d6;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: #5856d6;
  --cui-btn-hover-border-color: #5856d6;
  --cui-btn-focus-shadow-rgb: 88, 86, 214;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: #5856d6;
  --cui-btn-active-border-color: #5856d6;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #5856d6;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: #5856d6;
  --cui-gradient: none;
}

.btn-outline-secondary {
  --cui-btn-color: #6b7785;
  --cui-btn-border-color: #6b7785;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: #6b7785;
  --cui-btn-hover-border-color: #6b7785;
  --cui-btn-focus-shadow-rgb: 107, 119, 133;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: #6b7785;
  --cui-btn-active-border-color: #6b7785;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #6b7785;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: #6b7785;
  --cui-gradient: none;
}

.btn-outline-success {
  --cui-btn-color: #1b9e3e;
  --cui-btn-border-color: #1b9e3e;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: #1b9e3e;
  --cui-btn-hover-border-color: #1b9e3e;
  --cui-btn-focus-shadow-rgb: 27, 158, 62;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: #1b9e3e;
  --cui-btn-active-border-color: #1b9e3e;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #1b9e3e;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: #1b9e3e;
  --cui-gradient: none;
}

.btn-outline-info {
  --cui-btn-color: #39f;
  --cui-btn-border-color: #39f;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: #39f;
  --cui-btn-hover-border-color: #39f;
  --cui-btn-focus-shadow-rgb: 51, 153, 255;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: #39f;
  --cui-btn-active-border-color: #39f;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #39f;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: #39f;
  --cui-gradient: none;
}

.btn-outline-warning {
  --cui-btn-color: #f9b115;
  --cui-btn-border-color: #f9b115;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: #f9b115;
  --cui-btn-hover-border-color: #f9b115;
  --cui-btn-focus-shadow-rgb: 249, 177, 21;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: #f9b115;
  --cui-btn-active-border-color: #f9b115;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #f9b115;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: #f9b115;
  --cui-gradient: none;
}

.btn-outline-danger {
  --cui-btn-color: #e55353;
  --cui-btn-border-color: #e55353;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: #e55353;
  --cui-btn-hover-border-color: #e55353;
  --cui-btn-focus-shadow-rgb: 229, 83, 83;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: #e55353;
  --cui-btn-active-border-color: #e55353;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #e55353;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: #e55353;
  --cui-gradient: none;
}

.btn-outline-light {
  --cui-btn-color: #f3f4f7;
  --cui-btn-border-color: #f3f4f7;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: #f3f4f7;
  --cui-btn-hover-border-color: #f3f4f7;
  --cui-btn-focus-shadow-rgb: 243, 244, 247;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: #f3f4f7;
  --cui-btn-active-border-color: #f3f4f7;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #f3f4f7;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: #f3f4f7;
  --cui-gradient: none;
}

.btn-outline-dark {
  --cui-btn-color: #212631;
  --cui-btn-border-color: #212631;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: #212631;
  --cui-btn-hover-border-color: #212631;
  --cui-btn-focus-shadow-rgb: 33, 38, 49;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: #212631;
  --cui-btn-active-border-color: #212631;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #212631;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: #212631;
  --cui-gradient: none;
}

.btn-ghost-primary {
  --cui-btn-color: #5856d6;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: #5856d6;
  --cui-btn-hover-border-color: #5856d6;
  --cui-btn-hover-color: #fff;
  --cui-btn-active-bg: #5856d6;
  --cui-btn-active-border-color: #5856d6;
  --cui-btn-active-color: #fff;
  --cui-btn-disabled-color: #5856d6;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

.btn-ghost-secondary {
  --cui-btn-color: #6b7785;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: #6b7785;
  --cui-btn-hover-border-color: #6b7785;
  --cui-btn-hover-color: #fff;
  --cui-btn-active-bg: #6b7785;
  --cui-btn-active-border-color: #6b7785;
  --cui-btn-active-color: #fff;
  --cui-btn-disabled-color: #6b7785;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

.btn-ghost-success {
  --cui-btn-color: #1b9e3e;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: #1b9e3e;
  --cui-btn-hover-border-color: #1b9e3e;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-active-bg: #1b9e3e;
  --cui-btn-active-border-color: #1b9e3e;
  --cui-btn-active-color: #080a0c;
  --cui-btn-disabled-color: #1b9e3e;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

.btn-ghost-info {
  --cui-btn-color: #39f;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: #39f;
  --cui-btn-hover-border-color: #39f;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-active-bg: #39f;
  --cui-btn-active-border-color: #39f;
  --cui-btn-active-color: #080a0c;
  --cui-btn-disabled-color: #39f;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

.btn-ghost-warning {
  --cui-btn-color: #f9b115;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: #f9b115;
  --cui-btn-hover-border-color: #f9b115;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-active-bg: #f9b115;
  --cui-btn-active-border-color: #f9b115;
  --cui-btn-active-color: #080a0c;
  --cui-btn-disabled-color: #f9b115;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

.btn-ghost-danger {
  --cui-btn-color: #e55353;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: #e55353;
  --cui-btn-hover-border-color: #e55353;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-active-bg: #e55353;
  --cui-btn-active-border-color: #e55353;
  --cui-btn-active-color: #080a0c;
  --cui-btn-disabled-color: #e55353;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

.btn-ghost-light {
  --cui-btn-color: #f3f4f7;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: #f3f4f7;
  --cui-btn-hover-border-color: #f3f4f7;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-active-bg: #f3f4f7;
  --cui-btn-active-border-color: #f3f4f7;
  --cui-btn-active-color: #080a0c;
  --cui-btn-disabled-color: #f3f4f7;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

.btn-ghost-dark {
  --cui-btn-color: #212631;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: #212631;
  --cui-btn-hover-border-color: #212631;
  --cui-btn-hover-color: #fff;
  --cui-btn-active-bg: #212631;
  --cui-btn-active-border-color: #212631;
  --cui-btn-active-color: #fff;
  --cui-btn-disabled-color: #212631;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

.btn-link {
  --cui-btn-font-weight: 400;
  --cui-btn-color: var(--cui-link-color);
  --cui-btn-bg: transparent;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-color: var(--cui-link-hover-color);
  --cui-btn-hover-border-color: transparent;
  --cui-btn-active-border-color: transparent;
  --cui-btn-disabled-color: #6d7d9c;
  --cui-btn-disabled-border-color: transparent;
  --cui-btn-box-shadow: none;
  --cui-btn-focus-shadow-rgb: 113.05, 111.35, 220.15;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--cui-btn-color);
}

.btn-lg, .btn-group-lg > .btn {
  --cui-btn-padding-y: 0.5rem;
  --cui-btn-padding-x: 1rem;
  --cui-btn-font-size: 1.25rem;
  --cui-btn-border-radius: var(--cui-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --cui-btn-padding-y: 0.25rem;
  --cui-btn-padding-x: 0.5rem;
  --cui-btn-font-size: 0.875rem;
  --cui-btn-border-radius: var(--cui-border-radius-sm);
}

[data-coreui-theme=dark] .btn-primary {
  --cui-btn-color: #fff;
  --cui-btn-bg: rgb(94.2, 92.4, 207.6);
  --cui-btn-border-color: rgb(94.2, 92.4, 207.6);
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: rgb(80.07, 78.54, 176.46);
  --cui-btn-hover-border-color: rgb(75.36, 73.92, 166.08);
  --cui-btn-focus-shadow-rgb: 118.32, 116.79, 214.71;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: rgb(75.36, 73.92, 166.08);
  --cui-btn-active-border-color: rgb(70.65, 69.3, 155.7);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #fff;
  --cui-btn-disabled-bg: rgb(94.2, 92.4, 207.6);
  --cui-btn-disabled-border-color: rgb(94.2, 92.4, 207.6);
}
[data-coreui-theme=dark] .btn-secondary {
  --cui-btn-color: #fff;
  --cui-btn-bg: #6b7785;
  --cui-btn-border-color: #6b7785;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: rgb(90.95, 101.15, 113.05);
  --cui-btn-hover-border-color: rgb(85.6, 95.2, 106.4);
  --cui-btn-focus-shadow-rgb: 129.2, 139.4, 151.3;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: rgb(85.6, 95.2, 106.4);
  --cui-btn-active-border-color: rgb(80.25, 89.25, 99.75);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #fff;
  --cui-btn-disabled-bg: #6b7785;
  --cui-btn-disabled-border-color: #6b7785;
}
[data-coreui-theme=dark] .btn-success {
  --cui-btn-color: #080a0c;
  --cui-btn-bg: rgb(33.55, 151.45, 65.05);
  --cui-btn-border-color: rgb(33.55, 151.45, 65.05);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(66.7675, 166.9825, 93.5425);
  --cui-btn-hover-border-color: rgb(55.695, 161.805, 84.045);
  --cui-btn-focus-shadow-rgb: 29.7175, 130.2325, 57.0925;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(77.84, 172.16, 103.04);
  --cui-btn-active-border-color: rgb(55.695, 161.805, 84.045);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #080a0c;
  --cui-btn-disabled-bg: rgb(33.55, 151.45, 65.05);
  --cui-btn-disabled-border-color: rgb(33.55, 151.45, 65.05);
}
[data-coreui-theme=dark] .btn-info {
  --cui-btn-color: #080a0c;
  --cui-btn-bg: rgb(61.2, 153, 244.8);
  --cui-btn-border-color: rgb(61.2, 153, 244.8);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(90.27, 168.3, 246.33);
  --cui-btn-hover-border-color: rgb(80.58, 163.2, 245.82);
  --cui-btn-focus-shadow-rgb: 53.22, 131.55, 209.88;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(99.96, 173.4, 246.84);
  --cui-btn-active-border-color: rgb(80.58, 163.2, 245.82);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #080a0c;
  --cui-btn-disabled-bg: rgb(61.2, 153, 244.8);
  --cui-btn-disabled-border-color: rgb(61.2, 153, 244.8);
}
[data-coreui-theme=dark] .btn-warning {
  --cui-btn-color: #080a0c;
  --cui-btn-bg: rgb(237.6, 172.8, 32.4);
  --cui-btn-border-color: rgb(237.6, 172.8, 32.4);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(240.21, 185.13, 65.79);
  --cui-btn-hover-border-color: rgb(239.34, 181.02, 54.66);
  --cui-btn-focus-shadow-rgb: 203.16, 148.38, 29.34;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(241.08, 189.24, 76.92);
  --cui-btn-active-border-color: rgb(239.34, 181.02, 54.66);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #080a0c;
  --cui-btn-disabled-bg: rgb(237.6, 172.8, 32.4);
  --cui-btn-disabled-border-color: rgb(237.6, 172.8, 32.4);
}
[data-coreui-theme=dark] .btn-danger {
  --cui-btn-color: #080a0c;
  --cui-btn-bg: rgb(221.7, 90.3, 90.3);
  --cui-btn-border-color: rgb(221.7, 90.3, 90.3);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(226.695, 115.005, 115.005);
  --cui-btn-hover-border-color: rgb(225.03, 106.77, 106.77);
  --cui-btn-focus-shadow-rgb: 189.645, 78.255, 78.555;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(228.36, 123.24, 123.24);
  --cui-btn-active-border-color: rgb(225.03, 106.77, 106.77);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #080a0c;
  --cui-btn-disabled-bg: rgb(221.7, 90.3, 90.3);
  --cui-btn-disabled-border-color: rgb(221.7, 90.3, 90.3);
}
[data-coreui-theme=dark] .btn-light {
  --cui-btn-color: #080a0c;
  --cui-btn-bg: #f3f4f7;
  --cui-btn-border-color: #f3f4f7;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(244.8, 245.65, 248.2);
  --cui-btn-hover-border-color: rgb(244.2, 245.1, 247.8);
  --cui-btn-focus-shadow-rgb: 207.75, 208.9, 211.75;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(245.4, 246.2, 248.6);
  --cui-btn-active-border-color: rgb(244.2, 245.1, 247.8);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #080a0c;
  --cui-btn-disabled-bg: #f3f4f7;
  --cui-btn-disabled-border-color: #f3f4f7;
}
[data-coreui-theme=dark] .btn-dark {
  --cui-btn-color: #fff;
  --cui-btn-bg: #212631;
  --cui-btn-border-color: #212631;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: rgb(28.05, 32.3, 41.65);
  --cui-btn-hover-border-color: rgb(26.4, 30.4, 39.2);
  --cui-btn-focus-shadow-rgb: 66.3, 70.55, 79.9;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: rgb(26.4, 30.4, 39.2);
  --cui-btn-active-border-color: rgb(24.75, 28.5, 36.75);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #fff;
  --cui-btn-disabled-bg: #212631;
  --cui-btn-disabled-border-color: #212631;
}
[data-coreui-theme=dark] .btn-outline-primary {
  --cui-btn-color: rgb(94.2, 92.4, 207.6);
  --cui-btn-border-color: rgb(94.2, 92.4, 207.6);
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: rgb(94.2, 92.4, 207.6);
  --cui-btn-hover-border-color: rgb(94.2, 92.4, 207.6);
  --cui-btn-focus-shadow-rgb: 94.2, 92.4, 207.6;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: rgb(94.2, 92.4, 207.6);
  --cui-btn-active-border-color: rgb(94.2, 92.4, 207.6);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: rgb(94.2, 92.4, 207.6);
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: rgb(94.2, 92.4, 207.6);
  --cui-gradient: none;
}
[data-coreui-theme=dark] .btn-outline-secondary {
  --cui-btn-color: #6b7785;
  --cui-btn-border-color: #6b7785;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: #6b7785;
  --cui-btn-hover-border-color: #6b7785;
  --cui-btn-focus-shadow-rgb: 107, 119, 133;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: #6b7785;
  --cui-btn-active-border-color: #6b7785;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #6b7785;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: #6b7785;
  --cui-gradient: none;
}
[data-coreui-theme=dark] .btn-outline-success {
  --cui-btn-color: rgb(33.55, 151.45, 65.05);
  --cui-btn-border-color: rgb(33.55, 151.45, 65.05);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(33.55, 151.45, 65.05);
  --cui-btn-hover-border-color: rgb(33.55, 151.45, 65.05);
  --cui-btn-focus-shadow-rgb: 33.55, 151.45, 65.05;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(33.55, 151.45, 65.05);
  --cui-btn-active-border-color: rgb(33.55, 151.45, 65.05);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: rgb(33.55, 151.45, 65.05);
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: rgb(33.55, 151.45, 65.05);
  --cui-gradient: none;
}
[data-coreui-theme=dark] .btn-outline-info {
  --cui-btn-color: rgb(61.2, 153, 244.8);
  --cui-btn-border-color: rgb(61.2, 153, 244.8);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(61.2, 153, 244.8);
  --cui-btn-hover-border-color: rgb(61.2, 153, 244.8);
  --cui-btn-focus-shadow-rgb: 61.2, 153, 244.8;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(61.2, 153, 244.8);
  --cui-btn-active-border-color: rgb(61.2, 153, 244.8);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: rgb(61.2, 153, 244.8);
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: rgb(61.2, 153, 244.8);
  --cui-gradient: none;
}
[data-coreui-theme=dark] .btn-outline-warning {
  --cui-btn-color: rgb(237.6, 172.8, 32.4);
  --cui-btn-border-color: rgb(237.6, 172.8, 32.4);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(237.6, 172.8, 32.4);
  --cui-btn-hover-border-color: rgb(237.6, 172.8, 32.4);
  --cui-btn-focus-shadow-rgb: 237.6, 172.8, 32.4;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(237.6, 172.8, 32.4);
  --cui-btn-active-border-color: rgb(237.6, 172.8, 32.4);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: rgb(237.6, 172.8, 32.4);
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: rgb(237.6, 172.8, 32.4);
  --cui-gradient: none;
}
[data-coreui-theme=dark] .btn-outline-danger {
  --cui-btn-color: rgb(221.7, 90.3, 90.3);
  --cui-btn-border-color: rgb(221.7, 90.3, 90.3);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(221.7, 90.3, 90.3);
  --cui-btn-hover-border-color: rgb(221.7, 90.3, 90.3);
  --cui-btn-focus-shadow-rgb: 221.7, 90.3, 90.3;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(221.7, 90.3, 90.3);
  --cui-btn-active-border-color: rgb(221.7, 90.3, 90.3);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: rgb(221.7, 90.3, 90.3);
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: rgb(221.7, 90.3, 90.3);
  --cui-gradient: none;
}
[data-coreui-theme=dark] .btn-outline-light {
  --cui-btn-color: #f3f4f7;
  --cui-btn-border-color: #f3f4f7;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: #f3f4f7;
  --cui-btn-hover-border-color: #f3f4f7;
  --cui-btn-focus-shadow-rgb: 243, 244, 247;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: #f3f4f7;
  --cui-btn-active-border-color: #f3f4f7;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #f3f4f7;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: #f3f4f7;
  --cui-gradient: none;
}
[data-coreui-theme=dark] .btn-outline-dark {
  --cui-btn-color: #212631;
  --cui-btn-border-color: #212631;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: #212631;
  --cui-btn-hover-border-color: #212631;
  --cui-btn-focus-shadow-rgb: 33, 38, 49;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: #212631;
  --cui-btn-active-border-color: #212631;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #212631;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: #212631;
  --cui-gradient: none;
}
[data-coreui-theme=dark] .btn-ghost-primary {
  --cui-btn-color: rgb(94.2, 92.4, 207.6);
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: rgb(94.2, 92.4, 207.6);
  --cui-btn-hover-border-color: rgb(94.2, 92.4, 207.6);
  --cui-btn-hover-color: #fff;
  --cui-btn-active-bg: rgb(94.2, 92.4, 207.6);
  --cui-btn-active-border-color: rgb(94.2, 92.4, 207.6);
  --cui-btn-active-color: #fff;
  --cui-btn-disabled-color: rgb(94.2, 92.4, 207.6);
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}
[data-coreui-theme=dark] .btn-ghost-secondary {
  --cui-btn-color: #6b7785;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: #6b7785;
  --cui-btn-hover-border-color: #6b7785;
  --cui-btn-hover-color: #fff;
  --cui-btn-active-bg: #6b7785;
  --cui-btn-active-border-color: #6b7785;
  --cui-btn-active-color: #fff;
  --cui-btn-disabled-color: #6b7785;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}
[data-coreui-theme=dark] .btn-ghost-success {
  --cui-btn-color: rgb(33.55, 151.45, 65.05);
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: rgb(33.55, 151.45, 65.05);
  --cui-btn-hover-border-color: rgb(33.55, 151.45, 65.05);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-active-bg: rgb(33.55, 151.45, 65.05);
  --cui-btn-active-border-color: rgb(33.55, 151.45, 65.05);
  --cui-btn-active-color: #080a0c;
  --cui-btn-disabled-color: rgb(33.55, 151.45, 65.05);
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}
[data-coreui-theme=dark] .btn-ghost-info {
  --cui-btn-color: rgb(61.2, 153, 244.8);
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: rgb(61.2, 153, 244.8);
  --cui-btn-hover-border-color: rgb(61.2, 153, 244.8);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-active-bg: rgb(61.2, 153, 244.8);
  --cui-btn-active-border-color: rgb(61.2, 153, 244.8);
  --cui-btn-active-color: #080a0c;
  --cui-btn-disabled-color: rgb(61.2, 153, 244.8);
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}
[data-coreui-theme=dark] .btn-ghost-warning {
  --cui-btn-color: rgb(237.6, 172.8, 32.4);
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: rgb(237.6, 172.8, 32.4);
  --cui-btn-hover-border-color: rgb(237.6, 172.8, 32.4);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-active-bg: rgb(237.6, 172.8, 32.4);
  --cui-btn-active-border-color: rgb(237.6, 172.8, 32.4);
  --cui-btn-active-color: #080a0c;
  --cui-btn-disabled-color: rgb(237.6, 172.8, 32.4);
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}
[data-coreui-theme=dark] .btn-ghost-danger {
  --cui-btn-color: rgb(221.7, 90.3, 90.3);
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: rgb(221.7, 90.3, 90.3);
  --cui-btn-hover-border-color: rgb(221.7, 90.3, 90.3);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-active-bg: rgb(221.7, 90.3, 90.3);
  --cui-btn-active-border-color: rgb(221.7, 90.3, 90.3);
  --cui-btn-active-color: #080a0c;
  --cui-btn-disabled-color: rgb(221.7, 90.3, 90.3);
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}
[data-coreui-theme=dark] .btn-ghost-light {
  --cui-btn-color: #f3f4f7;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: #f3f4f7;
  --cui-btn-hover-border-color: #f3f4f7;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-active-bg: #f3f4f7;
  --cui-btn-active-border-color: #f3f4f7;
  --cui-btn-active-color: #080a0c;
  --cui-btn-disabled-color: #f3f4f7;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}
[data-coreui-theme=dark] .btn-ghost-dark {
  --cui-btn-color: #212631;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: #212631;
  --cui-btn-hover-border-color: #212631;
  --cui-btn-hover-color: #fff;
  --cui-btn-active-bg: #212631;
  --cui-btn-active-border-color: #212631;
  --cui-btn-active-color: #fff;
  --cui-btn-disabled-color: #212631;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-inline-start: 0;
}

.dropdown-menu {
  --cui-dropdown-zindex: 1000;
  --cui-dropdown-min-width: 10rem;
  --cui-dropdown-padding-x: 0;
  --cui-dropdown-padding-y: 0.5rem;
  --cui-dropdown-spacer: 0.125rem;
  --cui-dropdown-font-size: 1rem;
  --cui-dropdown-color: var(--cui-body-color);
  --cui-dropdown-bg: var(--cui-body-bg);
  --cui-dropdown-border-color: var(--cui-border-color-translucent);
  --cui-dropdown-border-radius: var(--cui-border-radius);
  --cui-dropdown-border-width: var(--cui-border-width);
  --cui-dropdown-inner-border-radius: calc(var(--cui-border-radius) - var(--cui-border-width));
  --cui-dropdown-divider-bg: var(--cui-border-color-translucent);
  --cui-dropdown-divider-margin-y: 0.5rem;
  --cui-dropdown-box-shadow: var(--cui-box-shadow);
  --cui-dropdown-link-color: var(--cui-body-color);
  --cui-dropdown-link-hover-color: var(--cui-body-color);
  --cui-dropdown-link-hover-bg: var(--cui-tertiary-bg);
  --cui-dropdown-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-dropdown-link-active-bg: var(--cui-primary);
  --cui-dropdown-link-disabled-color: var(--cui-tertiary-color);
  --cui-dropdown-item-padding-x: 1rem;
  --cui-dropdown-item-padding-y: 0.25rem;
  --cui-dropdown-header-color: #6d7d9c;
  --cui-dropdown-header-padding-x: 1rem;
  --cui-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--cui-dropdown-zindex);
  display: none;
  min-width: var(--cui-dropdown-min-width);
  padding: var(--cui-dropdown-padding-y) var(--cui-dropdown-padding-x);
  margin: 0;
  font-size: var(--cui-dropdown-font-size);
  color: var(--cui-dropdown-color);
  text-align: start;
  list-style: none;
  background-color: var(--cui-dropdown-bg);
  background-clip: padding-box;
  border: var(--cui-dropdown-border-width) solid var(--cui-dropdown-border-color);
  border-radius: var(--cui-dropdown-border-radius);
}
.dropdown-menu[data-coreui-popper] {
  inset-inline-start: 0;
  top: 100%;
  margin-top: var(--cui-dropdown-spacer);
}

.dropdown-menu-start {
  --cui-position: start;
}
.dropdown-menu-start[data-coreui-popper] {
  inset-inline-start: 0;
  inset-inline-end: auto;
}

.dropdown-menu-end {
  --cui-position: end;
}
.dropdown-menu-end[data-coreui-popper] {
  inset-inline-start: auto;
  inset-inline-end: 0;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --cui-position: start;
  }
  .dropdown-menu-sm-start[data-coreui-popper] {
    inset-inline-start: 0;
    inset-inline-end: auto;
  }
  .dropdown-menu-sm-end {
    --cui-position: end;
  }
  .dropdown-menu-sm-end[data-coreui-popper] {
    inset-inline-start: auto;
    inset-inline-end: 0;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --cui-position: start;
  }
  .dropdown-menu-md-start[data-coreui-popper] {
    inset-inline-start: 0;
    inset-inline-end: auto;
  }
  .dropdown-menu-md-end {
    --cui-position: end;
  }
  .dropdown-menu-md-end[data-coreui-popper] {
    inset-inline-start: auto;
    inset-inline-end: 0;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --cui-position: start;
  }
  .dropdown-menu-lg-start[data-coreui-popper] {
    inset-inline-start: 0;
    inset-inline-end: auto;
  }
  .dropdown-menu-lg-end {
    --cui-position: end;
  }
  .dropdown-menu-lg-end[data-coreui-popper] {
    inset-inline-start: auto;
    inset-inline-end: 0;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --cui-position: start;
  }
  .dropdown-menu-xl-start[data-coreui-popper] {
    inset-inline-start: 0;
    inset-inline-end: auto;
  }
  .dropdown-menu-xl-end {
    --cui-position: end;
  }
  .dropdown-menu-xl-end[data-coreui-popper] {
    inset-inline-start: auto;
    inset-inline-end: 0;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --cui-position: start;
  }
  .dropdown-menu-xxl-start[data-coreui-popper] {
    inset-inline-start: 0;
    inset-inline-end: auto;
  }
  .dropdown-menu-xxl-end {
    --cui-position: end;
  }
  .dropdown-menu-xxl-end[data-coreui-popper] {
    inset-inline-start: auto;
    inset-inline-end: 0;
  }
}
.dropup .dropdown-menu[data-coreui-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--cui-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-inline-start: 0;
}

.dropend .dropdown-menu[data-coreui-popper] {
  inset-inline-start: 100%;
  inset-inline-end: auto;
  top: 0;
  margin-inline-start: var(--cui-dropdown-spacer);
  margin-top: 0;
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-inline-start: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-coreui-popper] {
  inset-inline-start: auto;
  inset-inline-end: 100%;
  top: 0;
  margin-inline-end: var(--cui-dropdown-spacer);
  margin-top: 0;
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-inline-end: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-inline-start: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--cui-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--cui-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--cui-dropdown-item-padding-y) var(--cui-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--cui-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--cui-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--cui-dropdown-link-hover-color);
  background-color: var(--cui-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--cui-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--cui-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--cui-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--cui-dropdown-header-padding-y) var(--cui-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--cui-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--cui-dropdown-item-padding-y) var(--cui-dropdown-item-padding-x);
  color: var(--cui-dropdown-link-color);
}

.dropdown-menu-dark {
  --cui-dropdown-color: #dbdfe6;
  --cui-dropdown-bg: #323a49;
  --cui-dropdown-border-color: var(--cui-border-color-translucent);
  --cui-dropdown-box-shadow: ;
  --cui-dropdown-link-color: #dbdfe6;
  --cui-dropdown-link-hover-color: #fff;
  --cui-dropdown-divider-bg: var(--cui-border-color-translucent);
  --cui-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --cui-dropdown-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-dropdown-link-active-bg: var(--cui-primary);
  --cui-dropdown-link-disabled-color: #aab3c5;
  --cui-dropdown-header-color: #aab3c5;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--cui-border-radius);
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-inline-start: calc(-1 * var(--cui-border-width));
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-start-end-radius: 0;
  border-end-end-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-start-start-radius: 0;
  border-end-start-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-inline-start: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-inline-end: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(-1 * var(--cui-border-width));
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:nth-child(n+3),
.btn-group-vertical > :not(.btn-check) + .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --cui-nav-link-padding-x: 1rem;
  --cui-nav-link-padding-y: 0.5rem;
  --cui-nav-link-font-weight: ;
  --cui-nav-link-color: var(--cui-link-color);
  --cui-nav-link-hover-color: var(--cui-link-hover-color);
  --cui-nav-link-disabled-color: var(--cui-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-inline-start: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--cui-nav-link-padding-y) var(--cui-nav-link-padding-x);
  font-size: var(--cui-nav-link-font-size);
  font-weight: var(--cui-nav-link-font-weight);
  color: var(--cui-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--cui-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(88, 86, 214, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--cui-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --cui-nav-tabs-border-width: var(--cui-border-width);
  --cui-nav-tabs-border-color: var(--cui-border-color);
  --cui-nav-tabs-border-radius: var(--cui-border-radius);
  --cui-nav-tabs-link-hover-border-color: var(--cui-secondary-bg) var(--cui-secondary-bg) var(--cui-border-color);
  --cui-nav-tabs-link-active-color: var(--cui-emphasis-color);
  --cui-nav-tabs-link-active-bg: var(--cui-body-bg);
  --cui-nav-tabs-link-active-border-color: var(--cui-border-color) var(--cui-border-color) var(--cui-body-bg);
  border-bottom: var(--cui-nav-tabs-border-width) solid var(--cui-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--cui-nav-tabs-border-width));
  border: var(--cui-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--cui-nav-tabs-border-radius);
  border-top-right-radius: var(--cui-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--cui-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--cui-nav-tabs-link-active-color);
  background-color: var(--cui-nav-tabs-link-active-bg);
  border-color: var(--cui-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--cui-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --cui-nav-pills-border-radius: var(--cui-border-radius);
  --cui-nav-pills-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-nav-pills-link-active-bg: var(--cui-primary);
}
.nav-pills .nav-link {
  border-radius: var(--cui-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--cui-nav-pills-link-active-color);
  background-color: var(--cui-nav-pills-link-active-bg);
}

.nav-underline {
  --cui-nav-underline-gap: 1rem;
  --cui-nav-underline-border-width: 0.125rem;
  --cui-nav-underline-link-active-color: var(--cui-emphasis-color);
  gap: var(--cui-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--cui-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--cui-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-underline-border {
  --cui-nav-underline-border-gap: 0.5rem;
  --cui-nav-underline-border-border-color: var(--cui-border-color);
  --cui-nav-underline-border-border-width: 0.125rem;
  --cui-nav-underline-border-link-padding-x: 0.5rem;
  --cui-nav-underline-border-link-padding-y: 0.5rem;
  --cui-nav-underline-border-link-color: var(--cui-secondary-color);
  --cui-nav-underline-border-link-active-color: var(--cui-primary);
  --cui-nav-underline-border-link-disabled-color: var(--cui-tertiary-color);
  --cui-nav-link-color: var(--cui-nav-underline-border-link-color);
  --cui-nav-link-disabled-color: var(--cui-nav-underline-border-link-disabled-color);
  gap: var(--cui-nav-underline-border-gap);
  border-bottom: var(--cui-nav-underline-border-border-width) solid var(--cui-nav-underline-border-border-color);
}
.nav-underline-border .nav-link {
  padding: var(--cui-nav-underline-border-link-padding-y) var(--cui-nav-underline-border-link-padding-x);
  margin-bottom: calc(-1 * var(--cui-nav-underline-border-border-width));
  border-bottom: var(--cui-nav-underline-border-border-width) solid transparent;
}
.nav-underline-border .nav-link:hover, .nav-underline-border .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline-border .nav-link.active,
.nav-underline-border .show > .nav-link {
  font-weight: 700;
  color: var(--cui-nav-underline-border-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-enclosed {
  --cui-nav-enclosed-padding: 0.125rem;
  --cui-nav-enclosed-bg: var(--cui-tertiary-bg);
  --cui-nav-enclosed-border-radius: 0.5rem;
  --cui-nav-enclosed-link-padding-x: 0.875rem;
  --cui-nav-enclosed-link-padding-y: 0.375rem;
  --cui-nav-enclosed-link-color: var(--cui-body-color);
  --cui-nav-enclosed-link-border-width: 1px;
  --cui-nav-enclosed-link-active-color: var(--cui-body-color);
  --cui-nav-enclosed-link-active-bg: var(--cui-body-bg);
  --cui-nav-enclosed-link-active-border-color: var(--cui-border-color);
  --cui-nav-enclosed-link-hover-box-shadow: var(--cui-box-shadow-sm);
  --cui-nav-enclosed-link-disabled-color: var(--cui-secondary-color);
  display: inline-flex;
  padding: var(--cui-nav-enclosed-padding);
  background-color: var(--cui-nav-enclosed-bg);
  border-radius: var(--cui-nav-enclosed-border-radius);
}
.nav-enclosed .nav-link {
  padding: calc(var(--cui-nav-enclosed-link-padding-y) - var(--cui-nav-enclosed-link-border-width)) calc(var(--cui-nav-enclosed-link-padding-x) - var(--cui-nav-enclosed-link-border-width));
  color: var(--cui-nav-enclosed-link-color);
  border: var(--cui-nav-enclosed-link-border-width) solid transparent;
  border-radius: calc(var(--cui-nav-enclosed-border-radius) - var(--cui-nav-enclosed-padding));
}
.nav-enclosed .nav-link.disabled {
  color: var(--cui-nav-enclosed-link-disabled-color);
}
.nav-enclosed .nav-link.active,
.nav-enclosed .show > .nav-link {
  color: var(--cui-nav-enclosed-link-active-color);
  background-color: var(--cui-nav-enclosed-link-active-bg);
  border: 1px solid var(--cui-nav-enclosed-link-active-border-color);
}
.nav-enclosed .nav-link.active:not(:focus-visible),
.nav-enclosed .show > .nav-link:not(:focus-visible) {
  box-shadow: var(--cui-nav-enclosed-link-hover-box-shadow);
}

.nav-enclosed-pills {
  --cui-nav-enclosed-border-radius: 50rem;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-grow: 1;
  flex-basis: 0;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --cui-navbar-padding-x: 0;
  --cui-navbar-padding-y: 0.5rem;
  --cui-navbar-color: rgba(var(--cui-emphasis-color-rgb), 0.65);
  --cui-navbar-hover-color: rgba(var(--cui-emphasis-color-rgb), 0.8);
  --cui-navbar-disabled-color: rgba(var(--cui-emphasis-color-rgb), 0.3);
  --cui-navbar-active-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-navbar-brand-padding-y: 0.3125rem;
  --cui-navbar-brand-margin-end: 1rem;
  --cui-navbar-brand-font-size: 1.25rem;
  --cui-navbar-brand-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-navbar-brand-hover-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-navbar-nav-link-padding-x: 0.5rem;
  --cui-navbar-toggler-padding-y: 0.25rem;
  --cui-navbar-toggler-padding-x: 0.75rem;
  --cui-navbar-toggler-font-size: 1.25rem;
  --cui-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --cui-navbar-toggler-border-color: rgba(var(--cui-emphasis-color-rgb), 0.15);
  --cui-navbar-toggler-border-radius: var(--cui-border-radius);
  --cui-navbar-toggler-focus-width: 0.25rem;
  --cui-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-navbar-padding-y) var(--cui-navbar-padding-x);
}
.navbar > .container-xxl, .navbar > .container-xl, .navbar > .container-lg, .navbar > .container-md, .navbar > .container-sm, .navbar > .container,
.navbar > .container-fluid {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--cui-navbar-brand-padding-y);
  padding-bottom: var(--cui-navbar-brand-padding-y);
  margin-inline-end: var(--cui-navbar-brand-margin-end);
  font-size: var(--cui-navbar-brand-font-size);
  color: var(--cui-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--cui-navbar-brand-hover-color);
}

.navbar-nav {
  --cui-nav-link-padding-x: 0;
  --cui-nav-link-padding-y: 0.5rem;
  --cui-nav-link-font-weight: ;
  --cui-nav-link-color: var(--cui-navbar-color);
  --cui-nav-link-hover-color: var(--cui-navbar-hover-color);
  --cui-nav-link-disabled-color: var(--cui-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-inline-start: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--cui-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--cui-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--cui-navbar-active-color);
}

.navbar-collapse {
  flex-grow: 1;
  flex-basis: 100%;
  align-items: center;
}

.navbar-toggler {
  padding: var(--cui-navbar-toggler-padding-y) var(--cui-navbar-toggler-padding-x);
  font-size: var(--cui-navbar-toggler-font-size);
  line-height: 1;
  color: var(--cui-navbar-color);
  background-color: transparent;
  border: var(--cui-border-width) solid var(--cui-navbar-toggler-border-color);
  border-radius: var(--cui-navbar-toggler-border-radius);
  transition: var(--cui-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--cui-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--cui-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--cui-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--cui-navbar-nav-link-padding-x);
  padding-left: var(--cui-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-coreui-theme=dark] {
  --cui-navbar-color: rgba(255, 255, 255, 0.55);
  --cui-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --cui-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --cui-navbar-active-color: #fff;
  --cui-navbar-brand-color: #fff;
  --cui-navbar-brand-hover-color: #fff;
  --cui-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --cui-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

[data-coreui-theme=dark] .navbar-toggler-icon {
  --cui-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.card {
  --cui-card-spacer-y: 1rem;
  --cui-card-spacer-x: 1rem;
  --cui-card-title-spacer-y: 0.5rem;
  --cui-card-title-color: ;
  --cui-card-subtitle-color: ;
  --cui-card-border-width: var(--cui-border-width);
  --cui-card-border-color: var(--cui-border-color-translucent);
  --cui-card-border-radius: var(--cui-border-radius);
  --cui-card-box-shadow: ;
  --cui-card-inner-border-radius: calc(var(--cui-border-radius) - (var(--cui-border-width)));
  --cui-card-cap-padding-y: 0.5rem;
  --cui-card-cap-padding-x: 1rem;
  --cui-card-cap-bg: rgba(var(--cui-body-color-rgb), 0.03);
  --cui-card-cap-color: ;
  --cui-card-height: ;
  --cui-card-color: ;
  --cui-card-bg: var(--cui-body-bg);
  --cui-card-img-overlay-padding: 1rem;
  --cui-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--cui-card-height);
  color: var(--cui-body-color);
  word-wrap: break-word;
  background-color: var(--cui-card-bg);
  background-clip: border-box;
  border: var(--cui-card-border-width) solid var(--cui-card-border-color);
  border-radius: var(--cui-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--cui-card-inner-border-radius);
  border-top-right-radius: var(--cui-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--cui-card-inner-border-radius);
  border-bottom-left-radius: var(--cui-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--cui-card-spacer-y) var(--cui-card-spacer-x);
  color: var(--cui-card-color);
}

.card-title {
  margin-bottom: var(--cui-card-title-spacer-y);
  color: var(--cui-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--cui-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--cui-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-inline-start: var(--cui-card-spacer-x);
}

.card-header {
  padding: var(--cui-card-cap-padding-y) var(--cui-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--cui-card-cap-color);
  background-color: var(--cui-card-cap-bg);
  border-bottom: var(--cui-card-border-width) solid var(--cui-card-border-color);
}
.card-header:first-child {
  border-radius: var(--cui-card-inner-border-radius) var(--cui-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--cui-card-cap-padding-y) var(--cui-card-cap-padding-x);
  color: var(--cui-card-cap-color);
  background-color: var(--cui-card-cap-bg);
  border-top: var(--cui-card-border-width) solid var(--cui-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--cui-card-inner-border-radius) var(--cui-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--cui-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--cui-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--cui-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--cui-card-bg);
  border-bottom-color: var(--cui-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--cui-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--cui-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--cui-card-img-overlay-padding);
  border-radius: var(--cui-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--cui-card-inner-border-radius);
  border-top-right-radius: var(--cui-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--cui-card-inner-border-radius);
  border-bottom-left-radius: var(--cui-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--cui-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-inline-start: 0;
    border-inline-start: 0;
  }
  .card-group > .card:not(:last-child) {
    border-start-end-radius: 0;
    border-end-end-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-top,
  .card-group > .card:not(:last-child) > .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-bottom,
  .card-group > .card:not(:last-child) > .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-start-start-radius: 0;
    border-end-start-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-top,
  .card-group > .card:not(:first-child) > .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-bottom,
  .card-group > .card:not(:first-child) > card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --cui-accordion-color: var(--cui-body-color);
  --cui-accordion-bg: var(--cui-body-bg);
  --cui-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --cui-accordion-border-color: var(--cui-border-color);
  --cui-accordion-border-width: var(--cui-border-width);
  --cui-accordion-border-radius: var(--cui-border-radius);
  --cui-accordion-inner-border-radius: calc(var(--cui-border-radius) - (var(--cui-border-width)));
  --cui-accordion-btn-padding-x: 1.25rem;
  --cui-accordion-btn-padding-y: 1rem;
  --cui-accordion-btn-color: var(--cui-body-color);
  --cui-accordion-btn-bg: var(--cui-accordion-bg);
  --cui-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --cui-accordion-btn-icon-width: 1.25rem;
  --cui-accordion-btn-icon-transform: rotate(-180deg);
  --cui-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --cui-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --cui-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(88, 86, 214, 0.25);
  --cui-accordion-body-padding-x: 1.25rem;
  --cui-accordion-body-padding-y: 1rem;
  --cui-accordion-active-color: var(--cui-primary-text-emphasis);
  --cui-accordion-active-bg: var(--cui-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--cui-accordion-btn-padding-y) var(--cui-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--cui-accordion-btn-color);
  text-align: start;
  background-color: var(--cui-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--cui-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--cui-accordion-active-color);
  background-color: var(--cui-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--cui-accordion-border-width)) 0 var(--cui-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--cui-accordion-btn-active-icon);
  transform: var(--cui-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--cui-accordion-btn-icon-width);
  height: var(--cui-accordion-btn-icon-width);
  margin-inline-start: auto;
  content: "";
  background-image: var(--cui-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--cui-accordion-btn-icon-width);
  transition: var(--cui-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--cui-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--cui-accordion-color);
  background-color: var(--cui-accordion-bg);
  border: var(--cui-accordion-border-width) solid var(--cui-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--cui-accordion-border-radius);
  border-top-right-radius: var(--cui-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--cui-accordion-inner-border-radius);
  border-top-right-radius: var(--cui-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--cui-accordion-border-radius);
  border-bottom-left-radius: var(--cui-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--cui-accordion-inner-border-radius);
  border-bottom-left-radius: var(--cui-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--cui-accordion-border-radius);
  border-bottom-left-radius: var(--cui-accordion-border-radius);
}

.accordion-body {
  padding: var(--cui-accordion-body-padding-y) var(--cui-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse,
.accordion-flush > .accordion-item > .accordion-header .accordion-button,
.accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}

[data-coreui-theme=dark] .accordion-button::after {
  --cui-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --cui-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

.breadcrumb {
  --cui-breadcrumb-padding-x: 0;
  --cui-breadcrumb-padding-y: 0;
  --cui-breadcrumb-margin-bottom: 1rem;
  --cui-breadcrumb-bg: ;
  --cui-breadcrumb-border-radius: ;
  --cui-breadcrumb-divider-color: var(--cui-secondary-color);
  --cui-breadcrumb-item-padding-x: 0.5rem;
  --cui-breadcrumb-item-active-color: var(--cui-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--cui-breadcrumb-padding-y) var(--cui-breadcrumb-padding-x);
  margin-bottom: var(--cui-breadcrumb-margin-bottom);
  font-size: var(--cui-breadcrumb-font-size);
  list-style: none;
  background-color: var(--cui-breadcrumb-bg);
  border-radius: var(--cui-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-inline-start: var(--cui-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: inline-start;
  padding-inline-end: var(--cui-breadcrumb-item-padding-x);
  color: var(--cui-breadcrumb-divider-color);
  content: var(--cui-breadcrumb-divider, "/");
}
.breadcrumb-item.active {
  color: var(--cui-breadcrumb-item-active-color);
}

.pagination {
  --cui-pagination-padding-x: 0.75rem;
  --cui-pagination-padding-y: 0.375rem;
  --cui-pagination-font-size: 1rem;
  --cui-pagination-color: var(--cui-link-color);
  --cui-pagination-bg: var(--cui-body-bg);
  --cui-pagination-border-width: var(--cui-border-width);
  --cui-pagination-border-color: var(--cui-border-color);
  --cui-pagination-border-radius: var(--cui-border-radius);
  --cui-pagination-hover-color: var(--cui-link-hover-color);
  --cui-pagination-hover-bg: var(--cui-tertiary-bg);
  --cui-pagination-hover-border-color: var(--cui-border-color);
  --cui-pagination-focus-color: var(--cui-link-hover-color);
  --cui-pagination-focus-bg: var(--cui-secondary-bg);
  --cui-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(88, 86, 214, 0.25);
  --cui-pagination-active-color: rgba(255, 255, 255, 0.87);
  --cui-pagination-active-bg: var(--cui-primary);
  --cui-pagination-active-border-color: var(--cui-primary);
  --cui-pagination-disabled-color: var(--cui-secondary-color);
  --cui-pagination-disabled-bg: var(--cui-secondary-bg);
  --cui-pagination-disabled-border-color: var(--cui-border-color);
  display: flex;
  padding-inline-start: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--cui-pagination-padding-y) var(--cui-pagination-padding-x);
  font-size: var(--cui-pagination-font-size);
  color: var(--cui-pagination-color);
  text-decoration: none;
  background-color: var(--cui-pagination-bg);
  border: var(--cui-pagination-border-width) solid var(--cui-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--cui-pagination-hover-color);
  background-color: var(--cui-pagination-hover-bg);
  border-color: var(--cui-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--cui-pagination-focus-color);
  background-color: var(--cui-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--cui-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--cui-pagination-active-color);
  background-color: var(--cui-pagination-active-bg);
  border-color: var(--cui-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--cui-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--cui-pagination-disabled-bg);
  border-color: var(--cui-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-inline-start: calc(-1 * var(--cui-border-width));
}
.page-item:first-child .page-link {
  border-start-start-radius: var(--cui-pagination-border-radius);
  border-end-start-radius: var(--cui-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-start-end-radius: var(--cui-pagination-border-radius);
  border-end-end-radius: var(--cui-pagination-border-radius);
}

.pagination-lg {
  --cui-pagination-padding-x: 1.5rem;
  --cui-pagination-padding-y: 0.75rem;
  --cui-pagination-font-size: 1.25rem;
  --cui-pagination-border-radius: var(--cui-border-radius-lg);
}

.pagination-sm {
  --cui-pagination-padding-x: 0.5rem;
  --cui-pagination-padding-y: 0.25rem;
  --cui-pagination-font-size: 0.875rem;
  --cui-pagination-border-radius: var(--cui-border-radius-sm);
}

.badge {
  --cui-badge-padding-x: 0.65em;
  --cui-badge-padding-y: 0.35em;
  --cui-badge-font-size: 0.75em;
  --cui-badge-font-weight: 700;
  --cui-badge-color: #fff;
  --cui-badge-border-radius: var(--cui-border-radius);
  display: inline-block;
  padding: var(--cui-badge-padding-y) var(--cui-badge-padding-x);
  font-size: var(--cui-badge-font-size);
  font-weight: var(--cui-badge-font-weight);
  line-height: 1;
  color: var(--cui-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--cui-badge-border-radius, 0);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-sm {
  --cui-badge-padding-x: 0.5em;
  --cui-badge-padding-y: 0.3em;
  font-size: 0.65em;
}

.alert {
  --cui-alert-bg: transparent;
  --cui-alert-padding-x: 1rem;
  --cui-alert-padding-y: 1rem;
  --cui-alert-margin-bottom: 1rem;
  --cui-alert-color: inherit;
  --cui-alert-border-color: transparent;
  --cui-alert-border: var(--cui-border-width) solid var(--cui-alert-border-color);
  --cui-alert-border-radius: var(--cui-border-radius);
  --cui-alert-link-color: inherit;
  position: relative;
  padding: var(--cui-alert-padding-y) var(--cui-alert-padding-x);
  margin-bottom: var(--cui-alert-margin-bottom);
  color: var(--cui-alert-color);
  background-color: var(--cui-alert-bg);
  border: var(--cui-alert-border);
  border-radius: var(--cui-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--cui-alert-link-color);
}

.alert-dismissible {
  padding-inline-end: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  inset-inline-end: 0;
  top: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --cui-alert-color: var(--cui-primary-text-emphasis);
  --cui-alert-bg: var(--cui-primary-bg-subtle);
  --cui-alert-border-color: var(--cui-primary-border-subtle);
  --cui-alert-link-color: var(--cui-primary-text-emphasis);
}

.alert-secondary {
  --cui-alert-color: var(--cui-secondary-text-emphasis);
  --cui-alert-bg: var(--cui-secondary-bg-subtle);
  --cui-alert-border-color: var(--cui-secondary-border-subtle);
  --cui-alert-link-color: var(--cui-secondary-text-emphasis);
}

.alert-success {
  --cui-alert-color: var(--cui-success-text-emphasis);
  --cui-alert-bg: var(--cui-success-bg-subtle);
  --cui-alert-border-color: var(--cui-success-border-subtle);
  --cui-alert-link-color: var(--cui-success-text-emphasis);
}

.alert-info {
  --cui-alert-color: var(--cui-info-text-emphasis);
  --cui-alert-bg: var(--cui-info-bg-subtle);
  --cui-alert-border-color: var(--cui-info-border-subtle);
  --cui-alert-link-color: var(--cui-info-text-emphasis);
}

.alert-warning {
  --cui-alert-color: var(--cui-warning-text-emphasis);
  --cui-alert-bg: var(--cui-warning-bg-subtle);
  --cui-alert-border-color: var(--cui-warning-border-subtle);
  --cui-alert-link-color: var(--cui-warning-text-emphasis);
}

.alert-danger {
  --cui-alert-color: var(--cui-danger-text-emphasis);
  --cui-alert-bg: var(--cui-danger-bg-subtle);
  --cui-alert-border-color: var(--cui-danger-border-subtle);
  --cui-alert-link-color: var(--cui-danger-text-emphasis);
}

.alert-light {
  --cui-alert-color: var(--cui-light-text-emphasis);
  --cui-alert-bg: var(--cui-light-bg-subtle);
  --cui-alert-border-color: var(--cui-light-border-subtle);
  --cui-alert-link-color: var(--cui-light-text-emphasis);
}

.alert-dark {
  --cui-alert-color: var(--cui-dark-text-emphasis);
  --cui-alert-bg: var(--cui-dark-bg-subtle);
  --cui-alert-border-color: var(--cui-dark-border-subtle);
  --cui-alert-link-color: var(--cui-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: var(--cui-progress-height);
  }
}
.progress,
.progress-stacked {
  --cui-progress-height: 1rem;
  --cui-progress-font-size: 0.75rem;
  --cui-progress-bg: var(--cui-secondary-bg);
  --cui-progress-border-radius: var(--cui-border-radius);
  --cui-progress-box-shadow: var(--cui-box-shadow-inset);
  --cui-progress-bar-color: #fff;
  --cui-progress-bar-bg: var(--cui-primary);
  --cui-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--cui-progress-height);
  overflow: hidden;
  font-size: var(--cui-progress-font-size);
  background-color: var(--cui-progress-bg);
  border-radius: var(--cui-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--cui-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--cui-progress-bar-bg);
  transition: var(--cui-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--cui-progress-height) var(--cui-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.progress-thin {
  height: 4px;
}

.progress.progress-white {
  background-color: rgba(255, 255, 255, 0.2);
}
.progress.progress-white .progress-bar {
  background-color: #fff;
}

.progress-group {
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 1rem;
}

.progress-group-prepend {
  flex: 0 0 100px;
  align-self: center;
}

.progress-group-header {
  display: flex;
  flex-basis: 100%;
  align-items: center;
  margin-bottom: 0.25rem;
}

.progress-group-bars {
  flex-grow: 1;
  align-self: center;
}
.progress-group-bars .progress:not(:last-child) {
  margin-bottom: 2px;
}

.progress-group-header + .progress-group-bars {
  flex-basis: 100%;
}

.list-group {
  --cui-list-group-color: var(--cui-body-color);
  --cui-list-group-bg: var(--cui-body-bg);
  --cui-list-group-border-color: var(--cui-border-color);
  --cui-list-group-border-width: var(--cui-border-width);
  --cui-list-group-border-radius: var(--cui-border-radius);
  --cui-list-group-item-padding-x: 1rem;
  --cui-list-group-item-padding-y: 0.5rem;
  --cui-list-group-action-color: var(--cui-secondary-color);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-tertiary-bg);
  --cui-list-group-action-active-color: var(--cui-body-color);
  --cui-list-group-action-active-bg: var(--cui-secondary-bg);
  --cui-list-group-disabled-color: var(--cui-secondary-color);
  --cui-list-group-disabled-bg: var(--cui-body-bg);
  --cui-list-group-active-color: rgba(255, 255, 255, 0.87);
  --cui-list-group-active-bg: var(--cui-primary);
  --cui-list-group-active-border-color: var(--cui-primary);
  display: flex;
  flex-direction: column;
  padding-inline-start: 0;
  margin-bottom: 0;
  border-radius: var(--cui-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--cui-list-group-item-padding-y) var(--cui-list-group-item-padding-x);
  color: var(--cui-list-group-color);
  text-decoration: none;
  background-color: var(--cui-list-group-bg);
  border: var(--cui-list-group-border-width) solid var(--cui-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--cui-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--cui-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--cui-list-group-active-color);
  background-color: var(--cui-list-group-active-bg);
  border-color: var(--cui-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--cui-list-group-border-width));
  border-top-width: var(--cui-list-group-border-width);
}

.list-group-item-action {
  width: 100%;
  color: var(--cui-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:not(.active):hover, .list-group-item-action:not(.active):focus {
  z-index: 1;
  color: var(--cui-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--cui-list-group-action-hover-bg);
}
.list-group-item-action:not(.active):active {
  color: var(--cui-list-group-action-active-color);
  background-color: var(--cui-list-group-action-active-bg);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-end-start-radius: var(--cui-list-group-border-radius);
  border-start-end-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-start-end-radius: var(--cui-list-group-border-radius);
  border-end-start-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-inline-start-width: 0;
  border-top-width: var(--cui-list-group-border-width);
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-inline-start: calc(-1 * var(--cui-list-group-border-width));
  border-inline-start-width: var(--cui-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-end-start-radius: var(--cui-list-group-border-radius);
    border-start-end-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-start-end-radius: var(--cui-list-group-border-radius);
    border-end-start-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-inline-start-width: 0;
    border-top-width: var(--cui-list-group-border-width);
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-inline-start: calc(-1 * var(--cui-list-group-border-width));
    border-inline-start-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-end-start-radius: var(--cui-list-group-border-radius);
    border-start-end-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-start-end-radius: var(--cui-list-group-border-radius);
    border-end-start-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-inline-start-width: 0;
    border-top-width: var(--cui-list-group-border-width);
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-inline-start: calc(-1 * var(--cui-list-group-border-width));
    border-inline-start-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-end-start-radius: var(--cui-list-group-border-radius);
    border-start-end-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-start-end-radius: var(--cui-list-group-border-radius);
    border-end-start-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-inline-start-width: 0;
    border-top-width: var(--cui-list-group-border-width);
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-inline-start: calc(-1 * var(--cui-list-group-border-width));
    border-inline-start-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-end-start-radius: var(--cui-list-group-border-radius);
    border-start-end-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-start-end-radius: var(--cui-list-group-border-radius);
    border-end-start-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-inline-start-width: 0;
    border-top-width: var(--cui-list-group-border-width);
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-inline-start: calc(-1 * var(--cui-list-group-border-width));
    border-inline-start-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-end-start-radius: var(--cui-list-group-border-radius);
    border-start-end-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-start-end-radius: var(--cui-list-group-border-radius);
    border-end-start-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-inline-start-width: 0;
    border-top-width: var(--cui-list-group-border-width);
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-inline-start: calc(-1 * var(--cui-list-group-border-width));
    border-inline-start-width: var(--cui-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--cui-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --cui-list-group-color: var(--cui-primary-text-emphasis);
  --cui-list-group-bg: var(--cui-primary-bg-subtle);
  --cui-list-group-border-color: var(--cui-primary-border-subtle);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-primary-border-subtle);
  --cui-list-group-action-active-color: var(--cui-emphasis-color);
  --cui-list-group-action-active-bg: var(--cui-primary-border-subtle);
  --cui-list-group-active-color: var(--cui-primary-bg-subtle);
  --cui-list-group-active-bg: var(--cui-primary-text-emphasis);
  --cui-list-group-active-border-color: var(--cui-primary-text-emphasis);
}

.list-group-item-secondary {
  --cui-list-group-color: var(--cui-secondary-text-emphasis);
  --cui-list-group-bg: var(--cui-secondary-bg-subtle);
  --cui-list-group-border-color: var(--cui-secondary-border-subtle);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-secondary-border-subtle);
  --cui-list-group-action-active-color: var(--cui-emphasis-color);
  --cui-list-group-action-active-bg: var(--cui-secondary-border-subtle);
  --cui-list-group-active-color: var(--cui-secondary-bg-subtle);
  --cui-list-group-active-bg: var(--cui-secondary-text-emphasis);
  --cui-list-group-active-border-color: var(--cui-secondary-text-emphasis);
}

.list-group-item-success {
  --cui-list-group-color: var(--cui-success-text-emphasis);
  --cui-list-group-bg: var(--cui-success-bg-subtle);
  --cui-list-group-border-color: var(--cui-success-border-subtle);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-success-border-subtle);
  --cui-list-group-action-active-color: var(--cui-emphasis-color);
  --cui-list-group-action-active-bg: var(--cui-success-border-subtle);
  --cui-list-group-active-color: var(--cui-success-bg-subtle);
  --cui-list-group-active-bg: var(--cui-success-text-emphasis);
  --cui-list-group-active-border-color: var(--cui-success-text-emphasis);
}

.list-group-item-info {
  --cui-list-group-color: var(--cui-info-text-emphasis);
  --cui-list-group-bg: var(--cui-info-bg-subtle);
  --cui-list-group-border-color: var(--cui-info-border-subtle);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-info-border-subtle);
  --cui-list-group-action-active-color: var(--cui-emphasis-color);
  --cui-list-group-action-active-bg: var(--cui-info-border-subtle);
  --cui-list-group-active-color: var(--cui-info-bg-subtle);
  --cui-list-group-active-bg: var(--cui-info-text-emphasis);
  --cui-list-group-active-border-color: var(--cui-info-text-emphasis);
}

.list-group-item-warning {
  --cui-list-group-color: var(--cui-warning-text-emphasis);
  --cui-list-group-bg: var(--cui-warning-bg-subtle);
  --cui-list-group-border-color: var(--cui-warning-border-subtle);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-warning-border-subtle);
  --cui-list-group-action-active-color: var(--cui-emphasis-color);
  --cui-list-group-action-active-bg: var(--cui-warning-border-subtle);
  --cui-list-group-active-color: var(--cui-warning-bg-subtle);
  --cui-list-group-active-bg: var(--cui-warning-text-emphasis);
  --cui-list-group-active-border-color: var(--cui-warning-text-emphasis);
}

.list-group-item-danger {
  --cui-list-group-color: var(--cui-danger-text-emphasis);
  --cui-list-group-bg: var(--cui-danger-bg-subtle);
  --cui-list-group-border-color: var(--cui-danger-border-subtle);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-danger-border-subtle);
  --cui-list-group-action-active-color: var(--cui-emphasis-color);
  --cui-list-group-action-active-bg: var(--cui-danger-border-subtle);
  --cui-list-group-active-color: var(--cui-danger-bg-subtle);
  --cui-list-group-active-bg: var(--cui-danger-text-emphasis);
  --cui-list-group-active-border-color: var(--cui-danger-text-emphasis);
}

.list-group-item-light {
  --cui-list-group-color: var(--cui-light-text-emphasis);
  --cui-list-group-bg: var(--cui-light-bg-subtle);
  --cui-list-group-border-color: var(--cui-light-border-subtle);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-light-border-subtle);
  --cui-list-group-action-active-color: var(--cui-emphasis-color);
  --cui-list-group-action-active-bg: var(--cui-light-border-subtle);
  --cui-list-group-active-color: var(--cui-light-bg-subtle);
  --cui-list-group-active-bg: var(--cui-light-text-emphasis);
  --cui-list-group-active-border-color: var(--cui-light-text-emphasis);
}

.list-group-item-dark {
  --cui-list-group-color: var(--cui-dark-text-emphasis);
  --cui-list-group-bg: var(--cui-dark-bg-subtle);
  --cui-list-group-border-color: var(--cui-dark-border-subtle);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-dark-border-subtle);
  --cui-list-group-action-active-color: var(--cui-emphasis-color);
  --cui-list-group-action-active-bg: var(--cui-dark-border-subtle);
  --cui-list-group-active-color: var(--cui-dark-bg-subtle);
  --cui-list-group-active-bg: var(--cui-dark-text-emphasis);
  --cui-list-group-active-border-color: var(--cui-dark-text-emphasis);
}

.btn-close {
  --cui-btn-close-color: #080a0c;
  --cui-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  --cui-btn-close-opacity: 0.5;
  --cui-btn-close-hover-opacity: 0.75;
  --cui-btn-close-focus-shadow: 0 0 0 0.25rem rgba(88, 86, 214, 0.25);
  --cui-btn-close-focus-opacity: 1;
  --cui-btn-close-disabled-opacity: 0.25;
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--cui-btn-close-color);
  background: transparent var(--cui-btn-close-bg) center/1em auto no-repeat;
  filter: var(--cui-btn-close-filter);
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--cui-btn-close-opacity);
}
.btn-close:hover {
  color: var(--cui-btn-close-color);
  text-decoration: none;
  opacity: var(--cui-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--cui-btn-close-focus-shadow);
  opacity: var(--cui-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--cui-btn-close-disabled-opacity);
}

.btn-close-white {
  --cui-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

:root,
[data-coreui-theme=light] {
  --cui-btn-close-filter: ;
}

[data-coreui-theme=dark] {
  --cui-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  --cui-toast-zindex: 1090;
  --cui-toast-padding-x: 0.75rem;
  --cui-toast-padding-y: 0.5rem;
  --cui-toast-spacing: 1.5rem;
  --cui-toast-max-width: 350px;
  --cui-toast-font-size: 0.875rem;
  --cui-toast-color: ;
  --cui-toast-bg: rgba(var(--cui-body-bg-rgb), 0.85);
  --cui-toast-border-width: var(--cui-border-width);
  --cui-toast-border-color: var(--cui-border-color-translucent);
  --cui-toast-border-radius: var(--cui-border-radius);
  --cui-toast-box-shadow: var(--cui-box-shadow);
  --cui-toast-header-color: var(--cui-secondary-color);
  --cui-toast-header-bg: rgba(var(--cui-body-bg-rgb), 0.85);
  --cui-toast-header-border-color: var(--cui-border-color-translucent);
  width: var(--cui-toast-max-width);
  max-width: 100%;
  font-size: var(--cui-toast-font-size);
  color: var(--cui-toast-color);
  pointer-events: auto;
  background-color: var(--cui-toast-bg);
  background-clip: padding-box;
  border: var(--cui-toast-border-width) solid var(--cui-toast-border-color);
  box-shadow: var(--cui-toast-box-shadow);
  border-radius: var(--cui-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --cui-toast-zindex: 1090;
  position: absolute;
  z-index: var(--cui-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--cui-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--cui-toast-padding-y) var(--cui-toast-padding-x);
  color: var(--cui-toast-header-color);
  background-color: var(--cui-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--cui-toast-border-width) solid var(--cui-toast-header-border-color);
  border-top-left-radius: calc(var(--cui-toast-border-radius) - var(--cui-toast-border-width));
  border-top-right-radius: calc(var(--cui-toast-border-radius) - var(--cui-toast-border-width));
}
.toast-header .btn-close {
  margin-inline: var(--cui-toast-padding-x) calc(-0.5 * var(--cui-toast-padding-x));
}

.toast-body {
  padding: var(--cui-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --cui-modal-zindex: 1055;
  --cui-modal-width: 500px;
  --cui-modal-padding: 1rem;
  --cui-modal-margin: 0.5rem;
  --cui-modal-color: var(--cui-body-color);
  --cui-modal-bg: var(--cui-body-bg);
  --cui-modal-border-color: var(--cui-border-color-translucent);
  --cui-modal-border-width: var(--cui-border-width);
  --cui-modal-border-radius: var(--cui-border-radius-lg);
  --cui-modal-box-shadow: var(--cui-box-shadow-sm);
  --cui-modal-inner-border-radius: calc(var(--cui-border-radius-lg) - (var(--cui-border-width)));
  --cui-modal-header-padding-x: 1rem;
  --cui-modal-header-padding-y: 1rem;
  --cui-modal-header-padding: 1rem 1rem;
  --cui-modal-header-border-color: var(--cui-border-color);
  --cui-modal-header-border-width: var(--cui-border-width);
  --cui-modal-title-line-height: 1.5;
  --cui-modal-footer-gap: 0.5rem;
  --cui-modal-footer-bg: ;
  --cui-modal-footer-border-color: var(--cui-border-color);
  --cui-modal-footer-border-width: var(--cui-border-width);
  position: fixed;
  inset-inline-start: 0;
  top: 0;
  z-index: var(--cui-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--cui-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--cui-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--cui-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--cui-modal-color);
  pointer-events: auto;
  background-color: var(--cui-modal-bg);
  background-clip: padding-box;
  border: var(--cui-modal-border-width) solid var(--cui-modal-border-color);
  border-radius: var(--cui-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --cui-backdrop-zindex: 1050;
  --cui-backdrop-bg: #080a0c;
  --cui-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--cui-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--cui-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--cui-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--cui-modal-header-padding);
  border-bottom: var(--cui-modal-header-border-width) solid var(--cui-modal-header-border-color);
  border-top-left-radius: var(--cui-modal-inner-border-radius);
  border-top-right-radius: var(--cui-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--cui-modal-header-padding-y) * 0.5) calc(var(--cui-modal-header-padding-x) * 0.5);
  margin-inline-start: auto;
  margin-inline-end: calc(-0.5 * var(--cui-modal-header-padding-x));
  margin-top: calc(-0.5 * var(--cui-modal-header-padding-y));
  margin-bottom: calc(-0.5 * var(--cui-modal-header-padding-y));
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--cui-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--cui-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--cui-modal-padding) - var(--cui-modal-footer-gap) * 0.5);
  background-color: var(--cui-modal-footer-bg);
  border-top: var(--cui-modal-footer-border-width) solid var(--cui-modal-footer-border-color);
  border-bottom-right-radius: var(--cui-modal-inner-border-radius);
  border-bottom-left-radius: var(--cui-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--cui-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --cui-modal-margin: 1.75rem;
    --cui-modal-box-shadow: var(--cui-box-shadow);
  }
  .modal-dialog {
    max-width: var(--cui-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --cui-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --cui-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --cui-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --cui-tooltip-zindex: 1080;
  --cui-tooltip-max-width: 200px;
  --cui-tooltip-padding-x: 0.5rem;
  --cui-tooltip-padding-y: 0.25rem;
  --cui-tooltip-margin: ;
  --cui-tooltip-font-size: 0.875rem;
  --cui-tooltip-color: var(--cui-body-bg);
  --cui-tooltip-bg: var(--cui-emphasis-color);
  --cui-tooltip-border-radius: var(--cui-border-radius);
  --cui-tooltip-opacity: 0.9;
  --cui-tooltip-arrow-width: 0.8rem;
  --cui-tooltip-arrow-height: 0.4rem;
  z-index: var(--cui-tooltip-zindex);
  display: block;
  margin: var(--cui-tooltip-margin);
  font-family: var(--cui-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--cui-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--cui-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--cui-tooltip-arrow-width);
  height: var(--cui-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--cui-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--cui-tooltip-arrow-height) calc(var(--cui-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--cui-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--cui-tooltip-arrow-height));
  width: var(--cui-tooltip-arrow-height);
  height: var(--cui-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--cui-tooltip-arrow-width) * 0.5) var(--cui-tooltip-arrow-height) calc(var(--cui-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--cui-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--cui-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--cui-tooltip-arrow-width) * 0.5) var(--cui-tooltip-arrow-height);
  border-bottom-color: var(--cui-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--cui-tooltip-arrow-height));
  width: var(--cui-tooltip-arrow-height);
  height: var(--cui-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--cui-tooltip-arrow-width) * 0.5) 0 calc(var(--cui-tooltip-arrow-width) * 0.5) var(--cui-tooltip-arrow-height);
  border-left-color: var(--cui-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--cui-tooltip-max-width);
  padding: var(--cui-tooltip-padding-y) var(--cui-tooltip-padding-x);
  color: var(--cui-tooltip-color);
  text-align: center;
  background-color: var(--cui-tooltip-bg);
  border-radius: var(--cui-tooltip-border-radius);
}

.popover {
  --cui-popover-zindex: 1070;
  --cui-popover-max-width: 276px;
  --cui-popover-font-size: 0.875rem;
  --cui-popover-bg: var(--cui-body-bg);
  --cui-popover-border-width: var(--cui-border-width);
  --cui-popover-border-color: var(--cui-border-color-translucent);
  --cui-popover-border-radius: var(--cui-border-radius-lg);
  --cui-popover-inner-border-radius: calc(var(--cui-border-radius-lg) - var(--cui-border-width));
  --cui-popover-box-shadow: var(--cui-box-shadow);
  --cui-popover-header-padding-x: 1rem;
  --cui-popover-header-padding-y: 0.5rem;
  --cui-popover-header-font-size: 1rem;
  --cui-popover-header-color: inherit;
  --cui-popover-header-bg: var(--cui-secondary-bg);
  --cui-popover-body-padding-x: 1rem;
  --cui-popover-body-padding-y: 1rem;
  --cui-popover-body-color: var(--cui-body-color);
  --cui-popover-arrow-width: 1rem;
  --cui-popover-arrow-height: 0.5rem;
  --cui-popover-arrow-border: var(--cui-popover-border-color);
  z-index: var(--cui-popover-zindex);
  display: block;
  max-width: var(--cui-popover-max-width);
  font-family: var(--cui-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--cui-popover-font-size);
  word-wrap: break-word;
  background-color: var(--cui-popover-bg);
  background-clip: padding-box;
  border: var(--cui-popover-border-width) solid var(--cui-popover-border-color);
  border-radius: var(--cui-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--cui-popover-arrow-width);
  height: var(--cui-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--cui-popover-arrow-height) calc(var(--cui-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--cui-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--cui-popover-border-width);
  border-top-color: var(--cui-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
  width: var(--cui-popover-arrow-height);
  height: var(--cui-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--cui-popover-arrow-width) * 0.5) var(--cui-popover-arrow-height) calc(var(--cui-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--cui-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--cui-popover-border-width);
  border-right-color: var(--cui-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--cui-popover-arrow-width) * 0.5) var(--cui-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--cui-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--cui-popover-border-width);
  border-bottom-color: var(--cui-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--cui-popover-arrow-width);
  margin-left: calc(-0.5 * var(--cui-popover-arrow-width));
  content: "";
  border-bottom: var(--cui-popover-border-width) solid var(--cui-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
  width: var(--cui-popover-arrow-height);
  height: var(--cui-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--cui-popover-arrow-width) * 0.5) 0 calc(var(--cui-popover-arrow-width) * 0.5) var(--cui-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--cui-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--cui-popover-border-width);
  border-left-color: var(--cui-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--cui-popover-header-padding-y) var(--cui-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--cui-popover-header-font-size);
  color: var(--cui-popover-header-color);
  background-color: var(--cui-popover-header-bg);
  border-bottom: var(--cui-popover-border-width) solid var(--cui-popover-border-color);
  border-top-left-radius: var(--cui-popover-inner-border-radius);
  border-top-right-radius: var(--cui-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--cui-popover-body-padding-y) var(--cui-popover-body-padding-x);
  color: var(--cui-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  filter: var(--cui-carousel-control-icon-filter);
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-coreui-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-coreui-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: var(--cui-carousel-caption-color);
  text-align: center;
}

.carousel-dark {
  --cui-carousel-indicator-active-bg: #080a0c;
  --cui-carousel-caption-color: #080a0c;
  --cui-carousel-control-icon-filter: invert(1) grayscale(100);
}

:root,
[data-coreui-theme=light] {
  --cui-carousel-indicator-active-bg: #fff;
  --cui-carousel-caption-color: #fff;
  --cui-carousel-control-icon-filter: ;
}

[data-coreui-theme=dark] {
  --cui-carousel-indicator-active-bg: #080a0c;
  --cui-carousel-caption-color: #080a0c;
  --cui-carousel-control-icon-filter: invert(1) grayscale(100);
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--cui-spinner-width);
  height: var(--cui-spinner-height);
  vertical-align: var(--cui-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--cui-spinner-animation-speed) linear infinite var(--cui-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --cui-spinner-width: 2rem;
  --cui-spinner-height: 2rem;
  --cui-spinner-vertical-align: -0.125em;
  --cui-spinner-border-width: 0.25em;
  --cui-spinner-animation-speed: 0.75s;
  --cui-spinner-animation-name: spinner-border;
  border: var(--cui-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --cui-spinner-width: 1rem;
  --cui-spinner-height: 1rem;
  --cui-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --cui-spinner-width: 2rem;
  --cui-spinner-height: 2rem;
  --cui-spinner-vertical-align: -0.125em;
  --cui-spinner-animation-speed: 0.75s;
  --cui-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --cui-spinner-width: 1rem;
  --cui-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --cui-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --cui-offcanvas-zindex: 1045;
  --cui-offcanvas-width: 400px;
  --cui-offcanvas-height: 30vh;
  --cui-offcanvas-padding-x: 1rem;
  --cui-offcanvas-padding-y: 1rem;
  --cui-offcanvas-color: var(--cui-body-color);
  --cui-offcanvas-bg: var(--cui-body-bg);
  --cui-offcanvas-border-width: var(--cui-border-width);
  --cui-offcanvas-border-color: var(--cui-border-color-translucent);
  --cui-offcanvas-box-shadow: var(--cui-box-shadow-sm);
  --cui-offcanvas-transition: transform 0.3s ease-in-out;
  --cui-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    inset-inline-start: 0;
    top: 0;
    width: var(--cui-offcanvas-width);
    border-inline-end: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    inset-inline-end: 0;
    top: 0;
    width: var(--cui-offcanvas-width);
    border-inline-start: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    inset-inline-start: 0;
    top: 0;
    width: var(--cui-offcanvas-width);
    border-inline-end: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    inset-inline-end: 0;
    top: 0;
    width: var(--cui-offcanvas-width);
    border-inline-start: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    inset-inline-start: 0;
    top: 0;
    width: var(--cui-offcanvas-width);
    border-inline-end: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    inset-inline-end: 0;
    top: 0;
    width: var(--cui-offcanvas-width);
    border-inline-start: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    inset-inline-start: 0;
    top: 0;
    width: var(--cui-offcanvas-width);
    border-inline-end: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    inset-inline-end: 0;
    top: 0;
    width: var(--cui-offcanvas-width);
    border-inline-start: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    inset-inline-start: 0;
    top: 0;
    width: var(--cui-offcanvas-width);
    border-inline-end: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    inset-inline-end: 0;
    top: 0;
    width: var(--cui-offcanvas-width);
    border-inline-start: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--cui-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--cui-offcanvas-color);
  visibility: hidden;
  background-color: var(--cui-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--cui-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  inset-inline-start: 0;
  top: 0;
  width: var(--cui-offcanvas-width);
  border-inline-end: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  inset-inline-end: 0;
  top: 0;
  width: var(--cui-offcanvas-width);
  border-inline-start: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--cui-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--cui-offcanvas-height);
  max-height: 100%;
  border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none !important;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: var(--cui-offcanvas-backdrop-bg, #080a0c);
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--cui-offcanvas-padding-y) var(--cui-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--cui-offcanvas-padding-y) * 0.5) calc(var(--cui-offcanvas-padding-x) * 0.5);
  margin-inline-start: auto;
  margin-inline-end: calc(-0.5 * var(--cui-offcanvas-padding-x));
  margin-top: calc(-0.5 * var(--cui-offcanvas-padding-y));
  margin-bottom: calc(-0.5 * var(--cui-offcanvas-padding-y));
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--cui-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--cui-offcanvas-padding-y) var(--cui-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #080a0c 55%, rgba(0, 0, 0, 0.8) 75%, #080a0c 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.avatar {
  --cui-avatar-width: 2rem;
  --cui-avatar-height: 2rem;
  --cui-avatar-font-size: 0.8rem;
  --cui-avatar-border-radius: 50em;
  --cui-avatar-status-width: 0.5rem;
  --cui-avatar-status-height: 0.5rem;
  --cui-avatar-status-border-radius: 50em;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--cui-avatar-width);
  height: var(--cui-avatar-height);
  font-size: var(--cui-avatar-font-size);
  vertical-align: middle;
  border-radius: var(--cui-avatar-border-radius);
  transition: margin 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .avatar {
    transition: none;
  }
}

.avatar-img {
  width: 100%;
  height: auto;
  border-radius: var(--cui-avatar-border-radius);
}

.avatar-status {
  position: absolute;
  inset-inline-end: 0;
  bottom: 0;
  display: block;
  width: var(--cui-avatar-status-width);
  height: var(--cui-avatar-status-height);
  border: 1px solid #fff;
  border-radius: var(--cui-avatar-status-border-radius);
}

.avatar-sm {
  --cui-avatar-width: 1.5rem;
  --cui-avatar-height: 1.5rem;
  --cui-avatar-font-size: 0.6rem;
  --cui-avatar-status-width: 0.4rem;
  --cui-avatar-status-height: 0.4rem;
}

.avatar-md {
  --cui-avatar-width: 2.5rem;
  --cui-avatar-height: 2.5rem;
  --cui-avatar-font-size: 1rem;
  --cui-avatar-status-width: 0.7rem;
  --cui-avatar-status-height: 0.7rem;
}

.avatar-lg {
  --cui-avatar-width: 3rem;
  --cui-avatar-height: 3rem;
  --cui-avatar-font-size: 1.2rem;
  --cui-avatar-status-width: 0.8rem;
  --cui-avatar-status-height: 0.8rem;
}

.avatar-xl {
  --cui-avatar-width: 4rem;
  --cui-avatar-height: 4rem;
  --cui-avatar-font-size: 1.6rem;
  --cui-avatar-status-width: 1rem;
  --cui-avatar-status-height: 1rem;
}

.avatars-stack {
  display: flex;
}
.avatars-stack .avatar {
  margin-inline-end: calc(-0.4 * var(--cui-avatar-width));
}
.avatars-stack .avatar:hover {
  margin-inline-end: 0;
}

.callout {
  --cui-callout-padding-x: 1rem;
  --cui-callout-padding-y: 1rem;
  --cui-callout-margin-x: 0;
  --cui-callout-margin-y: 1rem;
  --cui-callout-border-width: var(--cui-border-width);
  --cui-callout-border-color: var(--cui-border-color);
  --cui-callout-border-left-width: calc(var(--cui-border-width) * 4);
  --cui-callout-border-radius: var(--cui-border-radius);
  padding: var(--cui-callout-padding-y) var(--cui-callout-padding-x);
  margin: var(--cui-callout-margin-y) var(--cui-callout-margin-x);
  border: var(--cui-callout-border-width) solid var(--cui-callout-border-color);
  border-inline-start-color: var(--cui-callout-border-left-color);
  border-inline-start-width: var(--cui-callout-border-left-width);
  border-radius: var(--cui-callout-border-radius);
}

.callout-primary {
  --cui-callout-border-left-color: #5856d6;
}

.callout-secondary {
  --cui-callout-border-left-color: #6b7785;
}

.callout-success {
  --cui-callout-border-left-color: #1b9e3e;
}

.callout-danger {
  --cui-callout-border-left-color: #e55353;
}

.callout-warning {
  --cui-callout-border-left-color: #f9b115;
}

.callout-info {
  --cui-callout-border-left-color: #39f;
}

.callout-light {
  --cui-callout-border-left-color: #f3f4f7;
}

.callout-dark {
  --cui-callout-border-left-color: #212631;
}

.footer {
  --cui-footer-min-height: 3rem;
  --cui-footer-padding-x: 1rem;
  --cui-footer-padding-y: 0.5rem;
  --cui-footer-color: var(--cui-body-color);
  --cui-footer-bg: var(--cui-tertiary-bg);
  --cui-footer-border-color: var(--cui-border-color);
  --cui-footer-border: var(--cui-border-width) solid var(--cui-footer-border-color);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  min-height: var(--cui-footer-min-height);
  padding: var(--cui-footer-padding-y) var(--cui-footer-padding-x);
  color: var(--cui-footer-color);
  background: var(--cui-footer-bg);
  border-top: var(--cui-footer-border);
}

.footer-fixed {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.footer-sticky {
  position: sticky;
  bottom: 0;
  z-index: 1030;
}

.header {
  --cui-header-padding-x: 0.5rem;
  --cui-header-padding-y: 0.5rem;
  --cui-header-bg: var(--cui-body-bg);
  --cui-header-color: rgba(var(--cui-emphasis-color-rgb), 0.65);
  --cui-header-border-color: var(--cui-border-color);
  --cui-header-border: var(--cui-border-width) solid var(--cui-header-border-color);
  --cui-header-hover-color: rgba(var(--cui-emphasis-color-rgb), 0.8);
  --cui-header-disabled-color: rgba(var(--cui-emphasis-color-rgb), 0.3);
  --cui-header-active-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-header-transition: box-shadow 0.15s ease-in-out;
  --cui-header-brand-padding-y: 0.3125rem;
  --cui-header-brand-color: #212631;
  --cui-header-brand-hover-color: rgb(29.7, 34.2, 44.1);
  --cui-header-toggler-padding-x: 0.75rem;
  --cui-header-toggler-padding-y: 0.25rem;
  --cui-header-toggler-bg: transparent;
  --cui-header-toggler-color: rgba(var(--cui-emphasis-color-rgb), 0.65);
  --cui-header-toggler-border-radius: var(--cui-border-radius);
  --cui-header-toggler-hover-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-header-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  --cui-header-toggler-hover-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  --cui-header-nav-link-padding-x: 0.5rem;
  --cui-header-nav-link-padding-y: 0.5rem;
  --cui-header-divider-border-color: var(--cui-border-color);
  --cui-header-divider-border: var(--cui-border-width) solid var(--cui-header-divider-border-color);
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-header-padding-y) var(--cui-header-padding-x);
  background: var(--cui-header-bg);
  border-bottom: var(--cui-header-border);
  transition: var(--cui-header-transition);
}
@media (prefers-reduced-motion: reduce) {
  .header {
    transition: none;
  }
}
.header > .container-xxl, .header > .container-xl, .header > .container-lg, .header > .container-md, .header > .container-sm, .header > .container,
.header > .container-fluid {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.header.header-sticky {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.header-divider {
  flex-basis: calc(100% + 2 * var(--cui-header-padding-x));
  height: 0;
  margin: var(--cui-header-padding-y) calc(-1 * var(--cui-header-padding-x));
  border-top: var(--cui-header-divider-border);
}

.header-brand {
  padding-top: var(--cui-header-brand-padding-y);
  padding-bottom: var(--cui-header-brand-padding-y);
  margin-inline-end: 1rem;
  font-size: 1.25rem;
  color: var(--cui-header-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.header-brand:hover, .header-brand:focus {
  color: var(--cui-header-brand-hover-color);
}

.header-nav {
  display: flex;
  flex-direction: row;
  padding-inline-start: 0;
  margin-bottom: 0;
  list-style: none;
}
.header-nav .nav-link {
  padding: var(--cui-header-nav-link-padding-y) var(--cui-header-nav-link-padding-x);
  color: var(--cui-header-color);
}
.header-nav .nav-link:hover, .header-nav .nav-link:focus {
  color: var(--cui-header-hover-color);
}
.header-nav .nav-link.disabled {
  color: var(--cui-header-disabled-color);
}
.header-nav .show > .nav-link,
.header-nav .nav-link.active {
  color: var(--cui-header-active-color);
}
.header-nav .dropdown-menu {
  position: absolute;
}

.header-text {
  padding-top: var(--cui-header-nav-link-padding-y);
  padding-bottom: var(--cui-header-nav-link-padding-y);
  color: var(--cui-header-color);
}
.header-text a {
  color: var(--cui-header-active-color);
}
.header-text a:hover, .header-text a:focus {
  color: var(--cui-header-active-color);
}

.header-toggler {
  padding: var(--cui-header-toggler-padding-y) var(--cui-header-toggler-padding-x);
  font-size: 1.25rem;
  color: var(--cui-header-toggler-color);
  background-color: var(--cui-header-toggler-bg);
  border: 0;
  border-radius: var(--cui-header-toggler-border-radius);
}
.header-toggler:hover {
  color: var(--cui-header-toggler-hover-color);
  text-decoration: none;
}
.header-toggler:focus {
  outline: 0;
}
.header-toggler:not(:disabled) {
  cursor: pointer;
}

.header-toggler-icon {
  display: block;
  height: 1.5625rem;
  background-image: var(--cui-header-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
}
.header-toggler-icon:hover {
  background-image: var(--cui-header-toggler-hover-icon-bg);
}

.icon {
  display: inline-block;
  color: inherit;
  text-align: center;
  vertical-align: -0.125rem;
  fill: currentcolor;
}
.icon:not(.icon-c-s):not(.icon-custom-size) {
  width: 1rem;
  height: 1rem;
  font-size: 1rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-xxl {
  width: 2rem;
  height: 2rem;
  font-size: 2rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-xl {
  width: 1.5rem;
  height: 1.5rem;
  font-size: 1.5rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-lg {
  width: 1.25rem;
  height: 1.25rem;
  font-size: 1.25rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-sm {
  width: 0.875rem;
  height: 0.875rem;
  font-size: 0.875rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-3xl {
  width: 3rem;
  height: 3rem;
  font-size: 3rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-4xl {
  width: 4rem;
  height: 4rem;
  font-size: 4rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-5xl {
  width: 5rem;
  height: 5rem;
  font-size: 5rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-6xl {
  width: 6rem;
  height: 6rem;
  font-size: 6rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-7xl {
  width: 7rem;
  height: 7rem;
  font-size: 7rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-8xl {
  width: 8rem;
  height: 8rem;
  font-size: 8rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-9xl {
  width: 9rem;
  height: 9rem;
  font-size: 9rem;
}

.sidebar {
  --cui-sidebar-zindex: 1035;
  --cui-sidebar-width: 16rem;
  --cui-sidebar-bg: var(--cui-body-bg);
  --cui-sidebar-padding-x: 1rem;
  --cui-sidebar-padding-y: 1rem;
  --cui-sidebar-color: var(--cui-body-color);
  --cui-sidebar-brand-color: var(--cui-body-color);
  --cui-sidebar-brand-bg: rgba(8, 10, 12, 0.2);
  position: relative;
  display: flex;
  flex: 0 0 var(--cui-sidebar-width);
  flex-direction: column;
  order: -1;
  width: var(--cui-sidebar-width);
  color: var(--cui-sidebar-color);
  background: var(--cui-sidebar-bg);
  box-shadow: none;
  transition: margin-left 0.15s, margin-right 0.15s, box-shadow 0.075s, transform 0.15s, width 0.15s, z-index 0s ease 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar {
    transition: none;
  }
}
.sidebar:not(.sidebar-end) {
  margin-inline-start: 0;
}
.sidebar.sidebar-end {
  order: 99;
  margin-inline-end: 0;
}
@media (min-width: 992px) {
  .sidebar:not(.hide):not(.sidebar-narrow):not(.sidebar-narrow-unfoldable:not(:hover)):not(.sidebar-narrow-unfoldable):not(.sidebar-overlaid):not(.sidebar-end) ~ * {
    --cui-sidebar-occupy-start: 16rem;
  }
  .sidebar:not(.hide):not(.sidebar-narrow):not(.sidebar-narrow-unfoldable:not(:hover)):not(.sidebar-narrow-unfoldable):not(.sidebar-overlaid).sidebar-end ~ * {
    --cui-sidebar-occupy-end: 16rem;
  }
  .sidebar.hide:not(.sidebar-end) {
    margin-inline-start: calc(-1 * var(--cui-sidebar-width));
  }
  .sidebar.hide.sidebar-end {
    margin-inline-end: calc(-1 * var(--cui-sidebar-width));
  }
}
@media (max-width: 991.98px) {
  .sidebar {
    --cui-is-mobile: true;
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: var(--cui-sidebar-zindex);
  }
  .sidebar:not(.sidebar-end) {
    inset-inline-start: 0;
  }
  .sidebar:not(.sidebar-end):not(.show) {
    margin-inline-start: calc(-1 * var(--cui-sidebar-width));
  }
  .sidebar.sidebar-end {
    inset-inline-end: 0;
  }
  .sidebar.sidebar-end:not(.show) {
    margin-inline-end: calc(-1 * var(--cui-sidebar-width));
  }
}

.sidebar-fixed, .sidebar-narrow-unfoldable, .sidebar-overlaid {
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: var(--cui-sidebar-zindex);
}
.sidebar-fixed:not(.sidebar-end), .sidebar-narrow-unfoldable:not(.sidebar-end), .sidebar-overlaid:not(.sidebar-end) {
  inset-inline-start: 0;
}
.sidebar-fixed.sidebar-end, .sidebar-end.sidebar-narrow-unfoldable, .sidebar-end.sidebar-overlaid {
  inset-inline-end: 0;
}

.sidebar-overlaid {
  --cui-sidebar-overlaid-box-shadow: var(--cui-box-shadow);
}
.sidebar-overlaid:not(.sidebar-end) {
  margin-inline-start: calc(-1 * var(--cui-sidebar-width));
}
.sidebar-overlaid.sidebar-end {
  margin-inline-end: calc(-1 * var(--cui-sidebar-width));
}
.sidebar-overlaid.show {
  box-shadow: var(--cui-sidebar-overlaid-box-shadow);
}
.sidebar-overlaid.show:not(.sidebar-end) {
  margin-inline-start: 0;
}
.sidebar-overlaid.show.sidebar-end {
  margin-inline-end: 0;
}

.sidebar-sm {
  --cui-sidebar-width: 12rem;
}
@media (min-width: 992px) {
  .sidebar-sm:not(.hide):not(.sidebar-narrow):not(.sidebar-narrow-unfoldable:not(:hover)):not(.sidebar-narrow-unfoldable):not(.sidebar-overlaid):not(.sidebar-end) ~ * {
    --cui-sidebar-occupy-start: 12rem;
  }
  .sidebar-sm:not(.hide):not(.sidebar-narrow):not(.sidebar-narrow-unfoldable:not(:hover)):not(.sidebar-narrow-unfoldable):not(.sidebar-overlaid).sidebar-end ~ * {
    --cui-sidebar-occupy-end: 12rem;
  }
}

.sidebar-lg {
  --cui-sidebar-width: 20rem;
}
@media (min-width: 992px) {
  .sidebar-lg:not(.hide):not(.sidebar-narrow):not(.sidebar-narrow-unfoldable:not(:hover)):not(.sidebar-narrow-unfoldable):not(.sidebar-overlaid):not(.sidebar-end) ~ * {
    --cui-sidebar-occupy-start: 20rem;
  }
  .sidebar-lg:not(.hide):not(.sidebar-narrow):not(.sidebar-narrow-unfoldable:not(:hover)):not(.sidebar-narrow-unfoldable):not(.sidebar-overlaid).sidebar-end ~ * {
    --cui-sidebar-occupy-end: 20rem;
  }
}

.sidebar-xl {
  --cui-sidebar-width: 24rem;
}
@media (min-width: 992px) {
  .sidebar-xl:not(.hide):not(.sidebar-narrow):not(.sidebar-narrow-unfoldable:not(:hover)):not(.sidebar-narrow-unfoldable):not(.sidebar-overlaid):not(.sidebar-end) ~ * {
    --cui-sidebar-occupy-start: 24rem;
  }
  .sidebar-xl:not(.hide):not(.sidebar-narrow):not(.sidebar-narrow-unfoldable:not(:hover)):not(.sidebar-narrow-unfoldable):not(.sidebar-overlaid).sidebar-end ~ * {
    --cui-sidebar-occupy-end: 24rem;
  }
}

.sidebar-brand {
  color: var(--cui-sidebar-brand-color);
  white-space: nowrap;
}
.sidebar-brand .sidebar-brand-narrow {
  display: none;
}

.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-sidebar-padding-y) var(--cui-sidebar-padding-x);
}
.sidebar-header .btn-close {
  padding: calc(var(--cui-sidebar-padding-y) * 0.5) calc(var(--cui-sidebar-padding-x) * 0.5);
  margin-inline-end: calc(-0.5 * var(--cui-sidebar-padding-x));
  margin-top: calc(-0.5 * var(--cui-sidebar-padding-y));
  margin-bottom: calc(-0.5 * var(--cui-sidebar-padding-y));
}

.sidebar-body {
  padding: var(--cui-sidebar-padding-y) var(--cui-sidebar-padding-x);
}

.sidebar-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-sidebar-padding-y) var(--cui-sidebar-padding-x);
}

.sidebar-toggler {
  --cui-sidebar-toggler-width: 0.5rem;
  --cui-sidebar-toggler-height: 0.5rem;
  --cui-sidebar-toggler-bg: transparent;
  --cui-sidebar-toggler-color: var(--cui-tertiary-color);
  --cui-sidebar-toggler-icon: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  --cui-sidebar-toggler-hover-color: var(--cui-secondary-color);
  --cui-sidebar-toggler-focus-shadow: 0 0 0 0.25rem rgba(88, 86, 214, 0.25);
  --cui-sidebar-toggler-focus-color: var(--cui-secondary-color);
  --cui-sidebar-toggler-transition: transform 0.15s;
  position: relative;
  box-sizing: content-box;
  width: var(--cui-sidebar-toggler-width);
  height: var(--cui-sidebar-toggler-height);
  padding: 0.25rem 0.25rem;
  background-color: var(--cui-sidebar-toggler-bg);
  border: 0;
  border-radius: 0.375rem;
}
.sidebar-toggler::before {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  content: "";
  background-color: var(--cui-sidebar-toggler-color);
  mask: var(--cui-sidebar-toggler-icon) no-repeat center;
  transition: var(--cui-sidebar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-toggler::before {
    transition: none;
  }
}
.sidebar-toggler:hover {
  text-decoration: none;
}
.sidebar-toggler:hover::before {
  background-color: var(--cui-sidebar-toggler-hover-color);
}
.sidebar-toggler:focus {
  position: relative;
  outline: 0;
  box-shadow: var(--cui-sidebar-toggler-focus-shadow);
}
.sidebar-toggler:focus::before {
  background-color: var(--cui-sidebar-toggler-focus-color);
}
@media (max-width: 991.98px) {
  .sidebar-toggler {
    display: none;
  }
}

.sidebar-backdrop {
  --cui-backdrop-zindex: 1034;
  --cui-backdrop-bg: #080a0c;
  --cui-backdrop-opacity: 0.5;
}
@media (max-width: 991.98px) {
  .sidebar-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: var(--cui-backdrop-zindex);
    width: 100vw;
    height: 100vh;
    background-color: var(--cui-backdrop-bg);
  }
  .sidebar-backdrop.fade {
    opacity: 0;
  }
  .sidebar-backdrop.show {
    opacity: var(--cui-backdrop-opacity);
  }
}

.sidebar-dark {
  --cui-body-color: rgba(255, 255, 255, 0.87);
  --cui-body-bg: #212631;
  --cui-emphasis-color: #fff;
  --cui-secondary-color: rgba(255, 255, 255, 0.6);
  --cui-secondary-bg: #323a49;
  --cui-tertiary-color: rgba(255, 255, 255, 0.38);
  --cui-tertiary-bg: rgb(41.5, 48, 61);
  --cui-border-color: #323a49;
}
.sidebar-dark .sidebar-toggler {
  filter: var(--cui-sidebar-toggler-white-filter);
}

.sidebar-nav {
  --cui-sidebar-nav-padding-x: 0.5rem;
  --cui-sidebar-nav-padding-y: 0.5rem;
  --cui-sidebar-nav-gap: 1px;
  --cui-sidebar-nav-title-padding-x: 1rem;
  --cui-sidebar-nav-title-padding-y: 0.75rem;
  --cui-sidebar-nav-title-margin-top: 1rem;
  --cui-sidebar-nav-title-color: var(--cui-tertiary-color);
  --cui-sidebar-nav-link-padding-x: 1rem;
  --cui-sidebar-nav-link-padding-y: 0.75rem;
  --cui-sidebar-nav-link-color: var(--cui-body-color);
  --cui-sidebar-nav-link-bg: transparent;
  --cui-sidebar-nav-link-border-color: transparent;
  --cui-sidebar-nav-link-border-radius: var(--cui-border-radius);
  --cui-sidebar-nav-link-border-width: 0;
  --cui-sidebar-nav-link-active-color: var(--cui-emphasis-color);
  --cui-sidebar-nav-link-active-bg: var(--cui-tertiary-bg);
  --cui-sidebar-nav-link-disabled-color: var(--cui-tertiary-color);
  --cui-sidebar-nav-link-hover-color: var(--cui-emphasis-color);
  --cui-sidebar-nav-link-hover-bg: var(--cui-tertiary-bg);
  --cui-sidebar-nav-link-icon-margin: 0.75rem;
  --cui-sidebar-nav-link-icon-color: var(--cui-tertiary-color);
  --cui-sidebar-nav-link-icon-width: 1.25rem;
  --cui-sidebar-nav-link-icon-height: 1.25rem;
  --cui-sidebar-nav-link-icon-font-size: 1.25rem;
  --cui-sidebar-nav-link-active-icon-color: var(--cui-emphasis-color);
  --cui-sidebar-nav-link-disabled-icon-color: var(--cui-tertiary-color);
  --cui-sidebar-nav-link-hover-icon-color: var(--cui-body-color);
  --cui-sidebar-nav-link-icon-bullet-size: 0.3125rem;
  --cui-sidebar-nav-link-icon-bullet-bg: transparent;
  --cui-sidebar-nav-link-icon-bullet-border-width: 1px;
  --cui-sidebar-nav-link-icon-bullet-border-radius: 50rem;
  --cui-sidebar-nav-link-icon-bullet-border-color: var(--cui-tertiary-color);
  --cui-sidebar-nav-link-active-icon-bullet-bg: transparent;
  --cui-sidebar-nav-link-active-icon-bullet-border-color: var(--cui-emphasis-color);
  --cui-sidebar-nav-link-disabled-icon-bullet-bg: transparent;
  --cui-sidebar-nav-link-disabled-icon-bullet-border-color: var(--cui-tertiary-color);
  --cui-sidebar-nav-link-hover-icon-bullet-bg: transparent;
  --cui-sidebar-nav-link-hover-icon-bullet-border-color: var(--cui-body-color);
  --cui-sidebar-nav-group-bg: transparent;
  --cui-sidebar-nav-group-border-width: 0;
  --cui-sidebar-nav-group-border-radius: var(--cui-border-radius);
  --cui-sidebar-nav-group-border-color: transparent;
  --cui-sidebar-nav-group-items-padding-y: 0;
  --cui-sidebar-nav-group-items-padding-x: 0;
  --cui-sidebar-nav-group-indicator-color: var(--cui-tertiary-color);
  --cui-sidebar-nav-group-indicator-icon: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  --cui-sidebar-nav-group-indicator-hover-color: var(--cui-emphasis-color);
  --cui-sidebar-nav-group-indicator-hover-icon: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  --cui-sidebar-nav-group-toggle-show-color: var(--cui-body-color);
  position: relative;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  padding: var(--cui-sidebar-nav-padding-y) var(--cui-sidebar-nav-padding-x);
  margin-bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
  list-style: none;
}
.sidebar-nav .nav-item + .nav-item,
.sidebar-nav .nav-item + .nav-group,
.sidebar-nav .nav-group + .nav-item {
  margin-top: var(--cui-sidebar-nav-gap);
}
.sidebar-nav .nav-title {
  padding: var(--cui-sidebar-nav-title-padding-y) var(--cui-sidebar-nav-title-padding-x);
  margin-top: var(--cui-sidebar-nav-title-margin-top);
  font-size: 80%;
  font-weight: 700;
  color: var(--cui-sidebar-nav-title-color);
  text-transform: uppercase;
  transition: height 0.15s, margin 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-title {
    transition: none;
  }
}
.sidebar-nav .nav-link {
  display: flex;
  flex: 1 1;
  align-items: center;
  padding: var(--cui-sidebar-nav-link-padding-y) var(--cui-sidebar-nav-link-padding-x);
  color: var(--cui-sidebar-nav-link-color);
  text-decoration: none;
  white-space: nowrap;
  background: var(--cui-sidebar-nav-link-bg);
  border: var(--cui-sidebar-nav-link-border-width) solid var(--cui-sidebar-nav-link-border-color);
  border-radius: var(--cui-sidebar-nav-link-border-radius);
  transition: background 0.15s ease, color 0.15s ease, gap 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-link {
    transition: none;
  }
}
.sidebar-nav .nav-link.active {
  color: var(--cui-sidebar-nav-link-active-color);
  background: var(--cui-sidebar-nav-link-active-bg);
}
.sidebar-nav .nav-link.active .nav-icon {
  color: var(--cui-sidebar-nav-link-active-icon-color);
}
.sidebar-nav .nav-link.active .nav-icon-bullet {
  background: var(--cui-sidebar-link-active-icon-bullet-bg);
  border-color: var(--cui-sidebar-link-active-icon-bullet-border-color);
}
.sidebar-nav .nav-link.disabled {
  color: var(--cui-sidebar-nav-link-disabled-color);
  pointer-events: none;
  cursor: not-allowed;
  background: transparent;
}
.sidebar-nav .nav-link.disabled .nav-icon {
  color: var(--cui-sidebar-nav-link-disabled-icon-color);
}
.sidebar-nav .nav-link.disabled .nav-icon-bullet {
  background: var(--cui-sidebar-link-disabled-icon-bullet-bg);
  border-color: var(--cui-sidebar-link-disabled-icon-bullet-border-color);
}
.sidebar-nav .nav-link.disabled:hover {
  color: var(--cui-sidebar-nav-link-disabled-color);
}
.sidebar-nav .nav-link.disabled:hover .nav-icon {
  color: var(--cui-sidebar-nav-link-disabled-icon-color);
}
.sidebar-nav .nav-link.disabled:hover .nav-icon-bullet {
  background: var(--cui-sidebar-link-disabled-icon-bullet-bg);
  border-color: var(--cui-sidebar-link-disabled-icon-bullet-border-color);
}
.sidebar-nav .nav-link.disabled:hover.nav-dropdown-toggle::after {
  background-color: var(--cui-sidebar-nav-group-indicator-hover-color);
  mask-image: var(--cui-sidebar-nav-group-indicator-hover-icon);
}
@media (hover: hover), (-ms-high-contrast: none) {
  .sidebar-nav .nav-link:hover {
    color: var(--cui-sidebar-nav-link-hover-color);
    text-decoration: none;
    background: var(--cui-sidebar-nav-link-hover-bg);
  }
  .sidebar-nav .nav-link:hover .nav-icon {
    color: var(--cui-sidebar-nav-link-hover-icon-color);
  }
  .sidebar-nav .nav-link:hover .nav-icon-bullet {
    background: var(--cui-sidebar-link-hover-icon-bullet-bg);
    border-color: var(--cui-sidebar-link-hover-icon-bullet-border-color);
  }
  .sidebar-nav .nav-link:hover.nav-group-toggle::after {
    background-color: var(--cui-sidebar-nav-group-indicator-hover-color);
    mask-image: var(--cui-sidebar-nav-group-indicator-hover-icon);
  }
}
.sidebar-nav .nav-icon {
  display: flex;
  flex: 0 0 var(--cui-sidebar-nav-link-icon-width);
  align-items: center;
  justify-content: center;
  height: var(--cui-sidebar-nav-link-icon-height);
  margin-inline-end: var(--cui-sidebar-nav-link-icon-margin);
  font-size: var(--cui-sidebar-nav-link-icon-font-size);
  color: var(--cui-sidebar-nav-link-icon-color);
  text-align: center;
  pointer-events: none;
  fill: currentcolor;
  transition: inherit;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-icon {
    transition: none;
  }
}
.sidebar-nav .nav-icon-bullet {
  display: inline-block;
  width: var(--cui-sidebar-nav-link-icon-bullet-size);
  height: var(--cui-sidebar-nav-link-icon-bullet-size);
  background: var(--cui-sidebar-nav-link-icon-bullet-bg);
  border: var(--cui-sidebar-nav-link-icon-bullet-border-width) solid var(--cui-sidebar-nav-link-icon-bullet-border-color);
  border-radius: var(--cui-sidebar-nav-link-icon-bullet-border-radius);
}
.sidebar-nav svg.nav-icon {
  overflow: hidden;
}
.sidebar-nav .nav-group {
  position: relative;
  border: var(--cui-sidebar-nav-group-border-width) solid var(--cui-sidebar-nav-group-border-color);
  border-radius: var(--cui-sidebar-nav-group-border-radius);
  transition: background 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-group {
    transition: none;
  }
}
.sidebar-nav .nav-group .nav-group-items {
  padding: var(--cui-sidebar-nav-group-items-padding-y) var(--cui-sidebar-nav-group-items-padding-x);
  overflow: hidden;
  transition: height 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-group .nav-group-items {
    transition: none;
  }
}
.sidebar-nav .nav-group:not(.show) .nav-group-items {
  display: none;
}
.sidebar-nav .nav-group.show {
  background: var(--cui-sidebar-nav-group-bg);
}
.sidebar-nav .nav-group.show .nav-group-toggle {
  color: var(--cui-sidebar-nav-group-toggle-show-color);
}
.sidebar-nav .nav-group.show > .nav-group-toggle::after {
  transform: rotate(180deg);
}
.sidebar-nav .nav-group.show + .show {
  margin-top: var(--cui-sidebar-nav-gap);
}
.sidebar-nav .nav-group-toggle {
  cursor: pointer;
}
.sidebar-nav .nav-group-toggle::after {
  display: block;
  flex: 0 1 12px;
  height: 12px;
  margin-inline-start: auto;
  content: "";
  background-color: var(--cui-sidebar-nav-group-indicator-color);
  mask-image: var(--cui-sidebar-nav-group-indicator-icon);
  transition: transform 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-group-toggle::after {
    transition: none;
  }
}
.sidebar-nav .nav-group-items {
  padding: 0;
  list-style: none;
}
.sidebar-nav .nav-group-items .nav-link {
  padding-inline-start: calc(var(--cui-sidebar-nav-link-padding-x) + var(--cui-sidebar-nav-link-icon-width) + var(--cui-sidebar-nav-link-icon-margin));
}
.sidebar-nav .nav-group-items .nav-icon {
  margin-inline-start: calc(-1 * (var(--cui-sidebar-nav-link-icon-width) + var(--cui-sidebar-nav-link-icon-margin)));
}
.sidebar-nav.compact .nav-link,
.sidebar-nav .compact .nav-link {
  --cui-sidebar-nav-link-padding-y: 0.5625rem;
}

.sidebar-narrow, .sidebar-narrow-unfoldable:not(:hover) {
  --cui-sidebar-narrow-width: 4rem;
}
@media (min-width: 992px) {
  .sidebar-narrow, .sidebar-narrow-unfoldable:not(:hover) {
    flex: 0 0 var(--cui-sidebar-narrow-width);
    width: var(--cui-sidebar-narrow-width);
    padding-bottom: var(--cui-sidebar-toggler-height);
    overflow: visible;
  }
  .sidebar-narrow .sidebar-brand-full, .sidebar-narrow-unfoldable:not(:hover) .sidebar-brand-full {
    display: none;
  }
  .sidebar-narrow .sidebar-brand-narrow, .sidebar-narrow-unfoldable:not(:hover) .sidebar-brand-narrow {
    display: block;
  }
  .sidebar-narrow .sidebar-header, .sidebar-narrow-unfoldable:not(:hover) .sidebar-header {
    justify-content: center;
    padding-right: 0;
    padding-left: 0;
  }
  .sidebar-narrow .sidebar-nav, .sidebar-narrow-unfoldable:not(:hover) .sidebar-nav {
    --cui-sidebar-nav-link-padding-x: 0.5rem;
    --cui-sidebar-nav-link-padding-y: 0.75rem;
  }
  .sidebar-narrow .nav-link, .sidebar-narrow-unfoldable:not(:hover) .nav-link {
    overflow: hidden;
  }
  .sidebar-narrow .nav-icon, .sidebar-narrow-unfoldable:not(:hover) .nav-icon {
    flex: 0 0 calc(var(--cui-sidebar-narrow-width) - var(--cui-sidebar-nav-padding-x) * 2 - var(--cui-sidebar-nav-link-padding-x) * 2);
  }
  .sidebar-narrow .d-narrow-none, .sidebar-narrow-unfoldable:not(:hover) .d-narrow-none,
  .sidebar-narrow .nav-label,
  .sidebar-narrow-unfoldable:not(:hover) .nav-label,
  .sidebar-narrow .nav-title,
  .sidebar-narrow-unfoldable:not(:hover) .nav-title,
  .sidebar-narrow .nav-group-items,
  .sidebar-narrow-unfoldable:not(:hover) .nav-group-items,
  .sidebar-narrow .nav-group.show .nav-group-items,
  .sidebar-narrow .sidebar-form,
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-form {
    height: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    visibility: hidden;
    opacity: 0;
  }
  .sidebar-narrow .sidebar-toggler::before, .sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler::before {
    transform: rotate(-180deg);
  }
  .sidebar-narrow.sidebar-end .sidebar-toggler::before, .sidebar-end.sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler::before {
    transform: rotate(0deg);
  }
}

.sidebar-narrow-unfoldable {
  --cui-sidebar-narrow-unfoldable-box-shadow: var(--cui-box-shadow);
}
.sidebar-narrow-unfoldable:hover {
  box-shadow: var(--cui-sidebar-narrow-unfoldable-box-shadow);
  box-shadow: 0 0.5rem 1rem rgba(8, 10, 12, 0.15);
}
.sidebar-narrow-unfoldable:hover .sidebar-toggler::before {
  transform: rotate(-180deg);
}
.sidebar-narrow-unfoldable:hover.sidebar-end .sidebar-toggler::before {
  transform: rotate(0deg);
}

@media (min-width: 992px) {
  .sidebar-narrow:not(.sidebar-end):not(.hide) ~ *,
  .sidebar-narrow-unfoldable:not(.sidebar-end):not(.hide) ~ * {
    --cui-sidebar-occupy-start: 4rem;
  }
  .sidebar-narrow.sidebar-end:not(.hide) ~ *,
  .sidebar-narrow-unfoldable.sidebar-end:not(.hide) ~ * {
    --cui-sidebar-occupy-end: 4rem;
  }
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: rgba(var(--cui-primary-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: rgba(var(--cui-secondary-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #080a0c !important;
  background-color: rgba(var(--cui-success-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #080a0c !important;
  background-color: rgba(var(--cui-info-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #080a0c !important;
  background-color: rgba(var(--cui-warning-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #080a0c !important;
  background-color: rgba(var(--cui-danger-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #080a0c !important;
  background-color: rgba(var(--cui-light-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: rgba(var(--cui-dark-rgb), var(--cui-bg-opacity, 1)) !important;
}

[data-coreui-theme=dark] .text-bg-primary {
  color: #fff !important;
  background-color: rgba(94.2, 92.4, 207.6, var(--cui-bg-opacity, 1)) !important;
}
[data-coreui-theme=dark] .text-bg-secondary {
  color: #fff !important;
  background-color: rgba(107, 119, 133, var(--cui-bg-opacity, 1)) !important;
}
[data-coreui-theme=dark] .text-bg-success {
  color: #080a0c !important;
  background-color: rgba(33.55, 151.45, 65.05, var(--cui-bg-opacity, 1)) !important;
}
[data-coreui-theme=dark] .text-bg-info {
  color: #080a0c !important;
  background-color: rgba(61.2, 153, 244.8, var(--cui-bg-opacity, 1)) !important;
}
[data-coreui-theme=dark] .text-bg-warning {
  color: #080a0c !important;
  background-color: rgba(237.6, 172.8, 32.4, var(--cui-bg-opacity, 1)) !important;
}
[data-coreui-theme=dark] .text-bg-danger {
  color: #080a0c !important;
  background-color: rgba(221.7, 90.3, 90.3, var(--cui-bg-opacity, 1)) !important;
}
[data-coreui-theme=dark] .text-bg-light {
  color: #080a0c !important;
  background-color: rgba(243, 244, 247, var(--cui-bg-opacity, 1)) !important;
}
[data-coreui-theme=dark] .text-bg-dark {
  color: #fff !important;
  background-color: rgba(33, 38, 49, var(--cui-bg-opacity, 1)) !important;
}

.link-primary {
  color: rgba(var(--cui-primary-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(var(--cui-primary-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: rgba(70.4, 68.8, 171.2, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(70.4, 68.8, 171.2, var(--cui-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: rgba(var(--cui-secondary-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(var(--cui-secondary-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: rgba(85.6, 95.2, 106.4, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(85.6, 95.2, 106.4, var(--cui-link-underline-opacity, 1)) !important;
}

.link-success {
  color: rgba(var(--cui-success-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(var(--cui-success-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: rgba(72.6, 177.4, 100.6, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(72.6, 177.4, 100.6, var(--cui-link-underline-opacity, 1)) !important;
}

.link-info {
  color: rgba(var(--cui-info-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(var(--cui-info-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: rgba(91.8, 173.4, 255, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(91.8, 173.4, 255, var(--cui-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: rgba(var(--cui-warning-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(var(--cui-warning-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: rgba(250.2, 192.6, 67.8, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(250.2, 192.6, 67.8, var(--cui-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: rgba(var(--cui-danger-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(var(--cui-danger-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: rgba(234.2, 117.4, 117.4, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(234.2, 117.4, 117.4, var(--cui-link-underline-opacity, 1)) !important;
}

.link-light {
  color: rgba(var(--cui-light-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(var(--cui-light-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: rgba(245.4, 246.2, 248.6, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(245.4, 246.2, 248.6, var(--cui-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: rgba(var(--cui-dark-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(var(--cui-dark-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: rgba(26.4, 30.4, 39.2, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(26.4, 30.4, 39.2, var(--cui-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: rgba(var(--cui-emphasis-color-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(var(--cui-emphasis-color-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: rgba(var(--cui-emphasis-color-rgb), var(--cui-link-opacity, 0.75)) !important;
  text-decoration-color: rgba(var(--cui-emphasis-color-rgb), var(--cui-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--cui-focus-ring-x, 0) var(--cui-focus-ring-y, 0) var(--cui-focus-ring-blur, 0) var(--cui-focus-ring-width) var(--cui-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--cui-link-color-rgb), var(--cui-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--cui-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--cui-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --cui-aspect-ratio: 100%;
}

.ratio-4x3 {
  --cui-aspect-ratio: 75%;
}

.ratio-16x9 {
  --cui-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --cui-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}
.visually-hidden *,
.visually-hidden-focusable:not(:focus):not(:focus-within) * {
  overflow: hidden !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--cui-border-width);
  min-height: 1em;
  padding: 0;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: inline-start !important;
}

.float-end {
  float: inline-end !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--cui-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--cui-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--cui-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --cui-focus-ring-color: rgba(var(--cui-primary-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-secondary {
  --cui-focus-ring-color: rgba(var(--cui-secondary-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-success {
  --cui-focus-ring-color: rgba(var(--cui-success-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-info {
  --cui-focus-ring-color: rgba(var(--cui-info-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-warning {
  --cui-focus-ring-color: rgba(var(--cui-warning-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-danger {
  --cui-focus-ring-color: rgba(var(--cui-danger-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-light {
  --cui-focus-ring-color: rgba(var(--cui-light-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-dark {
  --cui-focus-ring-color: rgba(var(--cui-dark-rgb), var(--cui-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  inset-inline-start: 0 !important;
}

.start-50 {
  inset-inline-start: 50% !important;
}

.start-100 {
  inset-inline-start: 100% !important;
}

.end-0 {
  inset-inline-end: 0 !important;
}

.end-50 {
  inset-inline-end: 50% !important;
}

.end-100 {
  inset-inline-end: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-inline-end: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-end-0 {
  border-inline-end: 0 !important;
}

.border-bottom {
  border-bottom: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-inline-start: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-start-0 {
  border-inline-start: 0 !important;
}

.border-primary {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-primary-rgb), var(--cui-border-opacity)) !important;
}

.border-secondary {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-secondary-rgb), var(--cui-border-opacity)) !important;
}

.border-success {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-success-rgb), var(--cui-border-opacity)) !important;
}

.border-info {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-info-rgb), var(--cui-border-opacity)) !important;
}

.border-warning {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-warning-rgb), var(--cui-border-opacity)) !important;
}

.border-danger {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-danger-rgb), var(--cui-border-opacity)) !important;
}

.border-light {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-light-rgb), var(--cui-border-opacity)) !important;
}

.border-dark {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-dark-rgb), var(--cui-border-opacity)) !important;
}

.border-black {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-black-rgb), var(--cui-border-opacity)) !important;
}

.border-white {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-white-rgb), var(--cui-border-opacity)) !important;
}

.border-top-primary {
  border-top-color: #5856d6 !important;
}

.border-top-secondary {
  border-top-color: #6b7785 !important;
}

.border-top-success {
  border-top-color: #1b9e3e !important;
}

.border-top-info {
  border-top-color: #39f !important;
}

.border-top-warning {
  border-top-color: #f9b115 !important;
}

.border-top-danger {
  border-top-color: #e55353 !important;
}

.border-top-light {
  border-top-color: #f3f4f7 !important;
}

.border-top-dark {
  border-top-color: #212631 !important;
}

.border-top-white {
  border-top-color: #fff !important;
}

.border-end-primary {
  border-inline-end-color: #5856d6 !important;
}

.border-end-secondary {
  border-inline-end-color: #6b7785 !important;
}

.border-end-success {
  border-inline-end-color: #1b9e3e !important;
}

.border-end-info {
  border-inline-end-color: #39f !important;
}

.border-end-warning {
  border-inline-end-color: #f9b115 !important;
}

.border-end-danger {
  border-inline-end-color: #e55353 !important;
}

.border-end-light {
  border-inline-end-color: #f3f4f7 !important;
}

.border-end-dark {
  border-inline-end-color: #212631 !important;
}

.border-end-white {
  border-inline-end-color: #fff !important;
}

.border-bottom-primary {
  border-bottom-color: #5856d6 !important;
}

.border-bottom-secondary {
  border-bottom-color: #6b7785 !important;
}

.border-bottom-success {
  border-bottom-color: #1b9e3e !important;
}

.border-bottom-info {
  border-bottom-color: #39f !important;
}

.border-bottom-warning {
  border-bottom-color: #f9b115 !important;
}

.border-bottom-danger {
  border-bottom-color: #e55353 !important;
}

.border-bottom-light {
  border-bottom-color: #f3f4f7 !important;
}

.border-bottom-dark {
  border-bottom-color: #212631 !important;
}

.border-bottom-white {
  border-bottom-color: #fff !important;
}

.border-start-primary {
  border-inline-start-color: #5856d6 !important;
}

.border-start-secondary {
  border-inline-start-color: #6b7785 !important;
}

.border-start-success {
  border-inline-start-color: #1b9e3e !important;
}

.border-start-info {
  border-inline-start-color: #39f !important;
}

.border-start-warning {
  border-inline-start-color: #f9b115 !important;
}

.border-start-danger {
  border-inline-start-color: #e55353 !important;
}

.border-start-light {
  border-inline-start-color: #f3f4f7 !important;
}

.border-start-dark {
  border-inline-start-color: #212631 !important;
}

.border-start-white {
  border-inline-start-color: #fff !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-top-1 {
  border-top-width: 1px !important;
}

.border-top-2 {
  border-top-width: 2px !important;
}

.border-top-3 {
  border-top-width: 3px !important;
}

.border-top-4 {
  border-top-width: 4px !important;
}

.border-top-5 {
  border-top-width: 5px !important;
}

.border-end-1 {
  border-inline-end-width: 1px !important;
}

.border-end-2 {
  border-inline-end-width: 2px !important;
}

.border-end-3 {
  border-inline-end-width: 3px !important;
}

.border-end-4 {
  border-inline-end-width: 4px !important;
}

.border-end-5 {
  border-inline-end-width: 5px !important;
}

.border-bottom-1 {
  border-bottom-width: 1px !important;
}

.border-bottom-2 {
  border-bottom-width: 2px !important;
}

.border-bottom-3 {
  border-bottom-width: 3px !important;
}

.border-bottom-4 {
  border-bottom-width: 4px !important;
}

.border-bottom-5 {
  border-bottom-width: 5px !important;
}

.border-start-1 {
  border-inline-start-width: 1px !important;
}

.border-start-2 {
  border-inline-start-width: 2px !important;
}

.border-start-3 {
  border-inline-start-width: 3px !important;
}

.border-start-4 {
  border-inline-start-width: 4px !important;
}

.border-start-5 {
  border-inline-start-width: 5px !important;
}

.border-primary-subtle {
  border-color: var(--cui-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--cui-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--cui-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--cui-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--cui-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--cui-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--cui-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--cui-dark-border-subtle) !important;
}

.border-opacity-10 {
  --cui-border-opacity: 0.1;
}

.border-opacity-25 {
  --cui-border-opacity: 0.25;
}

.border-opacity-50 {
  --cui-border-opacity: 0.5;
}

.border-opacity-75 {
  --cui-border-opacity: 0.75;
}

.border-opacity-100 {
  --cui-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-inline-end: 0 !important;
}

.me-1 {
  margin-inline-end: 0.25rem !important;
}

.me-2 {
  margin-inline-end: 0.5rem !important;
}

.me-3 {
  margin-inline-end: 1rem !important;
}

.me-4 {
  margin-inline-end: 1.5rem !important;
}

.me-5 {
  margin-inline-end: 3rem !important;
}

.me-auto {
  margin-inline-end: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-inline-start: 0 !important;
}

.ms-1 {
  margin-inline-start: 0.25rem !important;
}

.ms-2 {
  margin-inline-start: 0.5rem !important;
}

.ms-3 {
  margin-inline-start: 1rem !important;
}

.ms-4 {
  margin-inline-start: 1.5rem !important;
}

.ms-5 {
  margin-inline-start: 3rem !important;
}

.ms-auto {
  margin-inline-start: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-inline-end: 0 !important;
}

.pe-1 {
  padding-inline-end: 0.25rem !important;
}

.pe-2 {
  padding-inline-end: 0.5rem !important;
}

.pe-3 {
  padding-inline-end: 1rem !important;
}

.pe-4 {
  padding-inline-end: 1.5rem !important;
}

.pe-5 {
  padding-inline-end: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-inline-start: 0 !important;
}

.ps-1 {
  padding-inline-start: 0.25rem !important;
}

.ps-2 {
  padding-inline-start: 0.5rem !important;
}

.ps-3 {
  padding-inline-start: 1rem !important;
}

.ps-4 {
  padding-inline-start: 1.5rem !important;
}

.ps-5 {
  padding-inline-start: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--cui-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: start !important;
}

.text-end {
  text-align: end !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
[data-coreui-theme=dark] .dark\\:text-primary, [data-coreui-theme=dark] .dark\\:text-primary:not([class*="dark:"]),
.text-primary {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-primary-rgb), var(--cui-text-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:text-secondary, [data-coreui-theme=dark] .dark\\:text-secondary:not([class*="dark:"]),
.text-secondary {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-secondary-rgb), var(--cui-text-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:text-success, [data-coreui-theme=dark] .dark\\:text-success:not([class*="dark:"]),
.text-success {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-success-rgb), var(--cui-text-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:text-info, [data-coreui-theme=dark] .dark\\:text-info:not([class*="dark:"]),
.text-info {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-info-rgb), var(--cui-text-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:text-warning, [data-coreui-theme=dark] .dark\\:text-warning:not([class*="dark:"]),
.text-warning {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-warning-rgb), var(--cui-text-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:text-danger, [data-coreui-theme=dark] .dark\\:text-danger:not([class*="dark:"]),
.text-danger {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-danger-rgb), var(--cui-text-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:text-light, [data-coreui-theme=dark] .dark\\:text-light:not([class*="dark:"]),
.text-light {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-light-rgb), var(--cui-text-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:text-dark, [data-coreui-theme=dark] .dark\\:text-dark:not([class*="dark:"]),
.text-dark {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-dark-rgb), var(--cui-text-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:text-black, [data-coreui-theme=dark] .dark\\:text-black:not([class*="dark:"]),
.text-black {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-black-rgb), var(--cui-text-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:text-white, [data-coreui-theme=dark] .dark\\:text-white:not([class*="dark:"]),
.text-white {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-white-rgb), var(--cui-text-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:text-body, [data-coreui-theme=dark] .dark\\:text-body:not([class*="dark:"]),
.text-body {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-body-color-rgb), var(--cui-text-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:text-muted, [data-coreui-theme=dark] .dark\\:text-muted:not([class*="dark:"]),
.text-muted {
  --cui-text-opacity: 1;
  color: var(--cui-secondary-color) !important;
}

[data-coreui-theme=dark] .dark\\:text-black-50, [data-coreui-theme=dark] .dark\\:text-black-50:not([class*="dark:"]),
.text-black-50 {
  --cui-text-opacity: 1;
  color: rgba(8, 10, 12, 0.5) !important;
}

[data-coreui-theme=dark] .dark\\:text-white-50, [data-coreui-theme=dark] .dark\\:text-white-50:not([class*="dark:"]),
.text-white-50 {
  --cui-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

[data-coreui-theme=dark] .dark\\:text-body-secondary, [data-coreui-theme=dark] .dark\\:text-body-secondary:not([class*="dark:"]),
.text-body-secondary {
  --cui-text-opacity: 1;
  color: var(--cui-secondary-color) !important;
}

[data-coreui-theme=dark] .dark\\:text-body-tertiary, [data-coreui-theme=dark] .dark\\:text-body-tertiary:not([class*="dark:"]),
.text-body-tertiary {
  --cui-text-opacity: 1;
  color: var(--cui-tertiary-color) !important;
}

[data-coreui-theme=dark] .dark\\:text-body-emphasis, [data-coreui-theme=dark] .dark\\:text-body-emphasis:not([class*="dark:"]),
.text-body-emphasis {
  --cui-text-opacity: 1;
  color: var(--cui-emphasis-color) !important;
}

[data-coreui-theme=dark] .dark\\:text-reset, [data-coreui-theme=dark] .dark\\:text-reset:not([class*="dark:"]),
.text-reset {
  --cui-text-opacity: 1;
  color: inherit !important;
}

[data-coreui-theme=dark] .dark\\:text-high-emphasis-inverse, [data-coreui-theme=dark] .dark\\:text-high-emphasis-inverse:not([class*="dark:"]),
.text-high-emphasis-inverse {
  --cui-text-opacity: 1;
  color: var(--cui-high-emphasis-inverse) !important;
}

[data-coreui-theme=dark] .dark\\:text-medium-emphasis-inverse, [data-coreui-theme=dark] .dark\\:text-medium-emphasis-inverse:not([class*="dark:"]),
.text-medium-emphasis-inverse {
  --cui-text-opacity: 1;
  color: var(--cui-medium-emphasis-inverse) !important;
}

[data-coreui-theme=dark] .dark\\:text-disabled-inverse, [data-coreui-theme=dark] .dark\\:text-disabled-inverse:not([class*="dark:"]),
.text-disabled-inverse {
  --cui-text-opacity: 1;
  color: var(--cui-disabled-inverse) !important;
}

[data-coreui-theme=dark] .dark\\:text-high-emphasis, [data-coreui-theme=dark] .dark\\:text-high-emphasis:not([class*="dark:"]),
.text-high-emphasis {
  --cui-text-opacity: 1;
  color: var(--cui-high-emphasis) !important;
}

[data-coreui-theme=dark] .dark\\:text-medium-emphasis, [data-coreui-theme=dark] .dark\\:text-medium-emphasis:not([class*="dark:"]),
.text-medium-emphasis {
  --cui-text-opacity: 1;
  color: var(--cui-medium-emphasis) !important;
}

[data-coreui-theme=dark] .dark\\:text-disabled, [data-coreui-theme=dark] .dark\\:text-disabled:not([class*="dark:"]),
.text-disabled {
  --cui-text-opacity: 1;
  color: var(--cui-disabled) !important;
}

.text-opacity-25 {
  --cui-text-opacity: 0.25;
}

.text-opacity-50 {
  --cui-text-opacity: 0.5;
}

.text-opacity-75 {
  --cui-text-opacity: 0.75;
}

.text-opacity-100 {
  --cui-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--cui-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--cui-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--cui-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--cui-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--cui-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--cui-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--cui-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--cui-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --cui-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --cui-link-opacity: 0.1;
}

.link-opacity-25 {
  --cui-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --cui-link-opacity: 0.25;
}

.link-opacity-50 {
  --cui-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --cui-link-opacity: 0.5;
}

.link-opacity-75 {
  --cui-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --cui-link-opacity: 0.75;
}

.link-opacity-100 {
  --cui-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --cui-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-primary-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-secondary-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-success {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-success-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-info {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-info-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-warning {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-warning-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-danger {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-danger-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-light {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-light-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-dark {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-dark-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-link-color-rgb), var(--cui-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --cui-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --cui-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --cui-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --cui-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --cui-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --cui-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --cui-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --cui-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --cui-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --cui-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --cui-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --cui-link-underline-opacity: 1;
}

[data-coreui-theme=dark] .dark\\:bg-primary, [data-coreui-theme=dark] .dark\\:bg-primary:not([class*="dark:"]),
.bg-primary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-primary-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-secondary, [data-coreui-theme=dark] .dark\\:bg-secondary:not([class*="dark:"]),
.bg-secondary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-secondary-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-success, [data-coreui-theme=dark] .dark\\:bg-success:not([class*="dark:"]),
.bg-success {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-success-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-info, [data-coreui-theme=dark] .dark\\:bg-info:not([class*="dark:"]),
.bg-info {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-info-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-warning, [data-coreui-theme=dark] .dark\\:bg-warning:not([class*="dark:"]),
.bg-warning {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-warning-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-danger, [data-coreui-theme=dark] .dark\\:bg-danger:not([class*="dark:"]),
.bg-danger {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-danger-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-light, [data-coreui-theme=dark] .dark\\:bg-light:not([class*="dark:"]),
.bg-light {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-light-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-dark, [data-coreui-theme=dark] .dark\\:bg-dark:not([class*="dark:"]),
.bg-dark {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-dark-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-black, [data-coreui-theme=dark] .dark\\:bg-black:not([class*="dark:"]),
.bg-black {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-black-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-white, [data-coreui-theme=dark] .dark\\:bg-white:not([class*="dark:"]),
.bg-white {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-white-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-body, [data-coreui-theme=dark] .dark\\:bg-body:not([class*="dark:"]),
.bg-body {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-body-bg-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-transparent, [data-coreui-theme=dark] .dark\\:bg-transparent:not([class*="dark:"]),
.bg-transparent {
  --cui-bg-opacity: 1;
  background-color: transparent !important;
}

[data-coreui-theme=dark] .dark\\:bg-body-secondary, [data-coreui-theme=dark] .dark\\:bg-body-secondary:not([class*="dark:"]),
.bg-body-secondary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-secondary-bg-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-body-tertiary, [data-coreui-theme=dark] .dark\\:bg-body-tertiary:not([class*="dark:"]),
.bg-body-tertiary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-tertiary-bg-rgb), var(--cui-bg-opacity)) !important;
}

.bg-opacity-10 {
  --cui-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --cui-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --cui-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --cui-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --cui-bg-opacity: 1;
}

[data-coreui-theme=dark] .dark\\:bg-primary-subtle, [data-coreui-theme=dark] .dark\\:bg-primary-subtle:not([class*="dark:"]),
.bg-primary-subtle {
  background-color: var(--cui-primary-bg-subtle) !important;
}

[data-coreui-theme=dark] .dark\\:bg-secondary-subtle, [data-coreui-theme=dark] .dark\\:bg-secondary-subtle:not([class*="dark:"]),
.bg-secondary-subtle {
  background-color: var(--cui-secondary-bg-subtle) !important;
}

[data-coreui-theme=dark] .dark\\:bg-success-subtle, [data-coreui-theme=dark] .dark\\:bg-success-subtle:not([class*="dark:"]),
.bg-success-subtle {
  background-color: var(--cui-success-bg-subtle) !important;
}

[data-coreui-theme=dark] .dark\\:bg-info-subtle, [data-coreui-theme=dark] .dark\\:bg-info-subtle:not([class*="dark:"]),
.bg-info-subtle {
  background-color: var(--cui-info-bg-subtle) !important;
}

[data-coreui-theme=dark] .dark\\:bg-warning-subtle, [data-coreui-theme=dark] .dark\\:bg-warning-subtle:not([class*="dark:"]),
.bg-warning-subtle {
  background-color: var(--cui-warning-bg-subtle) !important;
}

[data-coreui-theme=dark] .dark\\:bg-danger-subtle, [data-coreui-theme=dark] .dark\\:bg-danger-subtle:not([class*="dark:"]),
.bg-danger-subtle {
  background-color: var(--cui-danger-bg-subtle) !important;
}

[data-coreui-theme=dark] .dark\\:bg-light-subtle, [data-coreui-theme=dark] .dark\\:bg-light-subtle:not([class*="dark:"]),
.bg-light-subtle {
  background-color: var(--cui-light-bg-subtle) !important;
}

[data-coreui-theme=dark] .dark\\:bg-dark-subtle, [data-coreui-theme=dark] .dark\\:bg-dark-subtle:not([class*="dark:"]),
.bg-dark-subtle {
  background-color: var(--cui-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--cui-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--cui-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--cui-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--cui-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--cui-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--cui-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--cui-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--cui-border-radius) !important;
  border-top-right-radius: var(--cui-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--cui-border-radius-sm) !important;
  border-top-right-radius: var(--cui-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--cui-border-radius) !important;
  border-top-right-radius: var(--cui-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--cui-border-radius-lg) !important;
  border-top-right-radius: var(--cui-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--cui-border-radius-xl) !important;
  border-top-right-radius: var(--cui-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--cui-border-radius-xxl) !important;
  border-top-right-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--cui-border-radius-pill) !important;
  border-top-right-radius: var(--cui-border-radius-pill) !important;
}

.rounded-end {
  border-start-end-radius: var(--cui-border-radius) !important;
  border-end-end-radius: var(--cui-border-radius) !important;
}

.rounded-end-0 {
  border-start-end-radius: 0 !important;
  border-end-end-radius: 0 !important;
}

.rounded-end-1 {
  border-start-end-radius: var(--cui-border-radius-sm) !important;
  border-end-end-radius: var(--cui-border-radius-sm) !important;
}

.rounded-end-2 {
  border-start-end-radius: var(--cui-border-radius) !important;
  border-end-end-radius: var(--cui-border-radius) !important;
}

.rounded-end-3 {
  border-start-end-radius: var(--cui-border-radius-lg) !important;
  border-end-end-radius: var(--cui-border-radius-lg) !important;
}

.rounded-end-4 {
  border-start-end-radius: var(--cui-border-radius-xl) !important;
  border-end-end-radius: var(--cui-border-radius-xl) !important;
}

.rounded-end-5 {
  border-start-end-radius: var(--cui-border-radius-xxl) !important;
  border-end-end-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-start-end-radius: 50% !important;
  border-end-end-radius: 50% !important;
}

.rounded-end-pill {
  border-start-end-radius: var(--cui-border-radius-pill) !important;
  border-end-end-radius: var(--cui-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--cui-border-radius) !important;
  border-bottom-left-radius: var(--cui-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--cui-border-radius-sm) !important;
  border-bottom-left-radius: var(--cui-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--cui-border-radius) !important;
  border-bottom-left-radius: var(--cui-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--cui-border-radius-lg) !important;
  border-bottom-left-radius: var(--cui-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--cui-border-radius-xl) !important;
  border-bottom-left-radius: var(--cui-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--cui-border-radius-xxl) !important;
  border-bottom-left-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--cui-border-radius-pill) !important;
  border-bottom-left-radius: var(--cui-border-radius-pill) !important;
}

.rounded-start {
  border-end-start-radius: var(--cui-border-radius) !important;
  border-start-start-radius: var(--cui-border-radius) !important;
}

.rounded-start-0 {
  border-end-start-radius: 0 !important;
  border-start-start-radius: 0 !important;
}

.rounded-start-1 {
  border-end-start-radius: var(--cui-border-radius-sm) !important;
  border-start-start-radius: var(--cui-border-radius-sm) !important;
}

.rounded-start-2 {
  border-end-start-radius: var(--cui-border-radius) !important;
  border-start-start-radius: var(--cui-border-radius) !important;
}

.rounded-start-3 {
  border-end-start-radius: var(--cui-border-radius-lg) !important;
  border-start-start-radius: var(--cui-border-radius-lg) !important;
}

.rounded-start-4 {
  border-end-start-radius: var(--cui-border-radius-xl) !important;
  border-start-start-radius: var(--cui-border-radius-xl) !important;
}

.rounded-start-5 {
  border-end-start-radius: var(--cui-border-radius-xxl) !important;
  border-start-start-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-end-start-radius: 50% !important;
  border-start-start-radius: 50% !important;
}

.rounded-start-pill {
  border-end-start-radius: var(--cui-border-radius-pill) !important;
  border-start-start-radius: var(--cui-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: inline-start !important;
  }
  .float-sm-end {
    float: inline-end !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-inline-end: 0 !important;
  }
  .me-sm-1 {
    margin-inline-end: 0.25rem !important;
  }
  .me-sm-2 {
    margin-inline-end: 0.5rem !important;
  }
  .me-sm-3 {
    margin-inline-end: 1rem !important;
  }
  .me-sm-4 {
    margin-inline-end: 1.5rem !important;
  }
  .me-sm-5 {
    margin-inline-end: 3rem !important;
  }
  .me-sm-auto {
    margin-inline-end: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-inline-start: 0 !important;
  }
  .ms-sm-1 {
    margin-inline-start: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-inline-start: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-inline-start: 1rem !important;
  }
  .ms-sm-4 {
    margin-inline-start: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-inline-start: 3rem !important;
  }
  .ms-sm-auto {
    margin-inline-start: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-inline-end: 0 !important;
  }
  .pe-sm-1 {
    padding-inline-end: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-inline-end: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-inline-end: 1rem !important;
  }
  .pe-sm-4 {
    padding-inline-end: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-inline-end: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-inline-start: 0 !important;
  }
  .ps-sm-1 {
    padding-inline-start: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-inline-start: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-inline-start: 1rem !important;
  }
  .ps-sm-4 {
    padding-inline-start: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-inline-start: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: start !important;
  }
  .text-sm-end {
    text-align: end !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: inline-start !important;
  }
  .float-md-end {
    float: inline-end !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-inline-end: 0 !important;
  }
  .me-md-1 {
    margin-inline-end: 0.25rem !important;
  }
  .me-md-2 {
    margin-inline-end: 0.5rem !important;
  }
  .me-md-3 {
    margin-inline-end: 1rem !important;
  }
  .me-md-4 {
    margin-inline-end: 1.5rem !important;
  }
  .me-md-5 {
    margin-inline-end: 3rem !important;
  }
  .me-md-auto {
    margin-inline-end: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-inline-start: 0 !important;
  }
  .ms-md-1 {
    margin-inline-start: 0.25rem !important;
  }
  .ms-md-2 {
    margin-inline-start: 0.5rem !important;
  }
  .ms-md-3 {
    margin-inline-start: 1rem !important;
  }
  .ms-md-4 {
    margin-inline-start: 1.5rem !important;
  }
  .ms-md-5 {
    margin-inline-start: 3rem !important;
  }
  .ms-md-auto {
    margin-inline-start: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-inline-end: 0 !important;
  }
  .pe-md-1 {
    padding-inline-end: 0.25rem !important;
  }
  .pe-md-2 {
    padding-inline-end: 0.5rem !important;
  }
  .pe-md-3 {
    padding-inline-end: 1rem !important;
  }
  .pe-md-4 {
    padding-inline-end: 1.5rem !important;
  }
  .pe-md-5 {
    padding-inline-end: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-inline-start: 0 !important;
  }
  .ps-md-1 {
    padding-inline-start: 0.25rem !important;
  }
  .ps-md-2 {
    padding-inline-start: 0.5rem !important;
  }
  .ps-md-3 {
    padding-inline-start: 1rem !important;
  }
  .ps-md-4 {
    padding-inline-start: 1.5rem !important;
  }
  .ps-md-5 {
    padding-inline-start: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: start !important;
  }
  .text-md-end {
    text-align: end !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: inline-start !important;
  }
  .float-lg-end {
    float: inline-end !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-inline-end: 0 !important;
  }
  .me-lg-1 {
    margin-inline-end: 0.25rem !important;
  }
  .me-lg-2 {
    margin-inline-end: 0.5rem !important;
  }
  .me-lg-3 {
    margin-inline-end: 1rem !important;
  }
  .me-lg-4 {
    margin-inline-end: 1.5rem !important;
  }
  .me-lg-5 {
    margin-inline-end: 3rem !important;
  }
  .me-lg-auto {
    margin-inline-end: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-inline-start: 0 !important;
  }
  .ms-lg-1 {
    margin-inline-start: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-inline-start: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-inline-start: 1rem !important;
  }
  .ms-lg-4 {
    margin-inline-start: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-inline-start: 3rem !important;
  }
  .ms-lg-auto {
    margin-inline-start: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-inline-end: 0 !important;
  }
  .pe-lg-1 {
    padding-inline-end: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-inline-end: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-inline-end: 1rem !important;
  }
  .pe-lg-4 {
    padding-inline-end: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-inline-end: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-inline-start: 0 !important;
  }
  .ps-lg-1 {
    padding-inline-start: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-inline-start: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-inline-start: 1rem !important;
  }
  .ps-lg-4 {
    padding-inline-start: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-inline-start: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: start !important;
  }
  .text-lg-end {
    text-align: end !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: inline-start !important;
  }
  .float-xl-end {
    float: inline-end !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-inline-end: 0 !important;
  }
  .me-xl-1 {
    margin-inline-end: 0.25rem !important;
  }
  .me-xl-2 {
    margin-inline-end: 0.5rem !important;
  }
  .me-xl-3 {
    margin-inline-end: 1rem !important;
  }
  .me-xl-4 {
    margin-inline-end: 1.5rem !important;
  }
  .me-xl-5 {
    margin-inline-end: 3rem !important;
  }
  .me-xl-auto {
    margin-inline-end: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-inline-start: 0 !important;
  }
  .ms-xl-1 {
    margin-inline-start: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-inline-start: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-inline-start: 1rem !important;
  }
  .ms-xl-4 {
    margin-inline-start: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-inline-start: 3rem !important;
  }
  .ms-xl-auto {
    margin-inline-start: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-inline-end: 0 !important;
  }
  .pe-xl-1 {
    padding-inline-end: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-inline-end: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-inline-end: 1rem !important;
  }
  .pe-xl-4 {
    padding-inline-end: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-inline-end: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-inline-start: 0 !important;
  }
  .ps-xl-1 {
    padding-inline-start: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-inline-start: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-inline-start: 1rem !important;
  }
  .ps-xl-4 {
    padding-inline-start: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-inline-start: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: start !important;
  }
  .text-xl-end {
    text-align: end !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: inline-start !important;
  }
  .float-xxl-end {
    float: inline-end !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-inline-end: 0 !important;
  }
  .me-xxl-1 {
    margin-inline-end: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-inline-end: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-inline-end: 1rem !important;
  }
  .me-xxl-4 {
    margin-inline-end: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-inline-end: 3rem !important;
  }
  .me-xxl-auto {
    margin-inline-end: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-inline-start: 0 !important;
  }
  .ms-xxl-1 {
    margin-inline-start: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-inline-start: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-inline-start: 1rem !important;
  }
  .ms-xxl-4 {
    margin-inline-start: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-inline-start: 3rem !important;
  }
  .ms-xxl-auto {
    margin-inline-start: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-inline-end: 0 !important;
  }
  .pe-xxl-1 {
    padding-inline-end: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-inline-end: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-inline-end: 1rem !important;
  }
  .pe-xxl-4 {
    padding-inline-end: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-inline-end: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-inline-start: 0 !important;
  }
  .ps-xxl-1 {
    padding-inline-start: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-inline-start: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-inline-start: 1rem !important;
  }
  .ps-xxl-4 {
    padding-inline-start: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-inline-start: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: start !important;
  }
  .text-xxl-end {
    text-align: end !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
/*!
 * CoreUI Plugins - Chart.js for CoreUI 3
 * @version v4.0.0
 * @link https://coreui.io
 * Copyright (c) 2023 creativeLabs Łukasz Holeczek
 * Licensed under MIT (https://github.com/coreui/coreui-chartjs/blob/main/LICENSE)
 */
.chartjs-tooltip {
  --cui-chartjs-tooltip-zindex: 1080;
  --cui-chartjs-tooltip-padding-x: 0.5rem;
  --cui-chartjs-tooltip-padding-y: 0.25rem;
  --cui-chartjs-tooltip-color: var(--cui-body-bg);
  --cui-chartjs-tooltip-bg: rgba(var(--cui-emphasis-color-rgb), 0.8);
  --cui-chartjs-tooltip-border-radius: var(--cui-border-radius);
  --cui-chartjs-tooltip-transition: all 0.15s ease;
  --cui-chartjs-tooltip-header-margin: 0.5rem;
  --cui-chartjs-tooltip-header-font-size: 0.875rem;
  --cui-chartjs-tooltip-header-font-weight: 700;
  --cui-chartjs-tooltip-body-font-size: 0.875rem;
  --cui-chartjs-tooltip-body-font-weight: 400;
  position: absolute;
  z-index: var(--cui-chartjs-tooltip-zindex);
  padding: var(--cui-chartjs-tooltip-padding-y) var(--cui-chartjs-tooltip-padding-x);
  color: var(--cui-chartjs-tooltip-color);
  pointer-events: none;
  background: var(--cui-chartjs-tooltip-bg);
  opacity: 0;
  transform: translate(-50%, 0);
  border-radius: var(--cui-chartjs-tooltip-border-radius);
  transition: var(--cui-chartjs-tooltip-transition);
}
@media (prefers-reduced-motion: reduce) {
  .chartjs-tooltip {
    transition: none;
  }
}

.chartjs-tooltip-header {
  margin-bottom: var(--cui-chartjs-tooltip-header-margin);
}

.chartjs-tooltip-header-item {
  font-size: var(--cui-chartjs-tooltip-header-font-size);
  font-weight: var(--cui-chartjs-tooltip-header-font-weight);
}

.chartjs-tooltip-body-item {
  align-items: center;
  font-size: var(--cui-chartjs-tooltip-body-font-size);
  font-weight: var(--cui-chartjs-tooltip-body-font-weight);
  white-space: nowrap;
}

.simplebar-content {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

:root {
  --transition-speed: 0.3s;
}

body {
  background-color: var(--cui-tertiary-bg);
}

.wrapper {
  width: 100%;
  padding-inline: var(--cui-sidebar-occupy-start, 0) var(--cui-sidebar-occupy-end, 0);
  will-change: auto;
  transition: padding 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .wrapper {
    transition: none;
  }
}

.header > .container-fluid,
.sidebar-header {
  min-height: calc(4rem + 1px);
}

.sidebar {
  --cui-sidebar-width: 16rem;
  --cui-sidebar-narrow-width: 4rem;
  --cui-sidebar-bg: #2c3e50;
  --cui-sidebar-color: #ecf0f1;
  --cui-sidebar-brand-color: #ffffff;
  --cui-sidebar-brand-bg: transparent;
  --cui-sidebar-nav-link-color: #ecf0f1;
  --cui-sidebar-nav-link-icon-color: #95a5a6;
  --cui-sidebar-nav-link-hover-color: #ffffff;
  --cui-sidebar-nav-link-hover-bg: rgba(255, 255, 255, 0.05);
  --cui-sidebar-nav-link-active-color: #ffffff;
  --cui-sidebar-nav-link-active-bg: rgba(255, 255, 255, 0.1);
  --cui-sidebar-nav-group-bg: rgba(0, 0, 0, 0.15);
  width: var(--cui-sidebar-width);
  transition: transform var(--transition-speed) ease, width var(--transition-speed) ease;
}
.sidebar .sidebar-brand-full {
  display: block;
  font-size: 1.25rem;
  font-weight: 600;
  transition: all var(--transition-speed) ease;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  cursor: pointer;
  color: var(--cui-sidebar-brand-color);
}
.sidebar .sidebar-brand-full:hover {
  color: #ffffff !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
}
.sidebar .sidebar-header {
  border-bottom: 1px solid #ffffff !important;
}
@media (prefers-color-scheme: light) {
  .sidebar .sidebar-header {
    border-bottom: 1px solid #ffffff !important;
  }
}
.sidebar .sidebar-footer {
  border-top: 1px solid #ffffff !important;
}
@media (prefers-color-scheme: light) {
  .sidebar .sidebar-footer {
    border-top: 1px solid #ffffff !important;
  }
}
.sidebar .sidebar-brand:hover {
  color: inherit !important;
  text-decoration: none !important;
  background-color: transparent !important;
}
.sidebar .sidebar-brand-narrow {
  display: none;
  font-size: 1.5rem;
  font-weight: 700;
  opacity: 0;
  transition: opacity var(--transition-speed) ease;
}
.sidebar .sidebar-toggler-wrapper {
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 0.375rem;
  transition: background-color 0.2s ease;
}
.sidebar .sidebar-toggler-wrapper:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.sidebar .sidebar-toggler-wrapper .sidebar-toggler-icon {
  width: 20px;
  height: 20px;
  color: var(--cui-sidebar-brand-color);
  transition: transform var(--transition-speed) ease;
}
.sidebar .sidebar-toggler-wrapper .sidebar-toggler-icon.rotated {
  transform: rotate(180deg);
}
@media (max-width: 768px) {
  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1031;
    width: var(--cui-sidebar-width);
    height: 100vh;
    transform: translateX(-100%);
  }
  .sidebar.show {
    transform: translateX(0);
  }
}
.sidebar.sidebar-narrow {
  width: var(--cui-sidebar-narrow-width);
}
.sidebar.sidebar-narrow .sidebar-brand-full {
  display: none;
  opacity: 0;
}
.sidebar.sidebar-narrow .sidebar-brand-narrow {
  display: block;
  opacity: 1;
}
.sidebar.sidebar-narrow .nav-label {
  display: none;
}
.sidebar.sidebar-narrow .nav-icon {
  margin-right: 0;
}
.sidebar.sidebar-narrow .nav-link {
  justify-content: center;
  padding: 0.5rem;
}
@media (min-width: 769px) {
  .sidebar.sidebar-narrow:hover {
    width: var(--cui-sidebar-width);
  }
  .sidebar.sidebar-narrow:hover .sidebar-brand-narrow {
    display: none;
    opacity: 0;
  }
  .sidebar.sidebar-narrow:hover .sidebar-brand-full {
    display: block;
    opacity: 1;
  }
  .sidebar.sidebar-narrow:hover .nav-label {
    display: inline;
  }
  .sidebar.sidebar-narrow:hover .nav-icon {
    margin-right: 0.5rem;
  }
  .sidebar.sidebar-narrow:hover .nav-link {
    justify-content: flex-start;
    padding: 0.5rem 1rem;
  }
}

.sidebar-brand {
  min-height: 4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
}

.sidebar-nav {
  overflow-y: auto;
  overflow-x: hidden;
}

.header > .container-fluid + .container-fluid {
  min-height: 3rem;
}

.footer {
  min-height: calc(3rem + 1px);
}

[data-coreui-theme=dark] body {
  background-color: var(--cui-dark-bg-subtle);
}
[data-coreui-theme=dark] .footer {
  --cui-footer-bg: var(--cui-body-bg);
}
[data-coreui-theme=dark] .sidebar {
  --cui-sidebar-bg: #1a1d24;
  --cui-sidebar-color: #e9ecef;
  --cui-sidebar-brand-color: #ffffff;
  --cui-sidebar-nav-link-color: #e9ecef;
  --cui-sidebar-nav-link-icon-color: #768390;
  --cui-sidebar-nav-group-bg: rgba(250, 0, 0, 0.2);
}
[data-coreui-theme=dark] .sidebar .sidebar-footer {
  border-top: 1px solid rgba(255, 255, 255, 0.2) !important;
}
[data-coreui-theme=dark] .sidebar .sidebar-header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-content {
  background-color: var(--cui-dark-bg, #212631) !important;
  color: var(--cui-body-color, #fff) !important;
  border-color: var(--cui-dark-border-subtle, #333) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-header {
  background-color: var(--cui-dark-bg, #212631) !important;
  border-color: var(--cui-dark-border-subtle, #333) !important;
  color: var(--cui-body-color, #fff) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-header .modal-title {
  color: var(--cui-body-color, #fff) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-header .btn-close {
  filter: invert(1) grayscale(100%) brightness(200%);
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body {
  background-color: var(--cui-dark-bg, #212631) !important;
  color: var(--cui-body-color, #fff) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body p {
  color: var(--cui-body-color, #fff) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .bg-light {
  background-color: var(--cui-dark-bg-subtle, #2c3034) !important;
  color: var(--cui-body-color, #fff) !important;
  border: 1px solid var(--cui-dark-border-subtle, #333) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .bg-light strong {
  color: var(--cui-body-color, #fff) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .bg-light br + strong {
  color: var(--cui-body-color, #fff) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .alert.alert-success {
  background-color: rgba(25, 135, 84, 0.1) !important;
  border-color: var(--cui-success) !important;
  color: var(--cui-body-color, #fff) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .alert.alert-success .alert-heading {
  color: var(--cui-success) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .alert.alert-success p {
  color: var(--cui-body-color, #fff) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .alert.alert-success .bg-white {
  background-color: var(--cui-dark-bg-subtle, #2c3034) !important;
  color: var(--cui-body-color, #fff) !important;
  border-color: var(--cui-dark-border-subtle, #333) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .alert.alert-success .bg-white strong {
  color: var(--cui-body-color, #fff) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .alert.alert-success .bg-white code {
  background-color: var(--cui-gray-900, #1a1a1a) !important;
  color: var(--cui-success) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .alert.alert-success .text-muted {
  color: var(--cui-secondary-color, #8a93a2) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .alert.alert-danger {
  background-color: rgba(220, 53, 69, 0.1) !important;
  border-color: var(--cui-danger) !important;
  color: var(--cui-body-color, #fff) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .alert.alert-danger .alert-heading {
  color: var(--cui-danger) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .alert.alert-danger p {
  color: var(--cui-body-color, #fff) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .alert.alert-warning {
  background-color: rgba(255, 193, 7, 0.1) !important;
  border-color: var(--cui-warning) !important;
  color: var(--cui-body-color, #fff) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .alert.alert-warning .alert-heading {
  color: var(--cui-warning) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .alert.alert-warning p {
  color: var(--cui-body-color, #fff) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .alert.alert-info {
  background-color: rgba(13, 202, 240, 0.1) !important;
  border-color: var(--cui-info) !important;
  color: var(--cui-body-color, #fff) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .alert.alert-info .alert-heading {
  color: var(--cui-info) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .alert.alert-info p {
  color: var(--cui-body-color, #fff) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .text-danger {
  color: var(--cui-danger) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .text-warning {
  color: var(--cui-warning) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .text-muted {
  color: var(--cui-secondary-color, #8a93a2) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .text-success {
  color: var(--cui-success) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body .text-info {
  color: var(--cui-info) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body small {
  color: inherit !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body small.text-muted {
  color: var(--cui-secondary-color, #8a93a2) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body small.text-danger {
  color: var(--cui-danger) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-body small.text-warning {
  color: var(--cui-warning) !important;
}
[data-coreui-theme=dark] .modal .modal-dialog .modal-footer {
  background-color: var(--cui-dark-bg, #212631) !important;
  border-color: var(--cui-dark-border-subtle, #333) !important;
}
[data-coreui-theme=dark] .modal-backdrop.show + .modal .modal-dialog .modal-content .modal-body .bg-light,
[data-coreui-theme=dark] .modal .modal-dialog .modal-content .modal-body .bg-light {
  background-color: #2c3034 !important;
  color: #ffffff !important;
  border: 1px solid #333 !important;
}
[data-coreui-theme=dark] .modal-backdrop.show + .modal .modal-dialog .modal-content .modal-body .bg-light strong,
[data-coreui-theme=dark] .modal .modal-dialog .modal-content .modal-body .bg-light strong {
  color: #ffffff !important;
}
[data-coreui-theme=dark] .modal-backdrop.show + .modal .modal-dialog .modal-content .modal-body,
[data-coreui-theme=dark] .modal .modal-dialog .modal-content .modal-body {
  background-color: #212631 !important;
  color: #ffffff !important;
}
[data-coreui-theme=dark] .modal-backdrop.show + .modal .modal-dialog .modal-content .modal-body p,
[data-coreui-theme=dark] .modal .modal-dialog .modal-content .modal-body p {
  color: #ffffff !important;
}

/* Excel-like table column resizing */
.col-resizer {
  position: absolute;
  top: 0;
  right: 0;
  width: 6px;
  height: 100%;
  cursor: col-resize;
  -webkit-user-select: none;
          user-select: none;
}

.table-header-cell {
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.col-resizer::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 2px;
  width: 2px; /* thicker baseline line */
  background: rgba(0, 0, 0, 0.12); /* visible even without hover */
  transition: background 0.15s ease-in-out, width 0.15s ease-in-out;
}

.col-resizer:hover::after {
  background: rgba(0, 0, 0, 0.28);
  width: 3px; /* slightly thicker on hover */
}`, "",{"version":3,"sources":["webpack://./src/scss/style.scss","webpack://./node_modules/@coreui/coreui/scss/_banner.scss","webpack://./node_modules/@coreui/coreui/scss/_root.scss","webpack://./node_modules/@coreui/coreui/scss/vendor/_rfs.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_color-mode.scss","webpack://./node_modules/@coreui/coreui/scss/_reboot.scss","webpack://./node_modules/@coreui/coreui/scss/_variables.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_border-radius.scss","webpack://./node_modules/@coreui/coreui/scss/_type.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_lists.scss","webpack://./node_modules/@coreui/coreui/scss/_images.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_image.scss","webpack://./node_modules/@coreui/coreui/scss/_containers.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_container.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_breakpoints.scss","webpack://./node_modules/@coreui/coreui/scss/_grid.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_grid.scss","webpack://./node_modules/@coreui/coreui/scss/_tables.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_table-variants.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_labels.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-text.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-control.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_transition.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_gradients.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-select.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_ltr-rtl.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-check.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-range.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_floating-labels.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_input-group.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_forms.scss","webpack://./node_modules/@coreui/coreui/scss/_buttons.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_buttons.scss","webpack://./node_modules/@coreui/coreui/scss/_transitions.scss","webpack://./node_modules/@coreui/coreui/scss/_dropdown.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_caret.scss","webpack://./node_modules/@coreui/coreui/scss/_button-group.scss","webpack://./node_modules/@coreui/coreui/scss/_nav.scss","webpack://./node_modules/@coreui/coreui/scss/_navbar.scss","webpack://./node_modules/@coreui/coreui/scss/_card.scss","webpack://./node_modules/@coreui/coreui/scss/_accordion.scss","webpack://./node_modules/@coreui/coreui/scss/_breadcrumb.scss","webpack://./node_modules/@coreui/coreui/scss/_pagination.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_pagination.scss","webpack://./node_modules/@coreui/coreui/scss/_badge.scss","webpack://./node_modules/@coreui/coreui/scss/_alert.scss","webpack://./node_modules/@coreui/coreui/scss/_progress.scss","webpack://./node_modules/@coreui/coreui/scss/_list-group.scss","webpack://./node_modules/@coreui/coreui/scss/_close.scss","webpack://./node_modules/@coreui/coreui/scss/_toasts.scss","webpack://./node_modules/@coreui/coreui/scss/_modal.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_backdrop.scss","webpack://./node_modules/@coreui/coreui/scss/_tooltip.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_reset-text.scss","webpack://./node_modules/@coreui/coreui/scss/_popover.scss","webpack://./node_modules/@coreui/coreui/scss/_carousel.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_clearfix.scss","webpack://./node_modules/@coreui/coreui/scss/_spinners.scss","webpack://./node_modules/@coreui/coreui/scss/_offcanvas.scss","webpack://./node_modules/@coreui/coreui/scss/_placeholders.scss","webpack://./node_modules/@coreui/coreui/scss/_avatar.scss","webpack://./node_modules/@coreui/coreui/scss/_callout.scss","webpack://./node_modules/@coreui/coreui/scss/_footer.scss","webpack://./node_modules/@coreui/coreui/scss/_header.scss","webpack://./node_modules/@coreui/coreui/scss/_icon.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_icon.scss","webpack://./node_modules/@coreui/coreui/scss/sidebar/_sidebar.scss","webpack://./node_modules/@coreui/coreui/scss/sidebar/_sidebar-nav.scss","webpack://./node_modules/@coreui/coreui/scss/sidebar/_sidebar-narrow.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_color-bg.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_colored-links.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_focus-ring.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_icon-link.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_ratio.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_position.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_stacks.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_visually-hidden.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_visually-hidden.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_stretched-link.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_text-truncation.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_text-truncate.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_vr.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_utilities.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_api.scss","webpack://./node_modules/@coreui/chartjs/scss/coreui-chartjs.scss","webpack://./node_modules/@coreui/chartjs/scss/_tooltips.scss","webpack://./src/scss/vendors/simplebar.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACEhB;;;;EAAA;ACOA;;EASI,mBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,iBAAA;EAAA,mBAAA;EAAA,wBAAA;EAIA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,gBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAIA,8BAAA;EAAA,kCAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,6BAAA;EAAA,8BAAA;EAAA,0BAAA;EAIA,oCAAA;EAAA,sCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,oCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAIA,gCAAA;EAAA,kCAAA;EAAA,gCAAA;EAAA,6BAAA;EAAA,gCAAA;EAAA,+BAAA;EAAA,2CAAA;EAAA,6BAAA;EAIA,oCAAA;EAAA,sCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,oCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAGF,8BAAA;EACA,0BAAA;EAMA,sNAAA;EACA,0GAAA;EACA,0FAAA;EAOA,kDAAA;ECwOI,0BALI;EDjOR,2BAAA;EACA,2BAAA;EAKA,8CAAA;EACA,sCAAA;EACA,mBAAA;EACA,gCAAA;EAEA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,2CAAA;EACA,2BAAA;EACA,qCAAA;EAEA,kDAAA;EACA,0CAAA;EACA,0BAAA;EACA,oCAAA;EAEA,gDAAA;EACA,wCAAA;EACA,2BAAA;EACA,kCAAA;EAEA,+BAAA;EACA,4CAAA;EAEA,oDAAA;EACA,6CAAA;EACA,gCAAA;EACA,uCAAA;EAEA,oDAAA;EACA,4CAAA;EACA,yCAAA;EACA,wCAAA;EAEA,iDAAA;EACA,oDAAA;EACA,4CAAA;EAEA,sDAAA;EACA,uDAAA;EACA,iDAAA;EAGA,4BAAA;EAEA,yBAAA;EACA,iCAAA;EACA,gCAAA;EAEA,8CAAA;EACA,6CAAA;EAMA,yBAAA;EACA,mDAAA;EACA,0CAAA;EAGA,uBAAA;EACA,yBAAA;EACA,2BAAA;EACA,sDAAA;EAEA,6BAAA;EACA,+BAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,qDAAA;EACA,+BAAA;EAGA,qDAAA;EACA,8DAAA;EACA,uDAAA;EACA,8DAAA;EAIA,+BAAA;EACA,8BAAA;EACA,+CAAA;EAIA,+BAAA;EACA,sCAAA;EACA,iCAAA;EACA,wCAAA;AFjBF;;AIhII;EFuJA,kBAAA;EAGA,2CAAA;EACA,mCAAA;EACA,sBAAA;EACA,6BAAA;EAEA,0BAAA;EACA,uCAAA;EAEA,+CAAA;EACA,wCAAA;EACA,2BAAA;EACA,kCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,oCAAA;EACA,mCAAA;EAEA,8CAAA;EACA,+CAAA;EACA,yCAAA;EAGE,qCAAA;EAAA,wBAAA;EAAA,wCAAA;EAAA,iCAAA;EAAA,sCAAA;EAAA,oCAAA;EAAA,oBAAA;EAAA,mBAAA;EAIA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAIA,oCAAA;EAAA,kCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,8BAAA;EAAA,0BAAA;EAIA,sDAAA;EAAA,sCAAA;EAAA,kDAAA;EAAA,mDAAA;EAAA,sDAAA;EAAA,oDAAA;EAAA,kCAAA;EAAA,iCAAA;EAIA,gCAAA;EAAA,kCAAA;EAAA,gCAAA;EAAA,6BAAA;EAAA,gCAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,uCAAA;EAIA,oCAAA;EAAA,sCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,oCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAGF,4BAAA;EAEA,wCAAA;EACA,mDAAA;EACA,uCAAA;EACA,kDAAA;EAEA,0CAAA;EACA,gDAAA;EACA,uCAAA;EAEA,2BAAA;EACA,wDAAA;EAEA,4CAAA;EACA,mDAAA;EACA,gDAAA;EACA,uDAAA;AFLJ;;AKlNA;;;EAGE,sBAAA;ALqNF;;AKtMI;EANJ;IAOM,uBAAA;EL0MJ;AACF;;AK7LA;EACE,SAAA;EACA,wCAAA;EF+OI,oCALI;EExOR,wCAAA;EACA,wCAAA;EACA,4BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8BAAA;EACA,+CAAA;ALgMF;;AKvLA;EACE,cAAA;EACA,cC6pB4B;ED5pB5B,SAAA;EACA,yCAAA;EACA,aCmqB4B;ANze9B;;AKhLA;EACE,aAAA;EACA,qBCkmB4B;ED/lB5B,gBCkmB4B;EDjmB5B,gBCkmB4B;EDjmB5B,+BAAA;ALiLF;;AK9KA;EFyMQ,iCAAA;AHvBR;AGrII;EE7CJ;IFgNQ,iBAAA;EH1BN;AACF;;AKlLA;EFoMQ,iCAAA;AHdR;AG9II;EExCJ;IF2MQ,eAAA;EHjBN;AACF;;AKtLA;EF+LQ,+BAAA;AHLR;AGvJI;EEnCJ;IFsMQ,kBAAA;EHRN;AACF;;AK1LA;EF0LQ,iCAAA;AHIR;AGhKI;EE9BJ;IFiMQ,iBAAA;EHCN;AACF;;AK9LA;EFiLM,kBALI;AHsBV;;AK7LA;EF4KM,eALI;AH0BV;;AKtLA;EACE,aAAA;EACA,mBCoX0B;AN3L5B;;AK/KA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;ALkLF;;AK5KA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AL+KF;;AKzKA;;EAEE,0BAAA;AL4KF;;AKzKA;;;EAGE,aAAA;EACA,mBAAA;AL4KF;;AKzKA;;;;EAIE,gBAAA;AL4KF;;AKzKA;EACE,gBCue4B;AN3T9B;;AKvKA;EACE,sBAAA;EACA,qBAAA;AL0KF;;AKpKA;EACE,gBAAA;ALuKF;;AK/JA;;EAEE,mBCgd4B;AN9S9B;;AK1JA;EF+EM,kBALI;AHoFV;;AKvJA;EACE,iBC+hB4B;ED9hB5B,iCAAA;EACA,yCAAA;AL0JF;;AKjJA;;EAEE,kBAAA;EF0DI,iBALI;EEnDR,cAAA;EACA,wBAAA;ALoJF;;AKjJA;EAAM,eAAA;ALqJN;;AKpJA;EAAM,WAAA;ALwJN;;AKnJA;EACE,kEAAA;EACA,0BC4OwC;ANtF1C;AKpJE;EACE,qDAAA;ALsJJ;;AK5IE;EAEE,cAAA;EACA,qBAAA;AL8IJ;;AKvIA;;;;EAIE,sCC2X4B;EH1WxB,cALI;AH+HV;;AKnIA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFKI,kBALI;EEER,6BAAA;ALsIF;AKnIE;EFAI,kBALI;EEON,cAAA;EACA,kBAAA;ALqIJ;;AKjIA;EFPM,kBALI;EEcR,4BAAA;EACA,qBAAA;ALoIF;AKjIE;EACE,cAAA;ALmIJ;;AK/HA;EACE,2BAAA;EFnBI,kBALI;EE0BR,+CAAA;EACA,0DAAA;EEpSE,sBAAA;APuaJ;AKhIE;EACE,UAAA;EF1BE,cALI;AHkKV;;AKxHA;EACE,gBAAA;AL2HF;;AKrHA;;EAEE,sBAAA;ALwHF;;AKhHA;EACE,oBAAA;EACA,yBAAA;ALmHF;;AKhHA;EACE,mBC8a4B;ED7a5B,sBC6a4B;ED5a5B,iEAAA;EACA,iBAAA;ALmHF;;AK5GA;EAEE,mBAAA;EACA,gCAAA;AL8GF;;AK3GA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AL8GF;;AKtGA;EACE,qBAAA;ALyGF;;AKnGA;EAEE,gBAAA;ALqGF;;AK7FA;EACE,UAAA;ALgGF;;AK3FA;;;;;EAKE,SAAA;EACA,oBAAA;EFzHI,kBALI;EEgIR,oBAAA;AL8FF;;AK1FA;;EAEE,oBAAA;AL6FF;;AKxFA;EACE,eAAA;AL2FF;;AKxFA;EAGE,iBAAA;ALyFF;AKtFE;EACE,UAAA;ALwFJ;;AKjFA;EACE,wBAAA;ALoFF;;AK5EA;;;;EAIE,0BAAA;AL+EF;AK5EI;;;;EACE,eAAA;ALiFN;;AK1EA;EACE,UAAA;EACA,kBAAA;AL6EF;;AKxEA;EACE,gBAAA;AL2EF;;AKjEA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;ALoEF;;AK5DA;EACE,mBAAA;EACA,WAAA;EACA,UAAA;EACA,qBC8P4B;ED5P5B,oBAAA;EFhNM,iCAAA;AH+QR;AG3aI;EEsWJ;IFnMQ,iBAAA;EH4QN;AACF;AKjEE;EACE,WAAA;ALmEJ;;AK5DA;;;;;;;EAOE,UAAA;AL+DF;;AK5DA;EACE,YAAA;AL+DF;;AKtDA;EACE,6BAAA;EACA,oBAAA;ALyDF;;AKlDE;;;;EAIE,cAAA;ALqDJ;;AK9CA;EACE,wBAAA;ALiDF;;AK5CA;EACE,UAAA;AL+CF;;AKxCA;EACE,aAAA;EACA,0BAAA;AL2CF;;AKtCA;EACE,qBAAA;ALyCF;;AKpCA;EACE,SAAA;ALuCF;;AKhCA;EACE,kBAAA;EACA,eAAA;ALmCF;;AK3BA;EACE,wBAAA;AL8BF;;AKtBA;EACE,wBAAA;ALyBF;;AQ3lBA;ELoQM,kBALI;EK7PR,gBFirB8B;ANnFhC;;AQzlBE;EAGE,gBFmqBkB;EElqBlB,gBFkpB0B;EHrZtB,iCAAA;AH8VR;AG1fI;EKrGF;ILwQM,eAAA;EH2VN;AACF;;AQpmBE;EAGE,gBFmqBkB;EElqBlB,gBFkpB0B;EHrZtB,iCAAA;AHyWR;AGrgBI;EKrGF;ILwQM,iBAAA;EHsWN;AACF;;AQ/mBE;EAGE,gBFmqBkB;EElqBlB,gBFkpB0B;EHrZtB,iCAAA;AHoXR;AGhhBI;EKrGF;ILwQM,eAAA;EHiXN;AACF;;AQ1nBE;EAGE,gBFmqBkB;EElqBlB,gBFkpB0B;EHrZtB,iCAAA;AH+XR;AG3hBI;EKrGF;ILwQM,iBAAA;EH4XN;AACF;;AQroBE;EAGE,gBFmqBkB;EElqBlB,gBFkpB0B;EHrZtB,iCAAA;AH0YR;AGtiBI;EKrGF;ILwQM,eAAA;EHuYN;AACF;;AQhpBE;EAGE,gBFmqBkB;EElqBlB,gBFkpB0B;EHrZtB,iCAAA;AHqZR;AGjjBI;EKrGF;ILwQM,iBAAA;EHkZN;AACF;;AQnoBA;EC5DE,uBAAA;EACA,gBAAA;ATmsBF;;AQnoBA;ECjEE,uBAAA;EACA,gBAAA;ATwsBF;;AQroBA;EACE,qBAAA;ARwoBF;AQtoBE;EACE,yBF+qB0B;ANvC9B;;AQ9nBA;EL+MM,kBALI;EKxMR,yBAAA;ARioBF;;AQ7nBA;EACE,mBF4VO;EHpJH,kBALI;AH8bV;AQ9nBE;EACE,gBAAA;ARgoBJ;;AQ5nBA;EACE,iBAAA;EACA,mBFkVO;EHpJH,kBALI;EKvLR,cFjFU;ANgtBZ;AQ7nBE;EACE,aAAA;AR+nBJ;;AU9tBA;ECFE,eAAA;EAGA,YAAA;AXkuBF;;AU7tBA;EACE,gBJuyDkC;EItyDlC,6DAAA;EACA,gGAAA;EHCE,uCAAA;EIZF,eAAA;EAGA,YAAA;AX2uBF;;AUvtBA;EAEE,qBAAA;AVytBF;;AUttBA;EACE,qBAAA;EACA,cAAA;AVytBF;;AUttBA;EPyPM,kBALI;EOlPR,kEAAA;AVytBF;;AY7vBE;;;;;;;ECLA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,6CAAA;EACA,kBAAA;EACA,iBAAA;Ab4wBF;;AcptBI;EF5CE;IACE,gBN2gBe;ENyPrB;AACF;Ac1tBI;EF5CE;IACE,gBN2gBe;EN8PrB;AACF;Ac/tBI;EF5CE;IACE,gBN2gBe;ENmQrB;AACF;AcpuBI;EF5CE;IACE,iBN2gBe;ENwQrB;AACF;AczuBI;EF5CE;IACE,iBN2gBe;EN6QrB;AACF;AexyBA;EAEI,sBAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,4BAAA;EAGF,2BAAA;Af4yBF;;AexyBE;ECLA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EAEA,0CAAA;EACA,8CAAA;EACA,6CAAA;AhBgzBF;Ae/yBI;ECQF,cAAA;EACA,WAAA;EACA,eAAA;EACA,8CAAA;EACA,6CAAA;EACA,+BAAA;AhB0yBF;;AgB3vBM;EACE,SAAA;AhB8vBR;;AgB3vBM;EApCJ,cAAA;EACA,WAAA;AhBmyBF;;AgBrxBE;EACE,cAAA;EACA,WAAA;AhBwxBJ;;AgB1xBE;EACE,cAAA;EACA,UAAA;AhB6xBJ;;AgB/xBE;EACE,cAAA;EACA,mBAAA;AhBkyBJ;;AgBpyBE;EACE,cAAA;EACA,UAAA;AhBuyBJ;;AgBzyBE;EACE,cAAA;EACA,UAAA;AhB4yBJ;;AgB9yBE;EACE,cAAA;EACA,mBAAA;AhBizBJ;;AgBlxBM;EAhDJ,cAAA;EACA,WAAA;AhBs0BF;;AgBjxBU;EAhEN,cAAA;EACA,kBAAA;AhBq1BJ;;AgBtxBU;EAhEN,cAAA;EACA,mBAAA;AhB01BJ;;AgB3xBU;EAhEN,cAAA;EACA,UAAA;AhB+1BJ;;AgBhyBU;EAhEN,cAAA;EACA,mBAAA;AhBo2BJ;;AgBryBU;EAhEN,cAAA;EACA,mBAAA;AhBy2BJ;;AgB1yBU;EAhEN,cAAA;EACA,UAAA;AhB82BJ;;AgB/yBU;EAhEN,cAAA;EACA,mBAAA;AhBm3BJ;;AgBpzBU;EAhEN,cAAA;EACA,mBAAA;AhBw3BJ;;AgBzzBU;EAhEN,cAAA;EACA,UAAA;AhB63BJ;;AgB9zBU;EAhEN,cAAA;EACA,mBAAA;AhBk4BJ;;AgBn0BU;EAhEN,cAAA;EACA,mBAAA;AhBu4BJ;;AgBx0BU;EAhEN,cAAA;EACA,WAAA;AhB44BJ;;AgBr0BY;EAxDV,gCAAA;AhBi4BF;;AgBz0BY;EAxDV,iCAAA;AhBq4BF;;AgB70BY;EAxDV,wBAAA;AhBy4BF;;AgBj1BY;EAxDV,iCAAA;AhB64BF;;AgBr1BY;EAxDV,iCAAA;AhBi5BF;;AgBz1BY;EAxDV,wBAAA;AhBq5BF;;AgB71BY;EAxDV,iCAAA;AhBy5BF;;AgBj2BY;EAxDV,iCAAA;AhB65BF;;AgBr2BY;EAxDV,wBAAA;AhBi6BF;;AgBz2BY;EAxDV,iCAAA;AhBq6BF;;AgB72BY;EAxDV,iCAAA;AhBy6BF;;AgBt2BQ;;EAEE,iBAAA;AhBy2BV;;AgBt2BQ;;EAEE,iBAAA;AhBy2BV;;AgBh3BQ;;EAEE,uBAAA;AhBm3BV;;AgBh3BQ;;EAEE,uBAAA;AhBm3BV;;AgB13BQ;;EAEE,sBAAA;AhB63BV;;AgB13BQ;;EAEE,sBAAA;AhB63BV;;AgBp4BQ;;EAEE,oBAAA;AhBu4BV;;AgBp4BQ;;EAEE,oBAAA;AhBu4BV;;AgB94BQ;;EAEE,sBAAA;AhBi5BV;;AgB94BQ;;EAEE,sBAAA;AhBi5BV;;AgBx5BQ;;EAEE,oBAAA;AhB25BV;;AgBx5BQ;;EAEE,oBAAA;AhB25BV;;Acz9BI;EEcE;IACE,SAAA;EhB+8BN;EgB58BI;IApCJ,cAAA;IACA,WAAA;EhBm/BA;EgBr+BA;IACE,cAAA;IACA,WAAA;EhBu+BF;EgBz+BA;IACE,cAAA;IACA,UAAA;EhB2+BF;EgB7+BA;IACE,cAAA;IACA,mBAAA;EhB++BF;EgBj/BA;IACE,cAAA;IACA,UAAA;EhBm/BF;EgBr/BA;IACE,cAAA;IACA,UAAA;EhBu/BF;EgBz/BA;IACE,cAAA;IACA,mBAAA;EhB2/BF;EgB59BI;IAhDJ,cAAA;IACA,WAAA;EhB+gCA;EgB19BQ;IAhEN,cAAA;IACA,kBAAA;EhB6hCF;EgB99BQ;IAhEN,cAAA;IACA,mBAAA;EhBiiCF;EgBl+BQ;IAhEN,cAAA;IACA,UAAA;EhBqiCF;EgBt+BQ;IAhEN,cAAA;IACA,mBAAA;EhByiCF;EgB1+BQ;IAhEN,cAAA;IACA,mBAAA;EhB6iCF;EgB9+BQ;IAhEN,cAAA;IACA,UAAA;EhBijCF;EgBl/BQ;IAhEN,cAAA;IACA,mBAAA;EhBqjCF;EgBt/BQ;IAhEN,cAAA;IACA,mBAAA;EhByjCF;EgB1/BQ;IAhEN,cAAA;IACA,UAAA;EhB6jCF;EgB9/BQ;IAhEN,cAAA;IACA,mBAAA;EhBikCF;EgBlgCQ;IAhEN,cAAA;IACA,mBAAA;EhBqkCF;EgBtgCQ;IAhEN,cAAA;IACA,WAAA;EhBykCF;EgBlgCU;IAxDV,sBAAA;EhB6jCA;EgBrgCU;IAxDV,gCAAA;EhBgkCA;EgBxgCU;IAxDV,iCAAA;EhBmkCA;EgB3gCU;IAxDV,wBAAA;EhBskCA;EgB9gCU;IAxDV,iCAAA;EhBykCA;EgBjhCU;IAxDV,iCAAA;EhB4kCA;EgBphCU;IAxDV,wBAAA;EhB+kCA;EgBvhCU;IAxDV,iCAAA;EhBklCA;EgB1hCU;IAxDV,iCAAA;EhBqlCA;EgB7hCU;IAxDV,wBAAA;EhBwlCA;EgBhiCU;IAxDV,iCAAA;EhB2lCA;EgBniCU;IAxDV,iCAAA;EhB8lCA;EgB3hCM;;IAEE,iBAAA;EhB6hCR;EgB1hCM;;IAEE,iBAAA;EhB4hCR;EgBniCM;;IAEE,uBAAA;EhBqiCR;EgBliCM;;IAEE,uBAAA;EhBoiCR;EgB3iCM;;IAEE,sBAAA;EhB6iCR;EgB1iCM;;IAEE,sBAAA;EhB4iCR;EgBnjCM;;IAEE,oBAAA;EhBqjCR;EgBljCM;;IAEE,oBAAA;EhBojCR;EgB3jCM;;IAEE,sBAAA;EhB6jCR;EgB1jCM;;IAEE,sBAAA;EhB4jCR;EgBnkCM;;IAEE,oBAAA;EhBqkCR;EgBlkCM;;IAEE,oBAAA;EhBokCR;AACF;AcnoCI;EEcE;IACE,SAAA;EhBwnCN;EgBrnCI;IApCJ,cAAA;IACA,WAAA;EhB4pCA;EgB9oCA;IACE,cAAA;IACA,WAAA;EhBgpCF;EgBlpCA;IACE,cAAA;IACA,UAAA;EhBopCF;EgBtpCA;IACE,cAAA;IACA,mBAAA;EhBwpCF;EgB1pCA;IACE,cAAA;IACA,UAAA;EhB4pCF;EgB9pCA;IACE,cAAA;IACA,UAAA;EhBgqCF;EgBlqCA;IACE,cAAA;IACA,mBAAA;EhBoqCF;EgBroCI;IAhDJ,cAAA;IACA,WAAA;EhBwrCA;EgBnoCQ;IAhEN,cAAA;IACA,kBAAA;EhBssCF;EgBvoCQ;IAhEN,cAAA;IACA,mBAAA;EhB0sCF;EgB3oCQ;IAhEN,cAAA;IACA,UAAA;EhB8sCF;EgB/oCQ;IAhEN,cAAA;IACA,mBAAA;EhBktCF;EgBnpCQ;IAhEN,cAAA;IACA,mBAAA;EhBstCF;EgBvpCQ;IAhEN,cAAA;IACA,UAAA;EhB0tCF;EgB3pCQ;IAhEN,cAAA;IACA,mBAAA;EhB8tCF;EgB/pCQ;IAhEN,cAAA;IACA,mBAAA;EhBkuCF;EgBnqCQ;IAhEN,cAAA;IACA,UAAA;EhBsuCF;EgBvqCQ;IAhEN,cAAA;IACA,mBAAA;EhB0uCF;EgB3qCQ;IAhEN,cAAA;IACA,mBAAA;EhB8uCF;EgB/qCQ;IAhEN,cAAA;IACA,WAAA;EhBkvCF;EgB3qCU;IAxDV,sBAAA;EhBsuCA;EgB9qCU;IAxDV,gCAAA;EhByuCA;EgBjrCU;IAxDV,iCAAA;EhB4uCA;EgBprCU;IAxDV,wBAAA;EhB+uCA;EgBvrCU;IAxDV,iCAAA;EhBkvCA;EgB1rCU;IAxDV,iCAAA;EhBqvCA;EgB7rCU;IAxDV,wBAAA;EhBwvCA;EgBhsCU;IAxDV,iCAAA;EhB2vCA;EgBnsCU;IAxDV,iCAAA;EhB8vCA;EgBtsCU;IAxDV,wBAAA;EhBiwCA;EgBzsCU;IAxDV,iCAAA;EhBowCA;EgB5sCU;IAxDV,iCAAA;EhBuwCA;EgBpsCM;;IAEE,iBAAA;EhBssCR;EgBnsCM;;IAEE,iBAAA;EhBqsCR;EgB5sCM;;IAEE,uBAAA;EhB8sCR;EgB3sCM;;IAEE,uBAAA;EhB6sCR;EgBptCM;;IAEE,sBAAA;EhBstCR;EgBntCM;;IAEE,sBAAA;EhBqtCR;EgB5tCM;;IAEE,oBAAA;EhB8tCR;EgB3tCM;;IAEE,oBAAA;EhB6tCR;EgBpuCM;;IAEE,sBAAA;EhBsuCR;EgBnuCM;;IAEE,sBAAA;EhBquCR;EgB5uCM;;IAEE,oBAAA;EhB8uCR;EgB3uCM;;IAEE,oBAAA;EhB6uCR;AACF;Ac5yCI;EEcE;IACE,SAAA;EhBiyCN;EgB9xCI;IApCJ,cAAA;IACA,WAAA;EhBq0CA;EgBvzCA;IACE,cAAA;IACA,WAAA;EhByzCF;EgB3zCA;IACE,cAAA;IACA,UAAA;EhB6zCF;EgB/zCA;IACE,cAAA;IACA,mBAAA;EhBi0CF;EgBn0CA;IACE,cAAA;IACA,UAAA;EhBq0CF;EgBv0CA;IACE,cAAA;IACA,UAAA;EhBy0CF;EgB30CA;IACE,cAAA;IACA,mBAAA;EhB60CF;EgB9yCI;IAhDJ,cAAA;IACA,WAAA;EhBi2CA;EgB5yCQ;IAhEN,cAAA;IACA,kBAAA;EhB+2CF;EgBhzCQ;IAhEN,cAAA;IACA,mBAAA;EhBm3CF;EgBpzCQ;IAhEN,cAAA;IACA,UAAA;EhBu3CF;EgBxzCQ;IAhEN,cAAA;IACA,mBAAA;EhB23CF;EgB5zCQ;IAhEN,cAAA;IACA,mBAAA;EhB+3CF;EgBh0CQ;IAhEN,cAAA;IACA,UAAA;EhBm4CF;EgBp0CQ;IAhEN,cAAA;IACA,mBAAA;EhBu4CF;EgBx0CQ;IAhEN,cAAA;IACA,mBAAA;EhB24CF;EgB50CQ;IAhEN,cAAA;IACA,UAAA;EhB+4CF;EgBh1CQ;IAhEN,cAAA;IACA,mBAAA;EhBm5CF;EgBp1CQ;IAhEN,cAAA;IACA,mBAAA;EhBu5CF;EgBx1CQ;IAhEN,cAAA;IACA,WAAA;EhB25CF;EgBp1CU;IAxDV,sBAAA;EhB+4CA;EgBv1CU;IAxDV,gCAAA;EhBk5CA;EgB11CU;IAxDV,iCAAA;EhBq5CA;EgB71CU;IAxDV,wBAAA;EhBw5CA;EgBh2CU;IAxDV,iCAAA;EhB25CA;EgBn2CU;IAxDV,iCAAA;EhB85CA;EgBt2CU;IAxDV,wBAAA;EhBi6CA;EgBz2CU;IAxDV,iCAAA;EhBo6CA;EgB52CU;IAxDV,iCAAA;EhBu6CA;EgB/2CU;IAxDV,wBAAA;EhB06CA;EgBl3CU;IAxDV,iCAAA;EhB66CA;EgBr3CU;IAxDV,iCAAA;EhBg7CA;EgB72CM;;IAEE,iBAAA;EhB+2CR;EgB52CM;;IAEE,iBAAA;EhB82CR;EgBr3CM;;IAEE,uBAAA;EhBu3CR;EgBp3CM;;IAEE,uBAAA;EhBs3CR;EgB73CM;;IAEE,sBAAA;EhB+3CR;EgB53CM;;IAEE,sBAAA;EhB83CR;EgBr4CM;;IAEE,oBAAA;EhBu4CR;EgBp4CM;;IAEE,oBAAA;EhBs4CR;EgB74CM;;IAEE,sBAAA;EhB+4CR;EgB54CM;;IAEE,sBAAA;EhB84CR;EgBr5CM;;IAEE,oBAAA;EhBu5CR;EgBp5CM;;IAEE,oBAAA;EhBs5CR;AACF;Acr9CI;EEcE;IACE,SAAA;EhB08CN;EgBv8CI;IApCJ,cAAA;IACA,WAAA;EhB8+CA;EgBh+CA;IACE,cAAA;IACA,WAAA;EhBk+CF;EgBp+CA;IACE,cAAA;IACA,UAAA;EhBs+CF;EgBx+CA;IACE,cAAA;IACA,mBAAA;EhB0+CF;EgB5+CA;IACE,cAAA;IACA,UAAA;EhB8+CF;EgBh/CA;IACE,cAAA;IACA,UAAA;EhBk/CF;EgBp/CA;IACE,cAAA;IACA,mBAAA;EhBs/CF;EgBv9CI;IAhDJ,cAAA;IACA,WAAA;EhB0gDA;EgBr9CQ;IAhEN,cAAA;IACA,kBAAA;EhBwhDF;EgBz9CQ;IAhEN,cAAA;IACA,mBAAA;EhB4hDF;EgB79CQ;IAhEN,cAAA;IACA,UAAA;EhBgiDF;EgBj+CQ;IAhEN,cAAA;IACA,mBAAA;EhBoiDF;EgBr+CQ;IAhEN,cAAA;IACA,mBAAA;EhBwiDF;EgBz+CQ;IAhEN,cAAA;IACA,UAAA;EhB4iDF;EgB7+CQ;IAhEN,cAAA;IACA,mBAAA;EhBgjDF;EgBj/CQ;IAhEN,cAAA;IACA,mBAAA;EhBojDF;EgBr/CQ;IAhEN,cAAA;IACA,UAAA;EhBwjDF;EgBz/CQ;IAhEN,cAAA;IACA,mBAAA;EhB4jDF;EgB7/CQ;IAhEN,cAAA;IACA,mBAAA;EhBgkDF;EgBjgDQ;IAhEN,cAAA;IACA,WAAA;EhBokDF;EgB7/CU;IAxDV,sBAAA;EhBwjDA;EgBhgDU;IAxDV,gCAAA;EhB2jDA;EgBngDU;IAxDV,iCAAA;EhB8jDA;EgBtgDU;IAxDV,wBAAA;EhBikDA;EgBzgDU;IAxDV,iCAAA;EhBokDA;EgB5gDU;IAxDV,iCAAA;EhBukDA;EgB/gDU;IAxDV,wBAAA;EhB0kDA;EgBlhDU;IAxDV,iCAAA;EhB6kDA;EgBrhDU;IAxDV,iCAAA;EhBglDA;EgBxhDU;IAxDV,wBAAA;EhBmlDA;EgB3hDU;IAxDV,iCAAA;EhBslDA;EgB9hDU;IAxDV,iCAAA;EhBylDA;EgBthDM;;IAEE,iBAAA;EhBwhDR;EgBrhDM;;IAEE,iBAAA;EhBuhDR;EgB9hDM;;IAEE,uBAAA;EhBgiDR;EgB7hDM;;IAEE,uBAAA;EhB+hDR;EgBtiDM;;IAEE,sBAAA;EhBwiDR;EgBriDM;;IAEE,sBAAA;EhBuiDR;EgB9iDM;;IAEE,oBAAA;EhBgjDR;EgB7iDM;;IAEE,oBAAA;EhB+iDR;EgBtjDM;;IAEE,sBAAA;EhBwjDR;EgBrjDM;;IAEE,sBAAA;EhBujDR;EgB9jDM;;IAEE,oBAAA;EhBgkDR;EgB7jDM;;IAEE,oBAAA;EhB+jDR;AACF;Ac9nDI;EEcE;IACE,SAAA;EhBmnDN;EgBhnDI;IApCJ,cAAA;IACA,WAAA;EhBupDA;EgBzoDA;IACE,cAAA;IACA,WAAA;EhB2oDF;EgB7oDA;IACE,cAAA;IACA,UAAA;EhB+oDF;EgBjpDA;IACE,cAAA;IACA,mBAAA;EhBmpDF;EgBrpDA;IACE,cAAA;IACA,UAAA;EhBupDF;EgBzpDA;IACE,cAAA;IACA,UAAA;EhB2pDF;EgB7pDA;IACE,cAAA;IACA,mBAAA;EhB+pDF;EgBhoDI;IAhDJ,cAAA;IACA,WAAA;EhBmrDA;EgB9nDQ;IAhEN,cAAA;IACA,kBAAA;EhBisDF;EgBloDQ;IAhEN,cAAA;IACA,mBAAA;EhBqsDF;EgBtoDQ;IAhEN,cAAA;IACA,UAAA;EhBysDF;EgB1oDQ;IAhEN,cAAA;IACA,mBAAA;EhB6sDF;EgB9oDQ;IAhEN,cAAA;IACA,mBAAA;EhBitDF;EgBlpDQ;IAhEN,cAAA;IACA,UAAA;EhBqtDF;EgBtpDQ;IAhEN,cAAA;IACA,mBAAA;EhBytDF;EgB1pDQ;IAhEN,cAAA;IACA,mBAAA;EhB6tDF;EgB9pDQ;IAhEN,cAAA;IACA,UAAA;EhBiuDF;EgBlqDQ;IAhEN,cAAA;IACA,mBAAA;EhBquDF;EgBtqDQ;IAhEN,cAAA;IACA,mBAAA;EhByuDF;EgB1qDQ;IAhEN,cAAA;IACA,WAAA;EhB6uDF;EgBtqDU;IAxDV,sBAAA;EhBiuDA;EgBzqDU;IAxDV,gCAAA;EhBouDA;EgB5qDU;IAxDV,iCAAA;EhBuuDA;EgB/qDU;IAxDV,wBAAA;EhB0uDA;EgBlrDU;IAxDV,iCAAA;EhB6uDA;EgBrrDU;IAxDV,iCAAA;EhBgvDA;EgBxrDU;IAxDV,wBAAA;EhBmvDA;EgB3rDU;IAxDV,iCAAA;EhBsvDA;EgB9rDU;IAxDV,iCAAA;EhByvDA;EgBjsDU;IAxDV,wBAAA;EhB4vDA;EgBpsDU;IAxDV,iCAAA;EhB+vDA;EgBvsDU;IAxDV,iCAAA;EhBkwDA;EgB/rDM;;IAEE,iBAAA;EhBisDR;EgB9rDM;;IAEE,iBAAA;EhBgsDR;EgBvsDM;;IAEE,uBAAA;EhBysDR;EgBtsDM;;IAEE,uBAAA;EhBwsDR;EgB/sDM;;IAEE,sBAAA;EhBitDR;EgB9sDM;;IAEE,sBAAA;EhBgtDR;EgBvtDM;;IAEE,oBAAA;EhBytDR;EgBttDM;;IAEE,oBAAA;EhBwtDR;EgB/tDM;;IAEE,sBAAA;EhBiuDR;EgB9tDM;;IAEE,sBAAA;EhBguDR;EgBvuDM;;IAEE,oBAAA;EhByuDR;EgBtuDM;;IAEE,oBAAA;EhBwuDR;AACF;AiBj2DA;EAEE,+BAAA;EACA,4BAAA;EACA,gCAAA;EACA,6BAAA;EAEA,4CAAA;EACA,kCAAA;EACA,iDAAA;EACA,kCAAA;EACA,oDAAA;EACA,iEAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,gEAAA;EAEA,WAAA;EACA,mBX6ZO;EW5ZP,mBXuvB4B;EWtvB5B,2CAAA;AjBg2DF;AiBz1DE;EACE,sBAAA;EAEA,wFAAA;EACA,qCAAA;EACA,4CX+vB0B;EW9vB1B,8GAAA;AjB01DJ;AiBv1DE;EACE,uBAAA;AjBy1DJ;AiBt1DE;EACE,sBAAA;AjBw1DJ;;AiBp1DA;EACE,gEAAA;AjBu1DF;;AiBh1DA;EACE,iBAAA;AjBm1DF;;AiBz0DE;EACE,wBAAA;AjB40DJ;;AiB7zDE;EACE,uCAAA;AjBg0DJ;AiB7zDI;EACE,uCAAA;AjB+zDN;;AiBxzDE;EACE,sBAAA;AjB2zDJ;AiBxzDE;EACE,mBAAA;AjB0zDJ;;AiBhzDE;EACE,sDAAA;EACA,gDAAA;AjBmzDJ;;AiB7yDE;EACE,sDAAA;EACA,gDAAA;AjBgzDJ;;AiBxyDA;EACE,sDAAA;EACA,gDAAA;AjB2yDF;;AiBnyDE;EACE,qDAAA;EACA,+CAAA;AjBsyDJ;;AkBj7DE;EAOE,0BAAA;EACA,wCAAA;EACA,qDAAA;EACA,mDAAA;EACA,kCAAA;EACA,kDAAA;EACA,iCAAA;EACA,iDAAA;EACA,gCAAA;EAEA,6BAAA;EACA,2CAAA;AlB66DJ;;AkB/7DE;EAOE,0BAAA;EACA,wCAAA;EACA,qDAAA;EACA,mDAAA;EACA,kCAAA;EACA,kDAAA;EACA,iCAAA;EACA,oDAAA;EACA,gCAAA;EAEA,6BAAA;EACA,2CAAA;AlB27DJ;;AkB78DE;EAOE,0BAAA;EACA,wCAAA;EACA,qDAAA;EACA,mDAAA;EACA,kCAAA;EACA,kDAAA;EACA,iCAAA;EACA,kDAAA;EACA,gCAAA;EAEA,6BAAA;EACA,2CAAA;AlBy8DJ;;AkB39DE;EAOE,0BAAA;EACA,sCAAA;EACA,oDAAA;EACA,mDAAA;EACA,kCAAA;EACA,iDAAA;EACA,iCAAA;EACA,oDAAA;EACA,gCAAA;EAEA,6BAAA;EACA,2CAAA;AlBu9DJ;;AkBz+DE;EAOE,0BAAA;EACA,wCAAA;EACA,qDAAA;EACA,mDAAA;EACA,kCAAA;EACA,kDAAA;EACA,iCAAA;EACA,oDAAA;EACA,gCAAA;EAEA,6BAAA;EACA,2CAAA;AlBq+DJ;;AkBv/DE;EAOE,0BAAA;EACA,wCAAA;EACA,qDAAA;EACA,mDAAA;EACA,kCAAA;EACA,kDAAA;EACA,iCAAA;EACA,oDAAA;EACA,gCAAA;EAEA,6BAAA;EACA,2CAAA;AlBm/DJ;;AkBrgEE;EAOE,0BAAA;EACA,uBAAA;EACA,8CAAA;EACA,kDAAA;EACA,kCAAA;EACA,+CAAA;EACA,iCAAA;EACA,mDAAA;EACA,gCAAA;EAEA,6BAAA;EACA,2CAAA;AlBigEJ;;AkBnhEE;EAOE,uBAAA;EACA,uBAAA;EACA,+CAAA;EACA,8CAAA;EACA,+BAAA;EACA,4CAAA;EACA,8BAAA;EACA,+CAAA;EACA,6BAAA;EAEA,6BAAA;EACA,2CAAA;AlB+gEJ;;AiB/3DI;EACE,gBAAA;EACA,iCAAA;AjBk4DN;;Ac99DI;EG0FA;IACE,gBAAA;IACA,iCAAA;EjBw4DJ;AACF;Acr+DI;EG0FA;IACE,gBAAA;IACA,iCAAA;EjB84DJ;AACF;Ac3+DI;EG0FA;IACE,gBAAA;IACA,iCAAA;EjBo5DJ;AACF;Acj/DI;EG0FA;IACE,gBAAA;IACA,iCAAA;EjB05DJ;AACF;Acv/DI;EG0FA;IACE,gBAAA;IACA,iCAAA;EjBg6DJ;AACF;AmBrkEA;EACE,qBb+6BsC;ANwpCxC;;AmB9jEA;EACE,qDAAA;EACA,wDAAA;EACA,gBAAA;EhBgRI,kBALI;EgBvQR,gBbyoB4B;ANs7C9B;;AmB3jEA;EACE,mDAAA;EACA,sDAAA;EhBsQI,kBALI;AH8zDV;;AmB3jEA;EACE,oDAAA;EACA,uDAAA;EhBgQI,mBALI;AHo0DV;;AoB7lEA;EACE,mBdw6BsC;EH3oBlC,kBALI;EiBpRR,iCdw6BsC;ANsrCxC;;AqB9lEA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;ElBsRI,eALI;EkB9QR,gBfwoB4B;EevoB5B,gBf+oB4B;Ee9oB5B,4Bfg8BsC;Ee/7BtC,gBAAA;EACA,oCfy7BsC;Eex7BtC,4BAAA;EACA,6DAAA;EdDE,uCAAA;EeJE,wEDWJ;ArB4lEF;AsBnmEM;EDXN;ICYQ,gBAAA;EtBsmEN;AACF;AqB/lEE;EACE,gBAAA;ArBimEJ;AqB/lEI;EACE,eAAA;ArBimEN;AqB5lEE;EACE,4Bf06BoC;Eez6BpC,oCfo6BoC;Een6BpC,sCfk7BoC;Eej7BpC,UAAA;EAKE,iDfwjBkB;ANkiDxB;AqBtlEE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;ArB0kEJ;AqBrkEE;EACE,cAAA;EACA,UAAA;ArBukEJ;AqBnkEE;EACE,qEAAA;EAEA,UAAA;ArBokEJ;AqB5jEE;EAEE,yCfk3BoC;Ee/2BpC,UAAA;ArB2jEJ;AqBvjEE;EACE,yBAAA;EACA,0BAAA;EACA,0BfiuB0B;EehuB1B,4Bf02BoC;EiB98BtC,wCjB4nCgC;EethC9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,gDf6uB0B;Ee5uB1B,gBAAA;EC9FE,qID+FF;ArByjEJ;AsBppEM;ED+EJ;IC9EM,gBAAA;EtBupEN;AACF;AqB3jEE;EACE,yCf6gC8B;ANgjClC;;AqBpjEA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBf8hB4B;Ee7hB5B,4Bf+1BsC;Ee91BtC,6BAAA;EACA,yBAAA;EACA,uCAAA;ArBujEF;AqBrjEE;EACE,UAAA;ArBujEJ;AqBpjEE;EAEE,gBAAA;EACA,eAAA;ArBqjEJ;;AqB1iEA;EACE,oEfg1BsC;Ee/0BtC,uBAAA;ElBuII,mBALI;EIzQN,0CAAA;APsrEJ;AqB3iEE;EACE,uBAAA;EACA,wBAAA;EACA,yBfirB0B;AN43C9B;;AqBziEA;EACE,kEfo0BsC;Een0BtC,oBAAA;ElB0HI,kBALI;EIzQN,0CAAA;APksEJ;AqB1iEE;EACE,oBAAA;EACA,qBAAA;EACA,uBfwqB0B;ANo4C9B;;AqBpiEE;EACE,qEfizBoC;ANsvCxC;AqBpiEE;EACE,oEf8yBoC;ANwvCxC;AqBniEE;EACE,kEf2yBoC;AN0vCxC;;AqBhiEA;EACE,WfyyBsC;EexyBtC,iEfkyBsC;EejyBtC,iBf8nB4B;ANq6C9B;AqBjiEE;EACE,eAAA;ArBmiEJ;AqBhiEE;EACE,oBAAA;Ed3LA,uCAAA;AP8tEJ;AqB/hEE;EACE,oBAAA;EdhMA,uCAAA;APkuEJ;AqB9hEE;EAAoB,gEfkxBkB;AN+wCxC;AqBhiEE;EAAoB,8DfkxBkB;ANixCxC;;AwBhvEA;EACE,iEAAA;EAEA,cAAA;EACA,WAAA;EACA,6BlBszB4B;EkBrzB5B,2BlB+iCkC;EkB9iClC,qBlBmzB4B;EkBlzB5B,wBlBkzB4B;EHpiBxB,eALI;EqBtQR,gBlBgoB4B;EkB/nB5B,gBlBuoB4B;EkBtoB5B,4BlBw7BsC;EkBv7BtC,gBAAA;EACA,oClBi7BsC;EkBh7BtC,qFAAA;EACA,4BAAA;ECkFI,yCAAA;EDhFJ,0BlB2iCkC;EkB1iClC,6DAAA;EjBZE,uCAAA;EeJE,wEEmBJ;AxBgvEF;AsB/vEM;EERN;IFSQ,gBAAA;EtBkwEN;AACF;AwBnvEE;EACE,sClBq7BoC;EkBp7BpC,UAAA;EAKE,iDlB6iC4B;ANosClC;AwB7uEE;EAEE,2BlBqxB0B;EkBpxB1B,sBAAA;AxB8uEJ;AwB3uEE;EAEE,yClBs5BoC;ANs1CxC;AwBvuEE;EACE,kBAAA;EACA,wCAAA;AxByuEJ;;AwBruEA;EACE,4BlB+wB4B;EkB9wB5B,oBlB6wB4B;EkB5wB5B,uBlB4wB4B;EHhjBxB,mBALI;EIzQN,0CAAA;AP4xEJ;;AwBruEA;EACE,0BlB2wB4B;EkB1wB5B,mBlBywB4B;EkBxwB5B,sBlBwwB4B;EHpjBxB,kBALI;EIzQN,0CAAA;APoyEJ;;AwBnuEI;EACE,iEAAA;AxBsuEN;;A0BnzEA;EACE,cAAA;EACA,kBpBy+BwC;EoBx+BxC,2BpBy+BwC;EoBx+BxC,uBpBy+BwC;AN60C1C;A0BpzEE;EACE,mBAAA;EACA,2BAAA;A1BszEJ;;A0BlzEA;EACE,uBAAA;EACA,eAAA;A1BqzEF;A0BnzEE;EACE,iBAAA;EACA,uBAAA;A1BqzEJ;;A0BjzEA;EACE,uCAAA;EAEA,cAAA;EACA,UpBg9BwC;EoB/8BxC,WpB+8BwC;EoB98BxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,gDAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,6DpBi9BwC;EoBh9BxC,yBAAA;A1BmzEF;A0BhzEE;EnB7BE,qBAAA;APg1EJ;A0B/yEE;EAEE,kBpBy8BsC;ANu2C1C;A0B7yEE;EACE,uBpBg8BsC;AN+2C1C;A0B5yEE;EACE,sCpB45BoC;EoB35BpC,UAAA;EACA,iDpBsiBoB;ANwwDxB;A0B3yEE;EACE,kFAAA;EACA,kFAAA;A1B6yEJ;A0B3yEI;EAII,kEAAA;A1B0yER;A0BtyEI;EAII,kEAAA;A1BqyER;A0BhyEE;EACE,oCpBsgB0B;EoBrgB1B,gCpBqgB0B;EoBhgBxB,kEAAA;A1B8xEN;A0B1xEE;EACE,oBAAA;EACA,YAAA;EACA,YpBw6BuC;ANo3C3C;A0BrxEI;EACE,eAAA;EACA,YpB+5BqC;ANw3C3C;;A0BlxEA;EACE,0CAAA;A1BqxEF;;A0B7wEA;EACE,2BpB05BgC;ANs3ClC;A0B9wEE;EACE,6DAAA;EAEA,UpBo5B8B;EoBn5B9B,2BAAA;EACA,2CAAA;EACA,gCAAA;EnBnHA,kBAAA;EeJE,iDIyHF;A1B+wEJ;AsBp4EM;EI6GJ;IJ5GM,gBAAA;EtBu4EN;AACF;A0BlxEI;EACE,6DAAA;A1BoxEN;A0BjxEI;EACE,iCpBm5B4B;EoB94B1B,6DAAA;A1B+wER;A0B1wEE;EACE,uBAAA;A1B4wEJ;A0B1wEI;EACE,uBAAA;A1B4wEN;;A0BnwEE;EACE,kBAHO;EAIP,yBAAA;A1BswEJ;A0BpwEI;EACE,YARI;EASJ,cARK;EASL,yBAAA;A1BswEN;A0BnwEI;EAEE,sCAAA;A1BowEN;;A0BhxEE;EACE,iBAHO;EAIP,2BAAA;A1BmxEJ;A0BjxEI;EACE,UARI;EASJ,aARK;EASL,2BAAA;A1BmxEN;A0BhxEI;EAEE,qCAAA;A1BixEN;;A0B5wEA;EACE,qBAAA;EACA,uBpBy1BgC;ANs7ClC;;A0B5wEA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A1B+wEF;A0B3wEI;EACE,oBAAA;EACA,YAAA;EACA,apBkrBwB;AN2lD9B;;A0BtwEI;EACE,6DAAA;A1BywEN;;A2B98EA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A3Bi9EF;A2B/8EE;EACE,UAAA;A3Bi9EJ;A2B78EI;EAA0B,iErBgmCa;ANg3C3C;A2B/8EI;EAA0B,iErB+lCa;ANm3C3C;A2B/8EE;EACE,SAAA;A3Bi9EJ;A2B98EE;EACE,WrBilCuC;EqBhlCvC,YrBglCuC;EqB/kCvC,oBAAA;EACA,gBAAA;EJ/BF,oCjB6lB4B;EqB5jB1B,SrB+kCuC;EC/lCvC,mBAAA;EeJE,oHKuBF;ELvBE,4GKuBF;A3B+8EJ;AsBl+EM;EKUJ;ILTM,wBAAA;IAAA,gBAAA;EtBq+EN;AACF;A2Bl9EI;EJtCF,0CjBqnCyC;ANs4C3C;A2Bh9EE;EACE,WrB0jC8B;EqBzjC9B,crB0jC8B;EqBzjC9B,kBAAA;EACA,erByjC8B;EqBxjC9B,yCrByjC8B;EqBxjC9B,yBAAA;EpBhCA,mBAAA;APm/EJ;A2B98EE;EACE,WrBsjCuC;EqBrjCvC,YrBqjCuC;EqBpjCvC,gBAAA;EJzDF,oCjB6lB4B;EqBliB1B,SrBqjCuC;EC/lCvC,mBAAA;EeJE,iHKiDF;ELjDE,4GKiDF;A3B+8EJ;AsB5/EM;EKqCJ;ILpCM,qBAAA;IAAA,gBAAA;EtB+/EN;AACF;A2Bl9EI;EJhEF,0CjBqnCyC;ANg6C3C;A2Bh9EE;EACE,WrBgiC8B;EqB/hC9B,crBgiC8B;EqB/hC9B,kBAAA;EACA,erB+hC8B;EqB9hC9B,yCrB+hC8B;EqB9hC9B,yBAAA;EpB1DA,mBAAA;AP6gFJ;A2B98EE;EACE,oBAAA;A3Bg9EJ;A2B98EI;EACE,4CrBkiCqC;AN86C3C;A2B78EI;EACE,4CrB8hCqC;ANi7C3C;;A4BziFA;EACE,kBAAA;A5B4iFF;A4B1iFE;;;EAGE,wDtB6nCoC;EsB5nCpC,4DtB4nCoC;EsB3nCpC,iBtB4nCoC;ANg7CxC;A4BziFE;EACE,kBAAA;EACA,qBAAA;EACA,MAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,4CAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iDAAA;EACA,qBAAA;ENXE,gEMYF;A5B2iFJ;AsBnjFM;EMRJ;INSM,gBAAA;EtBsjFN;AACF;A4B7iFE;;EAEE,qBAAA;A5B+iFJ;A4B7iFI;;EACE,kBAAA;A5BgjFN;A4B7iFI;;;EAEE,qBtB+lCkC;EsB9lClC,wBtB+lCkC;ANi9CxC;A4B7iFI;;EACE,qBtB0lCkC;EsBzlClC,wBtB0lCkC;ANs9CxC;A4B5iFE;EACE,6BtBmxB0B;EsBlxB1B,qBtBmlCoC;EsBllCpC,wBtBmlCoC;AN29CxC;A4BviFI;;;;EACE,8DtB8kCkC;AN89CxC;A4BviFI;EACE,8DtBwkCkC;ANi+CxC;A4BpiFI;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,atB6jCkC;EsB5jClC,WAAA;EACA,oCtB63BkC;ECx7BpC,uCAAA;APmmFJ;A4BpiFE;EACE,yCtB03BoC;AN4qDxC;A4BliFI;EACE,uCAAA;A5BoiFN;A4BhiFE;;EAEE,ctB1EQ;AN4mFZ;;A6B1nFA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A7B6nFF;A6B3nFE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A7B6nFJ;A6BznFE;;;EAGE,UAAA;A7B2nFJ;A6BrnFE;EACE,kBAAA;EACA,UAAA;A7BunFJ;A6BrnFI;EACE,UAAA;A7BunFN;;A6B5mFA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;E1B8OI,eALI;E0BvOR,gBvBimB4B;EuBhmB5B,gBvBwmB4B;EuBvmB5B,gEAAA;EACA,kBAAA;EACA,mBAAA;EACA,yEAAA;EACA,wGAAA;EtBxCE,uCAAA;APwpFJ;;A6BtmFA;;;;EAIE,oBAAA;E1BwNI,kBALI;EIzQN,0CAAA;APiqFJ;;A6BtmFA;;;;EAIE,uBAAA;E1B+MI,mBALI;EIzQN,0CAAA;AP0qFJ;;A6BtmFA;;EAEE,wBAAA;A7BymFF;;A6B5lFI;;;;EtBnEA,0BAAA;EACA,wBAAA;APsqFJ;A6B3lFI;;;;EtB5EA,0BAAA;EACA,wBAAA;AP6qFJ;A6BrlFE;EACE,uDAAA;EtB5EA,4BAAA;EACA,0BAAA;APoqFJ;A6BrlFE;;EtBhFE,4BAAA;EACA,0BAAA;APyqFJ;;A8B9rFE;EACE,aAAA;EACA,WAAA;EACA,mBxB44BoC;EH3oBlC,kBALI;E2BzPN,kCxBooCqB;AN4jDzB;;A8B7rFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E3BoPE,mBALI;E2B5ON,WxBunCqB;EwBtnCrB,oCxBsnCqB;ECppCrB,uCAAA;AP8tFJ;;A8B3rFI;;;;EAEE,cAAA;A9BgsFN;;A8B/uFI;EAqDE,gDxBymCmB;EwBtmCjB,yCxBm6BgC;EwBl6BhC,yDAAA;EACA,4BAAA;EL2CF,2DAAA;EKzCE,gEAAA;A9B4rFR;A8BzrFM;EACE,gDxB8lCiB;EwBzlCf,4DxBylCe;AN8lDzB;;A8B5vFI;EA+EI,yCxB44BgC;EmBt3BlC,kFAAA;AzB4pFN;;A8BjwFI;EAuFE,gDxBukCmB;ANumDzB;A8B3qFQ;EAEE,kEAAA;EACA,4BxBu+B8B;EmB/9BlC,+DAAA;EKNI,2EAAA;A9B4qFV;A8BxqFM;EACE,gDxB0jCiB;EwBrjCf,4DxBqjCe;ANinDzB;;A8B/wFI;EAkHI,yCAAA;A9BiqFR;;A8BnxFI;EAyHE,gDxBqiCmB;ANynDzB;A8B5pFM;EACE,6CxBkiCiB;AN4nDzB;A8B3pFM;EACE,4DxB8hCiB;AN+nDzB;A8B1pFM;EACE,kCxB0hCiB;ANkoDzB;;A8BvpFI;EACE,0BAAA;A9B0pFN;;A8BpyFI;;;;;EAoJM,UAAA;A9BwpFV;;A8BxxFE;EACE,aAAA;EACA,WAAA;EACA,mBxB44BoC;EH3oBlC,kBALI;E2BzPN,oCxBooCqB;ANspDzB;;A8BvxFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E3BoPE,mBALI;E2B5ON,WxBunCqB;EwBtnCrB,mCxBsnCqB;ECppCrB,uCAAA;APwzFJ;;A8BrxFI;;;;EAEE,cAAA;A9B0xFN;;A8Bz0FI;EAqDE,kDxBymCmB;EwBtmCjB,yCxBm6BgC;EwBl6BhC,0DAAA;EACA,4BAAA;EL2CF,2DAAA;EKzCE,gEAAA;A9BsxFR;A8BnxFM;EACE,kDxB8lCiB;EwBzlCf,2DxBylCe;ANwrDzB;;A8Bt1FI;EA+EI,yCxB44BgC;EmBt3BlC,kFAAA;AzBsvFN;;A8B31FI;EAuFE,kDxBukCmB;ANisDzB;A8BrwFQ;EAEE,mEAAA;EACA,4BxBu+B8B;EmB/9BlC,+DAAA;EKNI,2EAAA;A9BswFV;A8BlwFM;EACE,kDxB0jCiB;EwBrjCf,2DxBqjCe;AN2sDzB;;A8Bz2FI;EAkHI,yCAAA;A9B2vFR;;A8B72FI;EAyHE,kDxBqiCmB;ANmtDzB;A8BtvFM;EACE,+CxBkiCiB;ANstDzB;A8BrvFM;EACE,2DxB8hCiB;ANytDzB;A8BpvFM;EACE,oCxB0hCiB;AN4tDzB;;A8BjvFI;EACE,0BAAA;A9BovFN;;A8B93FI;;;;;EAsJM,UAAA;A9BgvFV;;A+Bp4FA;EAEE,4BAAA;EACA,6BAAA;EACA,uBAAA;E5BkRI,yBALI;E4B3QR,0BAAA;EACA,0BAAA;EACA,sCAAA;EACA,yBAAA;EACA,+CAAA;EACA,mCAAA;EACA,iDAAA;EACA,yCAAA;EACA,+FAAA;EACA,gCAAA;EACA,mFAAA;EAGA,qBAAA;EACA,0DAAA;EACA,uCAAA;E5BiQI,mCALI;E4B1PR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,qEAAA;ExBxBE,2CAAA;EgBjBF,mCQ2CqB;ET9BjB,qISgCJ;A/Bk4FF;AsB95FM;ESRN;ITSQ,gBAAA;EtBi6FN;AACF;A+Br4FE;EACE,iCAAA;EAEA,yCAAA;EACA,+CAAA;A/Bs4FJ;A+Bn4FE;EAEE,2BAAA;EACA,mCAAA;EACA,yCAAA;A/Bo4FJ;A+Bj4FE;EACE,iCAAA;ER9DF,yCQ+DuB;EACrB,+CAAA;EACA,UAAA;EAKE,2CAAA;A/B+3FN;A+B33FE;EACE,+CAAA;EACA,UAAA;EAKE,2CAAA;A/By3FN;A+Br3FE;EAKE,kCAAA;EACA,0CAAA;EAGA,gDAAA;A/Bi3FJ;A+B92FI;EAKI,2CAAA;A/B42FR;A+Bv2FE;EAKI,2CAAA;A/Bq2FN;A+Bj2FE;EAGE,oCAAA;EACA,oBAAA;EACA,4CAAA;EAEA,kDAAA;EACA,wCAAA;A/Bg2FJ;;A+Bt1FA;EAEE,2CAAA;EACA,mCAAA;EACA,6CAAA;EACA,2CAAA;EACA,qDAAA;EACA,oDAAA;EACA,4CAAA;EACA,4CAAA;EACA,0CAAA;EACA,oDAAA;EACA,8EAAA;A/Bw1FF;;A+Bp1FA;EAEE,2CAAA;EACA,+CAAA;EACA,6CAAA;EACA,2CAAA;EACA,sDAAA;EACA,oDAAA;EACA,wDAAA;EACA,4CAAA;EACA,0CAAA;EACA,qDAAA;EACA,8EAAA;A/Bs1FF;;A+Bl1FA;EACE,0CAAA;EACA,4CAAA;EACA,yCAAA;A/Bq1FF;;A+Bh1FE;ECzJA,qBAAA;EACA,qBAAA;EACA,+BAAA;EACA,2BAAA;EACA,0CAAA;EACA,oDAAA;EACA,kDAAA;EACA,4BAAA;EACA,2CAAA;EACA,mDAAA;EACA,+DAAA;EACA,8BAAA;EACA,8BAAA;EACA,wCAAA;AhC6+FF;;A+Bj2FE;ECzJA,qBAAA;EACA,qBAAA;EACA,+BAAA;EACA,2BAAA;EACA,8CAAA;EACA,oDAAA;EACA,+CAAA;EACA,4BAAA;EACA,2CAAA;EACA,uDAAA;EACA,+DAAA;EACA,8BAAA;EACA,8BAAA;EACA,wCAAA;AhC8/FF;;A+Bl3FE;ECzJA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,4CAAA;EACA,oDAAA;EACA,8CAAA;EACA,+BAAA;EACA,4CAAA;EACA,qDAAA;EACA,+DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AhC+gGF;;A+Bn4FE;ECzJA,wBAAA;EACA,kBAAA;EACA,4BAAA;EACA,8BAAA;EACA,yCAAA;EACA,mDAAA;EACA,iDAAA;EACA,+BAAA;EACA,0CAAA;EACA,oDAAA;EACA,+DAAA;EACA,iCAAA;EACA,2BAAA;EACA,qCAAA;AhCgiGF;;A+Bp5FE;ECzJA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2CAAA;EACA,qDAAA;EACA,iDAAA;EACA,+BAAA;EACA,4CAAA;EACA,sDAAA;EACA,+DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AhCijGF;;A+Br6FE;ECzJA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,4CAAA;EACA,sDAAA;EACA,gDAAA;EACA,+BAAA;EACA,6CAAA;EACA,uDAAA;EACA,+DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AhCkkGF;;A+Bt7FE;ECzJA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,8CAAA;EACA,sDAAA;EACA,iDAAA;EACA,+BAAA;EACA,6CAAA;EACA,uDAAA;EACA,+DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AhCmlGF;;A+Bv8FE;ECzJA,qBAAA;EACA,qBAAA;EACA,+BAAA;EACA,2BAAA;EACA,0CAAA;EACA,mDAAA;EACA,6CAAA;EACA,4BAAA;EACA,0CAAA;EACA,oDAAA;EACA,+DAAA;EACA,8BAAA;EACA,8BAAA;EACA,wCAAA;AhComGF;;A+B97FE;EC1JA,wBAAA;EACA,+BAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,4BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+DAAA;EACA,iCAAA;EACA,kCAAA;EACA,wCAAA;EACA,oBAAA;AhC4lGF;;A+B/8FE;EC1JA,wBAAA;EACA,+BAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,4BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+DAAA;EACA,iCAAA;EACA,kCAAA;EACA,wCAAA;EACA,oBAAA;AhC6mGF;;A+Bh+FE;EC1JA,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+DAAA;EACA,iCAAA;EACA,kCAAA;EACA,wCAAA;EACA,oBAAA;AhC8nGF;;A+Bj/FE;EC1JA,qBAAA;EACA,4BAAA;EACA,8BAAA;EACA,wBAAA;EACA,kCAAA;EACA,wCAAA;EACA,+BAAA;EACA,yBAAA;EACA,mCAAA;EACA,+DAAA;EACA,8BAAA;EACA,kCAAA;EACA,qCAAA;EACA,oBAAA;AhC+oGF;;A+BlgGE;EC1JA,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,wCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+DAAA;EACA,iCAAA;EACA,kCAAA;EACA,wCAAA;EACA,oBAAA;AhCgqGF;;A+BnhGE;EC1JA,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+DAAA;EACA,iCAAA;EACA,kCAAA;EACA,wCAAA;EACA,oBAAA;AhCirGF;;A+BpiGE;EC1JA,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+DAAA;EACA,iCAAA;EACA,kCAAA;EACA,wCAAA;EACA,oBAAA;AhCksGF;;A+BrjGE;EC1JA,wBAAA;EACA,+BAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,sCAAA;EACA,4BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+DAAA;EACA,iCAAA;EACA,kCAAA;EACA,wCAAA;EACA,oBAAA;AhCmtGF;;A+BhkGE;ECpIA,wBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qCAAA;EACA,2BAAA;EACA,4BAAA;EACA,sCAAA;EACA,4BAAA;EACA,iCAAA;EACA,kCAAA;EACA,4CAAA;AhCwsGF;;A+B9kGE;ECpIA,wBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qCAAA;EACA,2BAAA;EACA,4BAAA;EACA,sCAAA;EACA,4BAAA;EACA,iCAAA;EACA,kCAAA;EACA,4CAAA;AhCstGF;;A+B5lGE;ECpIA,wBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,kCAAA;EACA,4CAAA;AhCouGF;;A+B1mGE;ECpIA,qBAAA;EACA,mCAAA;EACA,wBAAA;EACA,kCAAA;EACA,8BAAA;EACA,yBAAA;EACA,mCAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;EACA,4CAAA;AhCkvGF;;A+BxnGE;ECpIA,wBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,kCAAA;EACA,4CAAA;AhCgwGF;;A+BtoGE;ECpIA,wBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,kCAAA;EACA,4CAAA;AhC8wGF;;A+BppGE;ECpIA,wBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,kCAAA;EACA,4CAAA;AhC4xGF;;A+BlqGE;ECpIA,wBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qCAAA;EACA,2BAAA;EACA,4BAAA;EACA,sCAAA;EACA,4BAAA;EACA,iCAAA;EACA,kCAAA;EACA,4CAAA;AhC0yGF;;A+BpqGA;EACE,0BAAA;EACA,sCAAA;EACA,yBAAA;EACA,mCAAA;EACA,kDAAA;EACA,yCAAA;EACA,0CAAA;EACA,iCAAA;EACA,4CAAA;EACA,0BAAA;EACA,kDAAA;EAEA,0BzBwPwC;AN86F1C;A+B5pGE;EACE,2BAAA;A/B8pGJ;;A+BnpGA;EClKE,2BAAA;EACA,yBAAA;E7BmMI,4BALI;E6B5LR,oDAAA;AhCyzGF;;A+BtpGA;ECtKE,4BAAA;EACA,2BAAA;E7BmMI,6BALI;E6B5LR,oDAAA;AhCg0GF;;A+BtpGM;ECnPJ,qBAAA;EACA,oCAAA;EACA,8CAAA;EACA,2BAAA;EACA,6CAAA;EACA,uDAAA;EACA,kDAAA;EACA,4BAAA;EACA,8CAAA;EACA,sDAAA;EACA,+DAAA;EACA,8BAAA;EACA,6CAAA;EACA,uDAAA;AhC64GF;A+BvqGM;ECnPJ,qBAAA;EACA,qBAAA;EACA,+BAAA;EACA,2BAAA;EACA,8CAAA;EACA,oDAAA;EACA,+CAAA;EACA,4BAAA;EACA,2CAAA;EACA,uDAAA;EACA,+DAAA;EACA,8BAAA;EACA,8BAAA;EACA,wCAAA;AhC65GF;A+BvrGM;ECnPJ,wBAAA;EACA,uCAAA;EACA,iDAAA;EACA,8BAAA;EACA,mDAAA;EACA,0DAAA;EACA,sDAAA;EACA,+BAAA;EACA,+CAAA;EACA,2DAAA;EACA,+DAAA;EACA,iCAAA;EACA,gDAAA;EACA,0DAAA;AhC66GF;A+BvsGM;ECnPJ,wBAAA;EACA,mCAAA;EACA,6CAAA;EACA,8BAAA;EACA,6CAAA;EACA,uDAAA;EACA,iDAAA;EACA,+BAAA;EACA,8CAAA;EACA,wDAAA;EACA,+DAAA;EACA,iCAAA;EACA,4CAAA;EACA,sDAAA;AhC67GF;A+BvtGM;ECnPJ,wBAAA;EACA,qCAAA;EACA,+CAAA;EACA,8BAAA;EACA,8CAAA;EACA,wDAAA;EACA,iDAAA;EACA,+BAAA;EACA,+CAAA;EACA,yDAAA;EACA,+DAAA;EACA,iCAAA;EACA,8CAAA;EACA,wDAAA;AhC68GF;A+BvuGM;ECnPJ,wBAAA;EACA,oCAAA;EACA,8CAAA;EACA,8BAAA;EACA,kDAAA;EACA,yDAAA;EACA,mDAAA;EACA,+BAAA;EACA,gDAAA;EACA,0DAAA;EACA,+DAAA;EACA,iCAAA;EACA,6CAAA;EACA,uDAAA;AhC69GF;A+BvvGM;ECnPJ,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,6CAAA;EACA,sDAAA;EACA,iDAAA;EACA,+BAAA;EACA,6CAAA;EACA,uDAAA;EACA,+DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AhC6+GF;A+BvwGM;ECnPJ,qBAAA;EACA,qBAAA;EACA,+BAAA;EACA,2BAAA;EACA,2CAAA;EACA,mDAAA;EACA,6CAAA;EACA,4BAAA;EACA,0CAAA;EACA,sDAAA;EACA,+DAAA;EACA,8BAAA;EACA,8BAAA;EACA,wCAAA;AhC6/GF;A+BjxGM;EChOJ,uCAAA;EACA,8CAAA;EACA,2BAAA;EACA,0CAAA;EACA,oDAAA;EACA,6CAAA;EACA,4BAAA;EACA,2CAAA;EACA,qDAAA;EACA,+DAAA;EACA,gDAAA;EACA,kCAAA;EACA,uDAAA;EACA,oBAAA;AhCo/GF;A+BjyGM;EChOJ,wBAAA;EACA,+BAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,4BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+DAAA;EACA,iCAAA;EACA,kCAAA;EACA,wCAAA;EACA,oBAAA;AhCogHF;A+BjzGM;EChOJ,0CAAA;EACA,iDAAA;EACA,8BAAA;EACA,6CAAA;EACA,uDAAA;EACA,gDAAA;EACA,+BAAA;EACA,8CAAA;EACA,wDAAA;EACA,+DAAA;EACA,mDAAA;EACA,kCAAA;EACA,0DAAA;EACA,oBAAA;AhCohHF;A+Bj0GM;EChOJ,sCAAA;EACA,6CAAA;EACA,8BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4CAAA;EACA,+BAAA;EACA,0CAAA;EACA,oDAAA;EACA,+DAAA;EACA,+CAAA;EACA,kCAAA;EACA,sDAAA;EACA,oBAAA;AhCoiHF;A+Bj1GM;EChOJ,wCAAA;EACA,+CAAA;EACA,8BAAA;EACA,2CAAA;EACA,qDAAA;EACA,8CAAA;EACA,+BAAA;EACA,4CAAA;EACA,sDAAA;EACA,+DAAA;EACA,iDAAA;EACA,kCAAA;EACA,wDAAA;EACA,oBAAA;AhCojHF;A+Bj2GM;EChOJ,uCAAA;EACA,8CAAA;EACA,8BAAA;EACA,0CAAA;EACA,oDAAA;EACA,6CAAA;EACA,+BAAA;EACA,2CAAA;EACA,qDAAA;EACA,+DAAA;EACA,gDAAA;EACA,kCAAA;EACA,uDAAA;EACA,oBAAA;AhCokHF;A+Bj3GM;EChOJ,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+DAAA;EACA,iCAAA;EACA,kCAAA;EACA,wCAAA;EACA,oBAAA;AhColHF;A+Bj4GM;EChOJ,wBAAA;EACA,+BAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,sCAAA;EACA,4BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+DAAA;EACA,iCAAA;EACA,kCAAA;EACA,wCAAA;EACA,oBAAA;AhComHF;A+B34GM;EC1MJ,uCAAA;EACA,mCAAA;EACA,0CAAA;EACA,oDAAA;EACA,2BAAA;EACA,2CAAA;EACA,qDAAA;EACA,4BAAA;EACA,gDAAA;EACA,kCAAA;EACA,4CAAA;AhCwlHF;A+Bx5GM;EC1MJ,wBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qCAAA;EACA,2BAAA;EACA,4BAAA;EACA,sCAAA;EACA,4BAAA;EACA,iCAAA;EACA,kCAAA;EACA,4CAAA;AhCqmHF;A+Br6GM;EC1MJ,0CAAA;EACA,mCAAA;EACA,6CAAA;EACA,uDAAA;EACA,8BAAA;EACA,8CAAA;EACA,wDAAA;EACA,+BAAA;EACA,mDAAA;EACA,kCAAA;EACA,4CAAA;AhCknHF;A+Bl7GM;EC1MJ,sCAAA;EACA,mCAAA;EACA,yCAAA;EACA,mDAAA;EACA,8BAAA;EACA,0CAAA;EACA,oDAAA;EACA,+BAAA;EACA,+CAAA;EACA,kCAAA;EACA,4CAAA;AhC+nHF;A+B/7GM;EC1MJ,wCAAA;EACA,mCAAA;EACA,2CAAA;EACA,qDAAA;EACA,8BAAA;EACA,4CAAA;EACA,sDAAA;EACA,+BAAA;EACA,iDAAA;EACA,kCAAA;EACA,4CAAA;AhC4oHF;A+B58GM;EC1MJ,uCAAA;EACA,mCAAA;EACA,0CAAA;EACA,oDAAA;EACA,8BAAA;EACA,2CAAA;EACA,qDAAA;EACA,+BAAA;EACA,gDAAA;EACA,kCAAA;EACA,4CAAA;AhCypHF;A+Bz9GM;EC1MJ,wBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,kCAAA;EACA,4CAAA;AhCsqHF;A+Bt+GM;EC1MJ,wBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qCAAA;EACA,2BAAA;EACA,4BAAA;EACA,sCAAA;EACA,4BAAA;EACA,iCAAA;EACA,kCAAA;EACA,4CAAA;AhCmrHF;;AiC1wHA;EXgBM,gCWfJ;AjC6wHF;AsB1vHM;EWpBN;IXqBQ,gBAAA;EtB6vHN;AACF;AiChxHE;EACE,UAAA;AjCkxHJ;;AiC5wHE;EACE,aAAA;AjC+wHJ;;AiC3wHA;EACE,SAAA;EACA,gBAAA;EXDI,6BWEJ;AjC8wHF;AsB5wHM;EWLN;IXMQ,gBAAA;EtB+wHN;AACF;AiCjxHE;EACE,QAAA;EACA,YAAA;EXNE,4BWOF;AjCmxHJ;AsBtxHM;EWAJ;IXCM,gBAAA;EtByxHN;AACF;;AkCxyHA;;;;;;EAME,kBAAA;AlC2yHF;;AkCxyHA;EACE,mBAAA;AlC2yHF;AmC1xHI;EACE,qBAAA;EACA,4B7BykBwB;E6BxkBxB,uB7BukBwB;E6BtkBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AnCk0HF;AmCxwHI;EACE,sBAAA;AnC0wHN;;AkCjzHA;EAEE,2BAAA;EACA,+BAAA;EACA,2BAAA;EACA,gCAAA;EACA,+BAAA;E/BoQI,8BALI;E+B7PR,2CAAA;EACA,qCAAA;EACA,gEAAA;EACA,sDAAA;EACA,oDAAA;EACA,4FAAA;EACA,8DAAA;EACA,uCAAA;EACA,gDAAA;EACA,gDAAA;EACA,sDAAA;EACA,oDAAA;EACA,2DAAA;EACA,iDAAA;EACA,6DAAA;EACA,mCAAA;EACA,sCAAA;EACA,oCAAA;EACA,qCAAA;EACA,uCAAA;EAGA,kBAAA;EACA,mCAAA;EACA,aAAA;EACA,wCAAA;EACA,oEAAA;EACA,SAAA;E/BuOI,wCALI;E+BhOR,gCAAA;EACA,iBAAA;EACA,gBAAA;EACA,wCAAA;EACA,4BAAA;EACA,+EAAA;E3B9CE,gDAAA;APg2HJ;AkC9yHE;EACE,qBAAA;EACA,SAAA;EACA,sCAAA;AlCgzHJ;;AkCxxHI;EACE,qBAAA;AlC2xHN;AkCzxHM;EACE,qBAAA;EACA,sBAAA;AlC2xHR;;AkCvxHI;EACE,mBAAA;AlC0xHN;AkCxxHM;EACE,wBAAA;EACA,mBAAA;AlC0xHR;;Acz0HI;EoBiCA;IACE,qBAAA;ElC4yHJ;EkC1yHI;IACE,qBAAA;IACA,sBAAA;ElC4yHN;EkCxyHE;IACE,mBAAA;ElC0yHJ;EkCxyHI;IACE,wBAAA;IACA,mBAAA;ElC0yHN;AACF;Ac11HI;EoBiCA;IACE,qBAAA;ElC4zHJ;EkC1zHI;IACE,qBAAA;IACA,sBAAA;ElC4zHN;EkCxzHE;IACE,mBAAA;ElC0zHJ;EkCxzHI;IACE,wBAAA;IACA,mBAAA;ElC0zHN;AACF;Ac12HI;EoBiCA;IACE,qBAAA;ElC40HJ;EkC10HI;IACE,qBAAA;IACA,sBAAA;ElC40HN;EkCx0HE;IACE,mBAAA;ElC00HJ;EkCx0HI;IACE,wBAAA;IACA,mBAAA;ElC00HN;AACF;Ac13HI;EoBiCA;IACE,qBAAA;ElC41HJ;EkC11HI;IACE,qBAAA;IACA,sBAAA;ElC41HN;EkCx1HE;IACE,mBAAA;ElC01HJ;EkCx1HI;IACE,wBAAA;IACA,mBAAA;ElC01HN;AACF;Ac14HI;EoBiCA;IACE,qBAAA;ElC42HJ;EkC12HI;IACE,qBAAA;IACA,sBAAA;ElC42HN;EkCx2HE;IACE,mBAAA;ElC02HJ;EkCx2HI;IACE,wBAAA;IACA,mBAAA;ElC02HN;AACF;AkCj2HE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,yCAAA;AlCm2HJ;AmC97HI;EACE,qBAAA;EACA,4B7BykBwB;E6BxkBxB,uB7BukBwB;E6BtkBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AnC+9HF;AmC56HI;EACE,sBAAA;AnC86HN;;AkCv2HE;EACE,wBAAA;EACA,sBAAA;EACA,MAAA;EACA,+CAAA;EACA,aAAA;AlC02HJ;AmCn9HI;EACE,qBAAA;EACA,4B7BykBwB;E6BxkBxB,uB7BukBwB;E6BtkBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AnC6+HF;AmCj8HI;EACE,sBAAA;AnCm8HN;AkCl3HI;EACE,iBAAA;AlCo3HN;;AkC92HE;EACE,wBAAA;EACA,sBAAA;EACA,MAAA;EACA,6CAAA;EACA,aAAA;AlCi3HJ;AmC3+HI;EACE,qBAAA;EACA,4B7BykBwB;E6BxkBxB,uB7BukBwB;E6BtkBxB,WAAA;AnC6+HN;AmCl+HM;EACE,aAAA;AnCo+HR;AmCj+HM;EACE,qBAAA;EACA,0B7BsjBsB;E6BrjBtB,uB7BojBsB;E6BnjBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;AnCugIF;AmCj+HI;EACE,sBAAA;AnCm+HN;AkCj4HI;EACE,iBAAA;AlCm4HN;;AkC53HA;EACE,SAAA;EACA,8CAAA;EACA,gBAAA;EACA,oDAAA;EACA,UAAA;AlC+3HF;;AkCz3HA;EACE,cAAA;EACA,WAAA;EACA,8EAAA;EACA,WAAA;EACA,gB5B8d4B;E4B7d5B,qCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E3B3KE,wDAAA;APwiIJ;AkC13HE;EAEE,2CAAA;EXjMF,mDWmMuB;AlC03HzB;AkCv3HE;EAEE,4CAAA;EACA,qBAAA;EXzMF,oDW0MuB;AlCw3HzB;AkCr3HE;EAEE,8CAAA;EACA,oBAAA;EACA,6BAAA;AlCs3HJ;;AkCh3HA;EACE,cAAA;AlCm3HF;;AkC/2HA;EACE,cAAA;EACA,kFAAA;EACA,gBAAA;E/BgEI,mBALI;E+BzDR,uCAAA;EACA,mBAAA;AlCk3HF;;AkC92HA;EACE,cAAA;EACA,8EAAA;EACA,qCAAA;AlCi3HF;;AkC72HA;EAEE,6BAAA;EACA,0BAAA;EACA,gEAAA;EACA,2BAAA;EACA,kCAAA;EACA,qCAAA;EACA,8DAAA;EACA,uDAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,oCAAA;AlC+2HF;;AoCzmIA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;ApC4mIF;AoC1mIE;;EACE,kBAAA;EACA,cAAA;ApC6mIJ;AoCxmIE;;;;;;;;;;;;EAME,UAAA;ApCgnIJ;;AoC3mIA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;ApC8mIF;AoC5mIE;EACE,WAAA;ApC8mIJ;;AoC1mIA;E7BjBI,uCAAA;AP+nIJ;AoC1mIE;;EAEE,uDAAA;ApC4mIJ;AoCxmIE;;;E7BXE,0BAAA;EACA,wBAAA;APwnIJ;AoCpmIE;;;E7BPE,4BAAA;EACA,0BAAA;APgnIJ;;AoCvlIA;EACE,wBAAA;EACA,uBAAA;ApC0lIF;AoCxlIE;EAGE,sBAAA;ApCwlIJ;AoCrlIE;EACE,oBAAA;ApCulIJ;;AoCnlIA;EACE,uBAAA;EACA,sBAAA;ApCslIF;;AoCnlIA;EACE,sBAAA;EACA,qBAAA;ApCslIF;;AoClkIA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;ApCqkIF;AoCnkIE;;EAEE,WAAA;ApCqkIJ;AoClkIE;;EAEE,8CAAA;ApCokIJ;AoChkIE;;E7B3FE,6BAAA;EACA,4BAAA;AP+pIJ;AoC5jIE;;;E7BlHE,yBAAA;EACA,0BAAA;APmrIJ;;AqCzsIA;EAEE,8BAAA;EACA,gCAAA;EAEA,4BAAA;EACA,2CAAA;EACA,uDAAA;EACA,yDAAA;EAGA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;ArCwsIF;;AqCrsIA;EACE,cAAA;EACA,oEAAA;ElCsQI,wCALI;EkC/PR,4CAAA;EACA,gCAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EflBI,uGemBJ;ArCwsIF;AsBvtIM;EeMN;IfLQ,gBAAA;EtB0tIN;AACF;AqC3sIE;EAEE,sCAAA;ArC4sIJ;AqCxsIE;EACE,UAAA;EACA,iD/B0jBoB;ANgpHxB;AqCtsIE;EAEE,yCAAA;EACA,oBAAA;EACA,eAAA;ArCusIJ;;AqC/rIA;EAEE,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,+GAAA;EACA,2DAAA;EACA,iDAAA;EACA,2GAAA;EAGA,sFAAA;ArC+rIF;AqC7rIE;EACE,0DAAA;EACA,0DAAA;E9B/CA,yDAAA;EACA,0DAAA;AP+uIJ;AqC9rII;EAGE,kBAAA;EACA,yDAAA;ArC8rIN;AqC1rIE;;EAEE,4CAAA;EACA,oDAAA;EACA,0DAAA;ArC4rIJ;AqCzrIE;EAEE,uDAAA;E9BnEA,yBAAA;EACA,0BAAA;AP8vIJ;;AqCjrIA;EAEE,uDAAA;EACA,4DAAA;EACA,kDAAA;ArCmrIF;AqChrIE;E9B9FE,iDAAA;APixIJ;AqC/qIE;;EAEE,6CAAA;EdrHF,qDcsHuB;ArCirIzB;;AqCxqIA;EAEE,6BAAA;EACA,0CAAA;EACA,gEAAA;EAGA,iCAAA;ArCwqIF;AqCtqIE;EACE,gBAAA;EACA,eAAA;EACA,sEAAA;ArCwqIJ;AqCtqII;EAEE,iCAAA;ArCuqIN;AqCnqIE;;EAEE,gB/BkgB0B;E+BjgB1B,iDAAA;EACA,iCAAA;ArCqqIJ;;AqC5pIA;EAEE,sCAAA;EACA,gEAAA;EACA,iDAAA;EACA,iDAAA;EACA,iDAAA;EACA,iEAAA;EACA,gEAAA;EACA,yEAAA;EAGA,gEAAA;EACA,kFAAA;EAEA,wCAAA;EACA,8GAAA;ArC2pIF;AqCzpIE;EACE,sGAAA;EACA,sEAAA;EACA,6EAAA;ArC2pIJ;AqCzpII;EAEE,iCAAA;ArC0pIN;AqCtpIE;;EAEE,gB/Bwd0B;E+Bvd1B,wDAAA;EACA,iCAAA;ArCwpIJ;;AqC/oIA;EACE,oCAAA;EACA,6CAAA;EACA,wCAAA;EACA,2CAAA;EACA,2CAAA;EACA,oDAAA;EACA,yCAAA;EACA,2DAAA;EACA,qDAAA;EACA,oEAAA;EACA,kEAAA;EACA,kEAAA;EAEA,oBAAA;EACA,wCAAA;EACA,4CAAA;E9BzME,oDAAA;AP21IJ;AqC/oIE;EACE,0LAAA;EACA,yCAAA;EACA,mEAAA;E9B/MA,4FAAA;APi2IJ;AqC/oII;EACE,kDAAA;ArCipIN;AqC7oIE;;EAEE,gDAAA;EACA,wDAAA;EACA,kEAAA;ArC+oIJ;AqC7oII;;EACE,yDAAA;ArCgpIN;;AqCzoIA;EACE,uCAAA;ArC4oIF;;AqCnoIE;;EAEE,cAAA;EACA,kBAAA;ArCsoIJ;;AqCjoIE;;EAEE,YAAA;EACA,aAAA;EACA,kBAAA;ArCooIJ;;AqC9nIE;;EACE,WAAA;ArCkoIJ;;AqCxnIE;EACE,aAAA;ArC2nIJ;AqCznIE;EACE,cAAA;ArC2nIJ;;AsCj5IA;EAEE,yBAAA;EACA,8BAAA;EACA,6DAAA;EACA,kEAAA;EACA,qEAAA;EACA,iEAAA;EACA,uCAAA;EACA,mCAAA;EACA,qCAAA;EACA,gEAAA;EACA,sEAAA;EACA,uCAAA;EACA,uCAAA;EACA,uCAAA;EACA,uCAAA;EACA,sEAAA;EACA,4EAAA;EACA,4DAAA;EACA,yCAAA;EACA,6DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,gEAAA;AtCi5IF;AsC34IE;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AtC84IJ;AsC13IA;EACE,8CAAA;EACA,iDAAA;EACA,qDAAA;EnCsNI,4CALI;EmC/MR,oCAAA;EACA,qBAAA;EACA,mBAAA;AtC43IF;AsC13IE;EAEE,0CAAA;AtC23IJ;;AsCj3IA;EAEE,2BAAA;EACA,gCAAA;EAEA,4BAAA;EACA,6CAAA;EACA,yDAAA;EACA,+DAAA;EAGA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AtCg3IF;AsC72II;EAEE,qCAAA;AtC82IN;AsC12IE;EACE,gBAAA;AtC42IJ;;AsCn2IA;EACE,mBhC6lCkC;EgC5lClC,sBhC4lCkC;EgC3lClC,8BAAA;AtCs2IF;AsCp2IE;;;EAGE,qCAAA;AtCs2IJ;;AsCz1IA;EACE,YAAA;EACA,gBAAA;EAGA,mBAAA;AtC01IF;;AsCt1IA;EACE,gFAAA;EnCmII,8CALI;EmC5HR,cAAA;EACA,8BAAA;EACA,6BAAA;EACA,4EAAA;E/BhJE,sDAAA;EeJE,gDgBsJJ;AtCy1IF;AsB3+IM;EgB0IN;IhBzIQ,gBAAA;EtB8+IN;AACF;AsC51IE;EACE,qBAAA;AtC81IJ;AsC31IE;EACE,qBAAA;EACA,UAAA;EACA,uDAAA;AtC61IJ;;AsCv1IA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AtC01IF;;AsCv1IA;EACE,0CAAA;EACA,gBAAA;AtC01IF;;Ac59II;EwB8IA;IAEI,iBAAA;IACA,2BAAA;EtCi1IN;EsC/0IM;IACE,mBAAA;EtCi1IR;EsC/0IQ;IACE,kBAAA;EtCi1IV;EsC90IQ;IACE,mDAAA;IACA,kDAAA;EtCg1IV;EsC50IM;IACE,iBAAA;EtC80IR;EsC30IM;IACE,wBAAA;IACA,gBAAA;EtC60IR;EsC10IM;IACE,aAAA;EtC40IR;EsCz0IM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IhBvOJ,gBgByOI;EtCy0IR;EsCt0IQ;IACE,aAAA;EtCw0IV;EsCr0IQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtCu0IV;AACF;Ac5gJI;EwB8IA;IAEI,iBAAA;IACA,2BAAA;EtCg4IN;EsC93IM;IACE,mBAAA;EtCg4IR;EsC93IQ;IACE,kBAAA;EtCg4IV;EsC73IQ;IACE,mDAAA;IACA,kDAAA;EtC+3IV;EsC33IM;IACE,iBAAA;EtC63IR;EsC13IM;IACE,wBAAA;IACA,gBAAA;EtC43IR;EsCz3IM;IACE,aAAA;EtC23IR;EsCx3IM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IhBvOJ,gBgByOI;EtCw3IR;EsCr3IQ;IACE,aAAA;EtCu3IV;EsCp3IQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtCs3IV;AACF;Ac3jJI;EwB8IA;IAEI,iBAAA;IACA,2BAAA;EtC+6IN;EsC76IM;IACE,mBAAA;EtC+6IR;EsC76IQ;IACE,kBAAA;EtC+6IV;EsC56IQ;IACE,mDAAA;IACA,kDAAA;EtC86IV;EsC16IM;IACE,iBAAA;EtC46IR;EsCz6IM;IACE,wBAAA;IACA,gBAAA;EtC26IR;EsCx6IM;IACE,aAAA;EtC06IR;EsCv6IM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IhBvOJ,gBgByOI;EtCu6IR;EsCp6IQ;IACE,aAAA;EtCs6IV;EsCn6IQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtCq6IV;AACF;Ac1mJI;EwB8IA;IAEI,iBAAA;IACA,2BAAA;EtC89IN;EsC59IM;IACE,mBAAA;EtC89IR;EsC59IQ;IACE,kBAAA;EtC89IV;EsC39IQ;IACE,mDAAA;IACA,kDAAA;EtC69IV;EsCz9IM;IACE,iBAAA;EtC29IR;EsCx9IM;IACE,wBAAA;IACA,gBAAA;EtC09IR;EsCv9IM;IACE,aAAA;EtCy9IR;EsCt9IM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IhBvOJ,gBgByOI;EtCs9IR;EsCn9IQ;IACE,aAAA;EtCq9IV;EsCl9IQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtCo9IV;AACF;AczpJI;EwB8IA;IAEI,iBAAA;IACA,2BAAA;EtC6gJN;EsC3gJM;IACE,mBAAA;EtC6gJR;EsC3gJQ;IACE,kBAAA;EtC6gJV;EsC1gJQ;IACE,mDAAA;IACA,kDAAA;EtC4gJV;EsCxgJM;IACE,iBAAA;EtC0gJR;EsCvgJM;IACE,wBAAA;IACA,gBAAA;EtCygJR;EsCtgJM;IACE,aAAA;EtCwgJR;EsCrgJM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IhBvOJ,gBgByOI;EtCqgJR;EsClgJQ;IACE,aAAA;EtCogJV;EsCjgJQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtCmgJV;AACF;AsC1jJI;EAEI,iBAAA;EACA,2BAAA;AtC2jJR;AsCzjJQ;EACE,mBAAA;AtC2jJV;AsCzjJU;EACE,kBAAA;AtC2jJZ;AsCxjJU;EACE,mDAAA;EACA,kDAAA;AtC0jJZ;AsCtjJQ;EACE,iBAAA;AtCwjJV;AsCrjJQ;EACE,wBAAA;EACA,gBAAA;AtCujJV;AsCpjJQ;EACE,aAAA;AtCsjJV;AsCnjJQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;EhBvOJ,gBgByOI;AtCmjJV;AsChjJU;EACE,aAAA;AtCkjJZ;AsC/iJU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AtCijJZ;;AsChiJA;;EAGE,6CAAA;EACA,mDAAA;EACA,sDAAA;EACA,+BAAA;EACA,8BAAA;EACA,oCAAA;EACA,2DAAA;EACA,sEAAA;AtCkiJF;;AsC5hJI;EACE,sEAAA;AtC+hJN;;AuC/zJA;EAEE,yBAAA;EACA,yBAAA;EACA,iCAAA;EACA,wBAAA;EACA,2BAAA;EACA,gDAAA;EACA,4DAAA;EACA,kDAAA;EACA,uBAAA;EACA,0FAAA;EACA,gCAAA;EACA,8BAAA;EACA,wDAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EACA,oCAAA;EACA,gCAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,4BAAA;EACA,qBAAA;EACA,oCAAA;EACA,2BAAA;EACA,uEAAA;EhClBE,4CAAA;APk1JJ;AuC5zJE;EACE,eAAA;EACA,cAAA;AvC8zJJ;AuC3zJE;EACE,mBAAA;EACA,sBAAA;AvC6zJJ;AuC3zJI;EACE,mBAAA;EhCvBF,2DAAA;EACA,4DAAA;APq1JJ;AuC3zJI;EACE,sBAAA;EhCdF,+DAAA;EACA,8DAAA;AP40JJ;AuCxzJE;;EAEE,aAAA;AvC0zJJ;;AuCtzJA;EAGE,cAAA;EACA,0DAAA;EACA,4BAAA;AvCuzJF;;AuCpzJA;EACE,6CAAA;EACA,kCAAA;AvCuzJF;;AuCpzJA;EACE,uDAAA;EACA,gBAAA;EACA,qCAAA;AvCuzJF;;AuCpzJA;EACE,gBAAA;AvCuzJF;;AuC/yJE;EACE,6CAAA;AvCkzJJ;;AuC1yJA;EACE,oEAAA;EACA,gBAAA;EACA,gCAAA;EACA,wCAAA;EACA,8EAAA;AvC6yJF;AuC3yJE;EhC9FE,0FAAA;AP44JJ;;AuCzyJA;EACE,oEAAA;EACA,gCAAA;EACA,wCAAA;EACA,2EAAA;AvC4yJF;AuC1yJE;EhCzGE,0FAAA;APs5JJ;;AuCnyJA;EACE,wDAAA;EACA,uDAAA;EACA,uDAAA;EACA,gBAAA;AvCsyJF;AuCpyJE;EACE,oCAAA;EACA,uCAAA;AvCsyJJ;;AuClyJA;EACE,wDAAA;EACA,uDAAA;AvCqyJF;;AuCjyJA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,4CAAA;EhC3IE,kDAAA;APg7JJ;;AuCjyJA;;;EAGE,WAAA;AvCoyJF;;AuCjyJA;;EhC5II,2DAAA;EACA,4DAAA;APk7JJ;;AuClyJA;;EhCnII,+DAAA;EACA,8DAAA;AP06JJ;;AuC3xJE;EACE,2CAAA;AvC8xJJ;Ac15JI;EyBwHJ;IAQI,aAAA;IACA,mBAAA;EvC8xJF;EuC3xJE;IACE,SAAA;IACA,gBAAA;EvC6xJJ;EuC3xJI;IACE,sBAAA;IACA,sBAAA;EvC6xJN;EuCxxJM;IhC3KJ,0BAAA;IACA,wBAAA;EPs8JF;EuCzxJQ;;IAGE,0BAAA;EvC0xJV;EuCxxJQ;;IAGE,6BAAA;EvCyxJV;EuCrxJM;IhC5KJ,4BAAA;IACA,0BAAA;EPo8JF;EuCtxJQ;;IAGE,yBAAA;EvCuxJV;EuCrxJQ;;IAGE,4BAAA;EvCsxJV;AACF;;AwCv/JA;EAEE,4CAAA;EACA,sCAAA;EACA,+KAAA;EACA,qDAAA;EACA,qDAAA;EACA,uDAAA;EACA,+FAAA;EACA,sCAAA;EACA,mCAAA;EACA,gDAAA;EACA,+CAAA;EACA,kEAAA;EACA,uCAAA;EACA,mDAAA;EACA,+DAAA;EACA,yEAAA;EACA,2EAAA;EACA,uCAAA;EACA,oCAAA;EACA,8DAAA;EACA,uDAAA;AxCy/JF;;AwCr/JA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8EAAA;ErC0PI,eALI;EqCnPR,qCAAA;EACA,iBAAA;EACA,6CAAA;EACA,SAAA;EjCzBE,gBAAA;EiC2BF,qBAAA;ElB/BI,2CkBgCJ;AxCw/JF;AsBphKM;EkBeN;IlBdQ,gBAAA;EtBuhKN;AACF;AwC3/JE;EACE,wCAAA;EACA,gDAAA;EACA,oGAAA;AxC6/JJ;AwC3/JI;EACE,sDAAA;EACA,kDAAA;AxC6/JN;AwCx/JE;EACE,cAAA;EACA,0CAAA;EACA,2CAAA;EACA,yBAAA;EACA,WAAA;EACA,+CAAA;EACA,4BAAA;EACA,oDAAA;ElBtDE,oDkBuDF;AxC0/JJ;AsB7iKM;EkB0CJ;IlBzCM,gBAAA;EtBgjKN;AACF;AwC5/JE;EACE,UAAA;AxC8/JJ;AwC3/JE;EACE,UAAA;EACA,UAAA;EACA,qDAAA;AxC6/JJ;;AwCz/JA;EACE,gBAAA;AxC4/JF;;AwCz/JA;EACE,iCAAA;EACA,yCAAA;EACA,iFAAA;AxC4/JF;AwC1/JE;EjCjEE,0DAAA;EACA,2DAAA;AP8jKJ;AwC3/JI;EjCpEA,gEAAA;EACA,iEAAA;APkkKJ;AwC1/JE;EACE,aAAA;AxC4/JJ;AwCx/JE;EjChEE,8DAAA;EACA,6DAAA;AP2jKJ;AwCx/JM;EjCpEF,oEAAA;EACA,mEAAA;AP+jKJ;AwCv/JI;EjCzEA,8DAAA;EACA,6DAAA;APmkKJ;;AwCr/JA;EACE,gFAAA;AxCw/JF;;AwC/+JE;EACE,eAAA;EACA,cAAA;EjClHA,gBAAA;APqmKJ;AwCh/JI;EAAgB,aAAA;AxCm/JpB;AwCl/JI;EAAe,gBAAA;AxCq/JnB;AwCl/JI;;;EjCzHA,gBAAA;APgnKJ;;AwC5+JI;EACE,kEAAA;EACA,yEAAA;AxC++JN;;AyCtoKA;EAEE,6BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,qBAAA;EACA,gCAAA;EACA,0DAAA;EACA,uCAAA;EACA,8DAAA;EAGA,aAAA;EACA,eAAA;EACA,wEAAA;EACA,kDAAA;EtC+QI,0CALI;EsCxQR,gBAAA;EACA,0CAAA;ElCFE,kDAAA;APwoKJ;;AyChoKE;EACE,0DAAA;AzCmoKJ;AyCjoKI;EACE,mBAAA;EACA,wDAAA;EACA,0CAAA;EhBwCA,2CAAA;AzB4lKN;AyC1nKE;EACE,8CAAA;AzC4nKJ;;A0CpqKA;EAEE,mCAAA;EACA,oCAAA;EvC0RI,gCALI;EuCnRR,6CAAA;EACA,uCAAA;EACA,sDAAA;EACA,sDAAA;EACA,wDAAA;EACA,yDAAA;EACA,iDAAA;EACA,4DAAA;EACA,yDAAA;EACA,kDAAA;EACA,wEAAA;EACA,wDAAA;EACA,8CAAA;EACA,wDAAA;EACA,2DAAA;EACA,qDAAA;EACA,+DAAA;EAGA,aAAA;EjC5BA,uBAAA;EACA,gBAAA;ATisKF;;A0ClqKA;EACE,kBAAA;EACA,cAAA;EACA,wEAAA;EvC8PI,0CALI;EuCvPR,kCAAA;EACA,qBAAA;EACA,0CAAA;EACA,mFAAA;EpBzBI,qIoB0BJ;A1CqqKF;AsB3rKM;EoBaN;IpBZQ,gBAAA;EtB8rKN;AACF;A0CxqKE;EACE,UAAA;EACA,wCAAA;EAEA,gDAAA;EACA,sDAAA;A1CyqKJ;A0CtqKE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,UpCo1CgC;EoCn1ChC,kDAAA;A1CwqKJ;A0CrqKE;EAEE,UAAA;EACA,yCAAA;EnB5DF,iDmB6DuB;EACrB,uDAAA;A1CsqKJ;A0CnqKE;EAEE,2CAAA;EACA,oBAAA;EACA,mDAAA;EACA,yDAAA;A1CoqKJ;;A0C/pKE;EACE,uDpCuzCgC;AN22HpC;A0C7pKM;EnClCF,8DAAA;EACA,4DAAA;APksKJ;A0C3pKM;EnCtDF,4DAAA;EACA,0DAAA;APotKJ;;A0C9oKA;ECvGE,kCAAA;EACA,mCAAA;ExC6RI,mCALI;EwCtRR,2DAAA;A3CyvKF;;A0CjpKA;EC3GE,kCAAA;EACA,mCAAA;ExC6RI,oCALI;EwCtRR,2DAAA;A3CgwKF;;A4CjwKA;EAEE,6BAAA;EACA,6BAAA;EzCyRI,6BALI;EyClRR,4BAAA;EACA,uBAAA;EACA,mDAAA;EAGA,qBAAA;EACA,8DAAA;EzCiRI,qCALI;EyC1QR,yCAAA;EACA,cAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gDAAA;A5CiwKF;A4C7vKE;EACE,aAAA;A5C+vKJ;;A4C1vKA;EACE,kBAAA;EACA,SAAA;A5C6vKF;;A4CtvKA;EACE,4BAAA;EACA,4BAAA;EzCoPI,iBALI;AH2gKV;;A6CnyKA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,+BAAA;EACA,0BAAA;EACA,qCAAA;EACA,+EAAA;EACA,mDAAA;EACA,+BAAA;EAGA,kBAAA;EACA,8DAAA;EACA,6CAAA;EACA,6BAAA;EACA,qCAAA;EACA,+BAAA;EtCHE,6CAAA;APuyKJ;;A6C/xKA;EAEE,cAAA;A7CiyKF;;A6C7xKA;EACE,gBvCunB4B;EuCtnB5B,kCAAA;A7CgyKF;;A6CxxKA;EACE,wBvC4oD8B;AN+oHhC;A6CxxKE;EACE,kBAAA;EACA,mBAAA;EACA,MAAA;EACA,UAAA;EACA,qBAAA;A7C0xKJ;;A6ClxKE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A7CqxKJ;;A6CzxKE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,0DAAA;A7C4xKJ;;A6ChyKE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A7CmyKJ;;A6CvyKE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A7C0yKJ;;A6C9yKE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A7CizKJ;;A6CrzKE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A7CwzKJ;;A6C5zKE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A7C+zKJ;;A6Cn0KE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A7Cs0KJ;;A8C/3KE;EACE;IAAK,iDAAA;E9Cm4KP;AACF;A8C/3KA;;EAGE,2BAAA;E3CiRI,iCALI;E2C1QR,0CAAA;EACA,sDAAA;EACA,sDAAA;EACA,8BAAA;EACA,yCAAA;EACA,8CAAA;EAGA,aAAA;EACA,kCAAA;EACA,gBAAA;E3CqQI,wCALI;E2C9PR,wCAAA;EvCXE,gDAAA;AP04KJ;;A8C13KA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;ExB5BI,8CwB6BJ;A9C63KF;AsBt5KM;EwBgBN;IxBfQ,gBAAA;EtBy5KN;AACF;;A8C/3KA;EvBLE,qMAAA;EuBOA,sEAAA;A9Ck4KF;;A8C/3KA;EACE,iBAAA;A9Ck4KF;;A8C/3KA;EACE,WAAA;A9Ck4KF;;A8C93KE;EACE,kDAAA;A9Ci4KJ;A8C93KM;EAJJ;IAKM,eAAA;E9Ci4KN;AACF;;A8C53KA;EACE,WAAA;A9C+3KF;;A8C33KA;EACE,0CAAA;A9C83KF;A8C73KE;EACE,sBxCnEQ;ANk8KZ;;A8C33KA;EACE,aAAA;EACA,mBAAA;EACA,mBxC8VO;ANgiKT;;A8C33KA;EACE,eAAA;EACA,kBAAA;A9C83KF;;A8C33KA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBxCqoDqC;ANyvHvC;;A8C33KA;EACE,YAAA;EACA,kBAAA;A9C83KF;A8C53KE;EACE,kBAAA;A9C83KJ;;A8C13KA;EACE,gBAAA;A9C63KF;;A+Cx+KA;EAEE,6CAAA;EACA,uCAAA;EACA,sDAAA;EACA,sDAAA;EACA,wDAAA;EACA,qCAAA;EACA,uCAAA;EACA,yDAAA;EACA,8DAAA;EACA,wDAAA;EACA,2DAAA;EACA,0DAAA;EACA,2DAAA;EACA,gDAAA;EACA,wDAAA;EACA,8CAAA;EACA,wDAAA;EAGA,aAAA;EACA,sBAAA;EAGA,uBAAA;EACA,gBAAA;ExCZE,kDAAA;APm/KJ;;A+Cn+KA;EACE,qBAAA;EACA,sBAAA;A/Cs+KF;A+Cp+KE;EAEE,oCAAA;EACA,0BAAA;A/Cq+KJ;;A+C79KA;EACE,kBAAA;EACA,cAAA;EACA,kFAAA;EACA,kCAAA;EACA,qBAAA;EACA,0CAAA;EACA,mFAAA;A/Cg+KF;A+C99KE;ExC/BE,+BAAA;EACA,gCAAA;APggLJ;A+C99KE;ExCrBE,mCAAA;EACA,kCAAA;APs/KJ;A+C99KE;EAEE,2CAAA;EACA,oBAAA;EACA,mDAAA;A/C+9KJ;A+C39KE;EACE,UAAA;EACA,yCAAA;EACA,iDAAA;EACA,uDAAA;A/C69KJ;A+Cz9KE;EACE,mBAAA;A/C29KJ;A+Cz9KI;EACE,yDAAA;EACA,oDAAA;A/C29KN;;A+Cj9KA;EACE,WAAA;EACA,yCAAA;EACA,mBAAA;A/Co9KF;A+Ch9KI;EAEE,UAAA;EACA,+CAAA;EACA,qBAAA;EACA,uDAAA;A/Ci9KN;A+C98KI;EACE,gDAAA;EACA,wDAAA;A/Cg9KN;;A+Cn8KI;EACE,mBAAA;A/Cs8KN;A+Cn8KQ;ExC1DJ,4DAAA;EAZA,0BAAA;AP6gLJ;A+Cl8KQ;ExC3EJ,4DAAA;EAYA,0BAAA;APqgLJ;A+Cj8KQ;EACE,aAAA;A/Cm8KV;A+Ch8KQ;EACE,4BAAA;EACA,oDAAA;A/Ck8KV;A+Ch8KU;EACE,kEAAA;EACA,6DAAA;A/Ck8KZ;;Ac3hLI;EiCiEA;IACE,mBAAA;E/C89KJ;E+C39KM;IxC1DJ,4DAAA;IAZA,0BAAA;EPqiLF;E+C19KM;IxC3EJ,4DAAA;IAYA,0BAAA;EP6hLF;E+Cz9KM;IACE,aAAA;E/C29KR;E+Cx9KM;IACE,4BAAA;IACA,oDAAA;E/C09KR;E+Cx9KQ;IACE,kEAAA;IACA,6DAAA;E/C09KV;AACF;AcpjLI;EiCiEA;IACE,mBAAA;E/Cs/KJ;E+Cn/KM;IxC1DJ,4DAAA;IAZA,0BAAA;EP6jLF;E+Cl/KM;IxC3EJ,4DAAA;IAYA,0BAAA;EPqjLF;E+Cj/KM;IACE,aAAA;E/Cm/KR;E+Ch/KM;IACE,4BAAA;IACA,oDAAA;E/Ck/KR;E+Ch/KQ;IACE,kEAAA;IACA,6DAAA;E/Ck/KV;AACF;Ac5kLI;EiCiEA;IACE,mBAAA;E/C8gLJ;E+C3gLM;IxC1DJ,4DAAA;IAZA,0BAAA;EPqlLF;E+C1gLM;IxC3EJ,4DAAA;IAYA,0BAAA;EP6kLF;E+CzgLM;IACE,aAAA;E/C2gLR;E+CxgLM;IACE,4BAAA;IACA,oDAAA;E/C0gLR;E+CxgLQ;IACE,kEAAA;IACA,6DAAA;E/C0gLV;AACF;AcpmLI;EiCiEA;IACE,mBAAA;E/CsiLJ;E+CniLM;IxC1DJ,4DAAA;IAZA,0BAAA;EP6mLF;E+CliLM;IxC3EJ,4DAAA;IAYA,0BAAA;EPqmLF;E+CjiLM;IACE,aAAA;E/CmiLR;E+ChiLM;IACE,4BAAA;IACA,oDAAA;E/CkiLR;E+ChiLQ;IACE,kEAAA;IACA,6DAAA;E/CkiLV;AACF;Ac5nLI;EiCiEA;IACE,mBAAA;E/C8jLJ;E+C3jLM;IxC1DJ,4DAAA;IAZA,0BAAA;EPqoLF;E+C1jLM;IxC3EJ,4DAAA;IAYA,0BAAA;EP6nLF;E+CzjLM;IACE,aAAA;E/C2jLR;E+CxjLM;IACE,4BAAA;IACA,oDAAA;E/C0jLR;E+CxjLQ;IACE,kEAAA;IACA,6DAAA;E/C0jLV;AACF;A+C7iLA;ExCnJI,gBAAA;APmsLJ;A+C7iLE;EACE,oDAAA;A/C+iLJ;A+C7iLI;EACE,sBAAA;A/C+iLN;;A+CliLE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,8DAAA;EACA,kEAAA;EACA,+DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;A/CqiLJ;;A+C/iLE;EACE,0DAAA;EACA,mDAAA;EACA,iEAAA;EACA,8DAAA;EACA,oEAAA;EACA,+DAAA;EACA,qEAAA;EACA,6DAAA;EACA,8DAAA;EACA,wEAAA;A/CkjLJ;;A+C5jLE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,8DAAA;EACA,kEAAA;EACA,+DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;A/C+jLJ;;A+CzkLE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,8DAAA;EACA,+DAAA;EACA,+DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;A/C4kLJ;;A+CtlLE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,8DAAA;EACA,kEAAA;EACA,+DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;A/CylLJ;;A+CnmLE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,8DAAA;EACA,iEAAA;EACA,+DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;A/CsmLJ;;A+ChnLE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,8DAAA;EACA,gEAAA;EACA,+DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A/CmnLJ;;A+C7nLE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,8DAAA;EACA,+DAAA;EACA,+DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;A/CgoLJ;;AgD7zLA;EAEE,8BAAA;EACA,4DAAA;EACA,4BAAA;EACA,mCAAA;EACA,mEAAA;EACA,gCAAA;EACA,sCAAA;EAGA,uBAAA;EACA,U1Co/D2B;E0Cn/D3B,W1Cm/D2B;E0Cl/D3B,sBAAA;EACA,iCAAA;EACA,yEAAA;EACA,mCAAA;EACA,SAAA;EzCNE,uBAAA;EyCQF,qCAAA;AhD6zLF;AgD1zLE;EACE,iCAAA;EACA,qBAAA;EACA,2CAAA;AhD4zLJ;AgDzzLE;EACE,UAAA;EACA,6CAAA;EACA,2CAAA;AhD2zLJ;AgDxzLE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,8CAAA;AhDyzLJ;;AgDjzLA;EAHE,kEAAA;AhDwzLF;;AgDjzLA;;EAEE,wBAAA;AhDozLF;;AIn2LI;E4CsCF,kEAAA;AhDi0LF;;AiDp3LA;EAEE,wBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;E9C2RI,+BALI;E8CpRR,mBAAA;EACA,kDAAA;EACA,iDAAA;EACA,6DAAA;EACA,mDAAA;EACA,6CAAA;EACA,oDAAA;EACA,yDAAA;EACA,oEAAA;EAGA,iCAAA;EACA,eAAA;E9C6QI,qCALI;E8CtQR,6BAAA;EACA,oBAAA;EACA,qCAAA;EACA,4BAAA;EACA,yEAAA;EACA,uCAAA;E1CRE,6CAAA;AP63LJ;AiDl3LE;EACE,UAAA;AjDo3LJ;AiDj3LE;EACE,aAAA;AjDm3LJ;;AiD/2LA;EACE,wBAAA;EAEA,kBAAA;EACA,gCAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AjDi3LF;AiD/2LE;EACE,uCAAA;AjDi3LJ;;AiD72LA;EACE,aAAA;EACA,mBAAA;EACA,8DAAA;EACA,oCAAA;EACA,4CAAA;EACA,4BAAA;EACA,uFAAA;E1ChCE,4FAAA;EACA,6FAAA;APi5LJ;AiD/2LE;EACE,iFAAA;AjDi3LJ;;AiD72LA;EACE,mCAAA;EACA,qBAAA;AjDg3LF;;AkD16LA;EAEE,wBAAA;EACA,wBAAA;EACA,yBAAA;EACA,0BAAA;EACA,wCAAA;EACA,kCAAA;EACA,6DAAA;EACA,iDAAA;EACA,sDAAA;EACA,gDAAA;EACA,8FAAA;EACA,kCAAA;EACA,kCAAA;EACA,qCAAA;EACA,wDAAA;EACA,wDAAA;EACA,kCAAA;EACA,8BAAA;EACA,uBAAA;EACA,wDAAA;EACA,wDAAA;EAGA,eAAA;EACA,qBAAA;EACA,MAAA;EACA,gCAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AlDw6LF;;AkDj6LA;EACE,kBAAA;EACA,WAAA;EACA,+BAAA;EAEA,oBAAA;AlDm6LF;AkDh6LE;EACE,8B5CijDgC;EgBlmD9B,mC4BkDF;AlDk6LJ;AsBh9LM;E4B4CJ;I5B3CM,gBAAA;EtBm9LN;AACF;AkDr6LE;EACE,e5C8iDgC;ANy3IpC;AkDn6LE;EACE,sB5C2iDgC;AN03IpC;;AkDj6LA;EACE,gDAAA;AlDo6LF;AkDl6LE;EACE,gBAAA;EACA,gBAAA;AlDo6LJ;AkDj6LE;EACE,gBAAA;AlDm6LJ;;AkD/5LA;EACE,aAAA;EACA,mBAAA;EACA,oDAAA;AlDk6LF;;AkD95LA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,6BAAA;EACA,oBAAA;EACA,qCAAA;EACA,4BAAA;EACA,yEAAA;E3CxFE,6CAAA;E2C4FF,UAAA;AlD85LF;;AkD15LA;EAEE,2BAAA;EACA,0BAAA;EACA,2BAAA;ECvHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,mCDuH0B;ECtH1B,YAAA;EACA,aAAA;EACA,wCDoH4D;AlDg6L9D;AmDjhME;EAAS,UAAA;AnDohMX;AmDnhME;EAAS,oCDgHiF;AlDs6L5F;;AkDj6LA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,wCAAA;EACA,8FAAA;E3CxGE,4DAAA;EACA,6DAAA;AP6gMJ;AkDn6LE;EACE,oGAAA;EACA,yBAAA;EACA,iEAAA;EACA,0DAAA;EACA,6DAAA;AlDq6LJ;;AkDh6LA;EACE,gBAAA;EACA,+CAAA;AlDm6LF;;AkD95LA;EACE,kBAAA;EAGA,cAAA;EACA,iCAAA;AlD+5LF;;AkD35LA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,2EAAA;EACA,4CAAA;EACA,2FAAA;E3C/HE,gEAAA;EACA,+DAAA;AP8hMJ;AkD15LE;EACE,+CAAA;AlD45LJ;;Ac7gMI;EoCuHF;IACE,2BAAA;IACA,6CAAA;ElD05LF;EkDt5LA;IACE,iCAAA;IACA,kBAAA;IACA,iBAAA;ElDw5LF;EkDr5LA;IACE,wBAAA;ElDu5LF;AACF;Ac5hMI;EoCyIF;;IAEE,wBAAA;ElDs5LF;AACF;AcliMI;EoCgJF;IACE,yBAAA;ElDq5LF;AACF;AkD54LI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AlD84LN;AkD54LM;EACE,YAAA;EACA,SAAA;E3C/MJ,gBAAA;AP8lMJ;AkD34LM;;E3CnNF,gBAAA;APkmMJ;AkD14LM;EACE,gBAAA;AlD44LR;;Ac5iMI;EoC8IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDk6LJ;EkDh6LI;IACE,YAAA;IACA,SAAA;I3C/MJ,gBAAA;EPknMF;EkD/5LI;;I3CnNF,gBAAA;EPsnMF;EkD95LI;IACE,gBAAA;ElDg6LN;AACF;AcjkMI;EoC8IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDs7LJ;EkDp7LI;IACE,YAAA;IACA,SAAA;I3C/MJ,gBAAA;EPsoMF;EkDn7LI;;I3CnNF,gBAAA;EP0oMF;EkDl7LI;IACE,gBAAA;ElDo7LN;AACF;AcrlMI;EoC8IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElD08LJ;EkDx8LI;IACE,YAAA;IACA,SAAA;I3C/MJ,gBAAA;EP0pMF;EkDv8LI;;I3CnNF,gBAAA;EP8pMF;EkDt8LI;IACE,gBAAA;ElDw8LN;AACF;AczmMI;EoC8IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElD89LJ;EkD59LI;IACE,YAAA;IACA,SAAA;I3C/MJ,gBAAA;EP8qMF;EkD39LI;;I3CnNF,gBAAA;EPkrMF;EkD19LI;IACE,gBAAA;ElD49LN;AACF;Ac7nMI;EoC8IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDk/LJ;EkDh/LI;IACE,YAAA;IACA,SAAA;I3C/MJ,gBAAA;EPksMF;EkD/+LI;;I3CnNF,gBAAA;EPssMF;EkD9+LI;IACE,gBAAA;ElDg/LN;AACF;AoD1tMA;EAEE,0BAAA;EACA,8BAAA;EACA,+BAAA;EACA,gCAAA;EACA,sBAAA;EjDwRI,iCALI;EiDjRR,uCAAA;EACA,2CAAA;EACA,qDAAA;EACA,0BAAA;EACA,iCAAA;EACA,kCAAA;EAGA,kCAAA;EACA,cAAA;EACA,iCAAA;ECtBA,uC/C2oB4B;E+CzoB5B,kBAAA;EACA,gB/CopB4B;E+CnpB5B,gB/C2pB4B;E+C1pB5B,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;ElDqRI,uCALI;EiDhQR,qBAAA;EACA,UAAA;ApDiuMF;AoD/tME;EAAS,mCAAA;ApDkuMX;AoDhuME;EACE,cAAA;EACA,qCAAA;EACA,uCAAA;ApDkuMJ;AoDhuMI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ApDkuMN;;AoD7tMA;EACE,kDAAA;ApDguMF;AoD9tME;EACE,SAAA;EACA,0FAAA;EACA,uCAAA;ApDguMJ;;AoD5tMA,qBAAA;AACA;EACE,gDAAA;EACA,sCAAA;EACA,sCAAA;ApD+tMF;AoD7tME;EACE,WAAA;EACA,qIAAA;EACA,yCAAA;ApD+tMJ;;AoD3tMA,mBAAA;AAEA;EACE,+CAAA;ApD6tMF;AoD3tME;EACE,YAAA;EACA,0FAAA;EACA,0CAAA;ApD6tMJ;;AoDztMA,qBAAA;AACA;EACE,iDAAA;EACA,sCAAA;EACA,sCAAA;ApD4tMF;AoD1tME;EACE,UAAA;EACA,qIAAA;EACA,wCAAA;ApD4tMJ;;AoDxtMA,mBAAA;AAkBA;EACE,uCAAA;EACA,kEAAA;EACA,+BAAA;EACA,kBAAA;EACA,uCAAA;E7CnGE,+CAAA;AP8yMJ;;AsD/zMA;EAEE,0BAAA;EACA,8BAAA;EnD4RI,iCALI;EmDrRR,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,wDAAA;EACA,8FAAA;EACA,+CAAA;EACA,oCAAA;EACA,sCAAA;EnDmRI,oCALI;EmD5QR,mCAAA;EACA,gDAAA;EACA,kCAAA;EACA,kCAAA;EACA,+CAAA;EACA,+BAAA;EACA,kCAAA;EACA,2DAAA;EAGA,kCAAA;EACA,cAAA;EACA,uCAAA;ED7BA,uC/C2oB4B;E+CzoB5B,kBAAA;EACA,gB/CopB4B;E+CnpB5B,gB/C2pB4B;E+C1pB5B,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;ElDqRI,uCALI;EmD1PR,qBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E/ClBE,+CAAA;AP21MJ;AsDr0ME;EACE,cAAA;EACA,qCAAA;EACA,uCAAA;AtDu0MJ;AsDr0MI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AtDs0MN;;AsDh0ME;EACE,sFAAA;AtDm0MJ;AsDj0MI;EAEE,0FAAA;AtDk0MN;AsD/zMI;EACE,SAAA;EACA,iDAAA;AtDi0MN;AsD9zMI;EACE,uCAAA;EACA,uCAAA;AtDg0MN;;AsD3zMA,qBAAA;AAEE;EACE,oFAAA;EACA,sCAAA;EACA,sCAAA;AtD6zMJ;AsD3zMI;EAEE,qIAAA;AtD4zMN;AsDzzMI;EACE,OAAA;EACA,mDAAA;AtD2zMN;AsDxzMI;EACE,qCAAA;EACA,yCAAA;AtD0zMN;;AsDrzMA,mBAAA;AAGE;EACE,mFAAA;AtDszMJ;AsDpzMI;EAEE,0FAAA;AtDqzMN;AsDlzMI;EACE,MAAA;EACA,oDAAA;AtDozMN;AsDjzMI;EACE,oCAAA;EACA,0CAAA;AtDmzMN;AsD9yME;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,qCAAA;EACA,wDAAA;EACA,WAAA;EACA,iFAAA;AtDgzMJ;;AsD5yMA,qBAAA;AAEE;EACE,qFAAA;EACA,sCAAA;EACA,sCAAA;AtD8yMJ;AsD5yMI;EAEE,qIAAA;AtD6yMN;AsD1yMI;EACE,QAAA;EACA,kDAAA;AtD4yMN;AsDzyMI;EACE,sCAAA;EACA,wCAAA;AtD2yMN;;AsDtyMA,mBAAA;AAkBA;EACE,gFAAA;EACA,gBAAA;EnD2GI,8CALI;EmDpGR,sCAAA;EACA,8CAAA;EACA,oFAAA;E/C9JE,8DAAA;EACA,+DAAA;APu7MJ;AsDvxME;EACE,aAAA;AtDyxMJ;;AsDrxMA;EACE,4EAAA;EACA,oCAAA;AtDwxMF;;AuD38MA;EACE,kBAAA;AvD88MF;;AuD38MA;EACE,mBAAA;AvD88MF;;AuD38MA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AvD88MF;AwD5+ME;EACE,cAAA;EACA,WAAA;EACA,WAAA;AxD8+MJ;;AuD/8MA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EjCvBI,sCiCwBJ;AvDk9MF;AsBt+MM;EiCaN;IjCZQ,gBAAA;EtBy+MN;AACF;;AuDp9MA;;;EAGE,cAAA;AvDu9MF;;AuDp9MA;;EAEE,2BAAA;AvDu9MF;;AuDp9MA;;EAEE,4BAAA;AvDu9MF;;AuD98ME;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AvDi9MJ;AuD98ME;;;EAGE,UAAA;EACA,UAAA;AvDg9MJ;AuD78ME;;EAEE,UAAA;EACA,UAAA;EjCjEE,2BiCkEF;AvD+8MJ;AsB7gNM;EiC0DJ;;IjCzDM,gBAAA;EtBihNN;AACF;;AuD58MA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UjDwvDmC;EiDvvDnC,UAAA;EACA,WjDzFU;EiD0FV,kBAAA;EACA,gBAAA;EACA,+CAAA;EACA,SAAA;EACA,YjDkvDmC;EgB90D/B,8BiC6FJ;AvD88MF;AsBviNM;EiCuEN;;IjCtEQ,gBAAA;EtB2iNN;AACF;AuDj9ME;;;EAEE,WjDpGQ;EiDqGR,qBAAA;EACA,UAAA;EACA,YjD0uDiC;AN0uJrC;;AuDj9MA;EACE,OAAA;AvDo9MF;;AuDj9MA;EACE,QAAA;AvDo9MF;;AuD/8MA;;EAEE,qBAAA;EACA,WjD4uDmC;EiD3uDnC,YjD2uDmC;EiD1uDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AvDk9MF;;AuD/8MA;E9B7BM,0DAAA;AzBg/MN;;AuDh9MA;E9BhCM,0DAAA;AzBo/MN;;AuD38MA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBjD2rDmC;EiD1rDnC,mBAAA;EACA,gBjDyrDmC;ANoxJrC;AuD38ME;EACE,uBAAA;EACA,cAAA;EACA,WjD0rDiC;EiDzrDjC,WjD0rDiC;EiDzrDjC,UAAA;EACA,iBjD0rDiC;EiDzrDjC,gBjDyrDiC;EiDxrDjC,mBAAA;EACA,eAAA;EACA,sBjDlKQ;EiDmKR,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YjDirDiC;EgBv1D/B,6BiCuKF;AvD48MJ;AsB/mNM;EiCkJJ;IjCjJM,gBAAA;EtBknNN;AACF;AuD98ME;EACE,UjD8qDiC;ANkyJrC;;AuDv8MA;EACE,kBAAA;EACA,UAAA;EACA,ejDwqDmC;EiDvqDnC,SAAA;EACA,oBjDqqDmC;EiDpqDnC,uBjDoqDmC;EiDnqDnC,wCAAA;EACA,kBAAA;AvD08MF;;AuD/7MA;EALE,2CAAA;EACA,qCAAA;EACA,4DAAA;AvDw8MF;;AuDj8MA;;EAEE,wCAAA;EACA,kCAAA;EACA,oCAAA;AvDo8MF;;AIrpNI;EmDoMF,2CAAA;EACA,qCAAA;EACA,4DAAA;AvDq9MF;;AyDtqNA;;EAEE,qBAAA;EACA,+BAAA;EACA,iCAAA;EACA,iDAAA;EAEA,kBAAA;EACA,+FAAA;AzDwqNF;;AyDpqNA;EACE;IAAK,0CAAA;EzDwqNL;AACF;AyDrqNA;EAEE,yBAAA;EACA,0BAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,4CAAA;EAGA,0DAAA;EACA,+BAAA;AzDoqNF;;AyDjqNA;EAEE,yBAAA;EACA,0BAAA;EACA,iCAAA;AzDmqNF;;AyD1pNA;EACE;IACE,mBAAA;EzD6pNF;EyD3pNA;IACE,UAAA;IACA,eAAA;EzD6pNF;AACF;AyDzpNA;EAEE,yBAAA;EACA,0BAAA;EACA,sCAAA;EACA,oCAAA;EACA,0CAAA;EAGA,8BAAA;EACA,UAAA;AzDwpNF;;AyDrpNA;EACE,yBAAA;EACA,0BAAA;AzDwpNF;;AyDppNE;EACE;;IAEE,mCAAA;EzDupNJ;AACF;A0DluNA;EAEE,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,+BAAA;EACA,+BAAA;EACA,4CAAA;EACA,sCAAA;EACA,qDAAA;EACA,iEAAA;EACA,oDAAA;EACA,sDAAA;EACA,sCAAA;A1DmuNF;;AczqNI;E4CzCF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IpChCA,2CoCkCA;E1DotNJ;AACF;AsBnvNM;EoCgBJ;IpCfM,gBAAA;EtBsvNN;AACF;Ac/rNI;E4CzBE;IACE,qBAAA;IACA,MAAA;IACA,iCAAA;IACA,4FAAA;IjCuDF,4BAAA;EzBqqNJ;E0DxtNI;IACE,mBAAA;IACA,MAAA;IACA,iCAAA;IACA,8FAAA;IACA,2BAAA;E1D0tNN;E0DvtNI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E1DytNN;E0DttNI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E1DwtNN;E0DrtNI;IAEE,0BAAA;E1DstNN;E0DntNI;IAGE,mBAAA;E1DmtNN;AACF;AcnvNI;E4C5BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E1DktNN;E0DhtNM;IACE,aAAA;E1DktNR;E0D/sNM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1DgtNR;AACF;;AcvvNI;E4CzCF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IpChCA,2CoCkCA;E1DkyNJ;AACF;AsBj0NM;EoCgBJ;IpCfM,gBAAA;EtBo0NN;AACF;Ac7wNI;E4CzBE;IACE,qBAAA;IACA,MAAA;IACA,iCAAA;IACA,4FAAA;IjCuDF,4BAAA;EzBmvNJ;E0DtyNI;IACE,mBAAA;IACA,MAAA;IACA,iCAAA;IACA,8FAAA;IACA,2BAAA;E1DwyNN;E0DryNI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E1DuyNN;E0DpyNI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E1DsyNN;E0DnyNI;IAEE,0BAAA;E1DoyNN;E0DjyNI;IAGE,mBAAA;E1DiyNN;AACF;Acj0NI;E4C5BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E1DgyNN;E0D9xNM;IACE,aAAA;E1DgyNR;E0D7xNM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1D8xNR;AACF;;Acr0NI;E4CzCF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IpChCA,2CoCkCA;E1Dg3NJ;AACF;AsB/4NM;EoCgBJ;IpCfM,gBAAA;EtBk5NN;AACF;Ac31NI;E4CzBE;IACE,qBAAA;IACA,MAAA;IACA,iCAAA;IACA,4FAAA;IjCuDF,4BAAA;EzBi0NJ;E0Dp3NI;IACE,mBAAA;IACA,MAAA;IACA,iCAAA;IACA,8FAAA;IACA,2BAAA;E1Ds3NN;E0Dn3NI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E1Dq3NN;E0Dl3NI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E1Do3NN;E0Dj3NI;IAEE,0BAAA;E1Dk3NN;E0D/2NI;IAGE,mBAAA;E1D+2NN;AACF;Ac/4NI;E4C5BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E1D82NN;E0D52NM;IACE,aAAA;E1D82NR;E0D32NM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1D42NR;AACF;;Acn5NI;E4CzCF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IpChCA,2CoCkCA;E1D87NJ;AACF;AsB79NM;EoCgBJ;IpCfM,gBAAA;EtBg+NN;AACF;Acz6NI;E4CzBE;IACE,qBAAA;IACA,MAAA;IACA,iCAAA;IACA,4FAAA;IjCuDF,4BAAA;EzB+4NJ;E0Dl8NI;IACE,mBAAA;IACA,MAAA;IACA,iCAAA;IACA,8FAAA;IACA,2BAAA;E1Do8NN;E0Dj8NI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E1Dm8NN;E0Dh8NI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E1Dk8NN;E0D/7NI;IAEE,0BAAA;E1Dg8NN;E0D77NI;IAGE,mBAAA;E1D67NN;AACF;Ac79NI;E4C5BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E1D47NN;E0D17NM;IACE,aAAA;E1D47NR;E0Dz7NM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1D07NR;AACF;;Acj+NI;E4CzCF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IpChCA,2CoCkCA;E1D4gOJ;AACF;AsB3iOM;EoCgBJ;IpCfM,gBAAA;EtB8iON;AACF;Acv/NI;E4CzBE;IACE,qBAAA;IACA,MAAA;IACA,iCAAA;IACA,4FAAA;IjCuDF,4BAAA;EzB69NJ;E0DhhOI;IACE,mBAAA;IACA,MAAA;IACA,iCAAA;IACA,8FAAA;IACA,2BAAA;E1DkhON;E0D/gOI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E1DihON;E0D9gOI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E1DghON;E0D7gOI;IAEE,0BAAA;E1D8gON;E0D3gOI;IAGE,mBAAA;E1D2gON;AACF;Ac3iOI;E4C5BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E1D0gON;E0DxgOM;IACE,aAAA;E1D0gOR;E0DvgOM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1DwgOR;AACF;;A0DxlOE;EAEI,eAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,iCAAA;EACA,kBAAA;EACA,yCAAA;EACA,4BAAA;EACA,UAAA;EpChCA,2CoCkCA;A1DylON;AsBvnOM;EoCgBJ;IpCfM,gBAAA;EtB0nON;AACF;A0D5lOM;EACE,qBAAA;EACA,MAAA;EACA,iCAAA;EACA,4FAAA;EjCuDF,4BAAA;AzBwiON;A0D3lOM;EACE,mBAAA;EACA,MAAA;EACA,iCAAA;EACA,8FAAA;EACA,2BAAA;A1D6lOR;A0D1lOM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,mCAAA;EACA,gBAAA;EACA,wFAAA;EACA,4BAAA;A1D4lOR;A0DzlOM;EACE,QAAA;EACA,OAAA;EACA,mCAAA;EACA,gBAAA;EACA,qFAAA;EACA,2BAAA;A1D2lOR;A0DxlOM;EAEE,0BAAA;A1DylOR;A0DtlOM;EAGE,mBAAA;A1DslOR;;A0D3jOA;EPzHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a7CmsCkC;E6ClsClC,YAAA;EACA,aAAA;EACA,2DOoHsD;A1DokOxD;AmDrrOE;EAAS,UAAA;AnDwrOX;AmDvrOE;EAAS,Y7CslDyB;ANomLpC;;A0DvkOA;EACE,aAAA;EACA,mBAAA;EACA,sEAAA;A1D0kOF;A0DxkOE;EACE,8FAAA;EACA,yBAAA;EACA,8DAAA;EACA,uDAAA;EACA,0DAAA;A1D0kOJ;;A0DtkOA;EACE,gBAAA;EACA,mDAAA;A1DykOF;;A0DtkOA;EACE,YAAA;EACA,sEAAA;EACA,gBAAA;A1DykOF;;A2D9tOA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YrD+5CkC;ANk0LpC;A2D/tOE;EACE,qBAAA;EACA,WAAA;A3DiuOJ;;A2D5tOA;EACE,iBAAA;A3D+tOF;;A2D5tOA;EACE,iBAAA;A3D+tOF;;A2D5tOA;EACE,iBAAA;A3D+tOF;;A2D1tOE;EACE,mDAAA;A3D6tOJ;;A2DztOA;EACE;IACE,YrDk4CgC;EN01LlC;AACF;A2DztOA;EACE,qFAAA;EACA,oBAAA;EACA,8CAAA;A3D2tOF;;A2DxtOA;EACE;IACE,uBAAA;E3D2tOF;AACF;A4DzwOA;EAEE,wBAAA;EACA,yBAAA;EACA,8BAAA;EACA,gCAAA;EACA,iCAAA;EACA,kCAAA;EACA,uCAAA;EAGA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,gCAAA;EACA,sCAAA;EACA,sBAAA;ErDAE,8CAAA;EeJE,wBsCMJ;A5DwwOF;AsB1wOM;EsClBN;ItCmBQ,gBAAA;EtB6wON;AACF;;A4D1wOA;EACE,WAAA;EACA,YAAA;ErDPE,8CAAA;APqxOJ;;A4D1wOA;EACE,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,qCAAA;EACA,uCAAA;EACA,sBAAA;ErDlBE,qDAAA;APgyOJ;;A4DzwOE;EACE,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,iCAAA;EACA,kCAAA;A5D4wOJ;;A4DjxOE;EACE,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,iCAAA;EACA,kCAAA;A5DoxOJ;;A4DzxOE;EACE,wBAAA;EACA,yBAAA;EACA,8BAAA;EACA,iCAAA;EACA,kCAAA;A5D4xOJ;;A4DjyOE;EACE,wBAAA;EACA,yBAAA;EACA,8BAAA;EACA,+BAAA;EACA,gCAAA;A5DoyOJ;;A4DhyOA;EACE,aAAA;A5DmyOF;A4DjyOE;EACE,uDAAA;A5DmyOJ;A4DjyOI;EACE,oBAAA;A5DmyON;;A6D91OA;EAEE,6BAAA;EACA,6BAAA;EACA,yBAAA;EACA,4BAAA;EACA,mDAAA;EACA,mDAAA;EACA,kEAAA;EACA,qDAAA;EAGA,kEAAA;EACA,+DAAA;EACA,6EAAA;EACA,+DAAA;EACA,+DAAA;EtDIE,+CAAA;AP21OJ;;A6Dx1OE;EACE,wCAAA;A7D21OJ;;A6D51OE;EACE,wCAAA;A7D+1OJ;;A6Dh2OE;EACE,wCAAA;A7Dm2OJ;;A6Dp2OE;EACE,wCAAA;A7Du2OJ;;A6Dx2OE;EACE,wCAAA;A7D22OJ;;A6D52OE;EACE,qCAAA;A7D+2OJ;;A6Dh3OE;EACE,wCAAA;A7Dm3OJ;;A6Dp3OE;EACE,wCAAA;A7Du3OJ;;A8Dh5OA;EAEE,6BAAA;EACA,4BAAA;EACA,8BAAA;EACA,yCAAA;EACA,uCAAA;EACA,kDAAA;EACA,iFAAA;EAGA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,wCAAA;EACA,gEAAA;EACA,8BAAA;EACA,gCAAA;EACA,oCAAA;A9Dg5OF;;A8D74OA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,axD0qCkC;ANsuMpC;;A8D74OA;EACE,gBAAA;EACA,SAAA;EACA,axDoqCkC;AN4uMpC;;A+D56OA;EAEE,8BAAA;EACA,8BAAA;EACA,mCAAA;EACA,6DAAA;EACA,kDAAA;EACA,iFAAA;EACA,kEAAA;EACA,qEAAA;EACA,iEAAA;EACA,qDAAA;EACA,uCAAA;EACA,iCAAA;EACA,qDAAA;EACA,uCAAA;EACA,uCAAA;EACA,oCAAA;EACA,qEAAA;EACA,4DAAA;EACA,wEAAA;EACA,sEAAA;EACA,4EAAA;EACA,uCAAA;EACA,uCAAA;EACA,0DAAA;EACA,iGAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,gEAAA;EACA,gCAAA;EACA,uCAAA;EzCxBI,wCyCyBJ;A/D46OF;AsBj8OM;EyChBN;IzCiBQ,gBAAA;EtBo8ON;AACF;A+D56OE;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;A/D+6OJ;A+Dj6OE;EACE,gBAAA;EACA,MAAA;EACA,azDgoCgC;ANmyMpC;;A+D/5OA;EACE,wDAAA;EACA,SAAA;EACA,0EAAA;EACA,4CAAA;A/Dk6OF;;A+D35OA;EACE,8CAAA;EACA,iDAAA;EACA,uBzDwsD8B;EH3/C1B,kBALI;E4DtMR,oCAAA;EACA,qBAAA;EACA,mBAAA;A/D85OF;A+D55OE;EAEE,0CAAA;A/D65OJ;;A+Dp5OA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;A/Du5OF;A+Dr5OE;EACE,kFAAA;EACA,8BAAA;A/Du5OJ;A+Dr5OI;EAEE,oCAAA;A/Ds5ON;A+Dn5OI;EACE,uCAAA;A/Dq5ON;A+Dj5OE;;EAEE,qCAAA;A/Dm5OJ;A+Dh5OE;EACE,kBAAA;A/Dk5OJ;;A+Dz4OA;EACE,iDAAA;EACA,oDAAA;EACA,8BAAA;A/D44OF;A+D14OE;EACE,qCAAA;A/D44OJ;A+D14OI;EAEE,qCAAA;A/D24ON;;A+Dt4OA;EACE,gFAAA;E5DwII,kBALI;E4DjIR,sCAAA;EACA,8CAAA;EACA,SAAA;ExD1IE,sDAAA;APohPJ;A+Dv4OE;EACE,4CAAA;EACA,qBAAA;A/Dy4OJ;A+Dt4OE;EACE,UAAA;A/Dw4OJ;A+Dp4OE;EACE,eAAA;A/Ds4OJ;;A+Dl4OA;EACE,cAAA;EACA,iBAAA;EACA,mDAAA;EACA,4BAAA;EACA,kCAAA;EACA,0BAAA;A/Dq4OF;A+Dn4OE;EACE,yDAAA;A/Dq4OJ;;AgE9jPA;EACE,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AhEikPF;AgEhkPE;ECPA,W3DiwBgB;E2DhwBhB,Y3DgwBgB;E2D/vBhB,e3D+vBgB;AN20NlB;AgElkPI;ECVF,W3DqwBgB;E2DpwBhB,Y3DowBgB;E2DnwBhB,e3DmwBgB;AN40NlB;AgEnkPI;ECdF,a3DowBgB;E2DnwBhB,c3DmwBgB;E2DlwBhB,iB3DkwBgB;ANk1NlB;AgEpkPI;EClBF,c3DmwBgB;E2DlwBhB,e3DkwBgB;E2DjwBhB,kB3DiwBgB;ANw1NlB;AgErkPI;ECtBF,e3DkwBgB;E2DjwBhB,gB3DiwBgB;E2DhwBhB,mB3DgwBgB;AN81NlB;AgErkPM;EC3BJ,WD4ByB;EC3BzB,YD2ByB;EC1BzB,eD0ByB;AhEykP3B;AgE1kPM;EC3BJ,WD4ByB;EC3BzB,YD2ByB;EC1BzB,eD0ByB;AhE8kP3B;AgE/kPM;EC3BJ,WD4ByB;EC3BzB,YD2ByB;EC1BzB,eD0ByB;AhEmlP3B;AgEplPM;EC3BJ,WD4ByB;EC3BzB,YD2ByB;EC1BzB,eD0ByB;AhEwlP3B;AgEzlPM;EC3BJ,WD4ByB;EC3BzB,YD2ByB;EC1BzB,eD0ByB;AhE6lP3B;AgE9lPM;EC3BJ,WD4ByB;EC3BzB,YD2ByB;EC1BzB,eD0ByB;AhEkmP3B;AgEnmPM;EC3BJ,WD4ByB;EC3BzB,YD2ByB;EC1BzB,eD0ByB;AhEumP3B;;AkE3nPA;EAEE,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,6BAAA;EACA,6BAAA;EACA,0CAAA;EACA,gDAAA;EACA,4CAAA;EAGA,kBAAA;EACA,aAAA;EACA,kCAAA;EACA,sBAAA;EAEA,SAAA;EACA,+BAAA;EACA,+BAAA;EACA,iCAAA;EACA,gBAAA;E5CZI,yH4CaJ;AlE0nPF;AsBnoPM;E4CbN;I5CcQ,gBAAA;EtBsoPN;AACF;AkE7nPE;EACE,sBAAA;AlE+nPJ;AkE5nPE;EACE,SAAA;EACA,oBAAA;AlE8nPJ;AcnmPI;EoDtBE;IACE,iCAAA;ElE4nPN;EkE1nPI;IACE,+BAAA;ElE4nPN;EkEvnPI;IACE,wDAAA;ElEynPN;EkEvnPI;IACE,sDAAA;ElEynPN;AACF;AcpmPI;EoDtEJ;IAwDI,qBAAA;IAEA,eAAA;IACA,MAAA;IACA,SAAA;IACA,kCAAA;ElEqnPF;EkEnnPE;IACE,qBAAA;ElEqnPJ;EkEnnPI;IACE,wDAAA;ElEqnPN;EkEjnPE;IACE,mBAAA;ElEmnPJ;EkEjnPI;IACE,sDAAA;ElEmnPN;AACF;;AkE9mPA;EACE,eAAA;EACA,MAAA;EACA,SAAA;EACA,kCAAA;AlEinPF;AkE/mPE;EACE,qBAAA;AlEinPJ;AkE9mPE;EACE,mBAAA;AlEgnPJ;;AkE5mPA;EAEE,wDAAA;AlE8mPF;AkEzmPE;EACE,wDAAA;AlE2mPJ;AkExmPE;EACE,sDAAA;AlE0mPJ;AkEvmPE;EACE,kDAAA;AlEymPJ;AkEvmPI;EACE,sBAAA;AlEymPN;AkEtmPI;EACE,oBAAA;AlEwmPN;;AkElmPE;EACE,0BAAA;AlEqmPJ;Ac1qPI;EoDyEI;IACE,iCAAA;ElEomPR;EkElmPM;IACE,+BAAA;ElEomPR;AACF;;AkE9mPE;EACE,0BAAA;AlEinPJ;ActrPI;EoDyEI;IACE,iCAAA;ElEgnPR;EkE9mPM;IACE,+BAAA;ElEgnPR;AACF;;AkE1nPE;EACE,0BAAA;AlE6nPJ;AclsPI;EoDyEI;IACE,iCAAA;ElE4nPR;EkE1nPM;IACE,+BAAA;ElE4nPR;AACF;;AkEtnPA;EACE,qCAAA;EACA,mBAAA;AlEynPF;AkEvnPE;EACE,aAAA;AlEynPJ;;AkErnPA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kEAAA;AlEwnPF;AkEtnPE;EACE,0FAAA;EACA,4DAAA;EACA,qDAAA;EACA,wDAAA;AlEwnPJ;;AkEpnPA;EACE,kEAAA;AlEunPF;;AkEpnPA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kEAAA;AlEunPF;;AkEpnPA;EAEE,mCAAA;EACA,oCAAA;EACA,qCAAA;EACA,sDAAA;EACA,oEAAA;EACA,6DAAA;EACA,yEAAA;EACA,6DAAA;EACA,iDAAA;EAGA,kBAAA;EACA,uBAAA;EACA,uCAAA;EACA,yCAAA;EACA,wBAAA;EACA,+CAAA;EACA,SAAA;E3DrLE,uBAAA;AP0yPJ;AkElnPE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kDAAA;EACA,sDAAA;E5CpME,iD4CqMF;AlEonPJ;AsBrzPM;E4CwLJ;I5CvLM,gBAAA;EtBwzPN;AACF;AkElnPE;EACE,qBAAA;AlEonPJ;AkEnnPI;EACE,wDAAA;AlEqnPN;AkEjnPE;EACE,kBAAA;EACA,UAAA;EACA,mDAAA;AlEmnPJ;AkEjnPI;EACE,wDAAA;AlEmnPN;Ac/wPI;EoDyGJ;IAwDI,aAAA;ElEknPF;AACF;;AkE5mPA;EAEE,2BAAA;EACA,0BAAA;EACA,2BAAA;AlE8mPF;Ac1xPI;EoDwKJ;IfpPE,eAAA;IACA,MAAA;IACA,OAAA;IACA,mCeyP4B;IfxP5B,YAAA;IACA,aAAA;IACA,wCesP8D;ElEonP9D;EmDv2PA;IAAS,UAAA;EnD02PT;EmDz2PA;IAAS,oCekPmF;ElE0nP5F;AACF;;AkEvnPA;EACE,2CAAA;EACA,sBAAA;EAEA,0BAAA;EAEA,+CAAA;EACA,2BAAA;EAEA,+CAAA;EACA,oCAAA;EAEA,2BAAA;AlEsnPF;AkEpnPE;EACE,+CAAA;AlEsnPJ;;AmEn4PA;EAEE,mCAAA;EACA,mCAAA;EACA,0BAAA;EAEA,uCAAA;EACA,0CAAA;EACA,wCAAA;EACA,wDAAA;EAEA,sCAAA;EACA,yCAAA;EACA,mDAAA;EACA,sCAAA;EACA,gDAAA;EACA,8DAAA;EACA,sCAAA;EAEA,8DAAA;EACA,wDAAA;EACA,gEAAA;EACA,6DAAA;EACA,uDAAA;EAEA,2CAAA;EACA,4DAAA;EACA,0CAAA;EACA,2CAAA;EACA,8CAAA;EACA,mEAAA;EACA,qEAAA;EACA,8DAAA;EAEA,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,uDAAA;EACA,0EAAA;EACA,yDAAA;EACA,iFAAA;EACA,2DAAA;EACA,mFAAA;EACA,wDAAA;EACA,4EAAA;EAEA,uCAAA;EACA,uCAAA;EACA,+DAAA;EACA,iDAAA;EACA,0CAAA;EACA,0CAAA;EACA,kEAAA;EACA,gFAAA;EACA,wEAAA;EACA,sFAAA;EACA,gEAAA;EAGA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,0EAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AnE63PF;AmE33PE;;;EAGE,sCAAA;AnE63PJ;AmE13PE;EACE,sFAAA;EACA,mDAAA;EACA,cAAA;EACA,gBAAA;EACA,yCAAA;EACA,yBAAA;E7CpEE,sC6CqEF;AnE43PJ;AsB77PM;E6C0DJ;I7CzDM,gBAAA;EtBg8PN;AACF;AmE93PE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,oFAAA;EACA,wCAAA;EACA,qBAAA;EACA,mBAAA;EACA,0CAAA;EACA,+FAAA;E5D7EA,wDAAA;EeJE,mE6CmFF;AnEg4PJ;AsB/8PM;E6CoEJ;I7CnEM,gBAAA;EtBk9PN;AACF;AmEn4PI;EACE,+CAAA;EACA,iDAAA;AnEq4PN;AmEn4PM;EACE,oDAAA;AnEq4PR;AmEl4PM;EACE,yDAAA;EACA,qEAAA;AnEo4PR;AmEh4PI;EACE,iDAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AnEk4PN;AmEh4PM;EACE,sDAAA;AnEk4PR;AmE/3PM;EACE,2DAAA;EACA,uEAAA;AnEi4PR;AmE93PM;EACE,iDAAA;AnEg4PR;AmE93PQ;EACE,sDAAA;AnEg4PV;AmE73PQ;EACE,2DAAA;EACA,uEAAA;AnE+3PV;AmE53PQ;EACE,oEAAA;EACA,6DAAA;AnE83PV;AmEz3PI;EACE;IACE,8CAAA;IACA,qBAAA;IACA,gDAAA;EnE23PN;EmEz3PM;IACE,mDAAA;EnE23PR;EmEx3PM;IACE,wDAAA;IACA,oEAAA;EnE03PR;EmEv3PM;IACE,oEAAA;IACA,6DAAA;EnEy3PR;AACF;AmEp3PE;EACE,aAAA;EACA,gDAAA;EACA,mBAAA;EACA,uBAAA;EACA,+CAAA;EACA,0DAAA;EACA,qDAAA;EACA,6CAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;E7CvKE,mB6CwKF;AnEs3PJ;AsB1hQM;E6CwJJ;I7CvJM,gBAAA;EtB6hQN;AACF;AmEx3PE;EACE,qBAAA;EACA,mDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uHAAA;EACA,oEAAA;AnE03PJ;AmEt3PE;EACE,gBAAA;AnEw3PJ;AmEr3PE;EACE,kBAAA;EACA,iGAAA;E5DvLA,yDAAA;EeJE,wC6C6LF;AnEu3PJ;AsBhjQM;E6CqLJ;I7CpLM,gBAAA;EtBmjQN;AACF;AmE13PI;EACE,kGAAA;EACA,gBAAA;E7CjMA,6B6CkMA;AnE43PN;AsB1jQM;E6C2LF;I7C1LI,gBAAA;EtB6jQN;AACF;AmE93PI;EACE,aAAA;AnEg4PN;AmE73PI;EACE,2CAAA;AnE+3PN;AmE73PM;EACE,qDAAA;AnE+3PR;AmE53PM;EACE,yBAAA;AnE83PR;AmE33PM;EACE,sCAAA;AnE63PR;AmEx3PE;EACE,eAAA;AnE03PJ;AmEx3PI;EACE,cAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,8DAAA;EACA,uDAAA;E7CpOA,2B6CqOA;AnE03PN;AsB3lQM;E6CyNF;I7CxNI,gBAAA;EtB8lQN;AACF;AmE33PE;EACE,UAAA;EACA,gBAAA;AnE63PJ;AmE33PI;EACE,oJAAA;AnE63PN;AmE13PI;EACE,kHAAA;AnE43PN;AmEt3PI;;EACE,2CAAA;AnEy3PN;;AoEhoQA;EAEE,gCAAA;ApEkoQF;ActkQI;EsD9DJ;IAMI,yCAAA;IACA,sCAAA;IACA,iDAAA;IACA,iBAAA;EpEkoQF;EoEhoQE;IACE,aAAA;EpEkoQJ;EoE/nQE;IACE,cAAA;EpEioQJ;EoE9nQE;IACE,uBAAA;IACA,gBAAA;IACA,eAAA;EpEgoQJ;EoE7nQE;IACE,wCAAA;IACA,yCAAA;EpE+nQJ;EoE5nQE;IACE,gBAAA;EpE8nQJ;EoE3nQE;IACE,kIAAA;EpE6nQJ;EoE1nQE;;;;;;;;;;IAME,oBAAA;IACA,qBAAA;IACA,oBAAA;IACA,kBAAA;IACA,UAAA;EpEgoQJ;EoE7nQE;I3CqBE,0BAAA;EzB2mQJ;EoE5nQE;IACE,uBAAA;EpE8nQJ;AACF;;AoE1nQA;EAEE,iEAAA;ApE4nQF;AoEnnQE;EACE,2DAAA;EACA,+C9D6gB0B;ANwmP9B;AoEnnQI;E3CJE,0BAAA;AzB0nQN;AoElnQI;EACE,uBAAA;ApEonQN;;AcvoQI;EsD2BA;;IACE,gCAAA;EpEinQJ;EoE/mQE;;IACE,8BAAA;EpEknQJ;AACF;;AwDntQE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AxDstQJ;;AqEntQE;EACE,sBAAA;EACA,mFAAA;ArEstQJ;;AqExtQE;EACE,sBAAA;EACA,qFAAA;ArE2tQJ;;AqE7tQE;EACE,yBAAA;EACA,mFAAA;ArEguQJ;;AqEluQE;EACE,yBAAA;EACA,gFAAA;ArEquQJ;;AqEvuQE;EACE,yBAAA;EACA,mFAAA;ArE0uQJ;;AqE5uQE;EACE,yBAAA;EACA,kFAAA;ArE+uQJ;;AqEjvQE;EACE,yBAAA;EACA,iFAAA;ArEovQJ;;AqEtvQE;EACE,sBAAA;EACA,gFAAA;ArEyvQJ;;AqEjvQM;EACE,sBAAA;EACA,8EAAA;ArEovQR;AqEtvQM;EACE,sBAAA;EACA,0EAAA;ArEwvQR;AqE1vQM;EACE,yBAAA;EACA,iFAAA;ArE4vQR;AqE9vQM;EACE,yBAAA;EACA,6EAAA;ArEgwQR;AqElwQM;EACE,yBAAA;EACA,+EAAA;ArEowQR;AqEtwQM;EACE,yBAAA;EACA,8EAAA;ArEwwQR;AqE1wQM;EACE,yBAAA;EACA,0EAAA;ArE4wQR;AqE9wQM;EACE,sBAAA;EACA,uEAAA;ArEgxQR;;AsE9xQE;EACE,0EAAA;EACA,oGAAA;AtEiyQJ;AsE9xQM;EAGE,qEAAA;EACA,+FAAA;AtE8xQR;;AsEvyQE;EACE,4EAAA;EACA,sGAAA;AtE0yQJ;AsEvyQM;EAGE,qEAAA;EACA,+FAAA;AtEuyQR;;AsEhzQE;EACE,0EAAA;EACA,oGAAA;AtEmzQJ;AsEhzQM;EAGE,sEAAA;EACA,gGAAA;AtEgzQR;;AsEzzQE;EACE,uEAAA;EACA,iGAAA;AtE4zQJ;AsEzzQM;EAGE,oEAAA;EACA,8FAAA;AtEyzQR;;AsEl0QE;EACE,0EAAA;EACA,oGAAA;AtEq0QJ;AsEl0QM;EAGE,sEAAA;EACA,gGAAA;AtEk0QR;;AsE30QE;EACE,yEAAA;EACA,mGAAA;AtE80QJ;AsE30QM;EAGE,uEAAA;EACA,iGAAA;AtE20QR;;AsEp1QE;EACE,wEAAA;EACA,kGAAA;AtEu1QJ;AsEp1QM;EAGE,uEAAA;EACA,iGAAA;AtEo1QR;;AsE71QE;EACE,uEAAA;EACA,iGAAA;AtEg2QJ;AsE71QM;EAGE,oEAAA;EACA,8FAAA;AtE61QR;;AsEt1QA;EACE,iFAAA;EACA,2GAAA;AtEy1QF;AsEt1QI;EAEE,oFAAA;EACA,8GAAA;AtEu1QN;;AuEn3QA;EACE,UAAA;EAEA,uJAAA;AvEq3QF;;AwEv3QA;EACE,oBAAA;EACA,alE0e4B;EkEze5B,mBAAA;EACA,oFAAA;EACA,6BlEwe4B;EkEve5B,2BAAA;AxE03QF;AwEx3QE;EACE,cAAA;EACA,UlEoe0B;EkEne1B,WlEme0B;EkEle1B,kBAAA;ElDIE,sCkDHF;AxE03QJ;AsBn3QM;EkDZJ;IlDaM,gBAAA;EtBs3QN;AACF;;AwEx3QI;EACE,oEAAA;AxE23QN;;AyE/4QA;EACE,kBAAA;EACA,WAAA;AzEk5QF;AyEh5QE;EACE,cAAA;EACA,oCAAA;EACA,WAAA;AzEk5QJ;AyE/4QE;EACE,kBAAA;EACA,qBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;AzEi5QJ;;AyE54QE;EACE,wBAAA;AzE+4QJ;;AyEh5QE;EACE,uBAAA;AzEm5QJ;;AyEp5QE;EACE,0BAAA;AzEu5QJ;;AyEx5QE;EACE,kCAAA;AzE25QJ;;A0E96QA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,apE4rCkC;ANqvOpC;;A0E96QA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,apEorCkC;AN6vOpC;;A0Ez6QI;EACE,gBAAA;EACA,MAAA;EACA,apEwqC8B;ANowOpC;;A0Ez6QI;EACE,gBAAA;EACA,SAAA;EACA,apEkqC8B;AN0wOpC;;Ac74QI;E4DxCA;IACE,gBAAA;IACA,MAAA;IACA,apEwqC8B;ENixOlC;E0Et7QE;IACE,gBAAA;IACA,SAAA;IACA,apEkqC8B;ENsxOlC;AACF;Ac15QI;E4DxCA;IACE,gBAAA;IACA,MAAA;IACA,apEwqC8B;EN6xOlC;E0El8QE;IACE,gBAAA;IACA,SAAA;IACA,apEkqC8B;ENkyOlC;AACF;Act6QI;E4DxCA;IACE,gBAAA;IACA,MAAA;IACA,apEwqC8B;ENyyOlC;E0E98QE;IACE,gBAAA;IACA,SAAA;IACA,apEkqC8B;EN8yOlC;AACF;Acl7QI;E4DxCA;IACE,gBAAA;IACA,MAAA;IACA,apEwqC8B;ENqzOlC;E0E19QE;IACE,gBAAA;IACA,SAAA;IACA,apEkqC8B;EN0zOlC;AACF;Ac97QI;E4DxCA;IACE,gBAAA;IACA,MAAA;IACA,apEwqC8B;ENi0OlC;E0Et+QE;IACE,gBAAA;IACA,SAAA;IACA,apEkqC8B;ENs0OlC;AACF;A2E5gRA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;A3E8gRF;;A2E3gRA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;A3E8gRF;;A4EphRA;;ECEE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;A7EuhRF;A6EphRE;;EACE,6BAAA;A7EuhRJ;A6EnhRE;;EACE,2BAAA;A7EshRJ;;A8EviRE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UxE8dsC;EwE7dtC,WAAA;A9E0iRJ;;A+EljRA;ECFE,gBAAA;EACA,uBAAA;EACA,mBAAA;AhFwjRF;;AiF5jRA;EACE,qBAAA;EACA,mBAAA;EACA,8B3E6uB4B;E2E5uB5B,eAAA;EACA,UAAA;EACA,8BAAA;EACA,a3EsuB4B;ANy1P9B;;AkFp+QU;EAcM,mCAAA;AlF09QhB;;AkFx+QU;EAcM,8BAAA;AlF89QhB;;AkF5+QU;EAcM,iCAAA;AlFk+QhB;;AkFh/QU;EAcM,iCAAA;AlFs+QhB;;AkFp/QU;EAcM,sCAAA;AlF0+QhB;;AkFx/QU;EAcM,mCAAA;AlF8+QhB;;AkF5/QU;EAcM,8BAAA;AlFk/QhB;;AkFhgRU;EAcM,4BAAA;AlFs/QhB;;AkFpgRU;EAcM,sBAAA;AlF0/QhB;;AkFxgRU;EAcM,8BAAA;AlF8/QhB;;AkF5gRU;EAcM,4BAAA;AlFkgRhB;;AkFhhRU;EAcM,2BAAA;AlFsgRhB;;AkFphRU;EAcM,iCAAA;AlF0gRhB;;AkFxhRU;EAcM,2BAAA;AlF8gRhB;;AkF5hRU;EAcM,qBAAA;AlFkhRhB;;AkFhiRU;EAcM,wBAAA;AlFshRhB;;AkFpiRU;EAcM,uBAAA;AlF0hRhB;;AkFxiRU;EAcM,wBAAA;AlF8hRhB;;AkF5iRU;EAcM,qBAAA;AlFkiRhB;;AkFhjRU;EAcM,yBAAA;AlFsiRhB;;AkFpjRU;EAcM,2BAAA;AlF0iRhB;;AkFxjRU;EAcM,4BAAA;AlF8iRhB;;AkF5jRU;EAcM,2BAAA;AlFkjRhB;;AkFhkRU;EAcM,2BAAA;AlFsjRhB;;AkFpkRU;EAcM,6BAAA;AlF0jRhB;;AkFxkRU;EAcM,8BAAA;AlF8jRhB;;AkF5kRU;EAcM,6BAAA;AlFkkRhB;;AkFhlRU;EAcM,2BAAA;AlFskRhB;;AkFplRU;EAcM,6BAAA;AlF0kRhB;;AkFxlRU;EAcM,8BAAA;AlF8kRhB;;AkF5lRU;EAcM,6BAAA;AlFklRhB;;AkFhmRU;EAcM,0BAAA;AlFslRhB;;AkFpmRU;EAcM,gCAAA;AlF0lRhB;;AkFxmRU;EAcM,yBAAA;AlF8lRhB;;AkF5mRU;EAcM,wBAAA;AlFkmRhB;;AkFhnRU;EAcM,+BAAA;AlFsmRhB;;AkFpnRU;EAcM,yBAAA;AlF0mRhB;;AkFxnRU;EAcM,6BAAA;AlF8mRhB;;AkF5nRU;EAcM,8BAAA;AlFknRhB;;AkFhoRU;EAcM,wBAAA;AlFsnRhB;;AkFpoRU;EAcM,+BAAA;AlF0nRhB;;AkFxoRU;EAcM,wBAAA;AlF8nRhB;;AkF5oRU;EAcM,4CAAA;AlFkoRhB;;AkFhpRU;EAcM,+CAAA;AlFsoRhB;;AkFppRU;EAcM,+CAAA;AlF0oRhB;;AkFxpRU;EAcM,2BAAA;AlF8oRhB;;AkFprRU;EACE,mFAAA;AlFurRZ;;AkFxrRU;EACE,qFAAA;AlF2rRZ;;AkF5rRU;EACE,mFAAA;AlF+rRZ;;AkFhsRU;EACE,gFAAA;AlFmsRZ;;AkFpsRU;EACE,mFAAA;AlFusRZ;;AkFxsRU;EACE,kFAAA;AlF2sRZ;;AkF5sRU;EACE,iFAAA;AlF+sRZ;;AkFhtRU;EACE,gFAAA;AlFmtRZ;;AkF5rRU;EAcM,2BAAA;AlFkrRhB;;AkFhsRU;EAcM,6BAAA;AlFsrRhB;;AkFpsRU;EAcM,6BAAA;AlF0rRhB;;AkFxsRU;EAcM,0BAAA;AlF8rRhB;;AkF5sRU;EAcM,2BAAA;AlFksRhB;;AkFhtRU;EAcM,iBAAA;AlFssRhB;;AkFptRU;EAcM,mBAAA;AlF0sRhB;;AkFxtRU;EAcM,oBAAA;AlF8sRhB;;AkF5tRU;EAcM,oBAAA;AlFktRhB;;AkFhuRU;EAcM,sBAAA;AlFstRhB;;AkFpuRU;EAcM,uBAAA;AlF0tRhB;;AkFxuRU;EAcM,gCAAA;AlF8tRhB;;AkF5uRU;EAcM,kCAAA;AlFkuRhB;;AkFhvRU;EAcM,mCAAA;AlFsuRhB;;AkFpvRU;EAcM,8BAAA;AlF0uRhB;;AkFxvRU;EAcM,gCAAA;AlF8uRhB;;AkF5vRU;EAcM,iCAAA;AlFkvRhB;;AkFhwRU;EzDvBJ,2CAAA;AzB2xRN;;AkFpwRU;EzDvBJ,sCAAA;AzB+xRN;;AkFxwRU;EzDvBJ,sCAAA;AzBmyRN;;AkF5wRU;EAcM,0FAAA;AlFkwRhB;;AkFhxRU;EAcM,oBAAA;AlFswRhB;;AkFpxRU;EAcM,8FAAA;AlF0wRhB;;AkFxxRU;EAcM,wBAAA;AlF8wRhB;;AkF5xRU;EAcM,qGAAA;AlFkxRhB;;AkFhyRU;EAcM,+BAAA;AlFsxRhB;;AkFpyRU;EAcM,iGAAA;AlF0xRhB;;AkFxyRU;EAcM,2BAAA;AlF8xRhB;;AkF5yRU;EAcM,uGAAA;AlFkyRhB;;AkFhzRU;EAcM,iCAAA;AlFsyRhB;;AkFpzRU;EAIQ,uBAAA;EAUF,gFAAA;AlF2yRhB;;AkFzzRU;EAIQ,uBAAA;EAUF,kFAAA;AlFgzRhB;;AkF9zRU;EAIQ,uBAAA;EAUF,gFAAA;AlFqzRhB;;AkFn0RU;EAIQ,uBAAA;EAUF,6EAAA;AlF0zRhB;;AkFx0RU;EAIQ,uBAAA;EAUF,gFAAA;AlF+zRhB;;AkF70RU;EAIQ,uBAAA;EAUF,+EAAA;AlFo0RhB;;AkFl1RU;EAIQ,uBAAA;EAUF,8EAAA;AlFy0RhB;;AkFv1RU;EAIQ,uBAAA;EAUF,6EAAA;AlF80RhB;;AkF51RU;EAIQ,uBAAA;EAUF,8EAAA;AlFm1RhB;;AkFj2RU;EAIQ,uBAAA;EAUF,8EAAA;AlFw1RhB;;AkFt2RU;EAcM,oCAAA;AlF41RhB;;AkF12RU;EAcM,oCAAA;AlFg2RhB;;AkF92RU;EAcM,oCAAA;AlFo2RhB;;AkFl3RU;EAcM,iCAAA;AlFw2RhB;;AkFt3RU;EAcM,oCAAA;AlF42RhB;;AkF13RU;EAcM,oCAAA;AlFg3RhB;;AkF93RU;EAcM,oCAAA;AlFo3RhB;;AkFl4RU;EAcM,oCAAA;AlFw3RhB;;AkFt4RU;EAcM,iCAAA;AlF43RhB;;AkF14RU;EAcM,2CAAA;AlFg4RhB;;AkF94RU;EAcM,2CAAA;AlFo4RhB;;AkFl5RU;EAcM,2CAAA;AlFw4RhB;;AkFt5RU;EAcM,wCAAA;AlF44RhB;;AkF15RU;EAcM,2CAAA;AlFg5RhB;;AkF95RU;EAcM,2CAAA;AlFo5RhB;;AkFl6RU;EAcM,2CAAA;AlFw5RhB;;AkFt6RU;EAcM,2CAAA;AlF45RhB;;AkF16RU;EAcM,wCAAA;AlFg6RhB;;AkF96RU;EAcM,uCAAA;AlFo6RhB;;AkFl7RU;EAcM,uCAAA;AlFw6RhB;;AkFt7RU;EAcM,uCAAA;AlF46RhB;;AkF17RU;EAcM,oCAAA;AlFg7RhB;;AkF97RU;EAcM,uCAAA;AlFo7RhB;;AkFl8RU;EAcM,uCAAA;AlFw7RhB;;AkFt8RU;EAcM,uCAAA;AlF47RhB;;AkF18RU;EAcM,uCAAA;AlFg8RhB;;AkF98RU;EAcM,oCAAA;AlFo8RhB;;AkFl9RU;EAcM,6CAAA;AlFw8RhB;;AkFt9RU;EAcM,6CAAA;AlF48RhB;;AkF19RU;EAcM,6CAAA;AlFg9RhB;;AkF99RU;EAcM,0CAAA;AlFo9RhB;;AkFl+RU;EAcM,6CAAA;AlFw9RhB;;AkFt+RU;EAcM,6CAAA;AlF49RhB;;AkF1+RU;EAcM,6CAAA;AlFg+RhB;;AkF9+RU;EAcM,6CAAA;AlFo+RhB;;AkFl/RU;EAcM,0CAAA;AlFw+RhB;;AkFt/RU;EAcM,4BAAA;AlF4+RhB;;AkF1/RU;EAcM,4BAAA;AlFg/RhB;;AkF9/RU;EAcM,4BAAA;AlFo/RhB;;AkFlgSU;EAcM,4BAAA;AlFw/RhB;;AkFtgSU;EAcM,4BAAA;AlF4/RhB;;AkF1gSU;EAcM,gCAAA;AlFggShB;;AkF9gSU;EAcM,gCAAA;AlFogShB;;AkFlhSU;EAcM,gCAAA;AlFwgShB;;AkFthSU;EAcM,gCAAA;AlF4gShB;;AkF1hSU;EAcM,gCAAA;AlFghShB;;AkF9hSU;EAcM,uCAAA;AlFohShB;;AkFliSU;EAcM,uCAAA;AlFwhShB;;AkFtiSU;EAcM,uCAAA;AlF4hShB;;AkF1iSU;EAcM,uCAAA;AlFgiShB;;AkF9iSU;EAcM,uCAAA;AlFoiShB;;AkFljSU;EAcM,mCAAA;AlFwiShB;;AkFtjSU;EAcM,mCAAA;AlF4iShB;;AkF1jSU;EAcM,mCAAA;AlFgjShB;;AkF9jSU;EAcM,mCAAA;AlFojShB;;AkFlkSU;EAcM,mCAAA;AlFwjShB;;AkFtkSU;EAcM,yCAAA;AlF4jShB;;AkF1kSU;EAcM,yCAAA;AlFgkShB;;AkF9kSU;EAcM,yCAAA;AlFokShB;;AkFllSU;EAcM,yCAAA;AlFwkShB;;AkFtlSU;EAcM,yCAAA;AlF4kShB;;AkF1lSU;EAcM,yDAAA;AlFglShB;;AkF9lSU;EAcM,2DAAA;AlFolShB;;AkFlmSU;EAcM,yDAAA;AlFwlShB;;AkFtmSU;EAcM,sDAAA;AlF4lShB;;AkF1mSU;EAcM,yDAAA;AlFgmShB;;AkF9mSU;EAcM,wDAAA;AlFomShB;;AkFlnSU;EAcM,uDAAA;AlFwmShB;;AkFtnSU;EAcM,sDAAA;AlF4mShB;;AkFlpSU;EACE,yBAAA;AlFqpSZ;;AkFtpSU;EACE,0BAAA;AlFypSZ;;AkF1pSU;EACE,yBAAA;AlF6pSZ;;AkF9pSU;EACE,0BAAA;AlFiqSZ;;AkFlqSU;EACE,uBAAA;AlFqqSZ;;AkF9oSU;EAcM,qBAAA;AlFooShB;;AkFlpSU;EAcM,qBAAA;AlFwoShB;;AkFtpSU;EAcM,qBAAA;AlF4oShB;;AkF1pSU;EAcM,sBAAA;AlFgpShB;;AkF9pSU;EAcM,sBAAA;AlFopShB;;AkFlqSU;EAcM,0BAAA;AlFwpShB;;AkFtqSU;EAcM,uBAAA;AlF4pShB;;AkF1qSU;EAcM,2BAAA;AlFgqShB;;AkF9qSU;EAcM,sBAAA;AlFoqShB;;AkFlrSU;EAcM,sBAAA;AlFwqShB;;AkFtrSU;EAcM,sBAAA;AlF4qShB;;AkF1rSU;EAcM,uBAAA;AlFgrShB;;AkF9rSU;EAcM,uBAAA;AlForShB;;AkFlsSU;EAcM,2BAAA;AlFwrShB;;AkFtsSU;EAcM,wBAAA;AlF4rShB;;AkF1sSU;EAcM,4BAAA;AlFgsShB;;AkF9sSU;EAcM,yBAAA;AlFosShB;;AkFltSU;EAcM,8BAAA;AlFwsShB;;AkFttSU;EAcM,iCAAA;AlF4sShB;;AkF1tSU;EAcM,sCAAA;AlFgtShB;;AkF9tSU;EAcM,yCAAA;AlFotShB;;AkFluSU;EAcM,uBAAA;AlFwtShB;;AkFtuSU;EAcM,uBAAA;AlF4tShB;;AkF1uSU;EAcM,yBAAA;AlFguShB;;AkF9uSU;EAcM,yBAAA;AlFouShB;;AkFlvSU;EAcM,0BAAA;AlFwuShB;;AkFtvSU;EAcM,4BAAA;AlF4uShB;;AkF1vSU;EAcM,kCAAA;AlFgvShB;;AkF9vSU;EAcM,sCAAA;AlFovShB;;AkFlwSU;EAcM,oCAAA;AlFwvShB;;AkFtwSU;EAcM,kCAAA;AlF4vShB;;AkF1wSU;EAcM,yCAAA;AlFgwShB;;AkF9wSU;EAcM,wCAAA;AlFowShB;;AkFlxSU;EAcM,wCAAA;AlFwwShB;;AkFtxSU;EAcM,kCAAA;AlF4wShB;;AkF1xSU;EAcM,gCAAA;AlFgxShB;;AkF9xSU;EAcM,8BAAA;AlFoxShB;;AkFlySU;EAcM,gCAAA;AlFwxShB;;AkFtySU;EAcM,+BAAA;AlF4xShB;;AkF1ySU;EAcM,oCAAA;AlFgyShB;;AkF9ySU;EAcM,kCAAA;AlFoyShB;;AkFlzSU;EAcM,gCAAA;AlFwyShB;;AkFtzSU;EAcM,uCAAA;AlF4yShB;;AkF1zSU;EAcM,sCAAA;AlFgzShB;;AkF9zSU;EAcM,iCAAA;AlFozShB;;AkFl0SU;EAcM,2BAAA;AlFwzShB;;AkFt0SU;EAcM,iCAAA;AlF4zShB;;AkF10SU;EAcM,+BAAA;AlFg0ShB;;AkF90SU;EAcM,6BAAA;AlFo0ShB;;AkFl1SU;EAcM,+BAAA;AlFw0ShB;;AkFt1SU;EAcM,8BAAA;AlF40ShB;;AkF11SU;EAcM,oBAAA;AlFg1ShB;;AkF91SU;EAcM,mBAAA;AlFo1ShB;;AkFl2SU;EAcM,mBAAA;AlFw1ShB;;AkFt2SU;EAcM,mBAAA;AlF41ShB;;AkF12SU;EAcM,mBAAA;AlFg2ShB;;AkF92SU;EAcM,mBAAA;AlFo2ShB;;AkFl3SU;EAcM,mBAAA;AlFw2ShB;;AkFt3SU;EAcM,mBAAA;AlF42ShB;;AkF13SU;EAcM,oBAAA;AlFg3ShB;;AkF93SU;EAcM,0BAAA;AlFo3ShB;;AkFl4SU;EAcM,yBAAA;AlFw3ShB;;AkFt4SU;EAcM,uBAAA;AlF43ShB;;AkF14SU;EAcM,yBAAA;AlFg4ShB;;AkF94SU;EAcM,uBAAA;AlFo4ShB;;AkFl5SU;EAcM,uBAAA;AlFw4ShB;;AkFt5SU;EAcM,0BAAA;EAAA,yBAAA;AlF64ShB;;AkF35SU;EAcM,gCAAA;EAAA,+BAAA;AlFk5ShB;;AkFh6SU;EAcM,+BAAA;EAAA,8BAAA;AlFu5ShB;;AkFr6SU;EAcM,6BAAA;EAAA,4BAAA;AlF45ShB;;AkF16SU;EAcM,+BAAA;EAAA,8BAAA;AlFi6ShB;;AkF/6SU;EAcM,6BAAA;EAAA,4BAAA;AlFs6ShB;;AkFp7SU;EAcM,6BAAA;EAAA,4BAAA;AlF26ShB;;AkFz7SU;EAcM,wBAAA;EAAA,2BAAA;AlFg7ShB;;AkF97SU;EAcM,8BAAA;EAAA,iCAAA;AlFq7ShB;;AkFn8SU;EAcM,6BAAA;EAAA,gCAAA;AlF07ShB;;AkFx8SU;EAcM,2BAAA;EAAA,8BAAA;AlF+7ShB;;AkF78SU;EAcM,6BAAA;EAAA,gCAAA;AlFo8ShB;;AkFl9SU;EAcM,2BAAA;EAAA,8BAAA;AlFy8ShB;;AkFv9SU;EAcM,2BAAA;EAAA,8BAAA;AlF88ShB;;AkF59SU;EAcM,wBAAA;AlFk9ShB;;AkFh+SU;EAcM,8BAAA;AlFs9ShB;;AkFp+SU;EAcM,6BAAA;AlF09ShB;;AkFx+SU;EAcM,2BAAA;AlF89ShB;;AkF5+SU;EAcM,6BAAA;AlFk+ShB;;AkFh/SU;EAcM,2BAAA;AlFs+ShB;;AkFp/SU;EAcM,2BAAA;AlF0+ShB;;AkFx/SU;EAcM,+BAAA;AlF8+ShB;;AkF5/SU;EAcM,qCAAA;AlFk/ShB;;AkFhgTU;EAcM,oCAAA;AlFs/ShB;;AkFpgTU;EAcM,kCAAA;AlF0/ShB;;AkFxgTU;EAcM,oCAAA;AlF8/ShB;;AkF5gTU;EAcM,kCAAA;AlFkgThB;;AkFhhTU;EAcM,kCAAA;AlFsgThB;;AkFphTU;EAcM,2BAAA;AlF0gThB;;AkFxhTU;EAcM,iCAAA;AlF8gThB;;AkF5hTU;EAcM,gCAAA;AlFkhThB;;AkFhiTU;EAcM,8BAAA;AlFshThB;;AkFpiTU;EAcM,gCAAA;AlF0hThB;;AkFxiTU;EAcM,8BAAA;AlF8hThB;;AkF5iTU;EAcM,8BAAA;AlFkiThB;;AkFhjTU;EAcM,iCAAA;AlFsiThB;;AkFpjTU;EAcM,uCAAA;AlF0iThB;;AkFxjTU;EAcM,sCAAA;AlF8iThB;;AkF5jTU;EAcM,oCAAA;AlFkjThB;;AkFhkTU;EAcM,sCAAA;AlFsjThB;;AkFpkTU;EAcM,oCAAA;AlF0jThB;;AkFxkTU;EAcM,oCAAA;AlF8jThB;;AkF5kTU;EAcM,qBAAA;AlFkkThB;;AkFhlTU;EAcM,2BAAA;AlFskThB;;AkFplTU;EAcM,0BAAA;AlF0kThB;;AkFxlTU;EAcM,wBAAA;AlF8kThB;;AkF5lTU;EAcM,0BAAA;AlFklThB;;AkFhmTU;EAcM,wBAAA;AlFslThB;;AkFpmTU;EAcM,2BAAA;EAAA,0BAAA;AlF2lThB;;AkFzmTU;EAcM,iCAAA;EAAA,gCAAA;AlFgmThB;;AkF9mTU;EAcM,gCAAA;EAAA,+BAAA;AlFqmThB;;AkFnnTU;EAcM,8BAAA;EAAA,6BAAA;AlF0mThB;;AkFxnTU;EAcM,gCAAA;EAAA,+BAAA;AlF+mThB;;AkF7nTU;EAcM,8BAAA;EAAA,6BAAA;AlFonThB;;AkFloTU;EAcM,yBAAA;EAAA,4BAAA;AlFynThB;;AkFvoTU;EAcM,+BAAA;EAAA,kCAAA;AlF8nThB;;AkF5oTU;EAcM,8BAAA;EAAA,iCAAA;AlFmoThB;;AkFjpTU;EAcM,4BAAA;EAAA,+BAAA;AlFwoThB;;AkFtpTU;EAcM,8BAAA;EAAA,iCAAA;AlF6oThB;;AkF3pTU;EAcM,4BAAA;EAAA,+BAAA;AlFkpThB;;AkFhqTU;EAcM,yBAAA;AlFspThB;;AkFpqTU;EAcM,+BAAA;AlF0pThB;;AkFxqTU;EAcM,8BAAA;AlF8pThB;;AkF5qTU;EAcM,4BAAA;AlFkqThB;;AkFhrTU;EAcM,8BAAA;AlFsqThB;;AkFprTU;EAcM,4BAAA;AlF0qThB;;AkFxrTU;EAcM,gCAAA;AlF8qThB;;AkF5rTU;EAcM,sCAAA;AlFkrThB;;AkFhsTU;EAcM,qCAAA;AlFsrThB;;AkFpsTU;EAcM,mCAAA;AlF0rThB;;AkFxsTU;EAcM,qCAAA;AlF8rThB;;AkF5sTU;EAcM,mCAAA;AlFksThB;;AkFhtTU;EAcM,4BAAA;AlFssThB;;AkFptTU;EAcM,kCAAA;AlF0sThB;;AkFxtTU;EAcM,iCAAA;AlF8sThB;;AkF5tTU;EAcM,+BAAA;AlFktThB;;AkFhuTU;EAcM,iCAAA;AlFstThB;;AkFpuTU;EAcM,+BAAA;AlF0tThB;;AkFxuTU;EAcM,kCAAA;AlF8tThB;;AkF5uTU;EAcM,wCAAA;AlFkuThB;;AkFhvTU;EAcM,uCAAA;AlFsuThB;;AkFpvTU;EAcM,qCAAA;AlF0uThB;;AkFxvTU;EAcM,uCAAA;AlF8uThB;;AkF5vTU;EAcM,qCAAA;AlFkvThB;;AkFhwTU;EAcM,iBAAA;AlFsvThB;;AkFpwTU;EAcM,uBAAA;AlF0vThB;;AkFxwTU;EAcM,sBAAA;AlF8vThB;;AkF5wTU;EAcM,oBAAA;AlFkwThB;;AkFhxTU;EAcM,sBAAA;AlFswThB;;AkFpxTU;EAcM,oBAAA;AlF0wThB;;AkFxxTU;EAcM,qBAAA;AlF8wThB;;AkF5xTU;EAcM,2BAAA;AlFkxThB;;AkFhyTU;EAcM,0BAAA;AlFsxThB;;AkFpyTU;EAcM,wBAAA;AlF0xThB;;AkFxyTU;EAcM,0BAAA;AlF8xThB;;AkF5yTU;EAcM,wBAAA;AlFkyThB;;AkFhzTU;EAcM,wBAAA;AlFsyThB;;AkFpzTU;EAcM,8BAAA;AlF0yThB;;AkFxzTU;EAcM,6BAAA;AlF8yThB;;AkF5zTU;EAcM,2BAAA;AlFkzThB;;AkFh0TU;EAcM,6BAAA;AlFszThB;;AkFp0TU;EAcM,2BAAA;AlF0zThB;;AkFx0TU;EAcM,iDAAA;AlF8zThB;;AkF50TU;EAcM,4CAAA;AlFk0ThB;;AkFh1TU;EAcM,4CAAA;AlFs0ThB;;AkFp1TU;EAcM,0CAAA;AlF00ThB;;AkFx1TU;EAcM,4CAAA;AlF80ThB;;AkF51TU;EAcM,6BAAA;AlFk1ThB;;AkFh2TU;EAcM,0BAAA;AlFs1ThB;;AkFp2TU;EAcM,6BAAA;AlF01ThB;;AkFx2TU;EAcM,6BAAA;AlF81ThB;;AkF52TU;EAcM,+BAAA;AlFk2ThB;;AkFh3TU;EAcM,2BAAA;AlFs2ThB;;AkFp3TU;EAcM,2BAAA;AlF02ThB;;AkFx3TU;EAcM,2BAAA;AlF82ThB;;AkF53TU;EAcM,2BAAA;AlFk3ThB;;AkFh4TU;EAcM,2BAAA;AlFs3ThB;;AkFp4TU;EAcM,8BAAA;AlF03ThB;;AkFx4TU;EAcM,yBAAA;AlF83ThB;;AkF54TU;EAcM,4BAAA;AlFk4ThB;;AkFh5TU;EAcM,2BAAA;AlFs4ThB;;AkFp5TU;EAcM,yBAAA;AlF04ThB;;AkFx5TU;EAcM,4BAAA;AlF84ThB;;AkF55TU;EAcM,0BAAA;AlFk5ThB;;AkFh6TU;EAcM,6BAAA;AlFs5ThB;;AkFp6TU;EAcM,gCAAA;AlF05ThB;;AkFx6TU;EAcM,qCAAA;AlF85ThB;;AkF56TU;EAcM,wCAAA;AlFk6ThB;;AkFh7TU;EAcM,oCAAA;AlFs6ThB;;AkFp7TU;EAcM,oCAAA;AlF06ThB;;AkFx7TU;EAcM,qCAAA;AlF86ThB;;AkF57TU;EAcM,8BAAA;AlFk7ThB;;AkFh8TU;EAcM,8BAAA;AlFs7ThB;;AkFt+TQ,qBAAA;AAkCE;EAcM,gCAAA;EAAA,iCAAA;AlF47ThB;;AkFv6TQ,mBAAA;AA/CE;;EAKQ,qBAAA;EAGJ,uEAAA;AlFq9Td;;AkF79TU;;EAKQ,qBAAA;EAGJ,yEAAA;AlF29Td;;AkFn+TU;;EAKQ,qBAAA;EAGJ,uEAAA;AlFi+Td;;AkFz+TU;;EAKQ,qBAAA;EAGJ,oEAAA;AlFu+Td;;AkF/+TU;;EAKQ,qBAAA;EAGJ,uEAAA;AlF6+Td;;AkFr/TU;;EAKQ,qBAAA;EAGJ,sEAAA;AlFm/Td;;AkF3/TU;;EAKQ,qBAAA;EAGJ,qEAAA;AlFy/Td;;AkFjgUU;;EAKQ,qBAAA;EAGJ,oEAAA;AlF+/Td;;AkFvgUU;;EAKQ,qBAAA;EAGJ,qEAAA;AlFqgUd;;AkF7gUU;;EAKQ,qBAAA;EAGJ,qEAAA;AlF2gUd;;AkFnhUU;;EAKQ,qBAAA;EAGJ,0EAAA;AlFihUd;;AkFzhUU;;EAKQ,qBAAA;EAGJ,4CAAA;AlFuhUd;;AkF/hUU;;EAKQ,qBAAA;EAGJ,sCAAA;AlF6hUd;;AkFriUU;;EAKQ,qBAAA;EAGJ,0CAAA;AlFmiUd;;AkF3iUU;;EAKQ,qBAAA;EAGJ,4CAAA;AlFyiUd;;AkFjjUU;;EAKQ,qBAAA;EAGJ,2CAAA;AlF+iUd;;AkFvjUU;;EAKQ,qBAAA;EAGJ,2CAAA;AlFqjUd;;AkF7jUU;;EAKQ,qBAAA;EAGJ,yBAAA;AlF2jUd;;AkFnkUU;;EAKQ,qBAAA;EAGJ,kDAAA;AlFikUd;;AkFzkUU;;EAKQ,qBAAA;EAGJ,oDAAA;AlFukUd;;AkF/kUU;;EAKQ,qBAAA;EAGJ,6CAAA;AlF6kUd;;AkFrlUU;;EAKQ,qBAAA;EAGJ,0CAAA;AlFmlUd;;AkF3lUU;;EAKQ,qBAAA;EAGJ,4CAAA;AlFylUd;;AkFjmUU;;EAKQ,qBAAA;EAGJ,qCAAA;AlF+lUd;;AkFnnUU;EACE,wBAAA;AlFsnUZ;;AkFvnUU;EACE,uBAAA;AlF0nUZ;;AkF3nUU;EACE,wBAAA;AlF8nUZ;;AkF/nUU;EACE,qBAAA;AlFkoUZ;;AkF3mUU;EAcM,kDAAA;AlFimUhB;;AkF/mUU;EAcM,oDAAA;AlFqmUhB;;AkFnnUU;EAcM,kDAAA;AlFymUhB;;AkFvnUU;EAcM,+CAAA;AlF6mUhB;;AkF3nUU;EAcM,kDAAA;AlFinUhB;;AkF/nUU;EAcM,iDAAA;AlFqnUhB;;AkFnoUU;EAcM,gDAAA;AlFynUhB;;AkFvoUU;EAcM,+CAAA;AlF6nUhB;;AkFnqUU;EACE,uBAAA;AlFsqUZ;;AkFjqUU;EACE,uBAAA;AlFoqUZ;;AkF3qUU;EACE,wBAAA;AlF8qUZ;;AkFzqUU;EACE,wBAAA;AlF4qUZ;;AkFnrUU;EACE,uBAAA;AlFsrUZ;;AkFjrUU;EACE,uBAAA;AlForUZ;;AkF3rUU;EACE,wBAAA;AlF8rUZ;;AkFzrUU;EACE,wBAAA;AlF4rUZ;;AkFnsUU;EACE,qBAAA;AlFssUZ;;AkFjsUU;EACE,qBAAA;AlFosUZ;;AkFnrUU;EAcM,yCAAA;AlFyqUhB;;AkFlqUU;EAOI,yCAAA;AlF+pUd;;AkF3rUU;EAcM,wCAAA;AlFirUhB;;AkF1qUU;EAOI,wCAAA;AlFuqUd;;AkFnsUU;EAcM,yCAAA;AlFyrUhB;;AkFlrUU;EAOI,yCAAA;AlF+qUd;;AkF3sUU;EAIQ,+BAAA;EAUF,iGAAA;AlFksUhB;;AkFhtUU;EAIQ,+BAAA;EAUF,mGAAA;AlFusUhB;;AkFrtUU;EAIQ,+BAAA;EAUF,iGAAA;AlF4sUhB;;AkF1tUU;EAIQ,+BAAA;EAUF,8FAAA;AlFitUhB;;AkF/tUU;EAIQ,+BAAA;EAUF,iGAAA;AlFstUhB;;AkFpuUU;EAIQ,+BAAA;EAUF,gGAAA;AlF2tUhB;;AkFzuUU;EAIQ,+BAAA;EAUF,+FAAA;AlFguUhB;;AkF9uUU;EAIQ,+BAAA;EAUF,8FAAA;AlFquUhB;;AkFnvUU;EAIQ,+BAAA;EAUF,uGAAA;AlF0uUhB;;AkFhxUU;EACE,+BAAA;AlFmxUZ;;AkF9wUU;EACE,+BAAA;AlFixUZ;;AkFxxUU;EACE,iCAAA;AlF2xUZ;;AkFtxUU;EACE,iCAAA;AlFyxUZ;;AkFhyUU;EACE,kCAAA;AlFmyUZ;;AkF9xUU;EACE,kCAAA;AlFiyUZ;;AkFxyUU;EACE,iCAAA;AlF2yUZ;;AkFtyUU;EACE,iCAAA;AlFyyUZ;;AkFhzUU;EACE,kCAAA;AlFmzUZ;;AkF9yUU;EACE,kCAAA;AlFizUZ;;AkFxzUU;EACE,+BAAA;AlF2zUZ;;AkFtzUU;EACE,+BAAA;AlFyzUZ;;AkFpzUU;;EAKQ,mBAAA;EAGJ,gFAAA;AlFkzUd;;AkF1zUU;;EAKQ,mBAAA;EAGJ,kFAAA;AlFwzUd;;AkFh0UU;;EAKQ,mBAAA;EAGJ,gFAAA;AlF8zUd;;AkFt0UU;;EAKQ,mBAAA;EAGJ,6EAAA;AlFo0Ud;;AkF50UU;;EAKQ,mBAAA;EAGJ,gFAAA;AlF00Ud;;AkFl1UU;;EAKQ,mBAAA;EAGJ,+EAAA;AlFg1Ud;;AkFx1UU;;EAKQ,mBAAA;EAGJ,8EAAA;AlFs1Ud;;AkF91UU;;EAKQ,mBAAA;EAGJ,6EAAA;AlF41Ud;;AkFp2UU;;EAKQ,mBAAA;EAGJ,8EAAA;AlFk2Ud;;AkF12UU;;EAKQ,mBAAA;EAGJ,8EAAA;AlFw2Ud;;AkFh3UU;;EAKQ,mBAAA;EAGJ,gFAAA;AlF82Ud;;AkFt3UU;;EAKQ,mBAAA;EAGJ,wCAAA;AlFo3Ud;;AkF53UU;;EAKQ,mBAAA;EAGJ,qFAAA;AlF03Ud;;AkFl4UU;;EAKQ,mBAAA;EAGJ,oFAAA;AlFg4Ud;;AkFp5UU;EACE,qBAAA;AlFu5UZ;;AkFx5UU;EACE,sBAAA;AlF25UZ;;AkF55UU;EACE,qBAAA;AlF+5UZ;;AkFh6UU;EACE,sBAAA;AlFm6UZ;;AkFp6UU;EACE,mBAAA;AlFu6UZ;;AkF55UU;;EAQI,yDAAA;AlFy5Ud;;AkFj6UU;;EAQI,2DAAA;AlF85Ud;;AkFt6UU;;EAQI,yDAAA;AlFm6Ud;;AkF36UU;;EAQI,sDAAA;AlFw6Ud;;AkFh7UU;;EAQI,yDAAA;AlF66Ud;;AkFr7UU;;EAQI,wDAAA;AlFk7Ud;;AkF17UU;;EAQI,uDAAA;AlFu7Ud;;AkF/7UU;;EAQI,sDAAA;AlF47Ud;;AkFx7UU;EAcM,gDAAA;AlF86UhB;;AkF57UU;EAcM,mCAAA;UAAA,2BAAA;AlFk7UhB;;AkFh8UU;EAcM,oCAAA;UAAA,4BAAA;AlFs7UhB;;AkFp8UU;EAcM,oCAAA;UAAA,4BAAA;AlF07UhB;;AkFx8UU;EAcM,+BAAA;AlF87UhB;;AkF58UU;EAcM,+BAAA;AlFk8UhB;;AkFh9UU;EAcM,kDAAA;AlFs8UhB;;AkFp9UU;EAcM,2BAAA;AlF08UhB;;AkFx9UU;EAcM,qDAAA;AlF88UhB;;AkF59UU;EAcM,kDAAA;AlFk9UhB;;AkFh+UU;EAcM,qDAAA;AlFs9UhB;;AkFp+UU;EAcM,qDAAA;AlF09UhB;;AkFx+UU;EAcM,sDAAA;AlF89UhB;;AkF5+UU;EAcM,6BAAA;AlFk+UhB;;AkFh/UU;EAcM,uDAAA;AlFs+UhB;;AkFp/UU;EAcM,2DAAA;EAAA,4DAAA;AlF2+UhB;;AkFz/UU;EAcM,oCAAA;EAAA,qCAAA;AlFg/UhB;;AkF9/UU;EAcM,8DAAA;EAAA,+DAAA;AlFq/UhB;;AkFngVU;EAcM,2DAAA;EAAA,4DAAA;AlF0/UhB;;AkFxgVU;EAcM,8DAAA;EAAA,+DAAA;AlF+/UhB;;AkF7gVU;EAcM,8DAAA;EAAA,+DAAA;AlFogVhB;;AkFlhVU;EAcM,+DAAA;EAAA,gEAAA;AlFygVhB;;AkFvhVU;EAcM,sCAAA;EAAA,uCAAA;AlF8gVhB;;AkF5hVU;EAcM,gEAAA;EAAA,iEAAA;AlFmhVhB;;AkFjiVU;EAcM,4DAAA;EAAA,0DAAA;AlFwhVhB;;AkFtiVU;EAcM,qCAAA;EAAA,mCAAA;AlF6hVhB;;AkF3iVU;EAcM,+DAAA;EAAA,6DAAA;AlFkiVhB;;AkFhjVU;EAcM,4DAAA;EAAA,0DAAA;AlFuiVhB;;AkFrjVU;EAcM,+DAAA;EAAA,6DAAA;AlF4iVhB;;AkF1jVU;EAcM,+DAAA;EAAA,6DAAA;AlFijVhB;;AkF/jVU;EAcM,gEAAA;EAAA,8DAAA;AlFsjVhB;;AkFpkVU;EAcM,uCAAA;EAAA,qCAAA;AlF2jVhB;;AkFzkVU;EAcM,iEAAA;EAAA,+DAAA;AlFgkVhB;;AkF9kVU;EAcM,+DAAA;EAAA,8DAAA;AlFqkVhB;;AkFnlVU;EAcM,wCAAA;EAAA,uCAAA;AlF0kVhB;;AkFxlVU;EAcM,kEAAA;EAAA,iEAAA;AlF+kVhB;;AkF7lVU;EAcM,+DAAA;EAAA,8DAAA;AlFolVhB;;AkFlmVU;EAcM,kEAAA;EAAA,iEAAA;AlFylVhB;;AkFvmVU;EAcM,kEAAA;EAAA,iEAAA;AlF8lVhB;;AkF5mVU;EAcM,mEAAA;EAAA,kEAAA;AlFmmVhB;;AkFjnVU;EAcM,0CAAA;EAAA,yCAAA;AlFwmVhB;;AkFtnVU;EAcM,oEAAA;EAAA,mEAAA;AlF6mVhB;;AkF3nVU;EAcM,4DAAA;EAAA,8DAAA;AlFknVhB;;AkFhoVU;EAcM,qCAAA;EAAA,uCAAA;AlFunVhB;;AkFroVU;EAcM,+DAAA;EAAA,iEAAA;AlF4nVhB;;AkF1oVU;EAcM,4DAAA;EAAA,8DAAA;AlFioVhB;;AkF/oVU;EAcM,+DAAA;EAAA,iEAAA;AlFsoVhB;;AkFppVU;EAcM,+DAAA;EAAA,iEAAA;AlF2oVhB;;AkFzpVU;EAcM,gEAAA;EAAA,kEAAA;AlFgpVhB;;AkF9pVU;EAcM,uCAAA;EAAA,yCAAA;AlFqpVhB;;AkFnqVU;EAcM,iEAAA;EAAA,mEAAA;AlF0pVhB;;AkFxqVU;EAcM,8BAAA;AlF8pVhB;;AkF5qVU;EAcM,6BAAA;AlFkqVhB;;AkFhrVU;EAcM,sBAAA;AlFsqVhB;;AkFprVU;EAcM,qBAAA;AlF0qVhB;;AkFxrVU;EAcM,qBAAA;AlF8qVhB;;AkF5rVU;EAcM,qBAAA;AlFkrVhB;;AkFhsVU;EAcM,qBAAA;AlFsrVhB;;AcruVI;EoEiCM;IAcM,8BAAA;ElF2rVd;EkFzsVQ;IAcM,4BAAA;ElF8rVd;EkF5sVQ;IAcM,sBAAA;ElFisVd;EkF/sVQ;IAcM,8BAAA;ElFosVd;EkFltVQ;IAcM,4BAAA;ElFusVd;EkFrtVQ;IAcM,2BAAA;ElF0sVd;EkFxtVQ;IAcM,iCAAA;ElF6sVd;EkF3tVQ;IAcM,2BAAA;ElFgtVd;EkF9tVQ;IAcM,0BAAA;ElFmtVd;EkFjuVQ;IAcM,gCAAA;ElFstVd;EkFpuVQ;IAcM,yBAAA;ElFytVd;EkFvuVQ;IAcM,wBAAA;ElF4tVd;EkF1uVQ;IAcM,+BAAA;ElF+tVd;EkF7uVQ;IAcM,yBAAA;ElFkuVd;EkFhvVQ;IAcM,6BAAA;ElFquVd;EkFnvVQ;IAcM,8BAAA;ElFwuVd;EkFtvVQ;IAcM,wBAAA;ElF2uVd;EkFzvVQ;IAcM,+BAAA;ElF8uVd;EkF5vVQ;IAcM,wBAAA;ElFivVd;EkF/vVQ;IAcM,yBAAA;ElFovVd;EkFlwVQ;IAcM,8BAAA;ElFuvVd;EkFrwVQ;IAcM,iCAAA;ElF0vVd;EkFxwVQ;IAcM,sCAAA;ElF6vVd;EkF3wVQ;IAcM,yCAAA;ElFgwVd;EkF9wVQ;IAcM,uBAAA;ElFmwVd;EkFjxVQ;IAcM,uBAAA;ElFswVd;EkFpxVQ;IAcM,yBAAA;ElFywVd;EkFvxVQ;IAcM,yBAAA;ElF4wVd;EkF1xVQ;IAcM,0BAAA;ElF+wVd;EkF7xVQ;IAcM,4BAAA;ElFkxVd;EkFhyVQ;IAcM,kCAAA;ElFqxVd;EkFnyVQ;IAcM,sCAAA;ElFwxVd;EkFtyVQ;IAcM,oCAAA;ElF2xVd;EkFzyVQ;IAcM,kCAAA;ElF8xVd;EkF5yVQ;IAcM,yCAAA;ElFiyVd;EkF/yVQ;IAcM,wCAAA;ElFoyVd;EkFlzVQ;IAcM,wCAAA;ElFuyVd;EkFrzVQ;IAcM,kCAAA;ElF0yVd;EkFxzVQ;IAcM,gCAAA;ElF6yVd;EkF3zVQ;IAcM,8BAAA;ElFgzVd;EkF9zVQ;IAcM,gCAAA;ElFmzVd;EkFj0VQ;IAcM,+BAAA;ElFszVd;EkFp0VQ;IAcM,oCAAA;ElFyzVd;EkFv0VQ;IAcM,kCAAA;ElF4zVd;EkF10VQ;IAcM,gCAAA;ElF+zVd;EkF70VQ;IAcM,uCAAA;ElFk0Vd;EkFh1VQ;IAcM,sCAAA;ElFq0Vd;EkFn1VQ;IAcM,iCAAA;ElFw0Vd;EkFt1VQ;IAcM,2BAAA;ElF20Vd;EkFz1VQ;IAcM,iCAAA;ElF80Vd;EkF51VQ;IAcM,+BAAA;ElFi1Vd;EkF/1VQ;IAcM,6BAAA;ElFo1Vd;EkFl2VQ;IAcM,+BAAA;ElFu1Vd;EkFr2VQ;IAcM,8BAAA;ElF01Vd;EkFx2VQ;IAcM,oBAAA;ElF61Vd;EkF32VQ;IAcM,mBAAA;ElFg2Vd;EkF92VQ;IAcM,mBAAA;ElFm2Vd;EkFj3VQ;IAcM,mBAAA;ElFs2Vd;EkFp3VQ;IAcM,mBAAA;ElFy2Vd;EkFv3VQ;IAcM,mBAAA;ElF42Vd;EkF13VQ;IAcM,mBAAA;ElF+2Vd;EkF73VQ;IAcM,mBAAA;ElFk3Vd;EkFh4VQ;IAcM,oBAAA;ElFq3Vd;EkFn4VQ;IAcM,0BAAA;ElFw3Vd;EkFt4VQ;IAcM,yBAAA;ElF23Vd;EkFz4VQ;IAcM,uBAAA;ElF83Vd;EkF54VQ;IAcM,yBAAA;ElFi4Vd;EkF/4VQ;IAcM,uBAAA;ElFo4Vd;EkFl5VQ;IAcM,uBAAA;ElFu4Vd;EkFr5VQ;IAcM,0BAAA;IAAA,yBAAA;ElF24Vd;EkFz5VQ;IAcM,gCAAA;IAAA,+BAAA;ElF+4Vd;EkF75VQ;IAcM,+BAAA;IAAA,8BAAA;ElFm5Vd;EkFj6VQ;IAcM,6BAAA;IAAA,4BAAA;ElFu5Vd;EkFr6VQ;IAcM,+BAAA;IAAA,8BAAA;ElF25Vd;EkFz6VQ;IAcM,6BAAA;IAAA,4BAAA;ElF+5Vd;EkF76VQ;IAcM,6BAAA;IAAA,4BAAA;ElFm6Vd;EkFj7VQ;IAcM,wBAAA;IAAA,2BAAA;ElFu6Vd;EkFr7VQ;IAcM,8BAAA;IAAA,iCAAA;ElF26Vd;EkFz7VQ;IAcM,6BAAA;IAAA,gCAAA;ElF+6Vd;EkF77VQ;IAcM,2BAAA;IAAA,8BAAA;ElFm7Vd;EkFj8VQ;IAcM,6BAAA;IAAA,gCAAA;ElFu7Vd;EkFr8VQ;IAcM,2BAAA;IAAA,8BAAA;ElF27Vd;EkFz8VQ;IAcM,2BAAA;IAAA,8BAAA;ElF+7Vd;EkF78VQ;IAcM,wBAAA;ElFk8Vd;EkFh9VQ;IAcM,8BAAA;ElFq8Vd;EkFn9VQ;IAcM,6BAAA;ElFw8Vd;EkFt9VQ;IAcM,2BAAA;ElF28Vd;EkFz9VQ;IAcM,6BAAA;ElF88Vd;EkF59VQ;IAcM,2BAAA;ElFi9Vd;EkF/9VQ;IAcM,2BAAA;ElFo9Vd;EkFl+VQ;IAcM,+BAAA;ElFu9Vd;EkFr+VQ;IAcM,qCAAA;ElF09Vd;EkFx+VQ;IAcM,oCAAA;ElF69Vd;EkF3+VQ;IAcM,kCAAA;ElFg+Vd;EkF9+VQ;IAcM,oCAAA;ElFm+Vd;EkFj/VQ;IAcM,kCAAA;ElFs+Vd;EkFp/VQ;IAcM,kCAAA;ElFy+Vd;EkFv/VQ;IAcM,2BAAA;ElF4+Vd;EkF1/VQ;IAcM,iCAAA;ElF++Vd;EkF7/VQ;IAcM,gCAAA;ElFk/Vd;EkFhgWQ;IAcM,8BAAA;ElFq/Vd;EkFngWQ;IAcM,gCAAA;ElFw/Vd;EkFtgWQ;IAcM,8BAAA;ElF2/Vd;EkFzgWQ;IAcM,8BAAA;ElF8/Vd;EkF5gWQ;IAcM,iCAAA;ElFigWd;EkF/gWQ;IAcM,uCAAA;ElFogWd;EkFlhWQ;IAcM,sCAAA;ElFugWd;EkFrhWQ;IAcM,oCAAA;ElF0gWd;EkFxhWQ;IAcM,sCAAA;ElF6gWd;EkF3hWQ;IAcM,oCAAA;ElFghWd;EkF9hWQ;IAcM,oCAAA;ElFmhWd;EkFjiWQ;IAcM,qBAAA;ElFshWd;EkFpiWQ;IAcM,2BAAA;ElFyhWd;EkFviWQ;IAcM,0BAAA;ElF4hWd;EkF1iWQ;IAcM,wBAAA;ElF+hWd;EkF7iWQ;IAcM,0BAAA;ElFkiWd;EkFhjWQ;IAcM,wBAAA;ElFqiWd;EkFnjWQ;IAcM,2BAAA;IAAA,0BAAA;ElFyiWd;EkFvjWQ;IAcM,iCAAA;IAAA,gCAAA;ElF6iWd;EkF3jWQ;IAcM,gCAAA;IAAA,+BAAA;ElFijWd;EkF/jWQ;IAcM,8BAAA;IAAA,6BAAA;ElFqjWd;EkFnkWQ;IAcM,gCAAA;IAAA,+BAAA;ElFyjWd;EkFvkWQ;IAcM,8BAAA;IAAA,6BAAA;ElF6jWd;EkF3kWQ;IAcM,yBAAA;IAAA,4BAAA;ElFikWd;EkF/kWQ;IAcM,+BAAA;IAAA,kCAAA;ElFqkWd;EkFnlWQ;IAcM,8BAAA;IAAA,iCAAA;ElFykWd;EkFvlWQ;IAcM,4BAAA;IAAA,+BAAA;ElF6kWd;EkF3lWQ;IAcM,8BAAA;IAAA,iCAAA;ElFilWd;EkF/lWQ;IAcM,4BAAA;IAAA,+BAAA;ElFqlWd;EkFnmWQ;IAcM,yBAAA;ElFwlWd;EkFtmWQ;IAcM,+BAAA;ElF2lWd;EkFzmWQ;IAcM,8BAAA;ElF8lWd;EkF5mWQ;IAcM,4BAAA;ElFimWd;EkF/mWQ;IAcM,8BAAA;ElFomWd;EkFlnWQ;IAcM,4BAAA;ElFumWd;EkFrnWQ;IAcM,gCAAA;ElF0mWd;EkFxnWQ;IAcM,sCAAA;ElF6mWd;EkF3nWQ;IAcM,qCAAA;ElFgnWd;EkF9nWQ;IAcM,mCAAA;ElFmnWd;EkFjoWQ;IAcM,qCAAA;ElFsnWd;EkFpoWQ;IAcM,mCAAA;ElFynWd;EkFvoWQ;IAcM,4BAAA;ElF4nWd;EkF1oWQ;IAcM,kCAAA;ElF+nWd;EkF7oWQ;IAcM,iCAAA;ElFkoWd;EkFhpWQ;IAcM,+BAAA;ElFqoWd;EkFnpWQ;IAcM,iCAAA;ElFwoWd;EkFtpWQ;IAcM,+BAAA;ElF2oWd;EkFzpWQ;IAcM,kCAAA;ElF8oWd;EkF5pWQ;IAcM,wCAAA;ElFipWd;EkF/pWQ;IAcM,uCAAA;ElFopWd;EkFlqWQ;IAcM,qCAAA;ElFupWd;EkFrqWQ;IAcM,uCAAA;ElF0pWd;EkFxqWQ;IAcM,qCAAA;ElF6pWd;EkF3qWQ;IAcM,iBAAA;ElFgqWd;EkF9qWQ;IAcM,uBAAA;ElFmqWd;EkFjrWQ;IAcM,sBAAA;ElFsqWd;EkFprWQ;IAcM,oBAAA;ElFyqWd;EkFvrWQ;IAcM,sBAAA;ElF4qWd;EkF1rWQ;IAcM,oBAAA;ElF+qWd;EkF7rWQ;IAcM,qBAAA;ElFkrWd;EkFhsWQ;IAcM,2BAAA;ElFqrWd;EkFnsWQ;IAcM,0BAAA;ElFwrWd;EkFtsWQ;IAcM,wBAAA;ElF2rWd;EkFzsWQ;IAcM,0BAAA;ElF8rWd;EkF5sWQ;IAcM,wBAAA;ElFisWd;EkF/sWQ;IAcM,wBAAA;ElFosWd;EkFltWQ;IAcM,8BAAA;ElFusWd;EkFrtWQ;IAcM,6BAAA;ElF0sWd;EkFxtWQ;IAcM,2BAAA;ElF6sWd;EkF3tWQ;IAcM,6BAAA;ElFgtWd;EkF9tWQ;IAcM,2BAAA;ElFmtWd;EkFjuWQ;IAcM,4BAAA;ElFstWd;EkFpuWQ;IAcM,0BAAA;ElFytWd;EkFvuWQ;IAcM,6BAAA;ElF4tWd;AACF;Ac5wWI;EoEiCM;IAcM,8BAAA;ElFiuWd;EkF/uWQ;IAcM,4BAAA;ElFouWd;EkFlvWQ;IAcM,sBAAA;ElFuuWd;EkFrvWQ;IAcM,8BAAA;ElF0uWd;EkFxvWQ;IAcM,4BAAA;ElF6uWd;EkF3vWQ;IAcM,2BAAA;ElFgvWd;EkF9vWQ;IAcM,iCAAA;ElFmvWd;EkFjwWQ;IAcM,2BAAA;ElFsvWd;EkFpwWQ;IAcM,0BAAA;ElFyvWd;EkFvwWQ;IAcM,gCAAA;ElF4vWd;EkF1wWQ;IAcM,yBAAA;ElF+vWd;EkF7wWQ;IAcM,wBAAA;ElFkwWd;EkFhxWQ;IAcM,+BAAA;ElFqwWd;EkFnxWQ;IAcM,yBAAA;ElFwwWd;EkFtxWQ;IAcM,6BAAA;ElF2wWd;EkFzxWQ;IAcM,8BAAA;ElF8wWd;EkF5xWQ;IAcM,wBAAA;ElFixWd;EkF/xWQ;IAcM,+BAAA;ElFoxWd;EkFlyWQ;IAcM,wBAAA;ElFuxWd;EkFryWQ;IAcM,yBAAA;ElF0xWd;EkFxyWQ;IAcM,8BAAA;ElF6xWd;EkF3yWQ;IAcM,iCAAA;ElFgyWd;EkF9yWQ;IAcM,sCAAA;ElFmyWd;EkFjzWQ;IAcM,yCAAA;ElFsyWd;EkFpzWQ;IAcM,uBAAA;ElFyyWd;EkFvzWQ;IAcM,uBAAA;ElF4yWd;EkF1zWQ;IAcM,yBAAA;ElF+yWd;EkF7zWQ;IAcM,yBAAA;ElFkzWd;EkFh0WQ;IAcM,0BAAA;ElFqzWd;EkFn0WQ;IAcM,4BAAA;ElFwzWd;EkFt0WQ;IAcM,kCAAA;ElF2zWd;EkFz0WQ;IAcM,sCAAA;ElF8zWd;EkF50WQ;IAcM,oCAAA;ElFi0Wd;EkF/0WQ;IAcM,kCAAA;ElFo0Wd;EkFl1WQ;IAcM,yCAAA;ElFu0Wd;EkFr1WQ;IAcM,wCAAA;ElF00Wd;EkFx1WQ;IAcM,wCAAA;ElF60Wd;EkF31WQ;IAcM,kCAAA;ElFg1Wd;EkF91WQ;IAcM,gCAAA;ElFm1Wd;EkFj2WQ;IAcM,8BAAA;ElFs1Wd;EkFp2WQ;IAcM,gCAAA;ElFy1Wd;EkFv2WQ;IAcM,+BAAA;ElF41Wd;EkF12WQ;IAcM,oCAAA;ElF+1Wd;EkF72WQ;IAcM,kCAAA;ElFk2Wd;EkFh3WQ;IAcM,gCAAA;ElFq2Wd;EkFn3WQ;IAcM,uCAAA;ElFw2Wd;EkFt3WQ;IAcM,sCAAA;ElF22Wd;EkFz3WQ;IAcM,iCAAA;ElF82Wd;EkF53WQ;IAcM,2BAAA;ElFi3Wd;EkF/3WQ;IAcM,iCAAA;ElFo3Wd;EkFl4WQ;IAcM,+BAAA;ElFu3Wd;EkFr4WQ;IAcM,6BAAA;ElF03Wd;EkFx4WQ;IAcM,+BAAA;ElF63Wd;EkF34WQ;IAcM,8BAAA;ElFg4Wd;EkF94WQ;IAcM,oBAAA;ElFm4Wd;EkFj5WQ;IAcM,mBAAA;ElFs4Wd;EkFp5WQ;IAcM,mBAAA;ElFy4Wd;EkFv5WQ;IAcM,mBAAA;ElF44Wd;EkF15WQ;IAcM,mBAAA;ElF+4Wd;EkF75WQ;IAcM,mBAAA;ElFk5Wd;EkFh6WQ;IAcM,mBAAA;ElFq5Wd;EkFn6WQ;IAcM,mBAAA;ElFw5Wd;EkFt6WQ;IAcM,oBAAA;ElF25Wd;EkFz6WQ;IAcM,0BAAA;ElF85Wd;EkF56WQ;IAcM,yBAAA;ElFi6Wd;EkF/6WQ;IAcM,uBAAA;ElFo6Wd;EkFl7WQ;IAcM,yBAAA;ElFu6Wd;EkFr7WQ;IAcM,uBAAA;ElF06Wd;EkFx7WQ;IAcM,uBAAA;ElF66Wd;EkF37WQ;IAcM,0BAAA;IAAA,yBAAA;ElFi7Wd;EkF/7WQ;IAcM,gCAAA;IAAA,+BAAA;ElFq7Wd;EkFn8WQ;IAcM,+BAAA;IAAA,8BAAA;ElFy7Wd;EkFv8WQ;IAcM,6BAAA;IAAA,4BAAA;ElF67Wd;EkF38WQ;IAcM,+BAAA;IAAA,8BAAA;ElFi8Wd;EkF/8WQ;IAcM,6BAAA;IAAA,4BAAA;ElFq8Wd;EkFn9WQ;IAcM,6BAAA;IAAA,4BAAA;ElFy8Wd;EkFv9WQ;IAcM,wBAAA;IAAA,2BAAA;ElF68Wd;EkF39WQ;IAcM,8BAAA;IAAA,iCAAA;ElFi9Wd;EkF/9WQ;IAcM,6BAAA;IAAA,gCAAA;ElFq9Wd;EkFn+WQ;IAcM,2BAAA;IAAA,8BAAA;ElFy9Wd;EkFv+WQ;IAcM,6BAAA;IAAA,gCAAA;ElF69Wd;EkF3+WQ;IAcM,2BAAA;IAAA,8BAAA;ElFi+Wd;EkF/+WQ;IAcM,2BAAA;IAAA,8BAAA;ElFq+Wd;EkFn/WQ;IAcM,wBAAA;ElFw+Wd;EkFt/WQ;IAcM,8BAAA;ElF2+Wd;EkFz/WQ;IAcM,6BAAA;ElF8+Wd;EkF5/WQ;IAcM,2BAAA;ElFi/Wd;EkF//WQ;IAcM,6BAAA;ElFo/Wd;EkFlgXQ;IAcM,2BAAA;ElFu/Wd;EkFrgXQ;IAcM,2BAAA;ElF0/Wd;EkFxgXQ;IAcM,+BAAA;ElF6/Wd;EkF3gXQ;IAcM,qCAAA;ElFggXd;EkF9gXQ;IAcM,oCAAA;ElFmgXd;EkFjhXQ;IAcM,kCAAA;ElFsgXd;EkFphXQ;IAcM,oCAAA;ElFygXd;EkFvhXQ;IAcM,kCAAA;ElF4gXd;EkF1hXQ;IAcM,kCAAA;ElF+gXd;EkF7hXQ;IAcM,2BAAA;ElFkhXd;EkFhiXQ;IAcM,iCAAA;ElFqhXd;EkFniXQ;IAcM,gCAAA;ElFwhXd;EkFtiXQ;IAcM,8BAAA;ElF2hXd;EkFziXQ;IAcM,gCAAA;ElF8hXd;EkF5iXQ;IAcM,8BAAA;ElFiiXd;EkF/iXQ;IAcM,8BAAA;ElFoiXd;EkFljXQ;IAcM,iCAAA;ElFuiXd;EkFrjXQ;IAcM,uCAAA;ElF0iXd;EkFxjXQ;IAcM,sCAAA;ElF6iXd;EkF3jXQ;IAcM,oCAAA;ElFgjXd;EkF9jXQ;IAcM,sCAAA;ElFmjXd;EkFjkXQ;IAcM,oCAAA;ElFsjXd;EkFpkXQ;IAcM,oCAAA;ElFyjXd;EkFvkXQ;IAcM,qBAAA;ElF4jXd;EkF1kXQ;IAcM,2BAAA;ElF+jXd;EkF7kXQ;IAcM,0BAAA;ElFkkXd;EkFhlXQ;IAcM,wBAAA;ElFqkXd;EkFnlXQ;IAcM,0BAAA;ElFwkXd;EkFtlXQ;IAcM,wBAAA;ElF2kXd;EkFzlXQ;IAcM,2BAAA;IAAA,0BAAA;ElF+kXd;EkF7lXQ;IAcM,iCAAA;IAAA,gCAAA;ElFmlXd;EkFjmXQ;IAcM,gCAAA;IAAA,+BAAA;ElFulXd;EkFrmXQ;IAcM,8BAAA;IAAA,6BAAA;ElF2lXd;EkFzmXQ;IAcM,gCAAA;IAAA,+BAAA;ElF+lXd;EkF7mXQ;IAcM,8BAAA;IAAA,6BAAA;ElFmmXd;EkFjnXQ;IAcM,yBAAA;IAAA,4BAAA;ElFumXd;EkFrnXQ;IAcM,+BAAA;IAAA,kCAAA;ElF2mXd;EkFznXQ;IAcM,8BAAA;IAAA,iCAAA;ElF+mXd;EkF7nXQ;IAcM,4BAAA;IAAA,+BAAA;ElFmnXd;EkFjoXQ;IAcM,8BAAA;IAAA,iCAAA;ElFunXd;EkFroXQ;IAcM,4BAAA;IAAA,+BAAA;ElF2nXd;EkFzoXQ;IAcM,yBAAA;ElF8nXd;EkF5oXQ;IAcM,+BAAA;ElFioXd;EkF/oXQ;IAcM,8BAAA;ElFooXd;EkFlpXQ;IAcM,4BAAA;ElFuoXd;EkFrpXQ;IAcM,8BAAA;ElF0oXd;EkFxpXQ;IAcM,4BAAA;ElF6oXd;EkF3pXQ;IAcM,gCAAA;ElFgpXd;EkF9pXQ;IAcM,sCAAA;ElFmpXd;EkFjqXQ;IAcM,qCAAA;ElFspXd;EkFpqXQ;IAcM,mCAAA;ElFypXd;EkFvqXQ;IAcM,qCAAA;ElF4pXd;EkF1qXQ;IAcM,mCAAA;ElF+pXd;EkF7qXQ;IAcM,4BAAA;ElFkqXd;EkFhrXQ;IAcM,kCAAA;ElFqqXd;EkFnrXQ;IAcM,iCAAA;ElFwqXd;EkFtrXQ;IAcM,+BAAA;ElF2qXd;EkFzrXQ;IAcM,iCAAA;ElF8qXd;EkF5rXQ;IAcM,+BAAA;ElFirXd;EkF/rXQ;IAcM,kCAAA;ElForXd;EkFlsXQ;IAcM,wCAAA;ElFurXd;EkFrsXQ;IAcM,uCAAA;ElF0rXd;EkFxsXQ;IAcM,qCAAA;ElF6rXd;EkF3sXQ;IAcM,uCAAA;ElFgsXd;EkF9sXQ;IAcM,qCAAA;ElFmsXd;EkFjtXQ;IAcM,iBAAA;ElFssXd;EkFptXQ;IAcM,uBAAA;ElFysXd;EkFvtXQ;IAcM,sBAAA;ElF4sXd;EkF1tXQ;IAcM,oBAAA;ElF+sXd;EkF7tXQ;IAcM,sBAAA;ElFktXd;EkFhuXQ;IAcM,oBAAA;ElFqtXd;EkFnuXQ;IAcM,qBAAA;ElFwtXd;EkFtuXQ;IAcM,2BAAA;ElF2tXd;EkFzuXQ;IAcM,0BAAA;ElF8tXd;EkF5uXQ;IAcM,wBAAA;ElFiuXd;EkF/uXQ;IAcM,0BAAA;ElFouXd;EkFlvXQ;IAcM,wBAAA;ElFuuXd;EkFrvXQ;IAcM,wBAAA;ElF0uXd;EkFxvXQ;IAcM,8BAAA;ElF6uXd;EkF3vXQ;IAcM,6BAAA;ElFgvXd;EkF9vXQ;IAcM,2BAAA;ElFmvXd;EkFjwXQ;IAcM,6BAAA;ElFsvXd;EkFpwXQ;IAcM,2BAAA;ElFyvXd;EkFvwXQ;IAcM,4BAAA;ElF4vXd;EkF1wXQ;IAcM,0BAAA;ElF+vXd;EkF7wXQ;IAcM,6BAAA;ElFkwXd;AACF;AclzXI;EoEiCM;IAcM,8BAAA;ElFuwXd;EkFrxXQ;IAcM,4BAAA;ElF0wXd;EkFxxXQ;IAcM,sBAAA;ElF6wXd;EkF3xXQ;IAcM,8BAAA;ElFgxXd;EkF9xXQ;IAcM,4BAAA;ElFmxXd;EkFjyXQ;IAcM,2BAAA;ElFsxXd;EkFpyXQ;IAcM,iCAAA;ElFyxXd;EkFvyXQ;IAcM,2BAAA;ElF4xXd;EkF1yXQ;IAcM,0BAAA;ElF+xXd;EkF7yXQ;IAcM,gCAAA;ElFkyXd;EkFhzXQ;IAcM,yBAAA;ElFqyXd;EkFnzXQ;IAcM,wBAAA;ElFwyXd;EkFtzXQ;IAcM,+BAAA;ElF2yXd;EkFzzXQ;IAcM,yBAAA;ElF8yXd;EkF5zXQ;IAcM,6BAAA;ElFizXd;EkF/zXQ;IAcM,8BAAA;ElFozXd;EkFl0XQ;IAcM,wBAAA;ElFuzXd;EkFr0XQ;IAcM,+BAAA;ElF0zXd;EkFx0XQ;IAcM,wBAAA;ElF6zXd;EkF30XQ;IAcM,yBAAA;ElFg0Xd;EkF90XQ;IAcM,8BAAA;ElFm0Xd;EkFj1XQ;IAcM,iCAAA;ElFs0Xd;EkFp1XQ;IAcM,sCAAA;ElFy0Xd;EkFv1XQ;IAcM,yCAAA;ElF40Xd;EkF11XQ;IAcM,uBAAA;ElF+0Xd;EkF71XQ;IAcM,uBAAA;ElFk1Xd;EkFh2XQ;IAcM,yBAAA;ElFq1Xd;EkFn2XQ;IAcM,yBAAA;ElFw1Xd;EkFt2XQ;IAcM,0BAAA;ElF21Xd;EkFz2XQ;IAcM,4BAAA;ElF81Xd;EkF52XQ;IAcM,kCAAA;ElFi2Xd;EkF/2XQ;IAcM,sCAAA;ElFo2Xd;EkFl3XQ;IAcM,oCAAA;ElFu2Xd;EkFr3XQ;IAcM,kCAAA;ElF02Xd;EkFx3XQ;IAcM,yCAAA;ElF62Xd;EkF33XQ;IAcM,wCAAA;ElFg3Xd;EkF93XQ;IAcM,wCAAA;ElFm3Xd;EkFj4XQ;IAcM,kCAAA;ElFs3Xd;EkFp4XQ;IAcM,gCAAA;ElFy3Xd;EkFv4XQ;IAcM,8BAAA;ElF43Xd;EkF14XQ;IAcM,gCAAA;ElF+3Xd;EkF74XQ;IAcM,+BAAA;ElFk4Xd;EkFh5XQ;IAcM,oCAAA;ElFq4Xd;EkFn5XQ;IAcM,kCAAA;ElFw4Xd;EkFt5XQ;IAcM,gCAAA;ElF24Xd;EkFz5XQ;IAcM,uCAAA;ElF84Xd;EkF55XQ;IAcM,sCAAA;ElFi5Xd;EkF/5XQ;IAcM,iCAAA;ElFo5Xd;EkFl6XQ;IAcM,2BAAA;ElFu5Xd;EkFr6XQ;IAcM,iCAAA;ElF05Xd;EkFx6XQ;IAcM,+BAAA;ElF65Xd;EkF36XQ;IAcM,6BAAA;ElFg6Xd;EkF96XQ;IAcM,+BAAA;ElFm6Xd;EkFj7XQ;IAcM,8BAAA;ElFs6Xd;EkFp7XQ;IAcM,oBAAA;ElFy6Xd;EkFv7XQ;IAcM,mBAAA;ElF46Xd;EkF17XQ;IAcM,mBAAA;ElF+6Xd;EkF77XQ;IAcM,mBAAA;ElFk7Xd;EkFh8XQ;IAcM,mBAAA;ElFq7Xd;EkFn8XQ;IAcM,mBAAA;ElFw7Xd;EkFt8XQ;IAcM,mBAAA;ElF27Xd;EkFz8XQ;IAcM,mBAAA;ElF87Xd;EkF58XQ;IAcM,oBAAA;ElFi8Xd;EkF/8XQ;IAcM,0BAAA;ElFo8Xd;EkFl9XQ;IAcM,yBAAA;ElFu8Xd;EkFr9XQ;IAcM,uBAAA;ElF08Xd;EkFx9XQ;IAcM,yBAAA;ElF68Xd;EkF39XQ;IAcM,uBAAA;ElFg9Xd;EkF99XQ;IAcM,uBAAA;ElFm9Xd;EkFj+XQ;IAcM,0BAAA;IAAA,yBAAA;ElFu9Xd;EkFr+XQ;IAcM,gCAAA;IAAA,+BAAA;ElF29Xd;EkFz+XQ;IAcM,+BAAA;IAAA,8BAAA;ElF+9Xd;EkF7+XQ;IAcM,6BAAA;IAAA,4BAAA;ElFm+Xd;EkFj/XQ;IAcM,+BAAA;IAAA,8BAAA;ElFu+Xd;EkFr/XQ;IAcM,6BAAA;IAAA,4BAAA;ElF2+Xd;EkFz/XQ;IAcM,6BAAA;IAAA,4BAAA;ElF++Xd;EkF7/XQ;IAcM,wBAAA;IAAA,2BAAA;ElFm/Xd;EkFjgYQ;IAcM,8BAAA;IAAA,iCAAA;ElFu/Xd;EkFrgYQ;IAcM,6BAAA;IAAA,gCAAA;ElF2/Xd;EkFzgYQ;IAcM,2BAAA;IAAA,8BAAA;ElF+/Xd;EkF7gYQ;IAcM,6BAAA;IAAA,gCAAA;ElFmgYd;EkFjhYQ;IAcM,2BAAA;IAAA,8BAAA;ElFugYd;EkFrhYQ;IAcM,2BAAA;IAAA,8BAAA;ElF2gYd;EkFzhYQ;IAcM,wBAAA;ElF8gYd;EkF5hYQ;IAcM,8BAAA;ElFihYd;EkF/hYQ;IAcM,6BAAA;ElFohYd;EkFliYQ;IAcM,2BAAA;ElFuhYd;EkFriYQ;IAcM,6BAAA;ElF0hYd;EkFxiYQ;IAcM,2BAAA;ElF6hYd;EkF3iYQ;IAcM,2BAAA;ElFgiYd;EkF9iYQ;IAcM,+BAAA;ElFmiYd;EkFjjYQ;IAcM,qCAAA;ElFsiYd;EkFpjYQ;IAcM,oCAAA;ElFyiYd;EkFvjYQ;IAcM,kCAAA;ElF4iYd;EkF1jYQ;IAcM,oCAAA;ElF+iYd;EkF7jYQ;IAcM,kCAAA;ElFkjYd;EkFhkYQ;IAcM,kCAAA;ElFqjYd;EkFnkYQ;IAcM,2BAAA;ElFwjYd;EkFtkYQ;IAcM,iCAAA;ElF2jYd;EkFzkYQ;IAcM,gCAAA;ElF8jYd;EkF5kYQ;IAcM,8BAAA;ElFikYd;EkF/kYQ;IAcM,gCAAA;ElFokYd;EkFllYQ;IAcM,8BAAA;ElFukYd;EkFrlYQ;IAcM,8BAAA;ElF0kYd;EkFxlYQ;IAcM,iCAAA;ElF6kYd;EkF3lYQ;IAcM,uCAAA;ElFglYd;EkF9lYQ;IAcM,sCAAA;ElFmlYd;EkFjmYQ;IAcM,oCAAA;ElFslYd;EkFpmYQ;IAcM,sCAAA;ElFylYd;EkFvmYQ;IAcM,oCAAA;ElF4lYd;EkF1mYQ;IAcM,oCAAA;ElF+lYd;EkF7mYQ;IAcM,qBAAA;ElFkmYd;EkFhnYQ;IAcM,2BAAA;ElFqmYd;EkFnnYQ;IAcM,0BAAA;ElFwmYd;EkFtnYQ;IAcM,wBAAA;ElF2mYd;EkFznYQ;IAcM,0BAAA;ElF8mYd;EkF5nYQ;IAcM,wBAAA;ElFinYd;EkF/nYQ;IAcM,2BAAA;IAAA,0BAAA;ElFqnYd;EkFnoYQ;IAcM,iCAAA;IAAA,gCAAA;ElFynYd;EkFvoYQ;IAcM,gCAAA;IAAA,+BAAA;ElF6nYd;EkF3oYQ;IAcM,8BAAA;IAAA,6BAAA;ElFioYd;EkF/oYQ;IAcM,gCAAA;IAAA,+BAAA;ElFqoYd;EkFnpYQ;IAcM,8BAAA;IAAA,6BAAA;ElFyoYd;EkFvpYQ;IAcM,yBAAA;IAAA,4BAAA;ElF6oYd;EkF3pYQ;IAcM,+BAAA;IAAA,kCAAA;ElFipYd;EkF/pYQ;IAcM,8BAAA;IAAA,iCAAA;ElFqpYd;EkFnqYQ;IAcM,4BAAA;IAAA,+BAAA;ElFypYd;EkFvqYQ;IAcM,8BAAA;IAAA,iCAAA;ElF6pYd;EkF3qYQ;IAcM,4BAAA;IAAA,+BAAA;ElFiqYd;EkF/qYQ;IAcM,yBAAA;ElFoqYd;EkFlrYQ;IAcM,+BAAA;ElFuqYd;EkFrrYQ;IAcM,8BAAA;ElF0qYd;EkFxrYQ;IAcM,4BAAA;ElF6qYd;EkF3rYQ;IAcM,8BAAA;ElFgrYd;EkF9rYQ;IAcM,4BAAA;ElFmrYd;EkFjsYQ;IAcM,gCAAA;ElFsrYd;EkFpsYQ;IAcM,sCAAA;ElFyrYd;EkFvsYQ;IAcM,qCAAA;ElF4rYd;EkF1sYQ;IAcM,mCAAA;ElF+rYd;EkF7sYQ;IAcM,qCAAA;ElFksYd;EkFhtYQ;IAcM,mCAAA;ElFqsYd;EkFntYQ;IAcM,4BAAA;ElFwsYd;EkFttYQ;IAcM,kCAAA;ElF2sYd;EkFztYQ;IAcM,iCAAA;ElF8sYd;EkF5tYQ;IAcM,+BAAA;ElFitYd;EkF/tYQ;IAcM,iCAAA;ElFotYd;EkFluYQ;IAcM,+BAAA;ElFutYd;EkFruYQ;IAcM,kCAAA;ElF0tYd;EkFxuYQ;IAcM,wCAAA;ElF6tYd;EkF3uYQ;IAcM,uCAAA;ElFguYd;EkF9uYQ;IAcM,qCAAA;ElFmuYd;EkFjvYQ;IAcM,uCAAA;ElFsuYd;EkFpvYQ;IAcM,qCAAA;ElFyuYd;EkFvvYQ;IAcM,iBAAA;ElF4uYd;EkF1vYQ;IAcM,uBAAA;ElF+uYd;EkF7vYQ;IAcM,sBAAA;ElFkvYd;EkFhwYQ;IAcM,oBAAA;ElFqvYd;EkFnwYQ;IAcM,sBAAA;ElFwvYd;EkFtwYQ;IAcM,oBAAA;ElF2vYd;EkFzwYQ;IAcM,qBAAA;ElF8vYd;EkF5wYQ;IAcM,2BAAA;ElFiwYd;EkF/wYQ;IAcM,0BAAA;ElFowYd;EkFlxYQ;IAcM,wBAAA;ElFuwYd;EkFrxYQ;IAcM,0BAAA;ElF0wYd;EkFxxYQ;IAcM,wBAAA;ElF6wYd;EkF3xYQ;IAcM,wBAAA;ElFgxYd;EkF9xYQ;IAcM,8BAAA;ElFmxYd;EkFjyYQ;IAcM,6BAAA;ElFsxYd;EkFpyYQ;IAcM,2BAAA;ElFyxYd;EkFvyYQ;IAcM,6BAAA;ElF4xYd;EkF1yYQ;IAcM,2BAAA;ElF+xYd;EkF7yYQ;IAcM,4BAAA;ElFkyYd;EkFhzYQ;IAcM,0BAAA;ElFqyYd;EkFnzYQ;IAcM,6BAAA;ElFwyYd;AACF;Acx1YI;EoEiCM;IAcM,8BAAA;ElF6yYd;EkF3zYQ;IAcM,4BAAA;ElFgzYd;EkF9zYQ;IAcM,sBAAA;ElFmzYd;EkFj0YQ;IAcM,8BAAA;ElFszYd;EkFp0YQ;IAcM,4BAAA;ElFyzYd;EkFv0YQ;IAcM,2BAAA;ElF4zYd;EkF10YQ;IAcM,iCAAA;ElF+zYd;EkF70YQ;IAcM,2BAAA;ElFk0Yd;EkFh1YQ;IAcM,0BAAA;ElFq0Yd;EkFn1YQ;IAcM,gCAAA;ElFw0Yd;EkFt1YQ;IAcM,yBAAA;ElF20Yd;EkFz1YQ;IAcM,wBAAA;ElF80Yd;EkF51YQ;IAcM,+BAAA;ElFi1Yd;EkF/1YQ;IAcM,yBAAA;ElFo1Yd;EkFl2YQ;IAcM,6BAAA;ElFu1Yd;EkFr2YQ;IAcM,8BAAA;ElF01Yd;EkFx2YQ;IAcM,wBAAA;ElF61Yd;EkF32YQ;IAcM,+BAAA;ElFg2Yd;EkF92YQ;IAcM,wBAAA;ElFm2Yd;EkFj3YQ;IAcM,yBAAA;ElFs2Yd;EkFp3YQ;IAcM,8BAAA;ElFy2Yd;EkFv3YQ;IAcM,iCAAA;ElF42Yd;EkF13YQ;IAcM,sCAAA;ElF+2Yd;EkF73YQ;IAcM,yCAAA;ElFk3Yd;EkFh4YQ;IAcM,uBAAA;ElFq3Yd;EkFn4YQ;IAcM,uBAAA;ElFw3Yd;EkFt4YQ;IAcM,yBAAA;ElF23Yd;EkFz4YQ;IAcM,yBAAA;ElF83Yd;EkF54YQ;IAcM,0BAAA;ElFi4Yd;EkF/4YQ;IAcM,4BAAA;ElFo4Yd;EkFl5YQ;IAcM,kCAAA;ElFu4Yd;EkFr5YQ;IAcM,sCAAA;ElF04Yd;EkFx5YQ;IAcM,oCAAA;ElF64Yd;EkF35YQ;IAcM,kCAAA;ElFg5Yd;EkF95YQ;IAcM,yCAAA;ElFm5Yd;EkFj6YQ;IAcM,wCAAA;ElFs5Yd;EkFp6YQ;IAcM,wCAAA;ElFy5Yd;EkFv6YQ;IAcM,kCAAA;ElF45Yd;EkF16YQ;IAcM,gCAAA;ElF+5Yd;EkF76YQ;IAcM,8BAAA;ElFk6Yd;EkFh7YQ;IAcM,gCAAA;ElFq6Yd;EkFn7YQ;IAcM,+BAAA;ElFw6Yd;EkFt7YQ;IAcM,oCAAA;ElF26Yd;EkFz7YQ;IAcM,kCAAA;ElF86Yd;EkF57YQ;IAcM,gCAAA;ElFi7Yd;EkF/7YQ;IAcM,uCAAA;ElFo7Yd;EkFl8YQ;IAcM,sCAAA;ElFu7Yd;EkFr8YQ;IAcM,iCAAA;ElF07Yd;EkFx8YQ;IAcM,2BAAA;ElF67Yd;EkF38YQ;IAcM,iCAAA;ElFg8Yd;EkF98YQ;IAcM,+BAAA;ElFm8Yd;EkFj9YQ;IAcM,6BAAA;ElFs8Yd;EkFp9YQ;IAcM,+BAAA;ElFy8Yd;EkFv9YQ;IAcM,8BAAA;ElF48Yd;EkF19YQ;IAcM,oBAAA;ElF+8Yd;EkF79YQ;IAcM,mBAAA;ElFk9Yd;EkFh+YQ;IAcM,mBAAA;ElFq9Yd;EkFn+YQ;IAcM,mBAAA;ElFw9Yd;EkFt+YQ;IAcM,mBAAA;ElF29Yd;EkFz+YQ;IAcM,mBAAA;ElF89Yd;EkF5+YQ;IAcM,mBAAA;ElFi+Yd;EkF/+YQ;IAcM,mBAAA;ElFo+Yd;EkFl/YQ;IAcM,oBAAA;ElFu+Yd;EkFr/YQ;IAcM,0BAAA;ElF0+Yd;EkFx/YQ;IAcM,yBAAA;ElF6+Yd;EkF3/YQ;IAcM,uBAAA;ElFg/Yd;EkF9/YQ;IAcM,yBAAA;ElFm/Yd;EkFjgZQ;IAcM,uBAAA;ElFs/Yd;EkFpgZQ;IAcM,uBAAA;ElFy/Yd;EkFvgZQ;IAcM,0BAAA;IAAA,yBAAA;ElF6/Yd;EkF3gZQ;IAcM,gCAAA;IAAA,+BAAA;ElFigZd;EkF/gZQ;IAcM,+BAAA;IAAA,8BAAA;ElFqgZd;EkFnhZQ;IAcM,6BAAA;IAAA,4BAAA;ElFygZd;EkFvhZQ;IAcM,+BAAA;IAAA,8BAAA;ElF6gZd;EkF3hZQ;IAcM,6BAAA;IAAA,4BAAA;ElFihZd;EkF/hZQ;IAcM,6BAAA;IAAA,4BAAA;ElFqhZd;EkFniZQ;IAcM,wBAAA;IAAA,2BAAA;ElFyhZd;EkFviZQ;IAcM,8BAAA;IAAA,iCAAA;ElF6hZd;EkF3iZQ;IAcM,6BAAA;IAAA,gCAAA;ElFiiZd;EkF/iZQ;IAcM,2BAAA;IAAA,8BAAA;ElFqiZd;EkFnjZQ;IAcM,6BAAA;IAAA,gCAAA;ElFyiZd;EkFvjZQ;IAcM,2BAAA;IAAA,8BAAA;ElF6iZd;EkF3jZQ;IAcM,2BAAA;IAAA,8BAAA;ElFijZd;EkF/jZQ;IAcM,wBAAA;ElFojZd;EkFlkZQ;IAcM,8BAAA;ElFujZd;EkFrkZQ;IAcM,6BAAA;ElF0jZd;EkFxkZQ;IAcM,2BAAA;ElF6jZd;EkF3kZQ;IAcM,6BAAA;ElFgkZd;EkF9kZQ;IAcM,2BAAA;ElFmkZd;EkFjlZQ;IAcM,2BAAA;ElFskZd;EkFplZQ;IAcM,+BAAA;ElFykZd;EkFvlZQ;IAcM,qCAAA;ElF4kZd;EkF1lZQ;IAcM,oCAAA;ElF+kZd;EkF7lZQ;IAcM,kCAAA;ElFklZd;EkFhmZQ;IAcM,oCAAA;ElFqlZd;EkFnmZQ;IAcM,kCAAA;ElFwlZd;EkFtmZQ;IAcM,kCAAA;ElF2lZd;EkFzmZQ;IAcM,2BAAA;ElF8lZd;EkF5mZQ;IAcM,iCAAA;ElFimZd;EkF/mZQ;IAcM,gCAAA;ElFomZd;EkFlnZQ;IAcM,8BAAA;ElFumZd;EkFrnZQ;IAcM,gCAAA;ElF0mZd;EkFxnZQ;IAcM,8BAAA;ElF6mZd;EkF3nZQ;IAcM,8BAAA;ElFgnZd;EkF9nZQ;IAcM,iCAAA;ElFmnZd;EkFjoZQ;IAcM,uCAAA;ElFsnZd;EkFpoZQ;IAcM,sCAAA;ElFynZd;EkFvoZQ;IAcM,oCAAA;ElF4nZd;EkF1oZQ;IAcM,sCAAA;ElF+nZd;EkF7oZQ;IAcM,oCAAA;ElFkoZd;EkFhpZQ;IAcM,oCAAA;ElFqoZd;EkFnpZQ;IAcM,qBAAA;ElFwoZd;EkFtpZQ;IAcM,2BAAA;ElF2oZd;EkFzpZQ;IAcM,0BAAA;ElF8oZd;EkF5pZQ;IAcM,wBAAA;ElFipZd;EkF/pZQ;IAcM,0BAAA;ElFopZd;EkFlqZQ;IAcM,wBAAA;ElFupZd;EkFrqZQ;IAcM,2BAAA;IAAA,0BAAA;ElF2pZd;EkFzqZQ;IAcM,iCAAA;IAAA,gCAAA;ElF+pZd;EkF7qZQ;IAcM,gCAAA;IAAA,+BAAA;ElFmqZd;EkFjrZQ;IAcM,8BAAA;IAAA,6BAAA;ElFuqZd;EkFrrZQ;IAcM,gCAAA;IAAA,+BAAA;ElF2qZd;EkFzrZQ;IAcM,8BAAA;IAAA,6BAAA;ElF+qZd;EkF7rZQ;IAcM,yBAAA;IAAA,4BAAA;ElFmrZd;EkFjsZQ;IAcM,+BAAA;IAAA,kCAAA;ElFurZd;EkFrsZQ;IAcM,8BAAA;IAAA,iCAAA;ElF2rZd;EkFzsZQ;IAcM,4BAAA;IAAA,+BAAA;ElF+rZd;EkF7sZQ;IAcM,8BAAA;IAAA,iCAAA;ElFmsZd;EkFjtZQ;IAcM,4BAAA;IAAA,+BAAA;ElFusZd;EkFrtZQ;IAcM,yBAAA;ElF0sZd;EkFxtZQ;IAcM,+BAAA;ElF6sZd;EkF3tZQ;IAcM,8BAAA;ElFgtZd;EkF9tZQ;IAcM,4BAAA;ElFmtZd;EkFjuZQ;IAcM,8BAAA;ElFstZd;EkFpuZQ;IAcM,4BAAA;ElFytZd;EkFvuZQ;IAcM,gCAAA;ElF4tZd;EkF1uZQ;IAcM,sCAAA;ElF+tZd;EkF7uZQ;IAcM,qCAAA;ElFkuZd;EkFhvZQ;IAcM,mCAAA;ElFquZd;EkFnvZQ;IAcM,qCAAA;ElFwuZd;EkFtvZQ;IAcM,mCAAA;ElF2uZd;EkFzvZQ;IAcM,4BAAA;ElF8uZd;EkF5vZQ;IAcM,kCAAA;ElFivZd;EkF/vZQ;IAcM,iCAAA;ElFovZd;EkFlwZQ;IAcM,+BAAA;ElFuvZd;EkFrwZQ;IAcM,iCAAA;ElF0vZd;EkFxwZQ;IAcM,+BAAA;ElF6vZd;EkF3wZQ;IAcM,kCAAA;ElFgwZd;EkF9wZQ;IAcM,wCAAA;ElFmwZd;EkFjxZQ;IAcM,uCAAA;ElFswZd;EkFpxZQ;IAcM,qCAAA;ElFywZd;EkFvxZQ;IAcM,uCAAA;ElF4wZd;EkF1xZQ;IAcM,qCAAA;ElF+wZd;EkF7xZQ;IAcM,iBAAA;ElFkxZd;EkFhyZQ;IAcM,uBAAA;ElFqxZd;EkFnyZQ;IAcM,sBAAA;ElFwxZd;EkFtyZQ;IAcM,oBAAA;ElF2xZd;EkFzyZQ;IAcM,sBAAA;ElF8xZd;EkF5yZQ;IAcM,oBAAA;ElFiyZd;EkF/yZQ;IAcM,qBAAA;ElFoyZd;EkFlzZQ;IAcM,2BAAA;ElFuyZd;EkFrzZQ;IAcM,0BAAA;ElF0yZd;EkFxzZQ;IAcM,wBAAA;ElF6yZd;EkF3zZQ;IAcM,0BAAA;ElFgzZd;EkF9zZQ;IAcM,wBAAA;ElFmzZd;EkFj0ZQ;IAcM,wBAAA;ElFszZd;EkFp0ZQ;IAcM,8BAAA;ElFyzZd;EkFv0ZQ;IAcM,6BAAA;ElF4zZd;EkF10ZQ;IAcM,2BAAA;ElF+zZd;EkF70ZQ;IAcM,6BAAA;ElFk0Zd;EkFh1ZQ;IAcM,2BAAA;ElFq0Zd;EkFn1ZQ;IAcM,4BAAA;ElFw0Zd;EkFt1ZQ;IAcM,0BAAA;ElF20Zd;EkFz1ZQ;IAcM,6BAAA;ElF80Zd;AACF;Ac93ZI;EoEiCM;IAcM,8BAAA;ElFm1Zd;EkFj2ZQ;IAcM,4BAAA;ElFs1Zd;EkFp2ZQ;IAcM,sBAAA;ElFy1Zd;EkFv2ZQ;IAcM,8BAAA;ElF41Zd;EkF12ZQ;IAcM,4BAAA;ElF+1Zd;EkF72ZQ;IAcM,2BAAA;ElFk2Zd;EkFh3ZQ;IAcM,iCAAA;ElFq2Zd;EkFn3ZQ;IAcM,2BAAA;ElFw2Zd;EkFt3ZQ;IAcM,0BAAA;ElF22Zd;EkFz3ZQ;IAcM,gCAAA;ElF82Zd;EkF53ZQ;IAcM,yBAAA;ElFi3Zd;EkF/3ZQ;IAcM,wBAAA;ElFo3Zd;EkFl4ZQ;IAcM,+BAAA;ElFu3Zd;EkFr4ZQ;IAcM,yBAAA;ElF03Zd;EkFx4ZQ;IAcM,6BAAA;ElF63Zd;EkF34ZQ;IAcM,8BAAA;ElFg4Zd;EkF94ZQ;IAcM,wBAAA;ElFm4Zd;EkFj5ZQ;IAcM,+BAAA;ElFs4Zd;EkFp5ZQ;IAcM,wBAAA;ElFy4Zd;EkFv5ZQ;IAcM,yBAAA;ElF44Zd;EkF15ZQ;IAcM,8BAAA;ElF+4Zd;EkF75ZQ;IAcM,iCAAA;ElFk5Zd;EkFh6ZQ;IAcM,sCAAA;ElFq5Zd;EkFn6ZQ;IAcM,yCAAA;ElFw5Zd;EkFt6ZQ;IAcM,uBAAA;ElF25Zd;EkFz6ZQ;IAcM,uBAAA;ElF85Zd;EkF56ZQ;IAcM,yBAAA;ElFi6Zd;EkF/6ZQ;IAcM,yBAAA;ElFo6Zd;EkFl7ZQ;IAcM,0BAAA;ElFu6Zd;EkFr7ZQ;IAcM,4BAAA;ElF06Zd;EkFx7ZQ;IAcM,kCAAA;ElF66Zd;EkF37ZQ;IAcM,sCAAA;ElFg7Zd;EkF97ZQ;IAcM,oCAAA;ElFm7Zd;EkFj8ZQ;IAcM,kCAAA;ElFs7Zd;EkFp8ZQ;IAcM,yCAAA;ElFy7Zd;EkFv8ZQ;IAcM,wCAAA;ElF47Zd;EkF18ZQ;IAcM,wCAAA;ElF+7Zd;EkF78ZQ;IAcM,kCAAA;ElFk8Zd;EkFh9ZQ;IAcM,gCAAA;ElFq8Zd;EkFn9ZQ;IAcM,8BAAA;ElFw8Zd;EkFt9ZQ;IAcM,gCAAA;ElF28Zd;EkFz9ZQ;IAcM,+BAAA;ElF88Zd;EkF59ZQ;IAcM,oCAAA;ElFi9Zd;EkF/9ZQ;IAcM,kCAAA;ElFo9Zd;EkFl+ZQ;IAcM,gCAAA;ElFu9Zd;EkFr+ZQ;IAcM,uCAAA;ElF09Zd;EkFx+ZQ;IAcM,sCAAA;ElF69Zd;EkF3+ZQ;IAcM,iCAAA;ElFg+Zd;EkF9+ZQ;IAcM,2BAAA;ElFm+Zd;EkFj/ZQ;IAcM,iCAAA;ElFs+Zd;EkFp/ZQ;IAcM,+BAAA;ElFy+Zd;EkFv/ZQ;IAcM,6BAAA;ElF4+Zd;EkF1/ZQ;IAcM,+BAAA;ElF++Zd;EkF7/ZQ;IAcM,8BAAA;ElFk/Zd;EkFhgaQ;IAcM,oBAAA;ElFq/Zd;EkFngaQ;IAcM,mBAAA;ElFw/Zd;EkFtgaQ;IAcM,mBAAA;ElF2/Zd;EkFzgaQ;IAcM,mBAAA;ElF8/Zd;EkF5gaQ;IAcM,mBAAA;ElFigad;EkF/gaQ;IAcM,mBAAA;ElFogad;EkFlhaQ;IAcM,mBAAA;ElFugad;EkFrhaQ;IAcM,mBAAA;ElF0gad;EkFxhaQ;IAcM,oBAAA;ElF6gad;EkF3haQ;IAcM,0BAAA;ElFghad;EkF9haQ;IAcM,yBAAA;ElFmhad;EkFjiaQ;IAcM,uBAAA;ElFshad;EkFpiaQ;IAcM,yBAAA;ElFyhad;EkFviaQ;IAcM,uBAAA;ElF4had;EkF1iaQ;IAcM,uBAAA;ElF+had;EkF7iaQ;IAcM,0BAAA;IAAA,yBAAA;ElFmiad;EkFjjaQ;IAcM,gCAAA;IAAA,+BAAA;ElFuiad;EkFrjaQ;IAcM,+BAAA;IAAA,8BAAA;ElF2iad;EkFzjaQ;IAcM,6BAAA;IAAA,4BAAA;ElF+iad;EkF7jaQ;IAcM,+BAAA;IAAA,8BAAA;ElFmjad;EkFjkaQ;IAcM,6BAAA;IAAA,4BAAA;ElFujad;EkFrkaQ;IAcM,6BAAA;IAAA,4BAAA;ElF2jad;EkFzkaQ;IAcM,wBAAA;IAAA,2BAAA;ElF+jad;EkF7kaQ;IAcM,8BAAA;IAAA,iCAAA;ElFmkad;EkFjlaQ;IAcM,6BAAA;IAAA,gCAAA;ElFukad;EkFrlaQ;IAcM,2BAAA;IAAA,8BAAA;ElF2kad;EkFzlaQ;IAcM,6BAAA;IAAA,gCAAA;ElF+kad;EkF7laQ;IAcM,2BAAA;IAAA,8BAAA;ElFmlad;EkFjmaQ;IAcM,2BAAA;IAAA,8BAAA;ElFulad;EkFrmaQ;IAcM,wBAAA;ElF0lad;EkFxmaQ;IAcM,8BAAA;ElF6lad;EkF3maQ;IAcM,6BAAA;ElFgmad;EkF9maQ;IAcM,2BAAA;ElFmmad;EkFjnaQ;IAcM,6BAAA;ElFsmad;EkFpnaQ;IAcM,2BAAA;ElFymad;EkFvnaQ;IAcM,2BAAA;ElF4mad;EkF1naQ;IAcM,+BAAA;ElF+mad;EkF7naQ;IAcM,qCAAA;ElFknad;EkFhoaQ;IAcM,oCAAA;ElFqnad;EkFnoaQ;IAcM,kCAAA;ElFwnad;EkFtoaQ;IAcM,oCAAA;ElF2nad;EkFzoaQ;IAcM,kCAAA;ElF8nad;EkF5oaQ;IAcM,kCAAA;ElFioad;EkF/oaQ;IAcM,2BAAA;ElFooad;EkFlpaQ;IAcM,iCAAA;ElFuoad;EkFrpaQ;IAcM,gCAAA;ElF0oad;EkFxpaQ;IAcM,8BAAA;ElF6oad;EkF3paQ;IAcM,gCAAA;ElFgpad;EkF9paQ;IAcM,8BAAA;ElFmpad;EkFjqaQ;IAcM,8BAAA;ElFspad;EkFpqaQ;IAcM,iCAAA;ElFypad;EkFvqaQ;IAcM,uCAAA;ElF4pad;EkF1qaQ;IAcM,sCAAA;ElF+pad;EkF7qaQ;IAcM,oCAAA;ElFkqad;EkFhraQ;IAcM,sCAAA;ElFqqad;EkFnraQ;IAcM,oCAAA;ElFwqad;EkFtraQ;IAcM,oCAAA;ElF2qad;EkFzraQ;IAcM,qBAAA;ElF8qad;EkF5raQ;IAcM,2BAAA;ElFirad;EkF/raQ;IAcM,0BAAA;ElForad;EkFlsaQ;IAcM,wBAAA;ElFurad;EkFrsaQ;IAcM,0BAAA;ElF0rad;EkFxsaQ;IAcM,wBAAA;ElF6rad;EkF3saQ;IAcM,2BAAA;IAAA,0BAAA;ElFisad;EkF/saQ;IAcM,iCAAA;IAAA,gCAAA;ElFqsad;EkFntaQ;IAcM,gCAAA;IAAA,+BAAA;ElFysad;EkFvtaQ;IAcM,8BAAA;IAAA,6BAAA;ElF6sad;EkF3taQ;IAcM,gCAAA;IAAA,+BAAA;ElFitad;EkF/taQ;IAcM,8BAAA;IAAA,6BAAA;ElFqtad;EkFnuaQ;IAcM,yBAAA;IAAA,4BAAA;ElFytad;EkFvuaQ;IAcM,+BAAA;IAAA,kCAAA;ElF6tad;EkF3uaQ;IAcM,8BAAA;IAAA,iCAAA;ElFiuad;EkF/uaQ;IAcM,4BAAA;IAAA,+BAAA;ElFquad;EkFnvaQ;IAcM,8BAAA;IAAA,iCAAA;ElFyuad;EkFvvaQ;IAcM,4BAAA;IAAA,+BAAA;ElF6uad;EkF3vaQ;IAcM,yBAAA;ElFgvad;EkF9vaQ;IAcM,+BAAA;ElFmvad;EkFjwaQ;IAcM,8BAAA;ElFsvad;EkFpwaQ;IAcM,4BAAA;ElFyvad;EkFvwaQ;IAcM,8BAAA;ElF4vad;EkF1waQ;IAcM,4BAAA;ElF+vad;EkF7waQ;IAcM,gCAAA;ElFkwad;EkFhxaQ;IAcM,sCAAA;ElFqwad;EkFnxaQ;IAcM,qCAAA;ElFwwad;EkFtxaQ;IAcM,mCAAA;ElF2wad;EkFzxaQ;IAcM,qCAAA;ElF8wad;EkF5xaQ;IAcM,mCAAA;ElFixad;EkF/xaQ;IAcM,4BAAA;ElFoxad;EkFlyaQ;IAcM,kCAAA;ElFuxad;EkFryaQ;IAcM,iCAAA;ElF0xad;EkFxyaQ;IAcM,+BAAA;ElF6xad;EkF3yaQ;IAcM,iCAAA;ElFgyad;EkF9yaQ;IAcM,+BAAA;ElFmyad;EkFjzaQ;IAcM,kCAAA;ElFsyad;EkFpzaQ;IAcM,wCAAA;ElFyyad;EkFvzaQ;IAcM,uCAAA;ElF4yad;EkF1zaQ;IAcM,qCAAA;ElF+yad;EkF7zaQ;IAcM,uCAAA;ElFkzad;EkFh0aQ;IAcM,qCAAA;ElFqzad;EkFn0aQ;IAcM,iBAAA;ElFwzad;EkFt0aQ;IAcM,uBAAA;ElF2zad;EkFz0aQ;IAcM,sBAAA;ElF8zad;EkF50aQ;IAcM,oBAAA;ElFi0ad;EkF/0aQ;IAcM,sBAAA;ElFo0ad;EkFl1aQ;IAcM,oBAAA;ElFu0ad;EkFr1aQ;IAcM,qBAAA;ElF00ad;EkFx1aQ;IAcM,2BAAA;ElF60ad;EkF31aQ;IAcM,0BAAA;ElFg1ad;EkF91aQ;IAcM,wBAAA;ElFm1ad;EkFj2aQ;IAcM,0BAAA;ElFs1ad;EkFp2aQ;IAcM,wBAAA;ElFy1ad;EkFv2aQ;IAcM,wBAAA;ElF41ad;EkF12aQ;IAcM,8BAAA;ElF+1ad;EkF72aQ;IAcM,6BAAA;ElFk2ad;EkFh3aQ;IAcM,2BAAA;ElFq2ad;EkFn3aQ;IAcM,6BAAA;ElFw2ad;EkFt3aQ;IAcM,2BAAA;ElF22ad;EkFz3aQ;IAcM,4BAAA;ElF82ad;EkF53aQ;IAcM,0BAAA;ElFi3ad;EkF/3aQ;IAcM,6BAAA;ElFo3ad;AACF;AmF58aA;EDyEU;IAcM,4BAAA;ElFy3ad;EkFv4aQ;IAcM,0BAAA;ElF43ad;EkF14aQ;IAcM,6BAAA;ElF+3ad;EkF74aQ;IAcM,4BAAA;ElFk4ad;AACF;AmFv8aA;EDsDU;IAcM,0BAAA;ElFu4ad;EkFr5aQ;IAcM,gCAAA;ElF04ad;EkFx5aQ;IAcM,yBAAA;ElF64ad;EkF35aQ;IAcM,wBAAA;ElFg5ad;EkF95aQ;IAcM,+BAAA;ElFm5ad;EkFj6aQ;IAcM,yBAAA;ElFs5ad;EkFp6aQ;IAcM,6BAAA;ElFy5ad;EkFv6aQ;IAcM,8BAAA;ElF45ad;EkF16aQ;IAcM,wBAAA;ElF+5ad;EkF76aQ;IAcM,+BAAA;ElFk6ad;EkFh7aQ;IAcM,wBAAA;ElFq6ad;AACF;AoFxhbA;;;;;;EAAA;ACEA;EAEE,kCAAA;EACA,uCAAA;EACA,wCAAA;EACA,+CAAA;EACA,kEAAA;EACA,6DAAA;EACA,gDAAA;EACA,2CAAA;EACA,gDAAA;EACA,6CAAA;EACA,8CAAA;EACA,2CAAA;EAGA,kBAAA;EACA,0CAAA;EACA,kFAAA;EACA,uCAAA;EACA,oBAAA;EACA,yCAAA;EACA,UAAA;EACA,6BAAA;E9EFE,uDAAA;EeJE,iD+DQJ;ArF4hbF;AsBhibM;E+DrBN;I/DsBQ,gBAAA;EtBmibN;AACF;;AqF9hbA;EACE,uDAAA;ArFiibF;;AqF9hbA;EACE,sDAAA;EACA,0DAAA;ArFiibF;;AqF9hbA;EACE,mBAAA;EACA,oDAAA;EACA,wDAAA;EACA,mBAAA;ArFiibF;;AsF5kbA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AtF+kbF;;AA5kbA;EACE,wBAAA;AA+kbF;;AA5kbA;EACE,wCAAA;AA+kbF;;AA5kbA;EACE,WAAA;EACA,mFAAA;EACA,iBAAA;EsBEI,yBtBDJ;AA+kbF;AsB1kbM;EtBTN;IsBUQ,gBAAA;EtB6kbN;AACF;;AAjlbA;;EAEE,4BAAA;AAolbF;;AAjlbA;EACE,0BAAA;EACA,gCAAA;EACA,yBAAA;EACA,4BAAA;EACA,kCAAA;EACA,mCAAA;EACA,qCAAA;EACA,0CAAA;EACA,2CAAA;EACA,0DAAA;EACA,4CAAA;EACA,0DAAA;EACA,+CAAA;EAEA,+BAAA;EACA,sFAAA;AAmlbF;AAjlbE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;EACA,oBAAA;EACA,uBAAA;EACA,eAAA;EACA,qCAAA;AAmlbJ;AAjlbI;EACE,yBAAA;EACA,wEAAA;AAmlbN;AAhlbE;EACE,2CAAA;AAklbJ;AAjlbI;EAFF;IAGI,2CAAA;EAolbJ;AACF;AAllbE;EACE,wCAAA;AAolbJ;AAllbI;EAHF;IAII,wCAAA;EAqlbJ;AACF;AAjlbI;EACE,yBAAA;EACA,gCAAA;EACA,wCAAA;AAmlbN;AA/kbE;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,gDAAA;AAilbJ;AA9kbE;EACE,eAAA;EACA,eAAA;EACA,uBAAA;EACA,sCAAA;AAglbJ;AA9kbI;EACE,0CAAA;AAglbN;AA7kbI;EACE,WAAA;EACA,YAAA;EACA,qCAAA;EACA,kDAAA;AA+kbN;AA7kbM;EACE,yBAAA;AA+kbR;AA1kbE;EArFF;IAsFI,eAAA;IACA,MAAA;IACA,OAAA;IACA,aAAA;IACA,+BAAA;IACA,aAAA;IACA,4BAAA;EA6kbF;EA3kbE;IACE,wBAAA;EA6kbJ;AACF;AA1kbE;EACE,sCAAA;AA4kbJ;AA1kbI;EACE,aAAA;EACA,UAAA;AA4kbN;AAzkbI;EACE,cAAA;EACA,UAAA;AA2kbN;AAxkbI;EACE,aAAA;AA0kbN;AAvkbI;EACE,eAAA;AAykbN;AAtkbI;EACE,uBAAA;EACA,eAAA;AAwkbN;AArkbI;EACE;IACE,+BAAA;EAukbN;EArkbM;IACE,aAAA;IACA,UAAA;EAukbR;EApkbM;IACE,cAAA;IACA,UAAA;EAskbR;EAnkbM;IACE,eAAA;EAqkbR;EAlkbM;IACE,oBAAA;EAokbR;EAjkbM;IACE,2BAAA;IACA,oBAAA;EAmkbR;AACF;;AA7jbA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AAgkbF;;AA7jbA;EACE,gBAAA;EACA,kBAAA;AAgkbF;;AA7jbA;EACE,gBAAA;AAgkbF;;AA7jbA;EACE,4BAAA;AAgkbF;;AA5jbE;EACE,2CAAA;AA+jbJ;AA5jbE;EACE,mCAAA;AA8jbJ;AA3jbE;EACE,yBAAA;EACA,4BAAA;EACA,kCAAA;EACA,qCAAA;EACA,0CAAA;EACA,gDAAA;AA6jbJ;AA5jbI;EACE,yDAAA;AA8jbN;AA5jbI;EACE,4DAAA;AA8jbN;AAvjbM;EACE,wDAAA;EACA,6CAAA;EACA,4DAAA;AAyjbR;AAtjbM;EACE,wDAAA;EACA,4DAAA;EACA,6CAAA;AAwjbR;AAtjbQ;EACE,6CAAA;AAwjbV;AArjbQ;EACE,kDAAA;AAujbV;AAnjbM;EACE,wDAAA;EACA,6CAAA;AAqjbR;AAnjbQ;EACE,6CAAA;AAqjbV;AAjjbQ;EACE,+DAAA;EACA,6CAAA;EACA,gEAAA;AAmjbV;AAjjbU;EACE,6CAAA;AAmjbZ;AAhjbU;EACE,6CAAA;AAkjbZ;AA5ibU;EACE,mDAAA;EACA,2CAAA;EACA,6CAAA;AA8ibZ;AA5ibY;EACE,oCAAA;AA8ibd;AA3ibY;EACE,6CAAA;AA6ibd;AA1ibY;EACE,+DAAA;EACA,6CAAA;EACA,4DAAA;AA4ibd;AA1ibc;EACE,6CAAA;AA4ibhB;AAzibc;EACE,yDAAA;EACA,oCAAA;AA2ibhB;AAvibY;EACE,qDAAA;AAyibd;AAribU;EACE,mDAAA;EACA,0CAAA;EACA,6CAAA;AAuibZ;AAribY;EACE,mCAAA;AAuibd;AApibY;EACE,6CAAA;AAsibd;AAlibU;EACE,mDAAA;EACA,2CAAA;EACA,6CAAA;AAoibZ;AAlibY;EACE,oCAAA;AAoibd;AAjibY;EACE,6CAAA;AAmibd;AA/hbU;EACE,oDAAA;EACA,wCAAA;EACA,6CAAA;AAiibZ;AA/hbY;EACE,iCAAA;AAiibd;AA9hbY;EACE,6CAAA;AAgibd;AA1hbQ;EACE,mCAAA;AA4hbV;AAzhbQ;EACE,oCAAA;AA2hbV;AAxhbQ;EACE,qDAAA;AA0hbV;AAvhbQ;EACE,oCAAA;AAyhbV;AAthbQ;EACE,iCAAA;AAwhbV;AAphbQ;EACE,yBAAA;AAshbV;AAphbU;EACE,qDAAA;AAshbZ;AAnhbU;EACE,mCAAA;AAqhbZ;AAlhbU;EACE,oCAAA;AAohbZ;AA/gbM;EACE,wDAAA;EACA,4DAAA;AAihbR;AA3gbE;;EAEE,oCAAA;EACA,yBAAA;EACA,iCAAA;AA6gbJ;AA3gbI;;EACE,yBAAA;AA8gbN;AA1gbE;;EAEE,oCAAA;EACA,yBAAA;AA4gbJ;AA1gbI;;EACE,yBAAA;AA6gbN;;AAxgbA,qCAAA;AACA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AA2gbF;;AAxgbA;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA2gbF;;AAxgbA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA,EAAA,0BAAA;EACA,+BAAA,EAAA,+BAAA;EACA,iEAAA;AA2gbF;;AAxgbA;EACE,+BAAA;EACA,UAAA,EAAA,8BAAA;AA2gbF","sourcesContent":["@use \"@coreui/coreui/scss/coreui\" as * with ( \n  $enable-deprecation-messages: false,\n);\n@use \"@coreui/chartjs/scss/coreui-chartjs\";\n@use \"vendors/simplebar\";\n\n:root {\n  --transition-speed: 0.3s;\n}\n\nbody {\n  background-color: var(--cui-tertiary-bg);\n}\n\n.wrapper {\n  width: 100%;\n  padding-inline: var(--cui-sidebar-occupy-start, 0) var(--cui-sidebar-occupy-end, 0);\n  will-change: auto;\n  @include transition(padding .15s);\n}\n\n.header > .container-fluid,\n.sidebar-header {\n  min-height: calc(4rem + 1px);\n}\n\n.sidebar {\n  --cui-sidebar-width: 16rem;\n  --cui-sidebar-narrow-width: 4rem;\n  --cui-sidebar-bg: #2c3e50;\n  --cui-sidebar-color: #ecf0f1;\n  --cui-sidebar-brand-color: #ffffff;\n  --cui-sidebar-brand-bg: transparent;\n  --cui-sidebar-nav-link-color: #ecf0f1;\n  --cui-sidebar-nav-link-icon-color: #95a5a6;\n  --cui-sidebar-nav-link-hover-color: #ffffff;\n  --cui-sidebar-nav-link-hover-bg: rgba(255, 255, 255, 0.05);\n  --cui-sidebar-nav-link-active-color: #ffffff;\n  --cui-sidebar-nav-link-active-bg: rgba(255, 255, 255, 0.1);\n  --cui-sidebar-nav-group-bg: rgba(0, 0, 0, 0.15);\n  \n  width: var(--cui-sidebar-width);\n  transition: transform var(--transition-speed) ease, width var(--transition-speed) ease;\n\n  .sidebar-brand-full {\n    display: block;\n    font-size: 1.25rem;\n    font-weight: 600;\n    transition: all var(--transition-speed) ease;\n    padding: 0.5rem 1rem;\n    border-radius: 0.375rem;\n    cursor: pointer;\n    color: var(--cui-sidebar-brand-color);\n\n    &:hover {\n      color: #ffffff !important;\n      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n    }\n  }\n  .sidebar-header {\n    border-bottom: 1px solid #ffffff !important;\n    @media (prefers-color-scheme: light) {\n      border-bottom: 1px solid #ffffff !important;\n    }\n  }\n  .sidebar-footer {\n    border-top: 1px solid #ffffff !important;\n    \n    @media (prefers-color-scheme: light) {\n      border-top: 1px solid #ffffff !important;\n    }\n  }\n\n  .sidebar-brand {\n    &:hover {\n      color: inherit !important;\n      text-decoration: none !important;\n      background-color: transparent !important;\n    }\n  }\n\n  .sidebar-brand-narrow {\n    display: none;\n    font-size: 1.5rem;\n    font-weight: 700;\n    opacity: 0;\n    transition: opacity var(--transition-speed) ease;\n  }\n\n  .sidebar-toggler-wrapper {\n    cursor: pointer;\n    padding: 0.5rem;\n    border-radius: 0.375rem;\n    transition: background-color 0.2s ease;\n\n    &:hover {\n      background-color: rgba(255, 255, 255, 0.1);\n    }\n\n    .sidebar-toggler-icon {\n      width: 20px;\n      height: 20px;\n      color: var(--cui-sidebar-brand-color);\n      transition: transform var(--transition-speed) ease;\n\n      &.rotated {\n        transform: rotate(180deg);\n      }\n    }\n  }\n\n  @media (max-width: 768px) {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1031;\n    width: var(--cui-sidebar-width);\n    height: 100vh;\n    transform: translateX(-100%);\n\n    &.show {\n      transform: translateX(0);\n    }\n  }\n\n  &.sidebar-narrow {\n    width: var(--cui-sidebar-narrow-width);\n\n    .sidebar-brand-full {\n      display: none;\n      opacity: 0;\n    }\n\n    .sidebar-brand-narrow {\n      display: block;\n      opacity: 1;\n    }\n\n    .nav-label {\n      display: none;\n    }\n\n    .nav-icon {\n      margin-right: 0;\n    }\n\n    .nav-link {\n      justify-content: center;\n      padding: 0.5rem;\n    }\n\n    @media (min-width: 769px) {\n      &:hover {\n        width: var(--cui-sidebar-width);\n\n        .sidebar-brand-narrow {\n          display: none;\n          opacity: 0;\n        }\n\n        .sidebar-brand-full {\n          display: block;\n          opacity: 1;\n        }\n\n        .nav-label {\n          display: inline;\n        }\n\n        .nav-icon {\n          margin-right: 0.5rem;\n        }\n\n        .nav-link {\n          justify-content: flex-start;\n          padding: 0.5rem 1rem;\n        }\n      }\n    }\n  }\n}\n\n.sidebar-brand {\n  min-height: 4rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 1rem;\n}\n\n.sidebar-nav {\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.header > .container-fluid + .container-fluid {\n  min-height: 3rem;\n}\n\n.footer {\n  min-height: calc(3rem + 1px);\n}\n\n@include color-mode(dark) {\n  body {\n    background-color: var(--cui-dark-bg-subtle);\n  }\n\n  .footer {\n    --cui-footer-bg: var(--cui-body-bg);\n  }\n\n  .sidebar {\n    --cui-sidebar-bg: #1a1d24;\n    --cui-sidebar-color: #e9ecef;\n    --cui-sidebar-brand-color: #ffffff;\n    --cui-sidebar-nav-link-color: #e9ecef;\n    --cui-sidebar-nav-link-icon-color: #768390;\n    --cui-sidebar-nav-group-bg: rgba(250, 0, 0, 0.2);\n    .sidebar-footer {\n      border-top: 1px solid rgba(255, 255, 255, 0.2) !important;\n    }\n    .sidebar-header {\n      border-bottom: 1px solid rgba(255, 255, 255, 0.2) !important;\n    }\n  }\n\n  // Global Modal Dark Mode Fixes - Tüm modaller için\n  .modal {\n    .modal-dialog {\n      .modal-content {\n        background-color: var(--cui-dark-bg, #212631) !important;\n        color: var(--cui-body-color, #fff) !important;\n        border-color: var(--cui-dark-border-subtle, #333) !important;\n      }\n      \n      .modal-header {\n        background-color: var(--cui-dark-bg, #212631) !important;\n        border-color: var(--cui-dark-border-subtle, #333) !important;\n        color: var(--cui-body-color, #fff) !important;\n        \n        .modal-title {\n          color: var(--cui-body-color, #fff) !important;\n        }\n        \n        .btn-close {\n          filter: invert(1) grayscale(100%) brightness(200%);\n        }\n      }\n      \n      .modal-body {\n        background-color: var(--cui-dark-bg, #212631) !important;\n        color: var(--cui-body-color, #fff) !important;\n        \n        p {\n          color: var(--cui-body-color, #fff) !important;\n        }\n        \n        // Modal içindeki tüm bg-light sınıfları için\n        .bg-light {\n          background-color: var(--cui-dark-bg-subtle, #2c3034) !important;\n          color: var(--cui-body-color, #fff) !important;\n          border: 1px solid var(--cui-dark-border-subtle, #333) !important;\n          \n          strong {\n            color: var(--cui-body-color, #fff) !important;\n          }\n          \n          br + strong {\n            color: var(--cui-body-color, #fff) !important;\n          }\n        }\n        \n        // Alert mesajları için\n        .alert {\n          &.alert-success {\n            background-color: rgba(25, 135, 84, 0.1) !important;\n            border-color: var(--cui-success) !important;\n            color: var(--cui-body-color, #fff) !important;\n            \n            .alert-heading {\n              color: var(--cui-success) !important;\n            }\n            \n            p {\n              color: var(--cui-body-color, #fff) !important;\n            }\n            \n            .bg-white {\n              background-color: var(--cui-dark-bg-subtle, #2c3034) !important;\n              color: var(--cui-body-color, #fff) !important;\n              border-color: var(--cui-dark-border-subtle, #333) !important;\n              \n              strong {\n                color: var(--cui-body-color, #fff) !important;\n              }\n              \n              code {\n                background-color: var(--cui-gray-900, #1a1a1a) !important;\n                color: var(--cui-success) !important;\n              }\n            }\n            \n            .text-muted {\n              color: var(--cui-secondary-color, #8a93a2) !important;\n            }\n          }\n          \n          &.alert-danger {\n            background-color: rgba(220, 53, 69, 0.1) !important;\n            border-color: var(--cui-danger) !important;\n            color: var(--cui-body-color, #fff) !important;\n            \n            .alert-heading {\n              color: var(--cui-danger) !important;\n            }\n            \n            p {\n              color: var(--cui-body-color, #fff) !important;\n            }\n          }\n          \n          &.alert-warning {\n            background-color: rgba(255, 193, 7, 0.1) !important;\n            border-color: var(--cui-warning) !important;\n            color: var(--cui-body-color, #fff) !important;\n            \n            .alert-heading {\n              color: var(--cui-warning) !important;\n            }\n            \n            p {\n              color: var(--cui-body-color, #fff) !important;\n            }\n          }\n          \n          &.alert-info {\n            background-color: rgba(13, 202, 240, 0.1) !important;\n            border-color: var(--cui-info) !important;\n            color: var(--cui-body-color, #fff) !important;\n            \n            .alert-heading {\n              color: var(--cui-info) !important;\n            }\n            \n            p {\n              color: var(--cui-body-color, #fff) !important;\n            }\n          }\n        }\n        \n        // Text renk sınıfları için\n        .text-danger {\n          color: var(--cui-danger) !important;\n        }\n        \n        .text-warning {\n          color: var(--cui-warning) !important;\n        }\n        \n        .text-muted {\n          color: var(--cui-secondary-color, #8a93a2) !important;\n        }\n        \n        .text-success {\n          color: var(--cui-success) !important;\n        }\n        \n        .text-info {\n          color: var(--cui-info) !important;\n        }\n        \n        // Küçük metin için\n        small {\n          color: inherit !important;\n          \n          &.text-muted {\n            color: var(--cui-secondary-color, #8a93a2) !important;\n          }\n          \n          &.text-danger {\n            color: var(--cui-danger) !important;\n          }\n          \n          &.text-warning {\n            color: var(--cui-warning) !important;\n          }\n        }\n      }\n      \n      .modal-footer {\n        background-color: var(--cui-dark-bg, #212631) !important;\n        border-color: var(--cui-dark-border-subtle, #333) !important;\n      }\n    }\n  }\n\n  // Daha spesifik selector'lar ekstra güvence için\n  .modal-backdrop.show + .modal .modal-dialog .modal-content .modal-body .bg-light,\n  .modal .modal-dialog .modal-content .modal-body .bg-light {\n    background-color: #2c3034 !important;\n    color: #ffffff !important;\n    border: 1px solid #333 !important;\n    \n    strong {\n      color: #ffffff !important;\n    }\n  }\n  \n  .modal-backdrop.show + .modal .modal-dialog .modal-content .modal-body,\n  .modal .modal-dialog .modal-content .modal-body {\n    background-color: #212631 !important;\n    color: #ffffff !important;\n    \n    p {\n      color: #ffffff !important;\n    }\n  }\n}\n\n/* Excel-like table column resizing */\n.col-resizer {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 6px;\n  height: 100%;\n  cursor: col-resize;\n  user-select: none;\n}\n\n.table-header-cell {\n  position: relative;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.col-resizer::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 2px;\n  width: 2px; /* thicker baseline line */\n  background: rgba(0, 0, 0, 0.12); /* visible even without hover */\n  transition: background 0.15s ease-in-out, width 0.15s ease-in-out;\n}\n\n.col-resizer:hover::after {\n  background: rgba(0, 0, 0, 0.28);\n  width: 3px; /* slightly thicker on hover */\n}","$file: \"\" !default;\n\n/*!\n * CoreUI #{$file} v5.4.0 (https://coreui.io)\n * Copyright (c) 2025 creativeLabs Łukasz Holeczek\n * Licensed under MIT (https://github.com/coreui/coreui/blob/main/LICENSE)\n */\n","@use \"sass:meta\";\n@use \"functions/color\" as *;\n@use \"functions/to-rgb\" as *;\n@use \"mixins/color-mode\" as *;\n@use \"vendor/rfs\" as *;\n@use \"maps\" as *;\n@use \"variables\" as *;\n@use \"variables-dark\" as *;\n\n:root,\n[data#{$data-infix}theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `meta.inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{meta.inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{meta.inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{meta.inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n\n  --#{$prefix}body-color-dark: #{$body-color-dark};\n  --#{$prefix}body-color-rgb-dark: #{to-rgb($body-color-dark)};\n  --#{$prefix}body-bg-dark: #{$body-bg-dark};\n  --#{$prefix}body-bg-rgb-dark: #{to-rgb($body-bg-dark)};\n\n  --#{$prefix}emphasis-color-dark: #{$body-emphasis-color-dark};\n  --#{$prefix}emphasis-color-rgb-dark: #{to-rgb($body-emphasis-color-dark)};\n\n  --#{$prefix}secondary-color-dark: #{$body-secondary-color-dark};\n  --#{$prefix}secondary-color-rgb-dark: #{to-rgb($body-secondary-color-dark)};\n  --#{$prefix}secondary-bg-dark: #{$body-secondary-bg-dark};\n  --#{$prefix}secondary-bg-rgb-dark: #{to-rgb($body-secondary-bg-dark)};\n\n  --#{$prefix}tertiary-color-dark: #{$body-tertiary-color-dark};\n  --#{$prefix}tertiary-color-rgb-dark: #{to-rgb($body-tertiary-color-dark)};\n  --#{$prefix}tertiary-bg-dark: #{$body-tertiary-bg-dark};\n  --#{$prefix}tertiary-bg-rgb-dark: #{to-rgb($body-tertiary-bg-dark)};\n\n  --#{$prefix}high-emphasis: #{$high-emphasis}; // Deprecated in v5.0.0\n  --#{$prefix}medium-emphasis: #{$medium-emphasis}; // Deprecated in v5.0.0\n  --#{$prefix}disabled: #{$disabled}; // Deprecated in v5.0.0\n\n  --#{$prefix}high-emphasis-inverse: #{$high-emphasis-inverse}; // Deprecated in v5.0.0\n  --#{$prefix}medium-emphasis-inverse: #{$medium-emphasis-inverse}; // Deprecated in v5.0.0\n  --#{$prefix}disabled-inverse: #{$disabled-inverse}; // Deprecated in v5.0.0\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.0.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    --#{$prefix}high-emphasis: #{$high-emphasis-dark}; // Deprecated in v5.0.0\n    --#{$prefix}medium-emphasis: #{$medium-emphasis-dark}; // Deprecated in v5.0.0\n    --#{$prefix}disabled: #{$disabled-dark}; // Deprecated in v5.0.0\n\n    @each $color, $value in $theme-colors-dark {\n      --#{$prefix}#{$color}: #{$value};\n    }\n\n    @each $color, $value in $grays-dark {\n      --#{$prefix}gray-#{$color}: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-rgb-dark {\n      --#{$prefix}#{$color}-rgb: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n@use \"sass:map\";\n@use \"sass:math\";\n@use \"sass:meta\";\n@use \"sass:string\";\n\n@use \"../variables\" as *;\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if meta.type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: $enable-rfs !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: math.unit($rfs-base-value);\n\n@function rfs-divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: math.unit($dividend);\n  $divisor-unit: math.unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map.has-key($unit-map, $dividend-unit)) {\n    $result: $result * map.get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: rfs-divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: rfs-divide($rfs-base-value, rfs-divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: math.unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: rfs-divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: rfs-divide($rfs-breakpoint, rfs-divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{rfs-divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(meta.type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(meta.type-of($value) == \"number\", math.unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{rfs-divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{rfs-divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return string.unquote(string.slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(meta.type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(meta.type-of($value) == \"number\", math.unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: rfs-divide($value, $value * 0 + if($unit == px, 1, rfs-divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{rfs-divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + rfs-divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{rfs-divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{rfs-divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return string.unquote(string.slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}","@use \"../variables\" as *;\n\n// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data#{$data-infix}theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","@use \"mixins/border-radius\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-inline-start: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-inline-start: 0; // 1\n  margin-bottom: .5rem;\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}pre-color, $pre-color);\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: var(--#{$prefix}kbd-color, $kbd-color);\n  background-color: var(--#{$prefix}kbd-bg, $kbd-bg);\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: var(--#{$prefix}table-caption-color, $table-caption-color);\n  text-align: start;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: inline-start; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n  @include font-size($legend-font-size);\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n\n*[dir=\"rtl\"] {\n  [type=\"tel\"],\n  [type=\"url\"],\n  [type=\"email\"],\n  [type=\"number\"] {\n    direction: ltr;\n  }\n}\n\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","@use \"sass:color\";\n@use \"sass:string\";\n@use \"functions/assert-ascending\" as *;\n@use \"functions/assert-starts-at-zero\" as *;\n@use \"functions/color\" as *;\n@use \"functions/color-contrast-variables\" as *;\n@use \"functions/math\" as *;\n@use \"functions/to-rgb\" as *;\n\n// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:     #fff !default;\n$gray-base: #323a49 !default;\n$gray-100:  #f3f4f7 !default;\n$gray-200:  #e7eaee !default;\n$gray-300:  #dbdfe6 !default;\n$gray-400:  #cfd4de !default;\n$gray-500:  #aab3c5 !default;\n$gray-600:  #6d7d9c !default;\n$gray-700:  #4a566d !default;\n$gray-800:  #323a49 !default;\n$gray-900:  #212631 !default;\n$black:     #080a0c !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// fusv-disable\n$high-emphasis:            rgba(shift-color($gray-base, +26%), .95) !default; // Deprecated in 5.0.0\n$medium-emphasis:          rgba(shift-color($gray-base, +26%), .681) !default; // Deprecated in 5.0.0\n$disabled:                 rgba(shift-color($gray-base, +26%), .38) !default; // Deprecated in 5.0.0\n\n$high-emphasis-inverse:    rgba($white, .87) !default; // Deprecated in 5.0.0\n$medium-emphasis-inverse:  rgba($white, .6) !default; // Deprecated in 5.0.0\n$disabled-inverse:         rgba($white, .38) !default; // Deprecated in 5.0.0\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.2 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG/#contrast-minimum\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       #5856d6 !default;\n$secondary:     #6b7785 !default;\n$success:       #1b9e3e !default;\n$info:          #39f !default;\n$warning:       #f9b115 !default;\n$danger:        #e55353 !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:    #3634a3 !default;\n$secondary-text-emphasis:  #212233 !default;\n$success-text-emphasis:    #0f5722 !default;\n$info-text-emphasis:       #184c77 !default;\n$warning-text-emphasis:    #764705 !default;\n$danger-text-emphasis:     #671414 !default;\n$light-text-emphasis:      $gray-700 !default;\n$dark-text-emphasis:       $gray-800 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:    #cfc7f3 !default;\n$secondary-bg-subtle:  #ced2d8 !default;\n$success-bg-subtle:    #cbedd6 !default;\n$info-bg-subtle:       #c0e6ff !default;\n$warning-bg-subtle:    #feecc5 !default;\n$danger-bg-subtle:     #f9d4d4 !default;\n$light-bg-subtle:      color.mix($gray-100, $white) !default;\n$dark-bg-subtle:       $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:    #9d92e6 !default;\n$secondary-border-subtle:  #9da5b1 !default;\n$success-border-subtle:    #96dbad !default;\n$info-border-subtle:       #80c6ff !default;\n$warning-border-subtle:    #fcd88a !default;\n$danger-border-subtle:     #f2a9a9 !default;\n$light-border-subtle:      $gray-200 !default;\n$dark-border-subtle:       $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n$enable-ltr:                  true !default;\n$enable-rtl:                  false !default;\n$enable-container-queries:    false !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             cui- !default; // Deprecated in v4.2.6 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Prefix for data attributes\n\n$data-infix:                  -coreui- !default;\n\n// Set mobile breakpoint\n\n$mobile-breakpoint:           lg !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                rgba(shift-color($gray-base, +26%), .95) !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba(shift-color($gray-base, +26%), .681) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba(shift-color($gray-base, +26%), .38) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n// scss-docs-start cq-grid-breakpoints\n$cq-grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n\n@include assert-ascending($cq-grid-breakpoints, \"$cq-grid-breakpoints\");\n@include assert-starts-at-zero($cq-grid-breakpoints, \"$cq-grid-breakpoints\");\n// scss-docs-end cq-grid-breakpoints\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.0.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      rgba($white, .87) !default;\n$component-active-bg:         var(--#{$prefix}primary) !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:                $font-size-base * 1.25 !default;\n$lead-font-weight:              300 !default;\n\n$small-font-size:               .875em !default;\n\n$sub-sup-font-size:             .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.0.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v4.2.6\n$hr-height:                   null !default; // Deprecated in v4.2.6\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n// Icons\n$icon-size-base:  1rem !default;\n$icon-size-sm:    $icon-size-base * .875 !default;\n$icon-size-lg:    $icon-size-base * 1.25 !default;\n$icon-size-xl:    $icon-size-base * 1.5 !default;\n$icon-size-xxl:   $icon-size-base * 2 !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(color.mix(color-contrast-variables($link-color, $color-contrast-dark, $color-contrast-light, $white, $black, $min-contrast-ratio), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n// scss-docs-start btn-outline-variables\n$btn-outline-color: var(--#{$prefix}secondary-color) !default;\n$btn-outline-border-color: var(--#{$prefix}border-color) !default;\n$btn-outline-active-color: var(--#{$prefix}body-color) !default;\n$btn-outline-active-bg: var(--#{$prefix}tertiary-bg) !default;\n$btn-outline-active-border-color: var(--#{$prefix}border-color) !default;\n$btn-outline-disabled-color: var(--#{$prefix}secondary-color) !default;\n$btn-outline-disabled-border-color: var(--#{$prefix}border-color) !default;\n$btn-outline-hover-color: var(--#{$prefix}body-color) !default;\n$btn-outline-hover-bg: var(--#{$prefix}tertiary-bg) !default;\n$btn-outline-hover-border-color: var(--#{$prefix}border-color) !default;\n$btn-outline-focus-shadow-rgb: var(--#{$prefix}tertiary-bg-rgb) !default;\n// scss-docs-end btn-outline-variables\n\n// scss-docs-start btn-ghost-variables\n$btn-ghost-color: var(--#{$prefix}secondary-color) !default;\n$btn-ghost-active-color: var(--#{$prefix}body-color) !default;\n$btn-ghost-active-bg: var(--#{$prefix}tertiary-bg) !default;\n$btn-ghost-disabled-color: var(--#{$prefix}secondary-color) !default;\n$btn-ghost-hover-color: var(--#{$prefix}body-color) !default;\n$btn-ghost-hover-bg: var(--#{$prefix}tertiary-bg) !default;\n$btn-ghost-focus-shadow-rgb: var(--#{$prefix}tertiary-bg-rgb) !default;\n// scss-docs-end btn-ghost-variables\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($primary, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n\n$form-switch-widths: (\n  lg: (\n    width: 2.5em,\n    height: 1.25em\n  ),\n  xl: (\n    width: 3em,\n    height: 1.5em\n  )\n) !default;\n// scss-docs-end form-switch-variables\n\n$form-check-inline-margin-end:    1rem !default;\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($primary, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-sidebar-backdrop:           1034 !default;\n$zindex-sidebar:                    1035 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n\n$nav-underline-border-gap:                  .5rem !default;\n$nav-underline-border-border-color:         var(--#{$prefix}border-color) !default;\n$nav-underline-border-border-width:         .125rem !default;\n$nav-underline-border-link-padding-y:       .5rem !default;\n$nav-underline-border-link-padding-x:       .5rem !default;\n$nav-underline-border-link-color:           var(--#{$prefix}secondary-color) !default;\n$nav-underline-border-link-active-color:    var(--#{$prefix}primary) !default;\n$nav-underline-border-link-disabled-color:  var(--#{$prefix}tertiary-color) !default;\n\n$nav-enclosed-padding:                   .125rem !default;\n$nav-enclosed-bg:                        var(--#{$prefix}tertiary-bg) !default;\n$nav-enclosed-border-radius:             $border-radius-lg !default;\n$nav-enclosed-link-padding-y:            .375rem !default;\n$nav-enclosed-link-padding-x:            .875rem !default;\n$nav-enclosed-link-color:                var(--#{$prefix}body-color) !default;\n$nav-enclosed-link-border-width:         1px !default;\n$nav-enclosed-link-active-color:         var(--#{$prefix}body-color) !default;\n$nav-enclosed-link-active-bg:            var(--#{$prefix}body-bg) !default;\n$nav-enclosed-link-active-border-color:  var(--#{$prefix}border-color) !default;\n$nav-enclosed-link-hover-box-shadow:     var(--#{$prefix}box-shadow-sm) !default;\n$nav-enclosed-link-disabled-color:       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v4.2.6\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(-1 * #{$pagination-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.0.0\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in 4.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in 4.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n\n$badge-font-size-sm:                .65em !default;\n$badge-padding-y-sm:                .3em !default;\n$badge-padding-x-sm:                .5em !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               var(--#{$prefix}body-color) !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Avatars\n// scss-docs-start avatar-variables\n$avatar-width:                 2rem !default;\n$avatar-height:                2rem !default;\n$avatar-font-size:             .8rem !default;\n$avatar-border-radius:         50em !default;\n$avatar-status-width:          .5rem !default;\n$avatar-status-height:         .5rem !default;\n$avatar-status-border-radius:  50em !default;\n$avatar-transition:            margin .15s !default;\n\n$avatar-sizes: (\n  sm: (\n    width: 1.5rem,\n    height: 1.5rem,\n    font-size: .6rem,\n    status-width: .4rem,\n    status-height: .4rem\n  ),\n  md: (\n    width: 2.5rem,\n    height: 2.5rem,\n    font-size: 1rem,\n    status-width: .7rem,\n    status-height: .7rem\n  ),\n  lg: (\n    width: 3rem,\n    height: 3rem,\n    font-size: 1.2rem,\n    status-width: .8rem,\n    status-height: .8rem\n  ),\n  xl: (\n    width: 4rem,\n    height: 4rem,\n    font-size: 1.6rem,\n    status-width: 1rem,\n    status-height: 1rem\n  ),\n) !default;\n// scss-docs-end avatar-variables\n\n// fusv-disable\n// Deprecated in 5.1.0 for CSS variables\n$avatar-widths: (\n  sm: 1.5rem,\n  md: 2.5rem,\n  lg: 3rem,\n  xl: 4rem\n) !default;\n// fusv-enable\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v4.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v4.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v4.2.0, to be removed in v6\n// fusv-enable\n\n// Callouts\n// scss-docs-start callout-variables\n$callout-padding-y:                 $spacer !default;\n$callout-padding-x:                 $spacer !default;\n$callout-margin-y:                  $spacer !default;\n$callout-margin-x:                  0 !default;\n$callout-border-radius:             var(--#{$prefix}border-radius) !default;\n$callout-border-width:              var(--#{$prefix}border-width) !default;\n$callout-border-color:              var(--#{$prefix}border-color) !default;\n$callout-border-left-width:         calc(#{$callout-border-width} * 4) !default; // stylelint-disable-line function-disallowed-list\n\n$callout-variants: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"danger\":     $danger,\n  \"warning\":    $warning,\n  \"info\":       $info,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end callout-variables\n\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   var(--#{$prefix}primary) !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n// TODO: clean-up ???\n$progress-group-margin-bottom:         $spacer !default;\n$progress-group-header-margin-bottom:  $spacer * .25 !default;\n// scss-docs-end progress-variables\n\n// List group\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.0.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.0.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Header\n// scss-docs-start header-variables\n$header-padding-y:              $spacer * .5 !default;\n$header-padding-x:              $spacer * .5 !default;\n$header-brand-font-size:        $font-size-lg !default;\n$header-color:                  rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$header-bg:                     var(--#{$prefix}body-bg) !default;\n$header-border-color:           var(--#{$prefix}border-color) !default;\n$header-border-width:           var(--#{$prefix}border-width) !default;\n$header-hover-color:            rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$header-active-color:           rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$header-disabled-color:         rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$header-transition:             box-shadow .15s ease-in-out !default;\n\n// Compute the header-brand padding-y so the header-brand will have the same height as header-text and nav-link\n$nav-link-height:               $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$header-brand-height:           $header-brand-font-size * $line-height-base !default;\n$header-brand-padding-y:        ($nav-link-height - $header-brand-height) * .5 !default;\n$header-brand-margin-end:       1rem !default;\n$header-brand-font-size:        $font-size-lg !default;\n$header-brand-color:            $gray-900 !default;\n$header-brand-hover-color:      shade-color($gray-900, 10%) !default;\n\n$header-toggler-padding-y:      .25rem !default;\n$header-toggler-padding-x:      .75rem !default;\n$header-toggler-font-size:      $font-size-lg !default;\n$header-toggler-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$header-toggler-bg:             transparent !default;\n$header-toggler-border-radius:  $btn-border-radius !default;\n$header-toggler-hover-color:    rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n\n$header-toggler-icon-bg:        url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$header-color}' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\") !default;\n$header-toggler-hover-icon-bg:  url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$header-hover-color}' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\") !default;\n\n$header-nav-link-padding-x:     .5rem !default;\n$header-nav-link-padding-y:     .5rem !default;\n\n$header-divider-border-width:   var(--#{$prefix}border-width) !default;\n$header-divider-border-color:   var(--#{$prefix}border-color) !default;\n// scss-docs-end header-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                string.quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n$carousel-control-icon-filter:       null !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default; // Deprecated in v5.3.2\n$carousel-dark-caption-color:        $black !default; // Deprecated in v5.3.2\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default; // Deprecated in v5.3.2\n// scss-docs-end carousel-dark-variables\n\n// scss-docs-start sidebar-variables\n$sidebar-width:                            16rem !default;\n$sidebar-widths: (\n  sm: 12rem,\n  lg: 20rem,\n  xl: 24rem\n) !default;\n$sidebar-narrow-width:                     4rem !default;\n$sidebar-padding-y:                        $spacer !default;\n$sidebar-padding-x:                        $spacer !default;\n$sidebar-color:                            var(--#{$prefix}body-color) !default;\n$sidebar-bg:                               var(--#{$prefix}body-bg) !default;\n$sidebar-transition:                       margin-left .15s, margin-right .15s, box-shadow .075s, transform .15s, width .15s, z-index 0s ease .15s !default;\n$sidebar-brand-color:                      var(--#{$prefix}body-color) !default;\n$sidebar-brand-bg:                         rgba($black, .2) !default;\n$sidebar-backdrop-bg:                      $black !default;\n$sidebar-backdrop-opacity:                 .5 !default;\n$sidebar-overlaid-box-shadow:              var(--#{$prefix}box-shadow) !default;\n$sidebar-narrow-unfoldable-box-shadow:     var(--#{$prefix}box-shadow) !default;\n// scss-docs-end sidebar-variables\n\n// scss-docs-start sidebar-nav-variables\n$sidebar-nav-padding-y:                       $sidebar-padding-y * .5 !default;\n$sidebar-nav-padding-x:                       $sidebar-padding-x * .5 !default;\n$sidebar-nav-gap:                             1px !default;\n\n$sidebar-nav-title-padding-y:                 .75rem !default;\n$sidebar-nav-title-padding-x:                 1rem !default;\n$sidebar-nav-title-margin-top:                1rem !default;\n$sidebar-nav-title-color:                     var(--#{$prefix}tertiary-color) !default;\n$sidebar-nav-title-transition:                height .15s, margin .15s !default;\n\n$sidebar-nav-link-padding-y:                  .75rem !default;\n$sidebar-nav-link-padding-x:                  1rem !default;\n$sidebar-nav-link-color:                      var(--#{$prefix}body-color) !default;\n$sidebar-nav-link-bg:                         transparent !default;\n$sidebar-nav-link-border-width:               0 !default;\n$sidebar-nav-link-border-color:               transparent !default;\n$sidebar-nav-link-border-radius:              var(--#{$prefix}border-radius) !default;\n$sidebar-nav-link-transition:                 background .15s ease, color .15s ease, gap .15s ease !default;\n\n$sidebar-compact-nav-link-padding-y:          .5625rem !default;\n\n$sidebar-narrow-nav-link-padding-y:           .75rem !default;\n$sidebar-narrow-nav-link-padding-x:           .5rem !default;\n\n$sidebar-nav-link-icon-margin:                .75rem !default;\n$sidebar-nav-link-icon-color:                 var(--#{$prefix}tertiary-color) !default;\n$sidebar-nav-link-icon-width:                 1.25rem !default;\n$sidebar-nav-link-icon-height:                1.25rem !default;\n$sidebar-nav-link-icon-font-size:             $sidebar-nav-link-icon-height !default;\n\n$sidebar-nav-link-icon-bullet-size:           .3125rem !default;\n$sidebar-nav-link-icon-bullet-bg:             transparent !default;\n$sidebar-nav-link-icon-bullet-border-width:   1px !default;\n$sidebar-nav-link-icon-bullet-border-color:   var(--#{$prefix}tertiary-color) !default;\n$sidebar-nav-link-icon-bullet-border-radius:  50rem !default;\n\n$sidebar-nav-link-hover-color:                        var(--#{$prefix}emphasis-color) !default;\n$sidebar-nav-link-hover-bg:                           var(--#{$prefix}tertiary-bg) !default;\n$sidebar-nav-link-hover-icon-color:                   var(--#{$prefix}body-color) !default;\n$sidebar-nav-link-hover-icon-bullet-bg:               transparent !default;\n$sidebar-nav-link-hover-icon-bullet-border-color:     var(--#{$prefix}body-color) !default;\n\n$sidebar-nav-link-active-color:                       var(--#{$prefix}emphasis-color) !default;\n$sidebar-nav-link-active-bg:                          var(--#{$prefix}tertiary-bg) !default;\n$sidebar-nav-link-active-icon-color:                  var(--#{$prefix}emphasis-color) !default;\n$sidebar-nav-link-active-icon-bullet-bg:              transparent !default;\n$sidebar-nav-link-active-icon-bullet-border-color:    var(--#{$prefix}emphasis-color) !default;\n\n$sidebar-nav-link-disabled-color:                     var(--#{$prefix}tertiary-color) !default;\n$sidebar-nav-link-disabled-icon-color:                var(--#{$prefix}tertiary-color) !default;\n$sidebar-nav-link-disabled-icon-bullet-bg:            transparent !default;\n$sidebar-nav-link-disabled-icon-bullet-border-color:  var(--#{$prefix}tertiary-color) !default;\n\n$sidebar-nav-group-bg:                        transparent !default;\n$sidebar-nav-group-border-width:              0 !default;\n$sidebar-nav-group-border-color:              transparent !default;\n$sidebar-nav-group-border-radius:             var(--#{$prefix}border-radius) !default;\n$sidebar-nav-group-transition:                background .15s ease-in-out !default;\n$sidebar-nav-group-toggle-show-color:         $sidebar-nav-link-color !default;\n\n$sidebar-nav-group-items-padding-y:           0 !default;\n$sidebar-nav-group-items-padding-x:           0 !default;\n$sidebar-nav-group-items-transition:          height .15s ease !default;\n\n$sidebar-nav-group-indicator-color:           var(--#{$prefix}tertiary-color) !default;\n$sidebar-nav-group-indicator-icon:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708'/></svg>\") !default;\n$sidebar-nav-group-indicator-hover-color:     $sidebar-nav-link-hover-color !default;\n$sidebar-nav-group-indicator-hover-icon:      $sidebar-nav-group-indicator-icon !default;\n$sidebar-nav-group-indicator-transition:      transform .15s !default;\n// scss-docs-end sidebar-nav-variables\n\n// scss-docs-start sidebar-toggler\n$sidebar-toggler-width:             .5rem !default;\n$sidebar-toggler-height:            .5rem !default;\n$sidebar-toggler-padding-x:         .25rem !default;\n$sidebar-toggler-padding-y:         .25rem !default;\n$sidebar-toggler-bg:                transparent !default;\n$sidebar-toggler-color:             var(--#{$prefix}tertiary-color) !default;\n$sidebar-toggler-icon:              url(\"data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cg xmlns='http://www.w3.org/2000/svg' transform='matrix(-1 0 0 -1 512 512)'%3E%3Cpath fill='%23000' d='M472,16H40A24.028,24.028,0,0,0,16,40V200H48V48H464V464H48V304H16V472a24.028,24.028,0,0,0,24,24H472a24.028,24.028,0,0,0,24-24V40A24.028,24.028,0,0,0,472,16Z'/%3E%3Cpolygon fill='%23000' points='209.377 363.306 232.004 385.933 366.627 251.31 232.004 116.687 209.377 139.313 305.374 235.311 16 235.311 16 267.311 305.372 267.311 209.377 363.306'/%3E%3C/g%3E%3C/svg%3E\") !default;\n$sidebar-toggler-focus-shadow:      $focus-ring-box-shadow !default;\n$sidebar-toggler-hover-color:       var(--#{$prefix}secondary-color) !default;\n$sidebar-toggler-focus-color:       var(--#{$prefix}secondary-color) !default;\n$sidebar-toggler-transition:        transform .15s !default;\n// scss-docs-end sidebar-toggler\n\n// Footer\n// scss-docs-start footer-variables\n$footer-min-height:    3rem !default;\n$footer-padding-y:     $spacer * .5 !default;\n$footer-padding-x:     $spacer !default;\n$footer-bg:            var(--#{$prefix}tertiary-bg) !default;\n$footer-color:         var(--#{$prefix}body-color) !default;\n$footer-border-width:  var(--#{$prefix}border-width) !default;\n$footer-border-color:  var(--#{$prefix}border-color) !default;\n// scss-docs-end footer-variables\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-filter:           null !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default; // Deprecated in v5.3.2\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v4.2.6, removing in v6\n\n$pre-color:                         null !default;\n","// stylelint-disable property-disallowed-list\n@use \"sass:list\";\n@use \"sass:meta\";\n@use \"../variables\" as *;\n\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if meta.type-of($value) == number {\n      $return: list.append($return, max($value, 0));\n    } @else {\n      $return: list.append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-start-end-radius: valid-radius($radius);\n    border-end-end-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-start-start-radius: valid-radius($radius);\n    border-end-start-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-start-start-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-start-end-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-end-end-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-end-start-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","@use \"mixins/lists\" as *;\n@use \"vendor/rfs\" as *;\n@use \"reboot\" as *;\n@use \"variables\" as *;\n\n//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n    @include font-size($font-size);\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-inline-end: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-inline-start: 0;\n  list-style: none;\n}\n","@use \"mixins/border-radius\" as *;\n@use \"mixins/box-shadow\" as *;\n@use \"mixins/image\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: var(--#{$prefix}thumbnail-bg, $thumbnail-bg);\n  border: $thumbnail-border-width solid var(--#{$prefix}thumbnail-border-color, $thumbnail-border-color);\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: var(--#{$prefix}figure-caption-color, $figure-caption-color);\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","@use \"mixins/breakpoints\" as *;\n@use \"mixins/container\" as *;\n@use \"variables\" as *;\n\n// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","@use \"../variables\" as *;\n\n// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","@use \"sass:list\";\n@use \"sass:map\";\n@use \"../variables\" as *;\n\n// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map.keys($breakpoints)) {\n  $n: list.index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < list.length($breakpoint-names), list.nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map.get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map.get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n//\n// Container query mixins\n//\n\n// Container query for applying styles when the container’s inline size is at least the breakpoint’s minimum width.\n@mixin container-breakpoint-up($name, $breakpoints: $cq-grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @container (min-width: #{$min}) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Container query for applying styles when the container’s inline size is at most the breakpoint’s maximum width.\n@mixin container-breakpoint-down($name, $breakpoints: $cq-grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @container (max-width: #{$max}) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Container query for applying styles between two breakpoints.\n@mixin container-breakpoint-between($lower, $upper, $breakpoints: $cq-grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @container (min-width: #{$min}) and (max-width: #{$max}) {\n      @content;\n    }\n  } @else if $max == null {\n    // When the upper breakpoint is the last one.\n    @include container-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    // When the lower breakpoint is the smallest.\n    @include container-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Container query for applying styles only within a single breakpoint range.\n@mixin container-breakpoint-only($name, $breakpoints: $cq-grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max: breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @container (min-width: #{$min}) and (max-width: #{$max}) {\n      @content;\n    }\n  } @else if $max == null {\n    // Last breakpoint – no maximum query.\n    @include container-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    // First breakpoint – no minimum query.\n    @include container-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","@use \"mixins/grid\" as *;\n@use \"variables\" as *;\n\n$include-column-box-sizing: false !default;\n\n// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n\n  --#{$prefix}mobile-breakpoint: #{$mobile-breakpoint};\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready($include-column-box-sizing);\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n\n@if $enable-container-queries {\n  .cq-container {\n    container-type: inline-size;\n  }\n\n  .cq-row {\n    container-type: inline-size;\n    @include make-row();\n\n    > * {\n      @include make-col-ready($include-column-box-sizing);\n    }\n  }\n\n  @include make-c-grid-columns();\n}\n","@use \"sass:map\";\n@use \"sass:math\";\n@use \"sass:meta\";\n@use \"breakpoints\" as *;\n@use \"../functions/math\" as *;\n@use \"../maps\" as *;\n@use \"../variables\" as *;\n\n// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready($include-column-box-sizing: false) {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(meta.variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: math.percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-inline-start: if($num == 0, 0, math.percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: math.percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map.keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0;\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map.keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n\n@mixin make-c-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map.keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include container-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.cq-col-{bp}` classes for equal-width flexbox columns\n      .cq-col#{$infix} {\n        flex: 1 0 0;\n      }\n\n      .cq-row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .cq-row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .cq-col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .cq-col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .cq-offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.cq-g-*`, `.cq-gx-*` or `.cq-gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .cq-g#{$infix}-#{$key},\n        .cq-gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .cq-g#{$infix}-#{$key},\n        .cq-gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n","@use \"sass:map\";\n@use \"mixins/breakpoints\" as *;\n@use \"mixins/table-variants\" as *;\n@use \"variables\" as *;\n\n//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map.keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","@use \"sass:color\";\n@use \"sass:math\";\n@use \"../functions/color-contrast\" as *;\n@use \"../functions/contrast-ratio\" as *;\n@use \"../variables\" as *;\n\n// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: color.mix($color, $background, math.percentage($table-hover-bg-factor));\n    $striped-bg: color.mix($color, $background, math.percentage($table-striped-bg-factor));\n    $active-bg: color.mix($color, $background, math.percentage($table-active-bg-factor));\n    $table-border-color: color.mix($color, $background, math.percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","@use \"../functions/math\" as *;\n@use \"../vendor/rfs\" as *;\n@use \"../variables\" as *;\n\n//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","@use \"../vendor/rfs\" as *;\n@use \"../variables\" as *;\n\n//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","@use \"sass:math\";\n@use \"../mixins/border-radius\" as *;\n@use \"../mixins/box-shadow\" as *;\n@use \"../mixins/gradients\" as *;\n@use \"../mixins/transition\" as *;\n@use \"../vendor/rfs\" as *;\n@use \"../variables\" as *;\n\n//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(math.unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: var(--#{$prefix}input-placeholder-color, $input-placeholder-color);\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@use \"sass:list\";\n@use \"../variables\" as *;\n\n@mixin transition($transition...) {\n  @if list.length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if list.length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if list.nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and list.nth($transition, 1) != null and list.nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","@use \"../variables\" as *;\n\n// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","@use \"../functions/escape-svg\" as *;\n@use \"../mixins/border-radius\" as *;\n@use \"../mixins/box-shadow\" as *;\n@use \"../mixins/color-mode\" as *;\n@use \"../mixins/ltr-rtl\" as *;\n@use \"../mixins/transition\" as *;\n@use \"../vendor/rfs\" as *;\n@use \"../variables\" as *;\n@use \"../variables-dark\" as *;\n\n// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding-inline-start: $form-select-padding-x;\n  padding-inline-end: $form-select-indicator-padding;\n  padding-top: $form-select-padding-y;\n  padding-bottom: $form-select-padding-y;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  @include ltr-rtl-value-only(\"background-position\", $form-select-bg-position);\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-inline-end: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-inline-start: $form-select-padding-x-sm;\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-inline-start: $form-select-padding-x-lg;\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","@use \"sass:string\";\n@use \"../functions/str-replace\" as *;\n@use \"../variables\" as *;\n\n// Applies styles only when LTR is enabled and the HTML does NOT have the \"rtl\"\n// attribute (i.e., left-to-right contexts).\n\n@mixin ltr {\n  @if $enable-ltr {\n    html:not([dir=\"rtl\"]) & {\n      @content;\n    }\n  }\n}\n\n// Applies styles only when RTL is enabled and the element is within an RTL\n// context (i.e., the element is a descendant of an element with dir=\"rtl\").\n\n@mixin rtl {\n  @if $enable-rtl {\n    *[dir=\"rtl\"] & {\n      @content;\n    }\n  }\n}\n\n// This function takes an element (or string) and returns its \"mirrored\" version.\n// For example, it will replace \"left\" with \"right\" and vice versa.\n\n@function reflect($element) {\n  $string: #{$element};\n  @if string.index($string, \"left\") {\n    @return str-replace($string, \"left\", \"right\");\n  }\n  @if string.index($string, \"right\") {\n    @return str-replace($string, \"right\", \"left\");\n  }\n\n  @return string.unquote($string);\n}\n\n// Generates CSS for a given property with different values for LTR and RTL\n// contexts. Allows an optional custom property name and value for RTL.\n//\n// @param {String} $property - The CSS property for LTR context (e.g., margin-left).\n// @param {String} $value - The value for the property in LTR context.\n// @param {String} $property-rtl - Optional custom property name for RTL context.\n// @param {String} $value-rtl - Optional custom value for RTL context.\n// @param {Boolean} $important - Optional \"!important\" flag.\n\n@mixin ltr-rtl($property, $value, $property-rtl: null, $value-rtl: null, $important: false) {\n  $property-reflected: reflect($property);\n  $value-reflected: reflect($value);\n\n  @if $enable-ltr and $enable-rtl {\n    @include ltr() {\n      #{$property}: $value if($important, !important, null);\n    }\n    @include rtl() {\n      @if $value-rtl {\n        #{$property-reflected}: $value-rtl if($important, !important, null);\n      }\n      @else {\n        #{$property-reflected}: $value-reflected if($important, !important, null);\n      }\n    }\n  }\n  @else {\n    @if $enable-rtl {\n      @if $value-rtl {\n        #{$property-reflected}: $value-rtl if($important, !important, null);\n      }\n      @else {\n        #{$property-reflected}: $value-reflected if($important, !important, null);\n      }\n    }\n    @else {\n      #{$property}: $value if($important, !important, null);\n    }\n  }\n}\n\n// Similar to ltr-rtl but assumes the property name is the same for both\n// contexts. It only mirrors the value for RTL if a custom RTL value is not\n// provided.\n//\n// @param {String} $property - The CSS property to apply.\n// @param {String} $value - The value for the property in LTR context.\n// @param {String} $value-rtl - Optional custom value for RTL context.\n// @param {Boolean} $important - Optional \"!important\" flag.\n\n@mixin ltr-rtl-value-only($property, $value, $value-rtl: null, $important: false) {\n  $value-reflected: reflect($value);\n\n  @if $enable-ltr and $enable-rtl {\n    @include ltr() {\n      #{$property}: $value if($important, !important, null);\n    }\n    @include rtl() {\n      @if $value-rtl {\n        #{$property}: $value-rtl if($important, !important, null);\n      } @else {\n        #{$property}: $value-reflected if($important, !important, null);\n      }\n    }\n  }\n  @else {\n    @if $enable-rtl {\n      @if $value-rtl {\n        #{$property}: $value-rtl if($important, !important, null);\n      } @else {\n        #{$property}: $value-reflected if($important, !important, null);\n      }\n    } @else {\n      #{$property}: $value if($important, !important, null);\n    }\n  }\n}\n","@use \"sass:map\";\n@use \"../functions/escape-svg\" as *;\n@use \"../mixins/border-radius\" as *;\n@use \"../mixins/color-mode\" as *;\n@use \"../mixins/transition\" as *;\n@use \"../variables\" as *;\n@use \"../variables-dark\" as *;\n\n//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-inline-start: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: inline-start;\n    margin-inline-start: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-inline: 0 $form-check-padding-start;\n  text-align: end;\n\n  .form-check-input {\n    float: inline-end;\n    margin-inline: 0 $form-check-padding-start * -1;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: var(--#{$prefix}form-check-input-checked-bg-color, $form-check-input-checked-bg-color);\n    border-color: var(--#{$prefix}form-check-input-checked-border-color, $form-check-input-checked-border-color);\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: var(--#{$prefix}form-check-label-color, $form-check-label-color);\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-inline-start: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-inline-start: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-inline: 0 $form-switch-padding-start;\n\n    .form-check-input {\n      margin-inline: 0 $form-switch-padding-start * -1;\n    }\n  }\n}\n\n@each $size, $map in $form-switch-widths {\n  $width: map.get($map, \"width\");\n  $height: map.get($map, \"height\");\n\n  .form-switch-#{$size} {\n    min-height: $height;\n    padding-inline-start: $width + .5em;\n\n    .form-check-input {\n      width: $width;\n      height: $height;\n      margin-inline-start: ($width + .5em) * -1;\n    }\n\n    .form-check-label {\n      // stylelint-disable-next-line function-disallowed-list\n      padding-top: calc((#{$height} - #{$font-size-base}) / 2);\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-inline-end: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","@use \"../functions/math\" as *;\n@use \"../mixins/border-radius\" as *;\n@use \"../mixins/box-shadow\" as *;\n@use \"../mixins/gradients\" as *;\n@use \"../mixins/transition\" as *;\n@use \"../variables\" as *;\n\n// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n","@use \"../mixins/border-radius\" as *;\n@use \"../mixins/transition\" as *;\n@use \"../variables\" as *;\n\n.form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    inset-inline-start: 0;\n    top: 0;\n    z-index: 2;\n    max-width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-inline-start: $form-floating-padding-x;\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  > textarea:focus,\n  > textarea:not(:placeholder-shown) {\n    ~ label::after {\n      position: absolute;\n      inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n      z-index: -1;\n      height: $form-floating-label-height;\n      content: \"\";\n      background-color: $input-bg;\n      @include border-radius($input-border-radius);\n    }\n  }\n  > textarea:disabled ~ label::after {\n    background-color: $input-disabled-bg;\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n  }\n}\n","@use \"sass:map\";\n@use \"sass:string\";\n@use \"../mixins/border-radius\" as *;\n@use \"../vendor/rfs\" as *;\n@use \"../variables\" as *;\n\n//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: var(--#{$prefix}input-group-addon-color, $input-group-addon-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}input-group-addon-bg, $input-group-addon-bg);\n  border: $input-border-width solid var(--#{$prefix}input-group-addon-border-color, $input-group-addon-border-color);\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-inline-end: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map.keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + string.unquote($state) + \"-tooltip)\" + \":not(.\" + string.unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-inline-start: calc(-1 * #{$input-border-width}); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","@use \"../functions/escape-svg\" as *;\n@use \"../functions/math\" as *;\n@use \"../mixins/border-radius\" as *;\n@use \"../mixins/ltr-rtl\" as *;\n@use \"../vendor/rfs\" as *;\n@use \"../variables\" as *;\n\n// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color, $color-contrast-dark, $color-contrast-light, $white, $black, $min-contrast-ratio),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-inline-end: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        @include ltr-rtl-value-only(\"background-position\", right $input-height-inner-quarter center, left $input-height-inner-quarter center);\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-inline-end: $input-height-inner;\n        @include ltr-rtl-value-only(\"background-position\", top $input-height-inner-quarter right $input-height-inner-quarter, top $input-height-inner-quarter left $input-height-inner-quarter);\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-inline-end: $form-select-feedback-icon-padding-end;\n          @include ltr-rtl-value-only(\"background-position\", #{$form-select-bg-position, $form-select-feedback-icon-position});\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-inline-start: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","@use \"functions/color\" as *;\n@use \"mixins/border-radius\" as *;\n@use \"mixins/box-shadow\" as *;\n@use \"mixins/buttons\" as *;\n@use \"mixins/color-mode\" as *;\n@use \"mixins/gradients\" as *;\n@use \"mixins/transition\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n@use \"variables-dark\" as *;\n\n//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n.btn-ghost {\n  // scss-docs-start btn-ghost-css-vars\n  --#{$prefix}btn-color: #{$btn-ghost-color};\n  --#{$prefix}btn-border-color: #{transparent};\n  --#{$prefix}btn-active-color: #{$btn-ghost-active-color};\n  --#{$prefix}btn-active-bg: #{$btn-ghost-active-bg};\n  --#{$prefix}btn-active-border-color: #{$btn-ghost-active-bg};\n  --#{$prefix}btn-disabled-color: #{$btn-ghost-disabled-color};\n  --#{$prefix}btn-disabled-border-color: #{transparent};\n  --#{$prefix}btn-hover-color: #{$btn-ghost-hover-color};\n  --#{$prefix}btn-hover-bg: #{$btn-ghost-hover-bg};\n  --#{$prefix}btn-hover-border-color: #{$btn-ghost-hover-bg};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(#{$btn-outline-focus-shadow-rgb}, .5);\n  // scss-docs-end btn-ghost-css-vars\n}\n\n.btn-outline {\n  // scss-docs-start btn-outline-css-vars\n  --#{$prefix}btn-color: #{$btn-outline-color};\n  --#{$prefix}btn-border-color: #{$btn-outline-border-color};\n  --#{$prefix}btn-active-color: #{$btn-outline-active-color};\n  --#{$prefix}btn-active-bg: #{$btn-outline-active-bg};\n  --#{$prefix}btn-active-border-color: #{$btn-outline-active-border-color};\n  --#{$prefix}btn-disabled-color: #{$btn-outline-disabled-color};\n  --#{$prefix}btn-disabled-border-color: #{$btn-outline-disabled-border-color};\n  --#{$prefix}btn-hover-color: #{$btn-outline-hover-color};\n  --#{$prefix}btn-hover-bg: #{$btn-outline-hover-bg};\n  --#{$prefix}btn-hover-border-color: #{$btn-outline-hover-border-color};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(#{$btn-ghost-focus-shadow-rgb}, .5);\n  // scss-docs-end btn-outline-css-vars\n}\n\n.btn-transparent {\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-hover-border-color: transparent;\n}\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-ghost-#{$color} {\n    @include button-ghost-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: none;\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @each $color, $value in $theme-colors-dark {\n      .btn-#{$color} {\n        @include button-variant($value, $value);\n      }\n    }\n\n    @each $color, $value in $theme-colors-dark {\n      .btn-outline-#{$color} {\n        @include button-outline-variant($value);\n      }\n    }\n\n    @each $color, $value in $theme-colors-dark {\n      .btn-ghost-#{$color} {\n        @include button-ghost-variant($value);\n      }\n    }\n  }\n}\n","@use \"sass:color\";\n@use \"../functions/color\" as *;\n@use \"../functions/color-contrast\" as *;\n@use \"../functions/to-rgb\" as *;\n@use \"../vendor/rfs\" as *;\n@use \"../variables\" as *;\n\n// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(color.mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-ghost-variant-mixin\n@mixin button-ghost-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $hover-background: $color,\n  $hover-border: $color,\n  $hover-color: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($color)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: transparent;\n}\n// scss-docs-end btn-ghost-variant-mixin\n\n// Button sizes\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n","@use \"mixins/transition\" as *;\n@use \"variables\" as *;\n\n.fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","@use \"sass:map\";\n@use \"mixins/border-radius\" as *;\n@use \"mixins/box-shadow\" as *;\n@use \"mixins/breakpoints\" as *;\n@use \"mixins/caret\" as *;\n@use \"mixins/gradients\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: start; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data#{$data-infix}popper] {\n    inset-inline-start: 0;\n    top: 100%;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `cui-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map.keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --#{$prefix}position: start;\n\n      &[data#{$data-infix}popper] {\n        inset-inline-start: 0;\n        inset-inline-end: auto;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --#{$prefix}position: end;\n\n      &[data#{$data-infix}popper] {\n        inset-inline-start: auto;\n        inset-inline-end: 0;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data#{$data-infix}popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data#{$data-infix}popper] {\n    inset-inline-start: 100%;\n    inset-inline-end: auto;\n    top: 0;\n    margin-inline-start: var(--#{$prefix}dropdown-spacer);\n    margin-top: 0;\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data#{$data-infix}popper] {\n    inset-inline-start: auto;\n    inset-inline-end: 100%;\n    top: 0;\n    margin-inline-end: var(--#{$prefix}dropdown-spacer);\n    margin-top: 0;\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","@use \"../variables\" as *;\n\n// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-inline-start: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-inline-end: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-inline-start: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","@use \"mixins/border-radius\" as *;\n@use \"mixins/box-shadow\" as *;\n@use \"buttons\" as *;\n@use \"variables\" as *;\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-inline-start: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-inline-start: 0;\n  }\n\n  .dropstart &::before {\n    margin-inline-end: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  // The top radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","@use \"mixins/border-radius\" as *;\n@use \"mixins/gradients\" as *;\n@use \"mixins/transition\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-inline-start: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Underline border\n//\n\n.nav-underline-border {\n  // scss-docs-start nav-underline-border-css-vars\n  --#{$prefix}nav-underline-border-gap: #{$nav-underline-border-gap};\n  --#{$prefix}nav-underline-border-border-color: #{$nav-underline-border-border-color};\n  --#{$prefix}nav-underline-border-border-width: #{$nav-underline-border-border-width};\n  --#{$prefix}nav-underline-border-link-padding-x: #{$nav-underline-border-link-padding-x};\n  --#{$prefix}nav-underline-border-link-padding-y: #{$nav-underline-border-link-padding-y};\n  --#{$prefix}nav-underline-border-link-color: #{$nav-underline-border-link-color};\n  --#{$prefix}nav-underline-border-link-active-color: #{$nav-underline-border-link-active-color};\n  --#{$prefix}nav-underline-border-link-disabled-color: #{$nav-underline-border-link-disabled-color};\n  // scss-docs-end nav-underline-border-css-vars\n\n  --#{$prefix}nav-link-color: var(--#{$prefix}nav-underline-border-link-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}nav-underline-border-link-disabled-color);\n\n  gap: var(--#{$prefix}nav-underline-border-gap);\n  border-bottom: var(--#{$prefix}nav-underline-border-border-width) solid var(--#{$prefix}nav-underline-border-border-color);\n\n  .nav-link {\n    padding: var(--#{$prefix}nav-underline-border-link-padding-y) var(--#{$prefix}nav-underline-border-link-padding-x);\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-underline-border-border-width)); // stylelint-disable-line function-disallowed-list\n    border-bottom: var(--#{$prefix}nav-underline-border-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-border-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Enclosed\n//\n\n.nav-enclosed {\n  --#{$prefix}nav-enclosed-padding: #{$nav-enclosed-padding};\n  --#{$prefix}nav-enclosed-bg: #{$nav-enclosed-bg};\n  --#{$prefix}nav-enclosed-border-radius: #{$nav-enclosed-border-radius};\n  --#{$prefix}nav-enclosed-link-padding-x: #{$nav-enclosed-link-padding-x};\n  --#{$prefix}nav-enclosed-link-padding-y: #{$nav-enclosed-link-padding-y};\n  --#{$prefix}nav-enclosed-link-color: #{$nav-enclosed-link-color};\n  --#{$prefix}nav-enclosed-link-border-width: #{$nav-enclosed-link-border-width};\n  --#{$prefix}nav-enclosed-link-active-color: #{$nav-enclosed-link-active-color};\n  --#{$prefix}nav-enclosed-link-active-bg: #{$nav-enclosed-link-active-bg};\n  --#{$prefix}nav-enclosed-link-active-border-color: #{$nav-enclosed-link-active-border-color};\n  --#{$prefix}nav-enclosed-link-hover-box-shadow: #{$nav-enclosed-link-hover-box-shadow};\n  --#{$prefix}nav-enclosed-link-disabled-color: #{$nav-enclosed-link-disabled-color};\n\n  display: inline-flex;\n  padding: var(--#{$prefix}nav-enclosed-padding);\n  background-color: var(--#{$prefix}nav-enclosed-bg);\n  @include border-radius(var(--#{$prefix}nav-enclosed-border-radius));\n\n  .nav-link {\n    padding: calc(var(--#{$prefix}nav-enclosed-link-padding-y) - var(--#{$prefix}nav-enclosed-link-border-width)) calc(var(--#{$prefix}nav-enclosed-link-padding-x) - var(--#{$prefix}nav-enclosed-link-border-width)); // stylelint-disable-line function-disallowed-list\n    color: var(--#{$prefix}nav-enclosed-link-color);\n    border: var(--#{$prefix}nav-enclosed-link-border-width) solid transparent;\n    @include border-radius(calc(var(--#{$prefix}nav-enclosed-border-radius) - var(--#{$prefix}nav-enclosed-padding)));\n\n    &.disabled {\n      color: var(--#{$prefix}nav-enclosed-link-disabled-color);\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-enclosed-link-active-color);\n    background-color: var(--#{$prefix}nav-enclosed-link-active-bg);\n    border: 1px solid var(--#{$prefix}nav-enclosed-link-active-border-color);\n\n    &:not(:focus-visible) {\n      box-shadow: var(--#{$prefix}nav-enclosed-link-hover-box-shadow);\n    }\n  }\n}\n\n// Enclosed pills\n\n.nav-enclosed-pills {\n  --#{$prefix}nav-enclosed-border-radius: #{$border-radius-pill};\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-grow: 1;\n    flex-basis: 0;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","@use \"sass:map\";\n@use \"functions/escape-svg\" as *;\n@use \"mixins/border-radius\" as *;\n@use \"mixins/box-shadow\" as *;\n@use \"mixins/breakpoints\" as *;\n@use \"mixins/color-mode\" as *;\n@use \"mixins/deprecate\" as *;\n@use \"mixins/gradients\" as *;\n@use \"mixins/transition\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-inline-end: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-inline-start: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-grow: 1;\n  flex-basis: 100%;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map.keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v4.2.6\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data#{$data-infix}theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","@use \"mixins/border-radius\" as *;\n@use \"mixins/box-shadow\" as *;\n@use \"mixins/breakpoints\" as *;\n@use \"variables\" as *;\n\n//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-inline-start: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      flex: 1 0 0;\n      margin-bottom: 0;\n\n      + .card {\n        margin-inline-start: 0;\n        border-inline-start: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          > .card-img-bottom,\n          > card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","@use \"functions/escape-svg\" as *;\n@use \"mixins/border-radius\" as *;\n@use \"mixins/color-mode\" as *;\n@use \"mixins/transition\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n@use \"variables-dark\" as *;\n\n//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: start; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-inline-start: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-collapse,\n    > .accordion-header .accordion-button,\n    > .accordion-header .accordion-button.collapsed {\n      @include border-radius(0);\n    }\n    // stylelint-enable selector-max-class\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n","@use \"functions/escape-svg\" as *;\n@use \"mixins/border-radius\" as *;\n@use \"mixins/ltr-rtl\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n.breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-inline-start: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: inline-start; // Suppress inline spacings and underlining of the separator\n      padding-inline-end: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      @include ltr-rtl(\n        \"content\",\n        var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)),\n        null,\n        var(--#{$prefix}breadcrumb-divider-flipped, escape-svg($breadcrumb-divider-flipped))\n      );\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n","@use \"mixins/border-radius\" as *;\n@use \"mixins/gradients\" as *;\n@use \"mixins/lists\" as *;\n@use \"mixins/pagination\" as *;\n@use \"mixins/transition\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n.pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-inline-start: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(-1 * #{$pagination-border-width}) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","@use \"../vendor/rfs\" as *;\n@use \"../variables\" as *;\n\n// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","@use \"mixins/gradients\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--#{$prefix}badge-border-radius, 0); // stylelint-disable-line property-disallowed-list\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n//\n// Badge Sizes\n//\n\n.badge-sm {\n  --#{$prefix}badge-padding-x: #{$badge-padding-x-sm};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y-sm};\n  @include font-size($badge-font-size-sm);\n}\n","@use \"sass:map\";\n@use \"mixins/border-radius\" as *;\n@use \"variables\" as *;\n\n//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-inline-end: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    inset-inline-end: 0;\n    top: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert.\n@each $state in map.keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","@use \"mixins/border-radius\" as *;\n@use \"mixins/box-shadow\" as *;\n@use \"mixins/gradients\" as *;\n@use \"mixins/transition\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: var(--#{$prefix}progress-height); }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n\n.progress-thin {\n  height: 4px;\n}\n\n// White progress bar\n.progress.progress-white {\n  background-color: rgba(255, 255, 255, .2);\n  .progress-bar {\n    background-color: $white;\n  }\n}\n\n.progress-group {\n  display: flex;\n  flex-flow: row wrap;\n  margin-bottom: $progress-group-margin-bottom;\n}\n\n.progress-group-prepend {\n  flex: 0 0 100px;\n  align-self: center;\n}\n\n.progress-group-header {\n  display: flex;\n  flex-basis: 100%;\n  align-items: center;\n  margin-bottom: $progress-group-header-margin-bottom;\n}\n\n.progress-group-bars {\n  flex-grow: 1;\n  align-self: center;\n\n  .progress:not(:last-child) {\n    margin-bottom: 2px;\n  }\n}\n\n.progress-group-header + .progress-group-bars {\n  flex-basis: 100%;\n}\n","@use \"sass:map\";\n@use \"mixins/border-radius\" as *;\n@use \"mixins/breakpoints\" as *;\n@use \"variables\" as *;\n\n// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-inline-start: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  &:not(.active) {\n    // Hover state\n    &:hover,\n    &:focus {\n      z-index: 1; // Place hover/focus items above their siblings for proper border styling\n      color: var(--#{$prefix}list-group-action-hover-color);\n      text-decoration: none;\n      background-color: var(--#{$prefix}list-group-action-hover-bg);\n    }\n\n    &:active {\n      color: var(--#{$prefix}list-group-action-active-color);\n      background-color: var(--#{$prefix}list-group-action-active-bg);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map.keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-inline-start-width: 0;\n          border-top-width: var(--#{$prefix}list-group-border-width);\n\n          &.active {\n            margin-inline-start: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-inline-start-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map.keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","@use \"functions/escape-svg\" as *;\n@use \"mixins/border-radius\" as *;\n@use \"mixins/color-mode\" as *;\n@use \"variables\" as *;\n@use \"variables-dark\" as *;\n\n// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  filter: var(--#{$prefix}btn-close-filter);\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter-dark};\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n:root,\n[data#{$data-infix}theme=\"light\"] {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include btn-close-white();\n  }\n}\n","@use \"mixins/border-radius\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n.toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-inline: var(--#{$prefix}toast-padding-x) calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n@use \"sass:map\";\n@use \"mixins/backdrop\" as *;\n@use \"mixins/border-radius\" as *;\n@use \"mixins/box-shadow\" as *;\n@use \"mixins/breakpoints\" as *;\n@use \"mixins/transition\" as *;\n@use \"variables\" as *;\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  inset-inline-start: 0;\n  top: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    transform: $modal-fade-transform;\n    @include transition($modal-transition);\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin-inline-start: auto;\n    margin-inline-end: calc(-.5 * var(--#{$prefix}modal-header-padding-x));\n    margin-top: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-bottom: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map.keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","@use \"../variables\" as *;\n\n// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","@use \"mixins/border-radius\" as *;\n@use \"mixins/deprecate\" as *;\n@use \"mixins/reset-text\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v4\", \"v4.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@use \"../variables\" as *;\n\n@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n","@use \"mixins/border-radius\" as *;\n@use \"mixins/box-shadow\" as *;\n@use \"mixins/reset-text\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n.popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","@use \"functions/escape-svg\" as *;\n@use \"mixins/clearfix\" as *;\n@use \"mixins/color-mode\" as *;\n@use \"mixins/ltr-rtl\" as *;\n@use \"mixins/transition\" as *;\n@use \"variables\" as *;\n@use \"variables-dark\" as *;\n\n// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  filter: var(--#{$prefix}carousel-control-icon-filter);\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  @include ltr-rtl-value-only(\"background-image\", escape-svg($carousel-control-prev-icon-bg), escape-svg($carousel-control-next-icon-bg));\n}\n.carousel-control-next-icon {\n  @include ltr-rtl-value-only(\"background-image\", escape-svg($carousel-control-next-icon-bg), escape-svg($carousel-control-prev-icon-bg));\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data#{$data-infix}target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data#{$data-infix}target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: var(--#{$prefix}carousel-caption-color);\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg-dark};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color-dark};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter-dark};\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n:root,\n[data#{$data-infix}theme=\"light\"] {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include carousel-dark();\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","@use \"variables\" as *;\n\n//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n@use \"sass:map\";\n@use \"mixins/backdrop\" as *;\n@use \"mixins/box-shadow\" as *;\n@use \"mixins/breakpoints\" as *;\n@use \"mixins/ltr-rtl\" as *;\n@use \"mixins/transition\" as *;\n@use \"variables\" as *;\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map.keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map.keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        inset-inline-start: 0;\n        top: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-inline-end: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        @include ltr-rtl-value-only(\"transform\", translateX(-100%), translateX(100%));\n      }\n\n      &.offcanvas-end {\n        inset-inline-end: 0;\n        top: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-inline-start: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none !important; // stylelint-disable-line declaration-no-important\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, var(--#{$prefix}offcanvas-backdrop-bg, $offcanvas-backdrop-bg), $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-inline-start: auto;\n    margin-inline-end: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n","@use \"variables\" as *;\n\n.placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","@use \"sass:map\";\n@use \"mixins/border-radius\" as *;\n@use \"mixins/transition\" as *;\n@use \"variables\" as *;\n\n.avatar {\n  // scss-docs-start avatar-css-vars\n  --#{$prefix}avatar-width: #{$avatar-width};\n  --#{$prefix}avatar-height: #{$avatar-height};\n  --#{$prefix}avatar-font-size: #{$avatar-font-size};\n  --#{$prefix}avatar-border-radius: #{$avatar-border-radius};\n  --#{$prefix}avatar-status-width: #{$avatar-status-width};\n  --#{$prefix}avatar-status-height: #{$avatar-status-height};\n  --#{$prefix}avatar-status-border-radius: #{$avatar-status-border-radius};\n  // scss-docs-end avatar-css-vars\n\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--#{$prefix}avatar-width);\n  height: var(--#{$prefix}avatar-height);\n  font-size: var(--#{$prefix}avatar-font-size);\n  vertical-align: middle;\n  @include border-radius(var(--#{$prefix}avatar-border-radius));\n  @include transition($avatar-transition);\n}\n\n.avatar-img {\n  width: 100%;\n  height: auto;\n  @include border-radius(var(--#{$prefix}avatar-border-radius));\n}\n\n.avatar-status {\n  position: absolute;\n  inset-inline-end: 0;\n  bottom: 0;\n  display: block;\n  width: var(--#{$prefix}avatar-status-width);\n  height: var(--#{$prefix}avatar-status-height);\n  border: 1px solid $white;\n  @include border-radius(var(--#{$prefix}avatar-status-border-radius));\n}\n\n@each $size, $map in $avatar-sizes {\n  .avatar-#{$size} {\n    --#{$prefix}avatar-width: #{map.get($map, \"width\")};\n    --#{$prefix}avatar-height: #{map.get($map, \"height\")};\n    --#{$prefix}avatar-font-size: #{map.get($map, \"font-size\")};\n    --#{$prefix}avatar-status-width: #{map.get($map, \"status-width\")};\n    --#{$prefix}avatar-status-height: #{map.get($map, \"status-height\")};\n  }\n}\n\n.avatars-stack {\n  display: flex;\n\n  .avatar {\n    margin-inline-end: calc(-.4 * var(--#{$prefix}avatar-width)); // stylelint-disable-line function-disallowed-list\n\n    &:hover {\n      margin-inline-end: 0;\n    }\n  }\n}\n","@use \"mixins/border-radius\" as *;\n@use \"variables\" as *;\n\n.callout {\n  // scss-docs-start callout-css-vars\n  --#{$prefix}callout-padding-x: #{$callout-padding-x};\n  --#{$prefix}callout-padding-y: #{$callout-padding-y};\n  --#{$prefix}callout-margin-x: #{$callout-margin-x};\n  --#{$prefix}callout-margin-y: #{$callout-margin-y};\n  --#{$prefix}callout-border-width: #{$callout-border-width};\n  --#{$prefix}callout-border-color: #{$callout-border-color};\n  --#{$prefix}callout-border-left-width: #{$callout-border-left-width};\n  --#{$prefix}callout-border-radius: #{$callout-border-radius};\n  // scss-docs-end callout-css-vars\n\n  padding: var(--#{$prefix}callout-padding-y) var(--#{$prefix}callout-padding-x);\n  margin: var(--#{$prefix}callout-margin-y) var(--#{$prefix}callout-margin-x);\n  border: var(--#{$prefix}callout-border-width) solid var(--#{$prefix}callout-border-color);\n  border-inline-start-color: var(--#{$prefix}callout-border-left-color);\n  border-inline-start-width: var(--#{$prefix}callout-border-left-width);\n  @include border-radius(var(--#{$prefix}callout-border-radius));\n}\n\n// scss-docs-start callout-modifiers\n// Generate contextual modifier classes for colorizing the collor.\n@each $state, $value in $callout-variants {\n  .callout-#{$state} {\n    --#{$prefix}callout-border-left-color: #{$value};\n  }\n}\n// scss-docs-end callout-modifiers\n","@use \"variables\" as *;\n\n.footer {\n  // scss-docs-start footer-css-vars\n  --#{$prefix}footer-min-height: #{$footer-min-height};\n  --#{$prefix}footer-padding-x: #{$footer-padding-x};\n  --#{$prefix}footer-padding-y: #{$footer-padding-y};\n  --#{$prefix}footer-color: #{$footer-color};\n  --#{$prefix}footer-bg: #{$footer-bg};\n  --#{$prefix}footer-border-color: #{$footer-border-color};\n  --#{$prefix}footer-border: #{$footer-border-width} solid var(--#{$prefix}footer-border-color);\n  // scss-docs-end footer-css-vars\n\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between;\n  min-height: var(--#{$prefix}footer-min-height);\n  padding: var(--#{$prefix}footer-padding-y) var(--#{$prefix}footer-padding-x);\n  color: var(--#{$prefix}footer-color);\n  background: var(--#{$prefix}footer-bg);\n  border-top: var(--#{$prefix}footer-border);\n}\n\n.footer-fixed {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.footer-sticky {\n  position: sticky;\n  bottom: 0;\n  z-index: $zindex-fixed;\n}\n","@use \"functions/escape-svg\" as *;\n@use \"mixins/border-radius\" as *;\n@use \"mixins/breakpoints\" as *;\n@use \"mixins/transition\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n.header {\n  // scss-docs-start header-css-vars\n  --#{$prefix}header-padding-x: #{$header-padding-x};\n  --#{$prefix}header-padding-y: #{$header-padding-y};\n  --#{$prefix}header-bg: #{$header-bg};\n  --#{$prefix}header-color: #{$header-color};\n  --#{$prefix}header-border-color: #{$header-border-color};\n  --#{$prefix}header-border: #{$header-border-width} solid var(--#{$prefix}header-border-color);\n  --#{$prefix}header-hover-color: #{$header-hover-color};\n  --#{$prefix}header-disabled-color: #{$header-disabled-color};\n  --#{$prefix}header-active-color: #{$header-active-color};\n  --#{$prefix}header-transition: #{$header-transition};\n  --#{$prefix}header-brand-padding-y: #{$header-brand-padding-y};\n  --#{$prefix}header-brand-color: #{$header-brand-color};\n  --#{$prefix}header-brand-hover-color: #{$header-brand-hover-color};\n  --#{$prefix}header-toggler-padding-x: #{$header-toggler-padding-x};\n  --#{$prefix}header-toggler-padding-y: #{$header-toggler-padding-y};\n  --#{$prefix}header-toggler-bg: #{$header-toggler-bg};\n  --#{$prefix}header-toggler-color: #{$header-toggler-color};\n  --#{$prefix}header-toggler-border-radius: #{$header-toggler-border-radius};\n  --#{$prefix}header-toggler-hover-color: #{$header-toggler-hover-color};\n  --#{$prefix}header-toggler-icon-bg: #{escape-svg($header-toggler-icon-bg)};\n  --#{$prefix}header-toggler-hover-icon-bg: #{escape-svg($header-toggler-hover-icon-bg)};\n  --#{$prefix}header-nav-link-padding-x: #{$header-nav-link-padding-x};\n  --#{$prefix}header-nav-link-padding-y: #{$header-nav-link-padding-y};\n  --#{$prefix}header-divider-border-color: #{$header-divider-border-color};\n  --#{$prefix}header-divider-border: #{$header-divider-border-width} solid var(--#{$prefix}header-divider-border-color);\n  // scss-docs-end header-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}header-padding-y) var(--#{$prefix}header-padding-x);\n  background: var(--#{$prefix}header-bg);\n  border-bottom: var(--#{$prefix}header-border);\n  @include transition(var(--#{$prefix}header-transition));\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n\n  &.header-sticky {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-sticky;\n  }\n}\n\n.header-divider {\n  flex-basis: calc(100% + (2 * var(--#{$prefix}header-padding-x))); // stylelint-disable-line function-disallowed-list\n  height: 0;\n  margin: var(--#{$prefix}header-padding-y) calc(-1 * var(--#{$prefix}header-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-top: var(--#{$prefix}header-divider-border);\n}\n\n// Header brand\n//\n// Used for brand, project, or site names.\n\n.header-brand {\n  padding-top: var(--#{$prefix}header-brand-padding-y);\n  padding-bottom: var(--#{$prefix}header-brand-padding-y);\n  margin-inline-end: $header-brand-margin-end;\n  @include font-size($header-brand-font-size);\n  color: var(--#{$prefix}header-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}header-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n// Header nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.header-nav {\n  display: flex;\n  flex-direction: row; // cannot use `inherit` to get the `.header`s value\n  padding-inline-start: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding: var(--#{$prefix}header-nav-link-padding-y) var(--#{$prefix}header-nav-link-padding-x);\n    color: var(--#{$prefix}header-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}header-hover-color);\n    }\n\n    &.disabled {\n      color: var(--#{$prefix}header-disabled-color);\n    }\n  }\n\n  .show > .nav-link,\n  .nav-link.active {\n    color: var(--#{$prefix}header-active-color);\n  }\n\n  .dropdown-menu {\n    position: absolute;\n  }\n}\n\n\n// Header text\n//\n//\n\n.header-text {\n  padding-top: var(--#{$prefix}header-nav-link-padding-y);\n  padding-bottom: var(--#{$prefix}header-nav-link-padding-y);\n  color: var(--#{$prefix}header-color);\n\n  a {\n    color: var(--#{$prefix}header-active-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}header-active-color);\n    }\n  }\n}\n\n.header-toggler {\n  padding: var(--#{$prefix}header-toggler-padding-y) var(--#{$prefix}header-toggler-padding-x);\n  @include font-size($header-toggler-font-size);\n  color: var(--#{$prefix}header-toggler-color);\n  background-color: var(--#{$prefix}header-toggler-bg);\n  border: 0; // remove default button style\n  @include border-radius(var(--#{$prefix}header-toggler-border-radius));\n\n  &:hover {\n    color: var(--#{$prefix}header-toggler-hover-color);\n    text-decoration: none;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  // Opinionated: add \"hand\" cursor to non-disabled .navbar-toggler elements\n  &:not(:disabled) {\n    cursor: pointer;\n  }\n}\n\n.header-toggler-icon {\n  display: block;\n  height: $header-toggler-font-size * 1.25;\n  background-image: var(--#{$prefix}header-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 100% 100%;\n\n  &:hover {\n    background-image: var(--#{$prefix}header-toggler-hover-icon-bg);\n  }\n}\n","@use \"mixins/icon\" as *;\n@use \"variables\" as *;\n\n.icon {\n  display: inline-block;\n  color: inherit;\n  text-align: center;\n  vertical-align: -.125rem; // Fix the position of icon\n  fill: currentcolor;\n  &:not(.icon-c-s):not(.icon-custom-size) {\n    @include icon-size($icon-size-base);\n\n    &.icon-xxl {\n      @include icon-size($icon-size-xxl);\n    }\n\n    &.icon-xl {\n      @include icon-size($icon-size-xl);\n    }\n\n    &.icon-lg {\n      @include icon-size($icon-size-lg);\n    }\n\n    &.icon-sm {\n      @include icon-size($icon-size-sm);\n    }\n\n    @for $i from 3 through 9 {\n      &.icon-#{$i}xl {\n        @include icon-size($i * $icon-size-base);\n      }\n    }\n  }\n}\n","// Icon sizes\n@mixin icon-size($icon-size) {\n  width: $icon-size;\n  height: $icon-size;\n  font-size: $icon-size;\n}\n","// stylelint-disable function-disallowed-list\n@use \"../functions/escape-svg\" as *;\n@use \"../mixins/backdrop\" as *;\n@use \"../mixins/border-radius\" as *;\n@use \"../mixins/breakpoints\" as *;\n@use \"../mixins/ltr-rtl\" as *;\n@use \"../mixins/transition\" as *;\n@use \"../variables\" as *;\n@use \"../variables-dark\" as *;\n\n.sidebar {\n  // scss-docs-start sidebar-css-vars\n  --#{$prefix}sidebar-zindex: #{$zindex-sidebar};\n  --#{$prefix}sidebar-width: #{$sidebar-width};\n  --#{$prefix}sidebar-bg: #{$sidebar-bg};\n  --#{$prefix}sidebar-padding-x: #{$sidebar-padding-x};\n  --#{$prefix}sidebar-padding-y: #{$sidebar-padding-y};\n  --#{$prefix}sidebar-color: #{$sidebar-color};\n  --#{$prefix}sidebar-brand-color: #{$sidebar-brand-color};\n  --#{$prefix}sidebar-brand-bg: #{$sidebar-brand-bg};\n  // scss-docs-end sidebar-css-vars\n\n  position: relative;\n  display: flex;\n  flex: 0 0 var(--#{$prefix}sidebar-width);\n  flex-direction: column;\n  // put the nav on the left\n  order: -1;\n  width: var(--#{$prefix}sidebar-width);\n  color: var(--#{$prefix}sidebar-color);\n  background: var(--#{$prefix}sidebar-bg);\n  box-shadow: none;\n  @include transition($sidebar-transition);\n\n  &:not(.sidebar-end){\n    margin-inline-start: 0;\n  }\n\n  &.sidebar-end {\n    order: 99;\n    margin-inline-end: 0;\n  }\n\n  @include media-breakpoint-up($mobile-breakpoint) {\n    &:not(.hide):not(.sidebar-narrow):not(.sidebar-narrow-unfoldable):not(.sidebar-overlaid) {\n      &:not(.sidebar-end) ~ * {\n        --#{$prefix}sidebar-occupy-start: #{$sidebar-width};\n      }\n      &.sidebar-end ~ * {\n        --#{$prefix}sidebar-occupy-end: #{$sidebar-width};\n      }\n    }\n\n    &.hide {\n      &:not(.sidebar-end) {\n        margin-inline-start: calc(-1 * var(--#{$prefix}sidebar-width));\n      }\n      &.sidebar-end {\n        margin-inline-end: calc(-1 * var(--#{$prefix}sidebar-width));\n\n      }\n    }\n  }\n\n  @include media-breakpoint-down($mobile-breakpoint) {\n    // Some of our components use this property to detect if the sidebar has mobile behavior.\n    --#{$prefix}is-mobile: true;\n\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    z-index: var(--#{$prefix}sidebar-zindex);\n\n    &:not(.sidebar-end) {\n      inset-inline-start: 0;\n\n      &:not(.show) {\n        margin-inline-start: calc(-1 * var(--#{$prefix}sidebar-width));\n      }\n    }\n\n    &.sidebar-end {\n      inset-inline-end: 0;\n\n      &:not(.show) {\n        margin-inline-end: calc(-1 * var(--#{$prefix}sidebar-width));\n      }\n    }\n  }\n}\n\n.sidebar-fixed {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  z-index: var(--#{$prefix}sidebar-zindex);\n\n  &:not(.sidebar-end) {\n    inset-inline-start: 0;\n  }\n\n  &.sidebar-end {\n    inset-inline-end: 0;\n  }\n}\n\n.sidebar-overlaid {\n  // scss-docs-start sidebar-overlaid-css-vars\n  --#{$prefix}sidebar-overlaid-box-shadow: #{$sidebar-overlaid-box-shadow};\n  // scss-docs-end sidebar-overlaid-css-vars\n\n  @extend .sidebar-fixed;\n\n  &:not(.sidebar-end){\n    margin-inline-start: calc(-1 * var(--#{$prefix}sidebar-width));\n  }\n\n  &.sidebar-end {\n    margin-inline-end: calc(-1 * var(--#{$prefix}sidebar-width));\n  }\n\n  &.show {\n    box-shadow: var(--#{$prefix}sidebar-overlaid-box-shadow);\n\n    &:not(.sidebar-end) {\n      margin-inline-start: 0;\n    }\n\n    &.sidebar-end {\n      margin-inline-end: 0;\n    }\n  }\n}\n\n@each $width, $value in $sidebar-widths {\n  .sidebar-#{$width} {\n    --#{$prefix}sidebar-width: #{$value};\n\n    @include media-breakpoint-up($mobile-breakpoint) {\n      &:not(.hide):not(.sidebar-narrow):not(.sidebar-narrow-unfoldable):not(.sidebar-overlaid) {\n        &:not(.sidebar-end) ~ * {\n          --#{$prefix}sidebar-occupy-start: #{$value};\n        }\n        &.sidebar-end ~ * {\n          --#{$prefix}sidebar-occupy-end: #{$value};\n        }\n      }\n    }\n  }\n}\n\n.sidebar-brand {\n  color: var(--#{$prefix}sidebar-brand-color);\n  white-space: nowrap;\n\n  .sidebar-brand-narrow {\n    display: none;\n  }\n}\n\n.sidebar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}sidebar-padding-y) var(--#{$prefix}sidebar-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}sidebar-padding-y) * .5) calc(var(--#{$prefix}sidebar-padding-x) * .5);\n    margin-inline-end: calc(-.5 * var(--#{$prefix}sidebar-padding-x));\n    margin-top: calc(-.5 * var(--#{$prefix}sidebar-padding-y));\n    margin-bottom: calc(-.5 * var(--#{$prefix}sidebar-padding-y));\n  }\n}\n\n.sidebar-body {\n  padding: var(--#{$prefix}sidebar-padding-y) var(--#{$prefix}sidebar-padding-x);\n}\n\n.sidebar-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}sidebar-padding-y) var(--#{$prefix}sidebar-padding-x);\n}\n\n.sidebar-toggler {\n  // scss-docs-start sidebar-toggler-css-vars\n  --#{$prefix}sidebar-toggler-width: #{$sidebar-toggler-width};\n  --#{$prefix}sidebar-toggler-height: #{$sidebar-toggler-height};\n  --#{$prefix}sidebar-toggler-bg: #{$sidebar-toggler-bg};\n  --#{$prefix}sidebar-toggler-color: #{$sidebar-toggler-color};\n  --#{$prefix}sidebar-toggler-icon: #{escape-svg($sidebar-toggler-icon)};\n  --#{$prefix}sidebar-toggler-hover-color: #{$sidebar-toggler-hover-color};\n  --#{$prefix}sidebar-toggler-focus-shadow: #{$sidebar-toggler-focus-shadow};\n  --#{$prefix}sidebar-toggler-focus-color: #{$sidebar-toggler-focus-color};\n  --#{$prefix}sidebar-toggler-transition: #{$sidebar-toggler-transition};\n  // scss-docs-end sidebar-toggler-css-vars\n\n  position: relative;\n  box-sizing: content-box;\n  width: var(--#{$prefix}sidebar-toggler-width);\n  height: var(--#{$prefix}sidebar-toggler-height);\n  padding: $sidebar-toggler-padding-y $sidebar-toggler-padding-x;\n  background-color: var(--#{$prefix}sidebar-toggler-bg);\n  border: 0;\n  @include border-radius();\n\n  &::before {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    content: \"\";\n    background-color: var(--#{$prefix}sidebar-toggler-color);\n    mask: var(--#{$prefix}sidebar-toggler-icon) no-repeat center;\n    @include transition(var(--#{$prefix}sidebar-toggler-transition));\n    @include rtl() {\n      transform: rotate(-180deg);\n    }\n  }\n\n  // Override <a>'s hover style\n  &:hover {\n    text-decoration: none;\n    &::before {\n      background-color: var(--#{$prefix}sidebar-toggler-hover-color);\n    }\n  }\n\n  &:focus {\n    position: relative;\n    outline: 0;\n    box-shadow: var(--#{$prefix}sidebar-toggler-focus-shadow);\n\n    &::before {\n      background-color: var(--#{$prefix}sidebar-toggler-focus-color);\n    }\n  }\n\n  @include media-breakpoint-down($mobile-breakpoint) {\n    display: none;\n  }\n}\n\n\n// Backdrop background\n\n.sidebar-backdrop {\n  // scss-docs-start sidebar-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-sidebar-backdrop};\n  --#{$prefix}backdrop-bg: #{$sidebar-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$sidebar-backdrop-opacity};\n  // scss-docs-end sidebar-backdrop-css-vars\n\n  @include media-breakpoint-down($mobile-breakpoint) {\n    @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n  }\n}\n\n.sidebar-dark {\n  --#{$prefix}body-color: #{$body-color-dark};\n  --#{$prefix}body-bg: #{$body-bg-dark};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n\n  --#{$prefix}border-color: #{$border-color-dark};\n\n  .sidebar-toggler {\n    filter: var(--#{$prefix}sidebar-toggler-white-filter);\n  }\n}\n","// Sidebar navigation\n@use \"../functions/escape-svg\" as *;\n@use \"../mixins/border-radius\" as *;\n@use \"../mixins/transition\" as *;\n@use \"../variables\" as *;\n\n.sidebar-nav {\n  // scss-docs-start sidebar-nav-css-vars\n  --#{$prefix}sidebar-nav-padding-x: #{$sidebar-nav-padding-x};\n  --#{$prefix}sidebar-nav-padding-y: #{$sidebar-nav-padding-y};\n  --#{$prefix}sidebar-nav-gap: #{$sidebar-nav-gap};\n\n  --#{$prefix}sidebar-nav-title-padding-x: #{$sidebar-nav-title-padding-x};\n  --#{$prefix}sidebar-nav-title-padding-y: #{$sidebar-nav-title-padding-y};\n  --#{$prefix}sidebar-nav-title-margin-top: #{$sidebar-nav-title-margin-top};\n  --#{$prefix}sidebar-nav-title-color: #{$sidebar-nav-title-color};\n\n  --#{$prefix}sidebar-nav-link-padding-x: #{$sidebar-nav-link-padding-x};\n  --#{$prefix}sidebar-nav-link-padding-y: #{$sidebar-nav-link-padding-y};\n  --#{$prefix}sidebar-nav-link-color: #{$sidebar-nav-link-color};\n  --#{$prefix}sidebar-nav-link-bg: #{$sidebar-nav-link-bg};\n  --#{$prefix}sidebar-nav-link-border-color: #{$sidebar-nav-link-border-color};\n  --#{$prefix}sidebar-nav-link-border-radius: #{$sidebar-nav-link-border-radius};\n  --#{$prefix}sidebar-nav-link-border-width: #{$sidebar-nav-link-border-width};\n\n  --#{$prefix}sidebar-nav-link-active-color: #{$sidebar-nav-link-active-color};\n  --#{$prefix}sidebar-nav-link-active-bg: #{$sidebar-nav-link-active-bg};\n  --#{$prefix}sidebar-nav-link-disabled-color: #{$sidebar-nav-link-disabled-color};\n  --#{$prefix}sidebar-nav-link-hover-color: #{$sidebar-nav-link-hover-color};\n  --#{$prefix}sidebar-nav-link-hover-bg: #{$sidebar-nav-link-hover-bg};\n\n  --#{$prefix}sidebar-nav-link-icon-margin: #{$sidebar-nav-link-icon-margin};\n  --#{$prefix}sidebar-nav-link-icon-color: #{$sidebar-nav-link-icon-color};\n  --#{$prefix}sidebar-nav-link-icon-width: #{$sidebar-nav-link-icon-width};\n  --#{$prefix}sidebar-nav-link-icon-height: #{$sidebar-nav-link-icon-height};\n  --#{$prefix}sidebar-nav-link-icon-font-size: #{$sidebar-nav-link-icon-font-size};\n  --#{$prefix}sidebar-nav-link-active-icon-color: #{$sidebar-nav-link-active-icon-color};\n  --#{$prefix}sidebar-nav-link-disabled-icon-color: #{$sidebar-nav-link-disabled-icon-color};\n  --#{$prefix}sidebar-nav-link-hover-icon-color: #{$sidebar-nav-link-hover-icon-color};\n\n  --#{$prefix}sidebar-nav-link-icon-bullet-size: #{$sidebar-nav-link-icon-bullet-size};\n  --#{$prefix}sidebar-nav-link-icon-bullet-bg: #{$sidebar-nav-link-icon-bullet-bg};\n  --#{$prefix}sidebar-nav-link-icon-bullet-border-width: #{$sidebar-nav-link-icon-bullet-border-width};\n  --#{$prefix}sidebar-nav-link-icon-bullet-border-radius: #{$sidebar-nav-link-icon-bullet-border-radius};\n  --#{$prefix}sidebar-nav-link-icon-bullet-border-color: #{$sidebar-nav-link-icon-bullet-border-color};\n  --#{$prefix}sidebar-nav-link-active-icon-bullet-bg: #{$sidebar-nav-link-active-icon-bullet-bg};\n  --#{$prefix}sidebar-nav-link-active-icon-bullet-border-color: #{$sidebar-nav-link-active-icon-bullet-border-color};\n  --#{$prefix}sidebar-nav-link-disabled-icon-bullet-bg: #{$sidebar-nav-link-disabled-icon-bullet-bg};\n  --#{$prefix}sidebar-nav-link-disabled-icon-bullet-border-color: #{$sidebar-nav-link-disabled-icon-bullet-border-color};\n  --#{$prefix}sidebar-nav-link-hover-icon-bullet-bg: #{$sidebar-nav-link-hover-icon-bullet-bg};\n  --#{$prefix}sidebar-nav-link-hover-icon-bullet-border-color: #{$sidebar-nav-link-hover-icon-bullet-border-color};\n\n  --#{$prefix}sidebar-nav-group-bg: #{$sidebar-nav-group-bg};\n  --#{$prefix}sidebar-nav-group-border-width: #{$sidebar-nav-group-border-width};\n  --#{$prefix}sidebar-nav-group-border-radius: #{$sidebar-nav-group-border-radius};\n  --#{$prefix}sidebar-nav-group-border-color: #{$sidebar-nav-group-border-color};\n  --#{$prefix}sidebar-nav-group-items-padding-y: #{$sidebar-nav-group-items-padding-y};\n  --#{$prefix}sidebar-nav-group-items-padding-x: #{$sidebar-nav-group-items-padding-x};\n  --#{$prefix}sidebar-nav-group-indicator-color: #{$sidebar-nav-group-indicator-color};\n  --#{$prefix}sidebar-nav-group-indicator-icon: #{escape-svg($sidebar-nav-group-indicator-icon)};\n  --#{$prefix}sidebar-nav-group-indicator-hover-color: #{$sidebar-nav-group-indicator-hover-color};\n  --#{$prefix}sidebar-nav-group-indicator-hover-icon: #{escape-svg($sidebar-nav-group-indicator-hover-icon)};\n  --#{$prefix}sidebar-nav-group-toggle-show-color: #{$sidebar-nav-group-toggle-show-color};\n  // scss-docs-end sidebar-nav-css-vars\n\n  position: relative;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding: var(--#{$prefix}sidebar-nav-padding-y) var(--#{$prefix}sidebar-nav-padding-x);\n  margin-bottom: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  list-style: none;\n\n  .nav-item + .nav-item,\n  .nav-item + .nav-group,\n  .nav-group + .nav-item {\n    margin-top: var(--#{$prefix}sidebar-nav-gap);\n  }\n\n  .nav-title {\n    padding: var(--#{$prefix}sidebar-nav-title-padding-y) var(--#{$prefix}sidebar-nav-title-padding-x);\n    margin-top: var(--#{$prefix}sidebar-nav-title-margin-top);\n    font-size: 80%;\n    font-weight: 700;\n    color: var(--#{$prefix}sidebar-nav-title-color);\n    text-transform: uppercase;\n    @include transition($sidebar-nav-title-transition);\n  }\n\n  .nav-link {\n    display: flex;\n    flex: 1;\n    align-items: center;\n    padding: var(--#{$prefix}sidebar-nav-link-padding-y) var(--#{$prefix}sidebar-nav-link-padding-x);\n    color: var(--#{$prefix}sidebar-nav-link-color);\n    text-decoration: none;\n    white-space: nowrap;\n    background: var(--#{$prefix}sidebar-nav-link-bg);\n    border: var(--#{$prefix}sidebar-nav-link-border-width) solid var(--#{$prefix}sidebar-nav-link-border-color);\n    @include border-radius(var(--#{$prefix}sidebar-nav-link-border-radius));\n    @include transition($sidebar-nav-link-transition);\n\n    &.active {\n      color: var(--#{$prefix}sidebar-nav-link-active-color);\n      background: var(--#{$prefix}sidebar-nav-link-active-bg);\n\n      .nav-icon {\n        color: var(--#{$prefix}sidebar-nav-link-active-icon-color);\n      }\n\n      .nav-icon-bullet {\n        background: var(--#{$prefix}sidebar-link-active-icon-bullet-bg);\n        border-color: var(--#{$prefix}sidebar-link-active-icon-bullet-border-color);\n      }\n    }\n\n    &.disabled {\n      color: var(--#{$prefix}sidebar-nav-link-disabled-color);\n      pointer-events: none;\n      cursor: not-allowed;\n      background: transparent;\n\n      .nav-icon {\n        color: var(--#{$prefix}sidebar-nav-link-disabled-icon-color);\n      }\n\n      .nav-icon-bullet {\n        background: var(--#{$prefix}sidebar-link-disabled-icon-bullet-bg);\n        border-color: var(--#{$prefix}sidebar-link-disabled-icon-bullet-border-color);\n      }\n\n      &:hover {\n        color: var(--#{$prefix}sidebar-nav-link-disabled-color);\n\n        .nav-icon {\n          color: var(--#{$prefix}sidebar-nav-link-disabled-icon-color);\n        }\n\n        .nav-icon-bullet {\n          background: var(--#{$prefix}sidebar-link-disabled-icon-bullet-bg);\n          border-color: var(--#{$prefix}sidebar-link-disabled-icon-bullet-border-color);\n        }\n\n        &.nav-dropdown-toggle::after {\n          background-color: var(--#{$prefix}sidebar-nav-group-indicator-hover-color);\n          mask-image: var(--#{$prefix}sidebar-nav-group-indicator-hover-icon);\n        }\n      }\n    }\n\n    @media (hover: hover), (-ms-high-contrast: none) {\n      &:hover {\n        color: var(--#{$prefix}sidebar-nav-link-hover-color);\n        text-decoration: none;\n        background: var(--#{$prefix}sidebar-nav-link-hover-bg);\n\n        .nav-icon {\n          color: var(--#{$prefix}sidebar-nav-link-hover-icon-color);\n        }\n\n        .nav-icon-bullet {\n          background: var(--#{$prefix}sidebar-link-hover-icon-bullet-bg);\n          border-color: var(--#{$prefix}sidebar-link-hover-icon-bullet-border-color);\n        }\n\n        &.nav-group-toggle::after {\n          background-color: var(--#{$prefix}sidebar-nav-group-indicator-hover-color);\n          mask-image: var(--#{$prefix}sidebar-nav-group-indicator-hover-icon);\n        }\n      }\n    }\n  }\n\n  .nav-icon {\n    display: flex;\n    flex: 0 0 var(--#{$prefix}sidebar-nav-link-icon-width);\n    align-items: center;\n    justify-content: center;\n    height: var(--#{$prefix}sidebar-nav-link-icon-height);\n    margin-inline-end: var(--#{$prefix}sidebar-nav-link-icon-margin);\n    font-size: var(--#{$prefix}sidebar-nav-link-icon-font-size);\n    color: var(--#{$prefix}sidebar-nav-link-icon-color);\n    text-align: center;\n    pointer-events: none;\n    fill: currentcolor;\n    @include transition(inherit);\n  }\n\n  .nav-icon-bullet {\n    display: inline-block;\n    width: var(--#{$prefix}sidebar-nav-link-icon-bullet-size);\n    height: var(--#{$prefix}sidebar-nav-link-icon-bullet-size);\n    background: var(--#{$prefix}sidebar-nav-link-icon-bullet-bg);\n    border: var(--#{$prefix}sidebar-nav-link-icon-bullet-border-width) solid var(--#{$prefix}sidebar-nav-link-icon-bullet-border-color);\n    border-radius: var(--#{$prefix}sidebar-nav-link-icon-bullet-border-radius); // stylelint-disable-line property-disallowed-list\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  svg.nav-icon {\n    overflow: hidden; // fix chrome 105+ width issue\n  }\n\n  .nav-group {\n    position: relative;\n    border: var(--#{$prefix}sidebar-nav-group-border-width) solid var(--#{$prefix}sidebar-nav-group-border-color);\n    @include border-radius(var(--#{$prefix}sidebar-nav-group-border-radius));\n    @include transition($sidebar-nav-group-transition);\n\n    .nav-group-items {\n      padding: var(--#{$prefix}sidebar-nav-group-items-padding-y) var(--#{$prefix}sidebar-nav-group-items-padding-x);\n      overflow: hidden;\n      @include transition($sidebar-nav-group-items-transition);\n    }\n\n    &:not(.show) .nav-group-items {\n      display: none;\n    }\n\n    &.show {\n      background: var(--#{$prefix}sidebar-nav-group-bg);\n\n      .nav-group-toggle {\n        color: var(--#{$prefix}sidebar-nav-group-toggle-show-color);\n      }\n\n      > .nav-group-toggle::after {\n        transform: rotate(180deg);\n      }\n\n      + .show {\n        margin-top: var(--#{$prefix}sidebar-nav-gap);\n      }\n    }\n  }\n\n  .nav-group-toggle {\n    cursor: pointer;\n\n    &::after {\n      display: block;\n      flex: 0 12px;\n      height: 12px;\n      margin-inline-start: auto;\n      content: \"\";\n      background-color: var(--#{$prefix}sidebar-nav-group-indicator-color);\n      mask-image: var(--#{$prefix}sidebar-nav-group-indicator-icon);\n      @include transition($sidebar-nav-group-indicator-transition);\n    }\n  }\n\n  .nav-group-items {\n    padding: 0;\n    list-style: none;\n\n    .nav-link {\n      padding-inline-start: calc(var(--#{$prefix}sidebar-nav-link-padding-x) + var(--#{$prefix}sidebar-nav-link-icon-width) + var(--#{$prefix}sidebar-nav-link-icon-margin)); // stylelint-disable-line function-disallowed-list\n    }\n\n    .nav-icon {\n      margin-inline-start: calc(-1 * (var(--#{$prefix}sidebar-nav-link-icon-width) + var(--#{$prefix}sidebar-nav-link-icon-margin))); // stylelint-disable-line function-disallowed-list\n    }\n  }\n\n  &.compact,\n  .compact {\n    .nav-link {\n      --#{$prefix}sidebar-nav-link-padding-y: #{$sidebar-compact-nav-link-padding-y};\n    }\n  }\n}\n","@use \"../mixins/breakpoints\" as *;\n@use \"../mixins/ltr-rtl\" as *;\n@use \"../variables\" as *;\n@use \"sidebar\" as *;\n\n.sidebar-narrow {\n  // scss-docs-start sidebar-narrow-css-vars\n  --#{$prefix}sidebar-narrow-width: #{$sidebar-narrow-width};\n  // scss-docs-end sidebar-narrow-css-vars\n\n  @include media-breakpoint-up($mobile-breakpoint) {\n    flex: 0 0 var(--#{$prefix}sidebar-narrow-width);\n    width: var(--#{$prefix}sidebar-narrow-width);\n    padding-bottom: var(--#{$prefix}sidebar-toggler-height);\n    overflow: visible;\n\n    .sidebar-brand-full {\n      display: none;\n    }\n\n    .sidebar-brand-narrow {\n      display: block;\n    }\n\n    .sidebar-header {\n      justify-content: center;\n      padding-right: 0;\n      padding-left: 0;\n    }\n\n    .sidebar-nav {\n      --#{$prefix}sidebar-nav-link-padding-x: #{$sidebar-narrow-nav-link-padding-x};\n      --#{$prefix}sidebar-nav-link-padding-y: #{$sidebar-narrow-nav-link-padding-y};\n    }\n\n    .nav-link {\n      overflow: hidden;\n    }\n\n    .nav-icon {\n      flex: 0 0 calc(var(--#{$prefix}sidebar-narrow-width) - (var(--#{$prefix}sidebar-nav-padding-x) * 2) - (var(--#{$prefix}sidebar-nav-link-padding-x) * 2)); // stylelint-disable-line function-disallowed-list\n    }\n\n    .d-narrow-none,\n    .nav-label,\n    .nav-title,\n    .nav-group-items,\n    .nav-group.show .nav-group-items,\n    .sidebar-form {\n      height: 0 !important; // stylelint-disable-line declaration-no-important\n      padding: 0 !important; // stylelint-disable-line declaration-no-important\n      margin: 0 !important; // stylelint-disable-line declaration-no-important\n      visibility: hidden;\n      opacity: 0;\n    }\n\n    .sidebar-toggler::before {\n      @include ltr-rtl(\"transform\", rotate(-180deg), null, rotate(0deg));\n    }\n\n    &.sidebar-end .sidebar-toggler::before {\n      transform: rotate(0deg);\n    }\n  }\n}\n\n.sidebar-narrow-unfoldable {\n  // scss-docs-start sidebar-narrow-unfoldable-css-vars\n  --#{$prefix}sidebar-narrow-unfoldable-box-shadow: #{$sidebar-narrow-unfoldable-box-shadow};\n  // scss-docs-end sidebar-narrow-unfoldable-css-vars\n\n  @extend .sidebar-fixed;\n\n  &:not(:hover) {\n    @extend .sidebar-narrow;\n  }\n\n  &:hover {\n    box-shadow: var(--#{$prefix}sidebar-narrow-unfoldable-box-shadow);\n    box-shadow: $box-shadow;\n\n    .sidebar-toggler::before {\n      @include ltr-rtl(\"transform\", rotate(-180deg), null, rotate(0deg));\n    }\n\n    &.sidebar-end .sidebar-toggler::before {\n      transform: rotate(0deg);\n    }\n  }\n}\n\n.sidebar-narrow,\n.sidebar-narrow-unfoldable {\n  @include media-breakpoint-up($mobile-breakpoint) {\n    &:not(.sidebar-end):not(.hide) ~ * {\n      --#{$prefix}sidebar-occupy-start: #{$sidebar-narrow-width};\n    }\n    &.sidebar-end:not(.hide) ~ * {\n      --#{$prefix}sidebar-occupy-end: #{$sidebar-narrow-width};\n    }\n  }\n}\n","@use \"../functions/color\" as *;\n@use \"../functions/color-contrast\" as *;\n@use \"../functions/to-rgb\" as *;\n@use \"../mixins/color-mode\" as *;\n@use \"../variables\" as *;\n@use \"../variables-dark\" as *;\n\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: rgba(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @each $color, $value in $theme-colors-dark {\n      $color-rgb: to-rgb($value);\n      .text-bg-#{$color} {\n        color: color-contrast($value) if($enable-important-utilities, !important, null);\n        background-color: rgba($color-rgb, var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n","@use \"../functions/color\" as *;\n@use \"../functions/color-contrast\" as *;\n@use \"../functions/to-rgb\" as *;\n@use \"../variables\" as *;\n\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: rgba(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: rgba(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: rgba(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: rgba(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: rgba(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: rgba(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: rgba(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: rgba(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n","@use \"../variables\" as *;\n\n.focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--cui-focus-ring-x`, `--cui-focus-ring-y`, or `--cui-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n","@use \"../mixins/transition\" as *;\n@use \"../variables\" as *;\n\n.icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","@use \"../variables\" as *;\n\n// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    inset-inline-start: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","@use \"sass:map\";\n@use \"../mixins/breakpoints\" as *;\n@use \"../variables\" as *;\n\n// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map.keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","@use \"../mixins/visually-hidden\" as *;\n\n//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n\n  // Fix to prevent overflowing children to become focusable\n  * {\n    overflow: hidden !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/WAI/WCAG22/Techniques/general/G1.html\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","@use \"../variables\" as *;\n\n//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","@use \"../mixins/text-truncate\" as *;\n\n//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","@use \"../variables\" as *;\n\n.vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  padding: 0;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","@use \"sass:list\";\n@use \"sass:map\";\n@use \"sass:meta\";\n@use \"sass:string\";\n@use \"../variables\" as *;\n@use \"../vendor/rfs\" as *;\n@use \"ltr-rtl\" as *;\n\n// Generate selectors for theme variants\n@function theme-prefix($theme, $selector) {\n  @return #{\"[data\" + $data-infix + \"theme=\"$theme + \"] .\" + $theme + \"\\\\:\" + $selector + \", [data\" + $data-infix + \"theme=\"$theme + \"] .\" + $theme + \"\\\\:\" + $selector + \":not([class*='#{$theme}:'])\"};\n}\n\n// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map.get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if meta.type-of($values) == \"string\" or meta.type-of(list.nth($values, 1)) != \"list\" {\n    $values: list.zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map.get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if meta.type-of($properties) == \"string\" {\n      $properties: list.append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map.has-key($utility, class), map.get($utility, class), list.nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map.has-key($utility, css-variable-name), map.get($utility, css-variable-name), map.get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map.has-key($utility, state), map.get($utility, state), ());\n\n    $infix: if($property-class == \"\" and string.slice($infix, 1, 1) == \"-\", string.slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map.get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map.get($utility, css-var);\n    $is-dark-mode: map.get($utility, dark-mode);\n    $is-local-vars: map.get($utility, local-vars);\n    $is-rtl: map.get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        @if $enable-dark-mode and $is-dark-mode {\n          #{theme-prefix(\"dark\", \"#{$property-class + $infix + $property-class-modifier}\")},\n          .#{$property-class + $infix + $property-class-modifier} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        } @else {\n          .#{$property-class + $infix + $property-class-modifier} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        @if $enable-dark-mode and $is-dark-mode {\n          #{theme-prefix(\"dark\", \"#{$property-class + $infix + $property-class-modifier}\")},\n          .#{$property-class + $infix + $property-class-modifier} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        } @else {\n          .#{$property-class + $infix + $property-class-modifier} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              @if $is-rtl == true {\n                @if (meta.type-of($value) == \"map\") {\n                  @include ltr-rtl($property, map.get($value, \"ltr\"), null, map.get($value, \"rtl\"), if($enable-important-utilities, !important, null));\n                } @else {\n                  @include ltr-rtl($property, $value, null, null, if($enable-important-utilities, !important, null));\n                }\n              } @else {\n                #{$property}: $value if($enable-important-utilities, !important, null);\n              }\n            }\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","@use \"sass:map\";\n@use \"sass:meta\";\n@use \"../utilities\" as *;\n@use \"../mixins/breakpoints\" as *;\n@use \"../mixins/utilities\" as *;\n@use \"../vendor/rfs\" as *;\n@use \"../variables\" as *;\n\n// Loop over each breakpoint\n@each $breakpoint in map.keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if meta.type-of($utility) == \"map\" and (map.get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map.keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map.get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if meta.type-of($utility) == \"map\" and map.get($utility, rfs) and (map.get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if meta.type-of($utility) == \"map\" and map.get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","/*!\n * CoreUI Plugins - Chart.js for CoreUI 3\n * @version v4.0.0\n * @link https://coreui.io\n * Copyright (c) 2023 creativeLabs Łukasz Holeczek\n * Licensed under MIT (https://github.com/coreui/coreui-chartjs/blob/main/LICENSE)\n */\n\n@import \"@coreui/coreui/scss/functions\";\n@import \"@coreui/coreui/scss/variables\";\n@import \"@coreui/coreui/scss/mixins/border-radius\";\n@import \"@coreui/coreui/scss/mixins/transition\";\n@import \"variables\";\n@import \"tooltips\";\n","// Custom tooltips\n\n.chartjs-tooltip {\n  // scss-docs-start chartjs-tooltip-css-vars\n  --#{$prefix}chartjs-tooltip-zindex: #{$chartjs-tooltip-zindex};\n  --#{$prefix}chartjs-tooltip-padding-x: #{$chartjs-tooltip-padding-x};\n  --#{$prefix}chartjs-tooltip-padding-y: #{$chartjs-tooltip-padding-y};\n  --#{$prefix}chartjs-tooltip-color: #{$chartjs-tooltip-color};\n  --#{$prefix}chartjs-tooltip-bg: #{$chartjs-tooltip-bg};\n  --#{$prefix}chartjs-tooltip-border-radius: #{$chartjs-tooltip-border-radius};\n  --#{$prefix}chartjs-tooltip-transition: #{$chartjs-tooltip-transition};\n  --#{$prefix}chartjs-tooltip-header-margin: #{$chartjs-tooltip-header-margin};\n  --#{$prefix}chartjs-tooltip-header-font-size: #{$chartjs-tooltip-header-font-size};\n  --#{$prefix}chartjs-tooltip-header-font-weight: #{$chartjs-tooltip-header-font-weight};\n  --#{$prefix}chartjs-tooltip-body-font-size: #{$chartjs-tooltip-body-font-size};\n  --#{$prefix}chartjs-tooltip-body-font-weight: #{$chartjs-tooltip-body-font-weight};\n  // scss-docs-end chartjs-tooltip-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}chartjs-tooltip-zindex);\n  padding: var(--#{$prefix}chartjs-tooltip-padding-y) var(--#{$prefix}chartjs-tooltip-padding-x);\n  color: var(--#{$prefix}chartjs-tooltip-color);\n  pointer-events: none;\n  background: var(--#{$prefix}chartjs-tooltip-bg);\n  opacity: 0;\n  transform: translate(-50%, 0);\n  @include border-radius(var(--#{$prefix}chartjs-tooltip-border-radius));\n  @include transition(var(--#{$prefix}chartjs-tooltip-transition));\n}\n\n.chartjs-tooltip-header {\n  margin-bottom: var(--#{$prefix}chartjs-tooltip-header-margin);\n}\n\n.chartjs-tooltip-header-item {\n  font-size: var(--#{$prefix}chartjs-tooltip-header-font-size);\n  font-weight: var(--#{$prefix}chartjs-tooltip-header-font-weight);\n}\n\n.chartjs-tooltip-body-item {\n  align-items: center;\n  font-size: var(--#{$prefix}chartjs-tooltip-body-font-size);\n  font-weight: var(--#{$prefix}chartjs-tooltip-body-font-weight);\n  white-space: nowrap;\n}\n",".simplebar-content {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
